/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var About, AccessibilitySupport, AuthTransition, DecisionBoard, GroupSelectionRegion, LocationTransition, Page, PointsList, Proposal, ProposalDescription, Root, SliderBubblemouth, buildPointsList,
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(37);
	
	__webpack_require__(16);
	
	__webpack_require__(30);
	
	__webpack_require__(31);
	
	__webpack_require__(32);
	
	__webpack_require__(17);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(43);
	
	__webpack_require__(7);
	
	__webpack_require__(36);
	
	__webpack_require__(2);
	
	__webpack_require__(22);
	
	__webpack_require__(12);
	
	__webpack_require__(44);
	
	__webpack_require__(13);
	
	__webpack_require__(47);
	
	__webpack_require__(14);
	
	__webpack_require__(1);
	
	__webpack_require__(41);
	
	__webpack_require__(45);
	
	__webpack_require__(6);
	
	__webpack_require__(33);
	
	__webpack_require__(38);
	
	__webpack_require__(40);
	
	__webpack_require__(35);
	
	__webpack_require__(34);
	
	__webpack_require__(42);
	
	__webpack_require__(29);
	
	__webpack_require__(39);
	
	__webpack_require__(46);
	
	fetch('decisionboard', {
	  docked: false
	});
	
	fetch('root', {
	  opinions_to_publish: []
	});
	
	window.get_proposal_mode = function() {
	  var loc, ref;
	  loc = fetch('location');
	  if (loc.url === '/') {
	    return null;
	  } else if (((ref = loc.query_params) != null ? ref.results : void 0) || TWO_COL()) {
	    return 'results';
	  } else {
	    return 'crafting';
	  }
	};
	
	window.get_selected_point = function() {
	  return fetch('location').query_params.selected;
	};
	
	window.updateProposalMode = function(proposal_mode, triggered_by) {
	  var loc;
	  loc = fetch('location');
	  if (proposal_mode === 'results' && loc.query_params.results || proposal_mode === 'crafting' && !loc.query_params.results) {
	    return;
	  }
	  if (proposal_mode === 'results') {
	    loc.query_params.results = true;
	  } else {
	    delete loc.query_params.results;
	  }
	  delete loc.query_params.selected;
	  save(loc);
	  if (proposal_mode === 'results' && $('.histogram').length > 0) {
	    $('.histogram').ensureInView({
	      offset_buffer: -50
	    });
	  }
	  return window.writeToLog({
	    what: 'toggle proposal mode',
	    details: {
	      from: get_proposal_mode(),
	      to: proposal_mode,
	      triggered_by: triggered_by
	    }
	  });
	};
	
	window.focus_color = function() {
	  return focus_blue;
	};
	
	Proposal = ReactiveComponent({
	  displayName: 'Proposal',
	  render: function() {
	    var adjustments, can_opine, col, community_points, current_user, doc, draw_handle, edit_mode, has_community_points, has_focus, hist, i, included_points, is_loading, just_you, len, local_proposal, minheight, mode, page, pc, pnt, point_cols, proposal, ref, ref1, ref2, ref3, show_all_points, subdomain, valence, w, your_opinion;
	    doc = fetch('document');
	    proposal = fetch(this.proposal);
	    page = fetch(this.page);
	    if (doc.title !== this.proposal.name) {
	      doc.title = this.proposal.name;
	      save(doc);
	    }
	    your_opinion = fetch(this.proposal.your_opinion);
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    point_cols = ['your_con_points', 'your_pro_points', 'community_cons', 'community_pros'];
	    edit_mode = false;
	    for (i = 0, len = point_cols.length; i < len; i++) {
	      pc = point_cols[i];
	      col = fetch(pc);
	      if (col.adding_new_point || ((ref = col.editing_points) != null ? ref.length : void 0) > 0) {
	        edit_mode = pc;
	        break;
	      }
	    }
	    local_proposal = fetch(shared_local_key(this.proposal));
	    has_focus = get_selected_point() ? 'point' : edit_mode ? 'edit point' : "opinion";
	    if (local_proposal.has_focus !== has_focus) {
	      local_proposal.has_focus = has_focus;
	      save(local_proposal);
	    }
	    mode = get_proposal_mode();
	    if (your_opinion.published) {
	      can_opine = permit('update opinion', this.proposal, your_opinion);
	    } else {
	      can_opine = permit('publish opinion', this.proposal);
	    }
	    if (mode === 'crafting' && !((can_opine === Permission.PERMITTED || can_opine === Permission.UNVERIFIED_EMAIL || can_opine === Permission.NOT_LOGGED_IN || can_opine === Permission.INSUFFICIENT_INFORMATION) || (can_opine === Permission.DISABLED && your_opinion.published))) {
	      updateProposalMode('results', 'permission not granted for crafting');
	    }
	    draw_handle = (can_opine !== Permission.DISABLED && can_opine !== Permission.INSUFFICIENT_PRIVILEGES) || your_opinion.published;
	    adjustments = fetch('reasons_height_adjustment');
	    minheight = 100 + (adjustments.opinion_region_height || 0);
	    if (get_selected_point()) {
	      minheight += adjustments.open_point_height;
	    }
	    if (adjustments.edit_point_height) {
	      minheight += adjustments.edit_point_height;
	    }
	    community_points = fetch("/page/" + this.proposal.slug).points || [];
	    if (mode === 'crafting') {
	      included_points = fetch(this.proposal.your_opinion).point_inclusions;
	      community_points = (function() {
	        var j, len1, results;
	        results = [];
	        for (j = 0, len1 = community_points.length; j < len1; j++) {
	          pnt = community_points[j];
	          if (!_.contains(included_points, pnt.key)) {
	            results.push(pnt);
	          }
	        }
	        return results;
	      })();
	    }
	    has_community_points = community_points.length > 0;
	    if (get_selected_point() && !this.local.show_all_points) {
	      this.local.show_all_points = true;
	      save(this.local);
	    }
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    show_all_points = this.local.show_all_points || mode === 'crafting' || community_points.length < 8 || hist.selected_opinion || hist.selected_opinions;
	    is_loading = !page.proposal || (this.proposal.name == null);
	    just_you = ((ref1 = fetch('filtered').current_filter) != null ? ref1.label : void 0) === 'just you';
	    return ARTICLE({
	      id: "proposal-" + this.proposal.id,
	      key: this.props.slug,
	      style: {
	        paddingBottom: browser.is_mobile && has_focus === 'edit point' ? 200 : void 0
	      }
	    }, DIV(null, ProposalDescription(), (((ref2 = customization('opinion_callout')) != null ? ref2[this.proposal.cluster] : void 0) || (customization('opinion_callout') && _.isFunction(customization('opinion_callout')))) ? (((ref3 = customization('opinion_callout')) != null ? ref3[this.proposal.cluster] : void 0) || customization('opinion_callout'))() : H1({
	      style: _.defaults({}, customization('list_label_style'), {
	        fontSize: 36,
	        fontWeight: 700,
	        fontStyle: 'oblique',
	        textAlign: 'center',
	        marginTop: 48
	      })
	    }, mode === 'crafting' || just_you ? TRANSLATE({
	      id: "engage.opinion_header"
	    }, 'What do you think?') : TRANSLATE({
	      id: "engage.opinion_header_results"
	    }, 'What do we think?')), DIV({
	      style: {
	        position: 'relative',
	        width: BODY_WIDTH(),
	        margin: '0px auto 20px auto'
	      }
	    }, OpinionFilter({
	      style: {
	        textAlign: 'center'
	      },
	      enable_comparison_wrapper_style: {
	        fontSize: 14,
	        marginTop: 4
	      }
	    })), is_loading ? LOADING_INDICATOR : void 0, !is_loading ? SECTION({
	      style: {
	        width: PROPOSAL_HISTO_WIDTH(),
	        margin: '0 auto',
	        position: 'relative',
	        zIndex: 1
	      }
	    }, H2({
	      className: 'hidden'
	    }, translator({
	      id: "engage.opinion_spectrum_explanation",
	      negative_pole: get_slider_label("slider_pole_labels.oppose", this.proposal),
	      positive_pole: get_slider_label("slider_pole_labels.support", this.proposal),
	      proposal_name: this.proposal.name
	    }, "Evaluations on spectrum from {negative_pole} to {positive_pole} of the proposal {proposal_name}")), Histogram({
	      key: namespaced_key('histogram', this.proposal),
	      proposal: this.proposal,
	      opinions: opinionsForProposal(this.proposal),
	      width: PROPOSAL_HISTO_WIDTH(),
	      height: fetch('histogram-dock').docked ? 50 : 170,
	      enable_individual_selection: true,
	      enable_range_selection: true,
	      draw_base: fetch('histogram-dock').docked ? true : false,
	      backgrounded: mode === 'crafting',
	      draw_base: true,
	      draw_base_labels: true,
	      base_style: "2px solid " + (mode === 'crafting' ? focus_color() : '#414141'),
	      label_style: {
	        fontSize: 14,
	        fontWeight: 400,
	        color: 'black',
	        fontStyle: 'oblique',
	        bottom: -28
	      },
	      on_click_when_backgrounded: function() {
	        return updateProposalMode('results', 'click_histogram');
	      }
	    }), Dock({
	      key: 'slider-dock',
	      docked_key: namespaced_key('slider', this.proposal),
	      dock_on_zoomed_screens: true,
	      constraints: ['decisionboard-dock', 'histogram-dock'],
	      skip_jut: mode === 'results',
	      dockable: (function(_this) {
	        return function() {
	          return mode === 'crafting';
	        };
	      })(this),
	      dummy: get_proposal_mode() === 'crafting',
	      dummy2: PROPOSAL_HISTO_WIDTH()
	    }, (function(_this) {
	      return function() {
	        return OpinionSlider({
	          key: namespaced_key('slider', _this.proposal),
	          width: PROPOSAL_HISTO_WIDTH() - 10,
	          your_opinion: _this.proposal.your_opinion,
	          focused: mode === 'crafting',
	          backgrounded: false,
	          permitted: draw_handle,
	          pole_labels: [get_slider_label("slider_pole_labels.oppose", _this.proposal), get_slider_label("slider_pole_labels.support", _this.proposal)]
	        });
	      };
	    })(this)())) : void 0, !is_loading ? DIV({
	      style: {
	        position: 'relative',
	        top: -8,
	        overflowY: !show_all_points ? 'hidden' : void 0,
	        overflowX: !show_all_points ? 'auto' : void 0
	      }
	    }, SECTION({
	      className: 'reasons_region',
	      style: {
	        width: REASONS_REGION_WIDTH(),
	        minHeight: show_all_points ? minheight : void 0,
	        position: 'relative',
	        paddingBottom: '4em',
	        margin: (draw_handle && !TWO_COL() ? '24px' : '0') + " auto 0 auto",
	        display: !customization('discussion_enabled', this.proposal) ? 'none' : void 0
	      }
	    }, H2({
	      className: 'hidden'
	    }, translator({
	      id: "engage.reasons_section_explanation"
	    }, 'Why people think what they do about the proposal')), GroupSelectionRegion(), !TWO_COL() && customization('discussion_enabled', this.proposal) ? Dock({
	      key: 'decisionboard-dock',
	      docked_key: 'decisionboard',
	      constraints: ['slider-dock'],
	      dock_on_zoomed_screens: true,
	      dockable: (function(_this) {
	        return function() {
	          return mode === 'crafting';
	        };
	      })(this),
	      start: -24,
	      stop: function() {
	        return $('.reasons_region').offset().top + $('.reasons_region').outerHeight() - 20;
	      },
	      style: {
	        position: 'absolute',
	        width: DECISION_BOARD_WIDTH(),
	        zIndex: 0,
	        display: 'inline-block',
	        verticalAlign: 'top',
	        left: '50%',
	        marginLeft: -DECISION_BOARD_WIDTH() / 2
	      }
	    }, DecisionBoard({
	      key: 'decisionboard'
	    })) : void 0, DIV({
	      style: {
	        height: !show_all_points ? 500 : void 0
	      }
	    }, PointsList({
	      key: 'community_cons',
	      rendered_as: 'community_point',
	      points_editable: TWO_COL(),
	      valence: 'cons',
	      points_draggable: mode === 'crafting',
	      drop_target: false,
	      points: buildPointsList(this.proposal, 'cons', (mode === 'results' ? 'score' : 'last_inclusion'), mode === 'crafting' && !TWO_COL(), mode === 'crafting' || TWO_COL() || !just_you),
	      style: {
	        visibility: !TWO_COL() && !has_community_points ? 'hidden' : void 0
	      }
	    }), PointsList({
	      key: 'community_pros',
	      rendered_as: 'community_point',
	      points_editable: TWO_COL(),
	      valence: 'pros',
	      points_draggable: mode === 'crafting',
	      drop_target: false,
	      points: buildPointsList(this.proposal, 'pros', (mode === 'results' ? 'score' : 'last_inclusion'), mode === 'crafting' && !TWO_COL(), mode === 'crafting' || TWO_COL() || !just_you),
	      style: {
	        visibility: !TWO_COL() && !has_community_points ? 'hidden' : void 0
	      }
	    }))), !show_all_points ? BUTTON({
	      style: {
	        padding: '12px 0',
	        fontSize: 24,
	        textAlign: 'center',
	        textDecoration: 'underline',
	        border: 'none',
	        cursor: 'pointer',
	        display: 'block',
	        width: POINT_WIDTH() * 2 + 18 * 2 + 100 * 2,
	        margin: 'auto',
	        position: 'relative',
	        zIndex: 1
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_all_points = true;
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          var ref4;
	          if ((ref4 = e.which) === 13 || ref4 === 32) {
	            _this.local.show_all_points = true;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, TRANSLATE({
	      id: "engage.show_all_thoughts"
	    }, "Show All Thoughts")) : void 0) : void 0), mode === 'results' ? (w = 600, DIV({
	      style: {
	        margin: '70px auto 48px auto',
	        width: w
	      }
	    }, (customization('ProposalNavigation') || GroupedProposalNavigation)({
	      width: w,
	      proposal: this.proposal
	    }))) : void 0, edit_mode && browser.is_mobile ? (valence = edit_mode === 'community_pros' || edit_mode === 'your_pro_points' ? 'pros' : 'cons', pc = fetch(edit_mode), EditPoint({
	      key: pc.adding_new_point ? "new_point_" + valence : pc.editing_points[0],
	      fresh: pc.adding_new_point,
	      valence: valence,
	      your_points_key: edit_mode
	    })) : void 0);
	  }
	});
	
	ProposalDescription = ReactiveComponent({
	  displayName: 'ProposalDescription',
	  render: function() {
	    var body, body_style, current_user, cust_desc, editor, item, ref, result, subdomain, title, title_style, wrapper_style;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    if (!this.local.description_fields) {
	      try {
	        this.local.description_fields = $.parseJSON(this.proposal.description_fields);
	        this.local.expanded_field = null;
	      } catch (error) {
	        this.local.description_fields = null;
	      }
	    }
	    this.max_description_height = customization('collapse_proposal_description_at', this.proposal);
	    editor = proposal_editor(this.proposal);
	    title = this.proposal.name;
	    body = this.proposal.description;
	    title_style = _.defaults({}, customization('list_label_style'), {
	      fontSize: 36,
	      fontWeight: 700,
	      fontStyle: 'oblique'
	    });
	    body_style = {
	      paddingTop: '1em',
	      position: 'relative',
	      maxHeight: this.local.description_collapsed ? this.max_description_height : void 0,
	      overflow: this.local.description_collapsed ? 'hidden' : void 0,
	      fontSize: 18
	    };
	    wrapper_style = {};
	    if (this.proposal.banner) {
	      wrapper_style = {
	        background: "url(" + this.proposal.banner + ") no-repeat center top fixed",
	        backgroundSize: 'cover',
	        paddingTop: 240
	      };
	    }
	    return DIV({
	      style: wrapper_style
	    }, DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative',
	        margin: '36px auto 12px auto',
	        fontSize: 18,
	        marginBottom: 18
	      }
	    }, !this.proposal.active ? SPAN({
	      style: {
	        display: 'inline-block',
	        color: 'rgb(250, 146, 45)',
	        padding: '4px 0px',
	        marginTop: 10
	      }
	    }, I({
	      className: 'fa fa-info-circle',
	      style: {
	        paddingRight: 7
	      }
	    }), TRANSLATE({
	      id: 'engage.proposal_closed'
	    }, 'Closed to new contributions at this time.')) : void 0, BUBBLE_WRAP({
	      user: !this.proposal.pic ? editor : void 0,
	      pic: this.proposal.pic ? this.proposal.pic : void 0,
	      width: HOMEPAGE_WIDTH(),
	      mouth_style: {
	        width: 24,
	        display: !customization('show_proposer_icon', "list/" + this.proposal.cluster) ? 'none' : void 0,
	        bottom: 28,
	        top: 'auto',
	        transform: 'rotate(-90deg)'
	      },
	      bubble_style: {
	        padding: '12px 24px',
	        borderRadius: 42
	      },
	      avatar_style: {
	        display: !customization('show_proposer_icon', "list/" + this.proposal.cluster) ? 'none' : void 0,
	        width: 124,
	        height: 124,
	        left: -28 - 124,
	        bottom: -30,
	        top: 'auto',
	        boxShadow: this.proposal.pic ? 'none' : void 0
	      },
	      mouth_shadow: {
	        dx: -3
	      }
	    }, DIV({
	      style: {
	        wordWrap: 'break-word'
	      }
	    }, DIV({
	      style: _.defaults({}, title_style || {}, {
	        fontSize: POINT_FONT_SIZE(),
	        lineHeight: 1.2
	      }),
	      className: 'statement'
	    }, title), DIV({
	      style: {
	        marginTop: 4,
	        fontSize: 14,
	        color: "black"
	      }
	    }, this.proposal.cluster ? SPAN(null, "#" + (this.proposal.cluster || 'proposals'), customization('show_proposal_meta_data') ? SPAN({
	      style: {
	        padding: '0 8px'
	      }
	    }, '|') : void 0) : void 0, customization('show_proposal_meta_data') ? TRANSLATE({
	      id: "engage.proposal_meta_data",
	      timestamp: prettyDate(this.proposal.created_at),
	      author: (ref = fetch(editor)) != null ? ref.name : void 0
	    }, "submitted {timestamp} by {author}") : void 0), this.proposal.under_review ? DIV({
	      style: {
	        color: 'white',
	        backgroundColor: 'orange',
	        fontSize: 14,
	        padding: 2,
	        marginTop: 8,
	        display: 'inline-block'
	      }
	    }, TRANSLATE({
	      id: 'engage.proposal_in_moderation_notice'
	    }, 'Under review (like all new proposals)')) : void 0, DIV({
	      className: 'proposal_details',
	      style: {
	        maxHeight: this.local.description_collapsed ? this.max_description_height : void 0,
	        overflowY: this.local.description_collapsed ? 'hidden' : void 0
	      }
	    }, body ? DIV({
	      className: "statement",
	      style: _.defaults({}, body_style || {}, {
	        wordWrap: 'break-word',
	        marginTop: '0.5em',
	        fontSize: POINT_FONT_SIZE()
	      })
	    }, (cust_desc = customization('proposal_description')) ? typeof cust_desc === 'function' ? cust_desc(this.proposal) : cust_desc[this.proposal.cluster] ? (result = cust_desc[this.proposal.cluster]({
	      proposal: this.proposal
	    }), typeof result === 'function' && /^function \(props, children\)/.test(Function.prototype.toString.call(result)) ? result = cust_desc[this.proposal.cluster]()({
	      proposal: this.proposal
	    }) : result) : DIV({
	      dangerouslySetInnerHTML: {
	        __html: body
	      }
	    }) : DIV({
	      dangerouslySetInnerHTML: {
	        __html: body
	      }
	    })) : void 0, this.local.description_fields ? DIV({
	      id: 'description_fields',
	      style: {
	        marginTop: '1em'
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.description_fields;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        item = ref1[i];
	        if (item.group) {
	          results.push(this.renderDescriptionFieldGroup(item));
	        } else {
	          results.push(this.renderDescriptionField(item));
	        }
	      }
	      return results;
	    }).call(this)) : void 0), this.local.description_collapsed ? BUTTON({
	      id: 'expand_full_text',
	      style: {
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        padding: '24px 0 10px 0',
	        fontWeight: 600,
	        textAlign: 'left',
	        border: 'none',
	        width: '100%',
	        backgroundColor: 'transparent'
	      },
	      onMouseDown: (function(_this) {
	        return function() {
	          _this.local.description_collapsed = false;
	          return save(_this.local);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.local.description_collapsed = false;
	            e.preventDefault();
	            document.activeElement.blur();
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, TRANSLATE({
	      id: 'engage.show_full_proposal_description'
	    }, 'Expand full text')) : void 0)), permit('update proposal', this.proposal) > 0 ? DIV({
	      style: {
	        marginTop: 5
	      }
	    }, A({
	      href: this.proposal.key + "/edit",
	      style: {
	        marginRight: 10,
	        color: '#999',
	        backgroundColor: 'white',
	        border: 'none',
	        padding: 0
	      }
	    }, TRANSLATE('engage.edit_button', 'edit')), permit('delete proposal', this.proposal) > 0 ? BUTTON({
	      style: {
	        marginRight: 10,
	        color: '#999',
	        backgroundColor: 'white',
	        border: 'none',
	        padding: 0
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (confirm('Delete this proposal forever?')) {
	            destroy(_this.proposal.key);
	            return loadPage('/');
	          }
	        };
	      })(this)
	    }, TRANSLATE('engage.delete_button', 'delete')) : void 0) : void 0));
	  },
	  componentDidMount: function() {
	    if (this.proposal.description && this.max_description_height && this.local.description_collapsed === void 0 && $('.proposal_details').height() > this.max_description_height) {
	      this.local.description_collapsed = true;
	      return save(this.local);
	    }
	  },
	  componentDidUpdate: function() {
	    var subdomain;
	    if (this.proposal.description && this.max_description_height && this.local.description_collapsed === void 0 && $('.proposal_details').height() > this.max_description_height) {
	      this.local.description_collapsed = true;
	      save(this.local);
	    }
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'RANDOM2015' && this.local.description_fields && $('#description_fields').find('.MathJax').length === 0) {
	      return MathJax.Hub.Queue(["Typeset", MathJax.Hub, "description_fields"]);
	    }
	  },
	  renderDescriptionField: function(field) {
	    var symbol;
	    symbol = field.expanded ? 'fa-chevron-down' : 'fa-chevron-right';
	    return DIV({
	      className: 'description_field',
	      key: field.label,
	      style: {
	        padding: '.25em 0'
	      }
	    }, DIV({
	      style: {
	        cursor: 'pointer'
	      },
	      onClick: (function(_this) {
	        return function() {
	          field.expanded = !field.expanded;
	          save(_this.local);
	          if (field.expanded) {
	            return window.writeToLog({
	              what: 'expand proposal description',
	              details: {
	                description_type: field.label
	              }
	            });
	          }
	        };
	      })(this)
	    }, SPAN({
	      className: "fa " + symbol,
	      style: {
	        opacity: .7,
	        position: 'relative',
	        left: -3,
	        paddingRight: 6,
	        display: 'inline-block',
	        width: 20
	      }
	    }), SPAN({
	      style: {
	        lineHeight: 1.6,
	        fontSize: 18
	      }
	    }, field.label)), field.expanded ? DIV({
	      style: {
	        padding: '10px 0',
	        overflow: 'hidden'
	      },
	      dangerouslySetInnerHTML: {
	        __html: field.html
	      }
	    }) : void 0);
	  },
	  renderDescriptionFieldGroup: function(group) {
	    var field;
	    return DIV({
	      className: 'description_group',
	      key: group.group,
	      style: {
	        position: 'relative',
	        marginBottom: 10,
	        borderLeft: '1px solid #e1e1e1',
	        paddingLeft: 20,
	        left: -20
	      }
	    }, DIV({
	      style: {
	        position: 'absolute',
	        width: 200,
	        left: -217,
	        textAlign: 'right',
	        top: 4,
	        fontWeight: browser.high_density_display ? 300 : 400
	      }
	    }, LABEL(null, group.group)), (function() {
	      var i, len, ref, results;
	      ref = group.items;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        field = ref[i];
	        results.push(this.renderDescriptionField(field));
	      }
	      return results;
	    }).call(this));
	  }
	});
	
	styles += ".proposal_details code, .proposal_details pre {\n  font-family: \"Courier New\",Courier,\"Lucida Sans Typewriter\",\"Lucida Typewriter\",monospace;\n},.proposal_details br, .description_field br {\n  padding-bottom: 0.5em; }\n.proposal_details p, \n.proposal_details ul, \n.description_field ul, \n.proposal_details ol, \n.description_field ol, \n.proposal_details table, \n.description_field p, \n.description_field table {\n  margin-bottom: 0.5em; }\n.proposal_details td, .description_field td {\n  padding: 0 3px; }\n.proposal_details li, .description_field li {\n  list-style: outside; padding-bottom: 8px;}\n.proposal_details ol li {\n  list-style-type: decimal; }  \n.proposal_details ul, .description_field ul,\n.proposal_details ol, .description_field ol {\n  padding-left: 20px;\n  margin-left: 20px; }\n.proposal_details a, .description_field a {\n  text-decoration: underline; }\n.proposal_details blockquote, .description_field blockquote {\n  opacity: 0.7;\n  padding: 10px 20px; }\n.proposal_details table, .description_field table {\n  padding: 20px 0px; font-size: 11px; \n}\n.proposal_details .ql-editor li, .description_field .ql-editor li {\n  list-style: inside;\n}\n.proposal_details .ql-editor ul, .description_field .ql-editor ol{\n  margin-left: 0;\n}\n.proposal_details .ql-editor ol li {\n  list-style-type: none; }  ";
	
	DecisionBoard = ReactiveComponent({
	  displayName: 'DecisionBoard',
	  render: function() {
	    var are_points_in_wings, can_opine, current_user, db, decision_board_style, enable_opining, give_opinion_button_width, give_opinion_style, gutter, hist, included_points, opinion_region_x, opinion_slider_width, p, pnt, register_dependency, slider, stance_position, subdomain, wing_points, your_opinion;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    db = fetch('decision_board');
	    your_opinion = fetch(this.proposal.your_opinion);
	    if (your_opinion.published) {
	      can_opine = permit('update opinion', this.proposal, your_opinion);
	    } else {
	      can_opine = permit('publish opinion', this.proposal);
	    }
	    enable_opining = can_opine !== Permission.INSUFFICIENT_PRIVILEGES && (can_opine !== Permission.DISABLED || your_opinion.published) && !(hist.selected_opinions || hist.selected_opinion);
	    if (!enable_opining) {
	      return DIV(null);
	    }
	    register_dependency = fetch(namespaced_key('slider', this.proposal)).value;
	    wing_points = fetch("/page/" + this.proposal.slug).points || [];
	    included_points = fetch(this.proposal.your_opinion).point_inclusions;
	    wing_points = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = wing_points.length; i < len; i++) {
	        pnt = wing_points[i];
	        if (!_.contains(included_points, pnt.key)) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	    are_points_in_wings = wing_points.length > 0;
	    decision_board_style = {
	      borderRadius: 16,
	      borderStyle: 'dashed',
	      borderWidth: 3,
	      borderColor: focus_color(),
	      transition: this.last_proposal_mode !== get_proposal_mode() || this.transitioning ? ("transform " + TRANSITION_SPEED + "ms, ") + ("width " + TRANSITION_SPEED + "ms, ") + ("min-height " + TRANSITION_SPEED + "ms") : 'none'
	    };
	    if (db.user_hovering_on_drop_target) {
	      decision_board_style.borderStyle = 'solid';
	    }
	    if (get_proposal_mode() === 'results') {
	      give_opinion_button_width = 200;
	      slider = fetch(namespaced_key('slider', this.proposal));
	      gutter = .1 * give_opinion_button_width;
	      opinion_slider_width = BODY_WIDTH() - 10;
	      stance_position = (slider.value + 1) / 2 * opinion_slider_width / BODY_WIDTH();
	      opinion_region_x = -gutter + stance_position * (DECISION_BOARD_WIDTH() - give_opinion_button_width + 2 * gutter);
	      _.extend(decision_board_style, {
	        borderStyle: 'solid',
	        backgroundColor: focus_color(),
	        borderBottom: '1px solid rgba(0,0,0,.6)',
	        cursor: 'pointer',
	        transform: "translate(" + opinion_region_x + "px, -10px)",
	        minHeight: 32,
	        width: give_opinion_button_width
	      });
	    } else {
	      _.extend(decision_board_style, {
	        transform: "translate(0, 10px)",
	        minHeight: are_points_in_wings ? 275 : 170,
	        width: DECISION_BOARD_WIDTH(),
	        borderBottom: decision_board_style.borderWidth + "px dashed " + (focus_color()),
	        backgroundColor: 'white'
	      });
	    }
	    if (get_proposal_mode() === 'results') {
	      give_opinion_style = {
	        backgroundColor: focus_color(),
	        display: 'block',
	        color: 'white',
	        padding: '.25em 18px',
	        margin: 0,
	        fontSize: 16,
	        boxShadow: 'none',
	        width: '100%'
	      };
	    } else {
	      give_opinion_style = {
	        visibility: 'hidden'
	      };
	    }
	    return SECTION({
	      className: 'opinion_region',
	      style: {
	        width: DECISION_BOARD_WIDTH()
	      }
	    }, H3({
	      className: 'hidden',
	      style: {
	        display: !TWO_COL() && get_proposal_mode() === 'results' ? 'none' : void 0
	      }
	    }, translator({
	      id: "engage.opinion_crafting_explanation",
	      proposal_name: this.proposal.name
	    }, "Craft your opinion using pros and cons about {proposal_name}")), SliderBubblemouth(), DIV({
	      'aria-live': 'polite',
	      key: 'body',
	      className: 'decision_board_body',
	      style: css.crossbrowserify(decision_board_style),
	      onClick: (function(_this) {
	        return function() {
	          if (get_proposal_mode() === 'results') {
	            updateProposalMode('crafting', 'give_opinion_button');
	            return $('.the_handle')[0].focus();
	          }
	        };
	      })(this)
	    }, DIV(null, get_proposal_mode() === 'crafting' ? DIV({
	      className: 'your_points',
	      style: {
	        padding: '0 18px',
	        marginTop: -3
	      }
	    }, PointsList({
	      key: 'your_pro_points',
	      valence: 'pros',
	      rendered_as: 'decision_board_point',
	      points_editable: true,
	      points_draggable: true,
	      drop_target: are_points_in_wings,
	      points: (function() {
	        var i, len, ref, results;
	        ref = fetch(this.proposal.your_opinion).point_inclusions;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          p = ref[i];
	          if (fetch(p).is_pro) {
	            results.push(p);
	          }
	        }
	        return results;
	      }).call(this)
	    }), PointsList({
	      key: 'your_con_points',
	      valence: 'cons',
	      rendered_as: 'decision_board_point',
	      points_editable: true,
	      points_draggable: true,
	      drop_target: are_points_in_wings,
	      points: (function() {
	        var i, len, ref, results;
	        ref = fetch(this.proposal.your_opinion).point_inclusions;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          p = ref[i];
	          if (!fetch(p).is_pro) {
	            results.push(p);
	          }
	        }
	        return results;
	      }).call(this)
	    }), DIV({
	      style: {
	        clear: 'both'
	      }
	    })) : void 0, BUTTON({
	      className: 'give_opinion_button primary_button',
	      style: give_opinion_style
	    }, your_opinion.published ? translator({
	      id: "engage.update_your_opinion_button"
	    }, 'Update your Opinion') : translator({
	      id: "engage.give_your_opinion_button"
	    }, 'Give your Opinion')))), DIV({
	      key: 'footer',
	      style: {
	        width: DECISION_BOARD_WIDTH()
	      }
	    }, BUTTON({
	      className: 'save_opinion_button primary_button',
	      style: {
	        display: 'none',
	        backgroundColor: focus_color(),
	        width: '100%'
	      },
	      onClick: (function(_this) {
	        return function() {
	          return saveOpinion(_this.proposal);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            saveOpinion(_this.proposal);
	            return e.preventDefault();
	          }
	        };
	      })(this),
	      'aria-label': your_opinion.published ? translator('engage.update_opinion_button', 'Return to results') : translator('engage.save_opinion_button', 'Save your opinion')
	    }, your_opinion.published ? translator('engage.update_opinion_button', 'Return to results') : translator('engage.save_opinion_button', 'Save your opinion')), !your_opinion.published ? DIV({
	      className: 'below_save',
	      style: {
	        display: 'none'
	      }
	    }, BUTTON({
	      className: 'cancel_opinion_button primary_cancel_button',
	      onClick: (function(_this) {
	        return function() {
	          return updateProposalMode('results', 'cancel_button');
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            updateProposalMode('results', 'cancel_button');
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, translator('engage.see_results_first_button', 'or just skip to the results'))) : DIV({
	      className: 'below_save',
	      style: {
	        display: 'none'
	      }
	    }, BUTTON({
	      style: {
	        textDecoration: 'underline'
	      },
	      className: 'cancel_opinion_button primary_cancel_button',
	      onClick: (function(_this) {
	        return function() {
	          your_opinion.published = false;
	          return save(your_opinion);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            your_opinion.published = false;
	            save(your_opinion);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, translator("engage.remove_my_opinion", 'Remove my opinion')))));
	  },
	  componentDidUpdate: function() {
	    this.transition();
	    return this.makeDroppable();
	  },
	  componentDidMount: function() {
	    this.transition();
	    return this.makeDroppable();
	  },
	  makeDroppable: function() {
	    var $el, db;
	    db = fetch('decision_board');
	    $el = $(this.getDOMNode());
	    if ($el.is('.ui-droppable')) {
	      return;
	    }
	    return $el.droppable({
	      accept: ".point_content",
	      drop: (function(_this) {
	        return function(ev, ui) {
	          var your_opinion;
	          if (ui.draggable.parent().is('.community_point')) {
	            your_opinion = fetch(_this.proposal.your_opinion);
	            your_opinion.point_inclusions.push(ui.draggable.parent().data('id'));
	            save(your_opinion);
	            window.writeToLog({
	              what: 'included point',
	              details: {
	                point: ui.draggable.parent().data('id')
	              }
	            });
	            db.user_hovering_on_drop_target = false;
	            return save(db);
	          }
	        };
	      })(this),
	      out: (function(_this) {
	        return function(ev, ui) {
	          if (ui.draggable.parent().is('.community_point')) {
	            db.user_hovering_on_drop_target = false;
	            return save(db);
	          }
	        };
	      })(this),
	      over: (function(_this) {
	        return function(ev, ui) {
	          if (ui.draggable.parent().is('.community_point')) {
	            db.user_hovering_on_drop_target = true;
	            return save(db);
	          }
	        };
	      })(this)
	    });
	  },
	  update_reasons_height: function() {
	    var s;
	    s = fetch('reasons_height_adjustment');
	    s.opinion_region_height = $(this.getDOMNode()).height();
	    return save(s);
	  },
	  transition: function() {
	    var final_state, initial_state, mode, perform, speed;
	    if (this.is_waiting()) {
	      return;
	    }
	    speed = !Modernizr.csstransitions || !this.last_proposal_mode ? 0 : TRANSITION_SPEED;
	    mode = get_proposal_mode();
	    perform = (function(_this) {
	      return function(transitions) {
	        var k, results, v;
	        results = [];
	        for (k in transitions) {
	          if (!hasProp.call(transitions, k)) continue;
	          v = transitions[k];
	          results.push($(_this.getDOMNode()).find(k).css(v));
	        }
	        return results;
	      };
	    })(this);
	    initial_state = {
	      '.give_opinion_button': {
	        visibility: 'hidden'
	      },
	      '.your_points, .save_opinion_button, .below_save': {
	        display: 'none'
	      }
	    };
	    final_state = JSON.parse(JSON.stringify(initial_state));
	    if (mode === 'results') {
	      final_state['.give_opinion_button'].visibility = '';
	    } else {
	      final_state['.your_points, .save_opinion_button, .below_save'].display = '';
	    }
	    if (this.last_proposal_mode !== mode) {
	      if (speed > 0) {
	        perform(initial_state);
	        this.transitioning = true;
	        _.delay((function(_this) {
	          return function() {
	            if (_this.isMounted()) {
	              perform(final_state);
	              _this.transitioning = false;
	              return _this.update_reasons_height();
	            }
	          };
	        })(this), speed + 200);
	      } else if (!this.transitioning) {
	        perform(initial_state);
	        perform(final_state);
	        this.update_reasons_height();
	      }
	      return this.last_proposal_mode = mode;
	    }
	  }
	});
	
	window.saveOpinion = function(proposal) {
	  var auth_form, can_opine, root, your_opinion;
	  root = fetch('root');
	  your_opinion = fetch(proposal.your_opinion);
	  if (your_opinion.published) {
	    can_opine = permit('update opinion', proposal, your_opinion);
	  } else {
	    can_opine = permit('publish opinion', proposal);
	  }
	  if (can_opine > 0) {
	    your_opinion.published = true;
	    save(your_opinion);
	    return updateProposalMode('results', 'save_button');
	  } else {
	    if (can_opine === Permission.UNVERIFIED_EMAIL) {
	      auth_form = 'verify email';
	      current_user.trying_to = 'send_verification_token';
	      save(current_user);
	    } else if (can_opine === Permission.INSUFFICIENT_INFORMATION) {
	      auth_form = 'user questions';
	    } else {
	      auth_form = 'create account';
	    }
	    reset_key('auth', {
	      form: auth_form,
	      goal: 'Save your opinion',
	      ask_questions: true
	    });
	    root.opinions_to_publish.push(proposal.your_opinion);
	    return save(root);
	  }
	};
	
	SliderBubblemouth = ReactiveComponent({
	  displayName: 'SliderBubblemouth',
	  render: function() {
	    var dash, db, fill, h, slider, stroke_width, transform, w;
	    slider = fetch(namespaced_key('slider', this.proposal));
	    db = fetch('decision_board');
	    w = 34;
	    h = 24;
	    stroke_width = 11;
	    if (get_proposal_mode() === 'crafting') {
	      transform = "translate(0, -4px) scale(1,.7)";
	      fill = 'white';
	      if (db.user_hovering_on_drop_target) {
	        dash = "none";
	      } else {
	        dash = "25, 10";
	      }
	    } else {
	      transform = "translate(0, -25px) scale(.5,.5) ";
	      fill = focus_color();
	      dash = "none";
	    }
	    return DIV({
	      key: 'slider_bubblemouth',
	      style: css.crossbrowserify({
	        left: 10 + translateStanceToPixelX(slider.value, DECISION_BOARD_WIDTH() - w - 20),
	        top: -h + 18 + 3,
	        position: 'absolute',
	        width: w,
	        height: h,
	        zIndex: 10,
	        transition: "transform " + TRANSITION_SPEED + "ms",
	        transform: transform
	      })
	    }, Bubblemouth({
	      apex_xfrac: (slider.value + 1) / 2,
	      width: w,
	      height: h,
	      fill: fill,
	      stroke: focus_color(),
	      stroke_width: get_proposal_mode() === 'crafting' ? stroke_width : 0,
	      dash_array: dash
	    }));
	  }
	});
	
	GroupSelectionRegion = ReactiveComponent({
	  displayName: 'GroupSelectionRegion',
	  render: function() {
	    var avatar_size, h, has_histogram_focus, hist, left, name, name_style, name_width, place_avatar_opinion_value, title, user, w;
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    has_histogram_focus = hist.selected_opinions || hist.selected_opinion;
	    if (!has_histogram_focus) {
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        width: BODY_WIDTH() + 160,
	        border: "3px solid " + (get_selected_point() ? '#eee' : focus_color()),
	        height: '100%',
	        position: 'absolute',
	        borderRadius: 16,
	        marginLeft: -BODY_WIDTH() / 2 - 80,
	        left: '50%',
	        top: 18
	      }
	    }, hist.selected_opinions ? (w = 40, h = 30, left = translateStanceToPixelX(hist.selected_opinion_value, BODY_WIDTH()) + 10, DIV({
	      style: cssTriangle('top', (get_selected_point() ? '#eee' : focus_color()), w, h, {
	        position: 'relative',
	        top: -32,
	        left: left
	      })
	    }, DIV({
	      style: cssTriangle('top', 'white', w - 1, h - 1, {
	        position: 'relative',
	        left: -(w - 2) / 2,
	        top: 6
	      })
	    }))) : (place_avatar_opinion_value = hist.selected_opinion_value > 0 ? .66 : -.8, left = translateStanceToPixelX(place_avatar_opinion_value, BODY_WIDTH() + 160), avatar_size = 80, user = fetch(fetch(hist.selected_opinion).user), name = user.name || 'Anonymous', title = name + "'" + (name[name.length - 1] !== 's' ? 's' : '') + " Opinion", name_width = widthWhenRendered(title, {
	      fontSize: '30px',
	      fontWeight: '600'
	    }), hist.selected_opinion_value > 0 ? name_style = {
	      left: -28 - avatar_size * .5 - name_width,
	      borderTopLeftRadius: 16,
	      paddingRight: avatar_size * .75,
	      paddingLeft: 18
	    } : name_style = {
	      left: avatar_size / 4,
	      borderTopRightRadius: 16,
	      paddingLeft: avatar_size * .75,
	      paddingRight: 18
	    }, DIV({
	      style: {
	        left: left,
	        position: 'absolute',
	        zIndex: 1
	      }
	    }, DIV(null, Avatar({
	      key: user,
	      user: user,
	      hide_tooltip: true,
	      style: {
	        position: 'absolute',
	        width: avatar_size,
	        height: avatar_size,
	        top: -avatar_size * .75,
	        left: -avatar_size / 4,
	        zIndex: 99,
	        border: "3px solid " + (focus_color())
	      }
	    }), DIV({
	      style: _.extend(name_style, {
	        position: 'absolute',
	        backgroundColor: focus_color(),
	        paddingTop: 8,
	        paddingBottom: 8,
	        color: 'white',
	        top: -58,
	        width: name_width + 10 + 18 + avatar_size * .75 + 10
	      })
	    }, SPAN({
	      style: {
	        fontSize: 30
	      }
	    }, title))))));
	  }
	});
	
	buildPointsList = function(proposal, valence, sort_field, filter_included, show_all_points) {
	  var filtered, filtered_out, hist, i, included_points, inclusions, j, len, len1, o, opinions, pnt, point, point_inclusions_per_point, points, results, sort;
	  sort_field = sort_field || 'score';
	  points = fetch("/page/" + proposal.slug).points || [];
	  opinions = fetch(proposal).opinions;
	  filtered_out = fetch('filtered');
	  if (filtered_out.users && !show_all_points) {
	    filtered = true;
	    opinions = (function() {
	      var i, len, ref, results;
	      results = [];
	      for (i = 0, len = opinions.length; i < len; i++) {
	        o = opinions[i];
	        if (!((ref = filtered_out.users) != null ? ref[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	  }
	  points = (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = points.length; i < len; i++) {
	      pnt = points[i];
	      if (pnt.is_pro === (valence === 'pros')) {
	        results.push(pnt);
	      }
	    }
	    return results;
	  })();
	  included_points = fetch(proposal.your_opinion).point_inclusions;
	  if (filter_included) {
	    points = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = points.length; i < len; i++) {
	        pnt = points[i];
	        if (!_.contains(included_points, pnt.key)) {
	          results.push(pnt);
	        }
	      }
	      return results;
	    })();
	  } else {
	    for (i = 0, len = included_points.length; i < len; i++) {
	      pnt = included_points[i];
	      point = fetch(pnt);
	      if (pnt.is_pro !== (valence === 'pros')) {
	        continue;
	      }
	      if (points.indexOf(point) === -1) {
	        points.push(point);
	      }
	    }
	  }
	  hist = fetch(namespaced_key('histogram', proposal));
	  if (hist.selected_opinion) {
	    opinions = [hist.selected_opinion];
	    filtered = true;
	  } else if (hist.selected_opinions) {
	    opinions = hist.selected_opinions;
	    filtered = true;
	  }
	  point_inclusions_per_point = {};
	  _.each(opinions, (function(_this) {
	    return function(opinion_key) {
	      var j, len1, opinion, ref, results;
	      opinion = fetch(opinion_key);
	      if (opinion.point_inclusions) {
	        ref = opinion.point_inclusions;
	        results = [];
	        for (j = 0, len1 = ref.length; j < len1; j++) {
	          point = ref[j];
	          point_inclusions_per_point[point] || (point_inclusions_per_point[point] = 0);
	          results.push(point_inclusions_per_point[point] += 1);
	        }
	        return results;
	      }
	    };
	  })(this));
	  if (opinions.length < 2) {
	    for (point in point_inclusions_per_point) {
	      inclusions = point_inclusions_per_point[point];
	      if (fetch(point).hide_name) {
	        delete point_inclusions_per_point[point];
	      }
	    }
	  }
	  points = (function() {
	    var j, len1, ref, results;
	    results = [];
	    for (j = 0, len1 = points.length; j < len1; j++) {
	      pnt = points[j];
	      if ((pnt.key in point_inclusions_per_point) || (ref = pnt.key, indexOf.call(included_points, ref) >= 0)) {
	        results.push(pnt);
	      }
	    }
	    return results;
	  })();
	  sort = function(pnt) {
	    if (filtered) {
	      return -point_inclusions_per_point[pnt.key];
	    } else {
	      return -pnt[sort_field];
	    }
	  };
	  points = _.sortBy(points, sort);
	  results = [];
	  for (j = 0, len1 = points.length; j < len1; j++) {
	    pnt = points[j];
	    results.push(pnt.key);
	  }
	  return results;
	};
	
	PointsList = ReactiveComponent({
	  displayName: 'PointsList',
	  render: function() {
	    var HEADING, get_heading, header_height, header_prefix, header_style, heading, mode, other_heading, pnt, point, points, wrapper, your_points;
	    points = (function() {
	      var i, len, ref, results;
	      ref = this.props.points;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        pnt = ref[i];
	        results.push(fetch(pnt));
	      }
	      return results;
	    }).call(this);
	    mode = get_proposal_mode();
	    your_points = this.data();
	    if (this.props.points_editable && !your_points.editing_points) {
	      _.extend(your_points, {
	        editing_points: [],
	        adding_new_point: false
	      });
	      save(your_points);
	    }
	    if (this.props.rendered_as === 'community_point') {
	      header_prefix = mode === 'results' ? 'top' : "other";
	      header_style = {
	        width: POINT_WIDTH(),
	        fontSize: 30,
	        fontWeight: 400,
	        position: 'relative',
	        left: this.props.valence === 'cons' ? -20 : 20
	      };
	      wrapper = this.drawCommunityPoints;
	    } else {
	      header_prefix = 'your';
	      header_style = {
	        width: POINT_WIDTH(),
	        fontWeight: 700,
	        color: focus_color(),
	        fontSize: 30
	      };
	      wrapper = this.drawYourPoints;
	    }
	    get_heading = (function(_this) {
	      return function(valence) {
	        var heading, heading_t, plural_point, point_labels;
	        point_labels = customization("point_labels", _this.proposal);
	        heading = point_labels[header_prefix + "_header"];
	        plural_point = get_point_label(valence, _this.proposal);
	        heading_t = translator({
	          id: "point_labels.header_" + header_prefix + "." + heading,
	          key: point_labels.translate ? "/translations" : "/translations/" + (fetch('/subdomain').name),
	          "arguments": capitalize(plural_point)
	        }, heading);
	        return heading_t;
	      };
	    })(this);
	    heading = get_heading(this.props.valence);
	    other_heading = get_heading(this.props.valence === 'pros' ? 'cons' : 'pros');
	    header_height = Math.max(heightWhenRendered(heading, header_style), heightWhenRendered(other_heading, header_style));
	    HEADING = this.props.rendered_as === 'community_point' ? H3 : H4;
	    return wrapper([
	      HEADING({
	        ref: 'point_list_heading',
	        id: this.local.key.replace('/', '-'),
	        className: 'points_heading_label',
	        style: _.extend(header_style, {
	          textAlign: 'center',
	          marginBottom: 18,
	          marginTop: 7,
	          height: header_height
	        })
	      }, heading), UL({
	        'aria-labelledby': this.local.key.replace('/', '-')
	      }, (function() {
	        var i, len, ref, results;
	        if (points.length > 0 || this.props.rendered_as === 'decision_board_point') {
	          results = [];
	          for (i = 0, len = points.length; i < len; i++) {
	            point = points[i];
	            if (this.props.points_editable && (ref = point.key, indexOf.call(your_points.editing_points, ref) >= 0) && !browser.is_mobile) {
	              results.push(EditPoint({
	                key: point.key,
	                fresh: false,
	                valence: this.props.valence,
	                your_points_key: this.props.key
	              }));
	            } else {
	              results.push(Point({
	                key: point.key,
	                rendered_as: this.props.rendered_as,
	                your_points_key: this.props.key,
	                enable_dragging: this.props.points_draggable
	              }));
	            }
	          }
	          return results;
	        }
	      }).call(this)), this.props.drop_target ? this.drawDropTarget() : void 0, this.props.points_editable ? this.drawAddNewPoint() : void 0
	    ]);
	  },
	  columnStandsOut: function() {
	    var contains_selection, is_editing, your_points;
	    your_points = this.data();
	    contains_selection = get_selected_point() && fetch(get_selected_point()).is_pro === (this.props.valence === 'pros');
	    is_editing = this.props.points_editable && (your_points.editing_points.length > 0 || your_points.adding_new_point);
	    return contains_selection || is_editing;
	  },
	  drawCommunityPoints: function(children) {
	    var x_pos;
	    x_pos = this.props.points_draggable ? this.props.valence === 'cons' ? 0 : DECISION_BOARD_WIDTH() : !TWO_COL() ? DECISION_BOARD_WIDTH() / 2 : 0;
	    return SECTION({
	      className: "point_list points_by_community " + this.props.valence + "_by_community",
	      style: css.crossbrowserify(_.defaults(this.props.style || {}, {
	        display: 'inline-block',
	        verticalAlign: 'top',
	        width: POINT_WIDTH(),
	        minHeight: (this.page.points.length > 4 && get_proposal_mode() === 'crafting' ? jQuery(window).height() : 100),
	        zIndex: this.columnStandsOut() ? 6 : 1,
	        margin: '38px 18px 0 18px',
	        position: 'relative',
	        transition: "transform " + TRANSITION_SPEED + "ms",
	        transform: "translate(" + x_pos + "px, 0)"
	      }))
	    }, get_proposal_mode() === 'crafting' && !TWO_COL() ? [
	      A({
	        className: 'hidden',
	        href: "#" + this.props.valence + "_on_decision_board",
	        'data-nojax': true,
	        onClick: (function(_this) {
	          return function(e) {
	            var ref;
	            e.stopPropagation();
	            if ((ref = document.activeElement) != null) {
	              ref.blur();
	            }
	            return $("[name='" + _this.props.valence + "_on_decision_board']").focus();
	          };
	        })(this)
	      }, "Skip to Your points."), A({
	        name: this.props.valence + "_by_community"
	      })
	    ] : void 0, children);
	  },
	  drawYourPoints: function(children) {
	    return SECTION({
	      className: "point_list points_on_decision_board " + this.props.valence + "_on_decision_board",
	      style: _.defaults(this.props.style || {}, {
	        display: 'inline-block',
	        verticalAlign: 'top',
	        width: POINT_WIDTH(),
	        marginTop: 28,
	        position: 'relative',
	        zIndex: this.columnStandsOut() ? 6 : 1,
	        float: this.props.valence === 'pros' ? 'right' : 'left'
	      })
	    }, A({
	      name: this.props.valence + "_on_decision_board"
	    }), children);
	  },
	  drawAddNewPoint: function() {
	    var can_add_new_point, hist, hist_selection, noun, your_points;
	    your_points = this.data();
	    can_add_new_point = permit('create point', this.proposal);
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    hist_selection = hist.selected_opinions || hist.selected_opinion;
	    if (can_add_new_point !== Permission.INSUFFICIENT_PRIVILEGES && !hist_selection) {
	      if (!your_points.adding_new_point) {
	        return DIV(null, DIV({
	          onClick: (function(_this) {
	            return function() {
	              if (can_add_new_point === Permission.NOT_LOGGED_IN) {
	                reset_key('auth', {
	                  form: 'create account',
	                  goal: 'Write a point',
	                  ask_questions: true
	                });
	              } else if (can_add_new_point === Permission.UNVERIFIED_EMAIL) {
	                reset_key('auth', {
	                  form: 'verify email',
	                  goal: 'Write a point',
	                  ask_questions: true
	                });
	                save(auth);
	                current_user.trying_to = 'send_verification_token';
	                save(current_user);
	              } else {
	                your_points.adding_new_point = true;
	                save(your_points);
	              }
	              return writeToLog({
	                what: 'click new point'
	              });
	            };
	          })(this)
	        }, this.props.rendered_as === 'decision_board_point' ? this.drawAddNewPointInDecisionBoard() : this.drawAddNewPointInCommunityCol()), this.props.rendered_as === 'decision_board_point' ? (this.props.valence === 'pros' ? noun = get_point_label('pro', this.proposal) : noun = get_point_label('con', this.proposal), noun = capitalize(noun), A({
	          className: 'hidden',
	          href: "#" + this.props.valence + "_by_community",
	          'data-nojax': true,
	          onClick: (function(_this) {
	            return function(e) {
	              var ref;
	              e.stopPropagation();
	              if ((ref = document.activeElement) != null) {
	                ref.blur();
	              }
	              return $("[name='" + _this.props.valence + "_by_community']").focus();
	            };
	          })(this)
	        }, "Skip to " + noun + " points by others to vote on important ones.")) : void 0);
	      } else if (!browser.is_mobile) {
	        return EditPoint({
	          key: "new_point_" + this.props.valence,
	          fresh: true,
	          valence: this.props.valence,
	          your_points_key: this.props.key
	        });
	      }
	    }
	  },
	  drawAddNewPointInCommunityCol: function() {
	    var button_text, point_label;
	    if (this.props.valence === 'pros') {
	      point_label = get_point_label('pro', this.proposal);
	    } else {
	      point_label = get_point_label('con', this.proposal);
	    }
	    button_text = translator({
	      id: "engage.add_a_point",
	      pro_or_con: point_label
	    }, "Add a new {pro_or_con}");
	    return DIV({
	      id: "add-point-" + this.props.valence,
	      style: {
	        cursor: 'pointer',
	        marginTop: 20
	      }
	    }, this.drawGhostedPoint({
	      width: POINT_WIDTH(),
	      text: button_text,
	      is_left: this.props.valence === 'cons',
	      style: {},
	      text_style: {
	        textDecoration: 'underline',
	        fontSize: browser.is_mobile ? 24 : void 0
	      }
	    }));
	  },
	  drawAddNewPointInDecisionBoard: function() {
	    var point_label, your_points;
	    your_points = this.data();
	    if (this.props.valence === 'pros') {
	      point_label = get_point_label('pro', this.proposal);
	    } else {
	      point_label = get_point_label('con', this.proposal);
	    }
	    return DIV({
	      style: {
	        padding: '.25em 0',
	        marginTop: '1em',
	        marginLeft: this.props.drop_target ? 20 : 9,
	        fontSize: POINT_FONT_SIZE()
	      }
	    }, this.props.drop_target ? SPAN({
	      'aria-hidden': true,
	      style: {
	        fontWeight: browser.high_density_display ? 300 : 400
	      }
	    }, (t('or')) + " ") : void 0, SPAN({
	      'aria-hidden': true,
	      style: {
	        padding: this.props.drop_target ? '0 6px' : '0 11px 0 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: '&bull;'
	      }
	    }), BUTTON({
	      className: "write_" + this.props.valence,
	      style: {
	        textDecoration: 'underline',
	        color: focus_color(),
	        padding: 0,
	        backgroundColor: 'transparent',
	        border: 'none'
	      }
	    }, TRANSLATE({
	      id: "engage.add_a_point",
	      pro_or_con: point_label
	    }, "Add a new {pro_or_con}")));
	  },
	  drawDropTarget: function() {
	    var drop_target_text, dt_w, left_or_right, local_proposal, point_label;
	    left_or_right = this.props.valence === 'pros' ? 'right' : 'left';
	    if (this.props.valence === 'pros') {
	      point_label = get_point_label('pro', this.proposal);
	    } else {
	      point_label = get_point_label('con', this.proposal);
	    }
	    drop_target_text = TRANSLATE({
	      id: "engage.drag_point." + left_or_right,
	      pro_or_con: point_label,
	      left_or_right: left_or_right
	    }, "Drag a {pro_or_con} from the " + left_or_right);
	    dt_w = POINT_WIDTH() - 24;
	    local_proposal = fetch(shared_local_key(this.proposal));
	    return DIV({
	      'aria-hidden': true,
	      style: {
	        marginLeft: this.props.valence === 'cons' ? 24 : 0,
	        marginRight: this.props.valence === 'pros' ? 24 : 0,
	        position: 'relative',
	        left: this.props.valence === 'cons' ? -18 : 18
	      }
	    }, this.drawGhostedPoint({
	      width: POINT_WIDTH() - 24,
	      text: drop_target_text,
	      is_left: this.props.valence === 'cons',
	      style: {
	        opacity: local_proposal.has_focus === 'edit point' ? .1 : void 0
	      },
	      text_style: {}
	    }));
	  },
	  drawGhostedPoint: function(props) {
	    var h, is_left, local_proposal, mouth_style, padding_x, padding_y, s_h, s_w, stroke_width, style, text, text_height, text_style, w, width;
	    text_style = props.text_style || {};
	    style = props.style || {};
	    width = props.width;
	    text = props.text;
	    is_left = props.is_left;
	    w = width;
	    padding_x = 18;
	    padding_y = 12;
	    text_height = heightWhenRendered(text, {
	      'font-size': POINT_FONT_SIZE(),
	      'width': w - 2 * padding_x
	    });
	    stroke_width = 1;
	    h = Math.max(text_height + 2 * padding_y, 85);
	    s_w = 8;
	    s_h = 6;
	    mouth_style = {
	      top: 8,
	      position: 'absolute'
	    };
	    if (is_left) {
	      mouth_style['transform'] = 'rotate(270deg) scaleX(-1)';
	      mouth_style['left'] = -POINT_MOUTH_WIDTH + stroke_width + 1;
	    } else {
	      mouth_style['transform'] = 'rotate(90deg)';
	      mouth_style['right'] = -POINT_MOUTH_WIDTH + stroke_width + 1;
	    }
	    local_proposal = fetch(shared_local_key(this.proposal));
	    return DIV({
	      style: _.defaults(style, {
	        position: 'relative',
	        opacity: local_proposal.has_focus === 'edit point' ? .1 : void 0
	      })
	    }, SVG({
	      width: w,
	      height: h
	    }, DEFS(null, PATTERN({
	      id: "drop-stripes-" + is_left + "-" + width,
	      width: s_w,
	      height: s_h,
	      patternUnits: "userSpaceOnUse"
	    }, RECT({
	      width: '100%',
	      height: '100%',
	      fill: 'white'
	    }), (function(_this) {
	      return function() {
	        var cross_hatch, i, idx, len, ref, results, x1, x2, y1, y2;
	        if (is_left) {
	          cross_hatch = [[-s_w / 2, 0, s_w, 1.5 * s_h], [0, -s_h / 2, 1.5 * s_w, s_h]];
	        } else {
	          cross_hatch = [[1.5 * s_w, 0, 0, 1.5 * s_h], [s_w, -s_h / 2, -s_w / 2, s_h]];
	        }
	        results = [];
	        for (idx = i = 0, len = cross_hatch.length; i < len; idx = ++i) {
	          ref = cross_hatch[idx], x1 = ref[0], y1 = ref[1], x2 = ref[2], y2 = ref[3];
	          results.push(LINE({
	            x1: x1,
	            y1: y1,
	            x2: x2,
	            y2: y2,
	            stroke: focus_color(),
	            strokeWidth: 1,
	            strokeOpacity: .2
	          }));
	        }
	        return results;
	      };
	    })(this)())), RECT({
	      width: w - 2 * stroke_width,
	      height: h - 2 * stroke_width,
	      x: stroke_width,
	      y: stroke_width,
	      rx: 16,
	      ry: 16,
	      fill: "url(#drop-stripes-" + is_left + "-" + width + ")",
	      stroke: focus_color(),
	      strokeWidth: stroke_width,
	      strokeDasharray: '4, 3'
	    })), SPAN({
	      style: _.defaults({}, text_style, {
	        fontSize: POINT_FONT_SIZE(),
	        position: 'absolute',
	        top: padding_y,
	        left: padding_x,
	        width: w - 2 * padding_x
	      })
	    }, text), Bubblemouth({
	      apex_xfrac: 0,
	      width: POINT_MOUTH_WIDTH,
	      height: POINT_MOUTH_WIDTH,
	      fill: '#F9FBFD',
	      stroke: focus_color(),
	      stroke_width: 6,
	      dash_array: '24, 18',
	      style: css.crossbrowserify(mouth_style)
	    }));
	  }
	});
	
	AccessibilitySupport = ReactiveComponent({
	  displayName: 'AccessibilitySupport',
	  render: function() {
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto'
	      }
	    }, H1({
	      style: {
	        fontSize: 32,
	        fontWeight: 600,
	        marginTop: 30,
	        marginBottom: 10
	      }
	    }, TRANSLATE({
	      id: 'accessibility.heading'
	    }, 'Accessibility Support')), P({
	      style: {
	        paddingBottom: 18,
	        fontSize: 24
	      }
	    }, TRANSLATE({
	      id: "accessibility.feedback_or_help",
	      link: {
	        component: A,
	        args: {
	          href: "mailto:accessibility@consider.it?subject=Accessibility support",
	          style: {
	            textDecoration: 'underline'
	          }
	        }
	      }
	    }, "If you are having difficulty using Considerit to give feedback, contact us at <link>accessibility@consider.it</link>. We will help you personally.")));
	  }
	});
	
	About = ReactiveComponent({
	  displayName: 'About',
	  componentWillMount: function() {
	    this.local.embed_html_directly = true;
	    this.local.html = null;
	    return this.local.save;
	  },
	  componentDidMount: function() {
	    return this.handleContent();
	  },
	  componentDidUpdate: function() {
	    return this.handleContent();
	  },
	  handleContent: function() {
	    var $el, iframe;
	    $el = $(this.getDOMNode());
	    if (this.local.embed_html_directly) {
	      if (this.local.html) {
	        return $el.find('.embedded_about_html').html(this.local.html);
	      }
	    } else {
	      $el.prop('tagName').toLowerCase() === 'iframe';
	      iframe = $el[0];
	      return _.delay(function() {
	        var e;
	        try {
	          return iframe.height = iframe.contentWindow.document.body.scrollHeight + "px";
	        } catch (error) {
	          e = error;
	          iframe.height = "2000px";
	          console.error('http/https mismatch for about page. Should work in production.');
	          return console.error(e);
	        }
	      }, 1000);
	    }
	  },
	  render: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (this.local.embed_html_directly && !this.local.html && subdomain.about_page_url) {
	      $.get(subdomain.about_page_url, (function(_this) {
	        return function(response) {
	          _this.local.html = response;
	          return save(_this.local);
	        };
	      })(this));
	    }
	    return DIV({
	      style: {
	        marginTop: 20
	      }
	    }, !subdomain.about_page_url ? DIV(null, 'No about page defined') : !this.local.embed_html_directly ? IFRAME({
	      src: subdomain.about_page_url,
	      width: CONTENT_WIDTH(),
	      style: {
	        display: 'block',
	        margin: 'auto'
	      }
	    }) : DIV({
	      className: 'embedded_about_html'
	    }));
	  }
	});
	
	LocationTransition = ReactiveComponent({
	  displayName: 'locationTransition',
	  render: function() {
	    var auth, loc;
	    loc = fetch('location');
	    if (this.last_location !== loc.url) {
	      auth = fetch('auth');
	      if (loc.url === '/edit_profile' && auth.form !== 'edit profile') {
	        reset_key(auth, {
	          form: 'edit profile',
	          ask_questions: true
	        });
	      } else if (auth.form) {
	        reset_key(auth);
	      }
	      if (loc.url === '/') {
	        reset_selection_state('filtered');
	      }
	      this.last_location = loc.url;
	    }
	    return SPAN(null);
	  }
	});
	
	AuthTransition = ReactiveComponent({
	  displayName: 'Computer',
	  render: function() {
	    var can_opine, current_user, i, j, len, len1, opinion, opinion_key, question, questions, questions_all_answered, ref, ref1, ref2, remaining_opinions, subdomain;
	    current_user = fetch('/current_user');
	    questions_all_answered = true;
	    questions = customization('auth_questions');
	    ref = questions || [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      question = ref[i];
	      if (question.required) {
	        questions_all_answered && (questions_all_answered = ((ref1 = question.input) === 'boolean' || ref1 === 'checklist') || !!current_user.tags[question.tag]);
	      }
	    }
	    if (current_user.csrf) {
	      arest.csrf(current_user.csrf);
	    }
	    if (this.root.opinions_to_publish.length > 0) {
	      remaining_opinions = [];
	      ref2 = this.root.opinions_to_publish;
	      for (j = 0, len1 = ref2.length; j < len1; j++) {
	        opinion_key = ref2[j];
	        opinion = fetch(opinion_key);
	        can_opine = permit('publish opinion', opinion.proposal);
	        if (can_opine > 0 && !opinion.published) {
	          opinion.published = true;
	          save(opinion);
	        } else {
	          remaining_opinions.push(opinion_key);
	        }
	      }
	      if (remaining_opinions.length !== this.root.opinions_to_publish.length) {
	        this.root.opinions_to_publish = remaining_opinions;
	        save(this.root);
	      }
	    }
	    if (current_user.needs_to_complete_profile) {
	      subdomain = fetch('/subdomain');
	      reset_key('auth', {
	        key: 'auth',
	        form: subdomain.SSO_domain ? 'edit profile' : 'create account via invitation',
	        goal: 'Complete registration',
	        ask_questions: true
	      });
	      if (subdomain.SSO_domain) {
	        loadPage('/edit_profile');
	      }
	    } else if (current_user.logged_in && !questions_all_answered && !fetch('auth').form) {
	      reset_key('auth', {
	        form: 'user questions',
	        goal: 'To start participating',
	        ask_questions: true
	      });
	    } else if (current_user.needs_to_verify && !window.send_verification_token) {
	      current_user.trying_to = 'send_verification_token';
	      save(current_user);
	      window.send_verification_token = true;
	      reset_key('auth', {
	        key: 'auth',
	        form: 'verify email',
	        goal: 'confirm you control this email',
	        ask_questions: false
	      });
	    }
	    return SPAN(null);
	  }
	});
	
	Page = ReactiveComponent({
	  displayName: 'Page',
	  mixins: [AccessControlled],
	  render: function() {
	    var access_granted, auth, loc, proposal, result, subdomain;
	    subdomain = fetch('/subdomain');
	    loc = fetch('location');
	    auth = fetch('auth');
	    access_granted = this.accessGranted();
	    return DIV(null, access_granted ? Header({
	      key: 'page_header'
	    }) : void 0, MAIN({
	      role: 'main',
	      style: {
	        position: 'relative',
	        zIndex: 1,
	        margin: 'auto'
	      }
	    }, (function() {
	      var i, len, ref, ref1, ref2;
	      if (auth.form) {
	        return Auth();
	      } else if (!access_granted) {
	        return AccessDenied();
	      } else if (loc.url.match(/(.+)\/edit/)) {
	        return EditProposal({
	          key: loc.url.match(/(.+)\/edit/)[1],
	          fresh: false
	        });
	      } else {
	        switch (loc.url) {
	          case '/':
	            return Homepage({
	              key: 'homepage'
	            });
	          case '/about':
	            return About();
	          case '/privacy_policy':
	            return PrivacyPolicy();
	          case '/terms_of_service':
	            return TermsOfService();
	          case '/proposal/new':
	            return EditProposal({
	              key: "new_proposal",
	              fresh: true
	            });
	          case '/accessibility_support':
	            return AccessibilitySupport();
	          case '/dashboard/email_notifications':
	            return Notifications({
	              key: '/page/dashboard/email_notifications'
	            });
	          case '/dashboard/data_import_export':
	            return DataDash({
	              key: "/page/dashboard/data_import_export"
	            });
	          case '/dashboard/moderate':
	            return ModerationDash({
	              key: "/page/dashboard/moderate"
	            });
	          case '/dashboard/application':
	            return AppSettingsDash({
	              key: "/page/dashboard/application"
	            });
	          case '/dashboard/customizations':
	            return CustomizationsDash({
	              key: "/page/dashboard/customizations"
	            });
	          case '/dashboard/roles':
	            return SubdomainRoles({
	              key: "/page/dashboard/roles"
	            });
	          case '/dashboard/tags':
	            return UserTags({
	              key: "/page/dashboard/tags"
	            });
	          case '/dashboard/translations':
	            return TranslationsDash({
	              key: "/page/dashboard/translations"
	            });
	          default:
	            if (((ref = this.page) != null ? ref.result : void 0) === 'Not found') {
	              return DIV({
	                style: {
	                  textAlign: 'center',
	                  fontSize: 32,
	                  marginTop: 50
	                }
	              }, "There doesn't seem to be a proposal here", DIV({
	                style: {
	                  color: '#555',
	                  fontSize: 16
	                }
	              }, "Check if the url is correct. The author may also have deleted it. Good luck!"));
	            } else {
	              result = null;
	              if (this.page.proposal) {
	                result = Proposal({
	                  key: this.page.proposal
	                });
	              } else if ((this.page.proposal == null) && (((ref1 = arest.cache['/proposals']) != null ? ref1.proposals : void 0) != null)) {
	                ref2 = arest.cache['/proposals'].proposals;
	                for (i = 0, len = ref2.length; i < len; i++) {
	                  proposal = ref2[i];
	                  if ('/' + proposal.slug === loc.url) {
	                    result = Proposal({
	                      key: "/proposal/" + proposal.id
	                    });
	                    break;
	                  }
	                }
	              }
	              return result || LOADING_INDICATOR;
	            }
	        }
	      }
	    }).call(this)), access_granted && !auth.form ? Footer({
	      key: 'page_footer'
	    }) : void 0);
	  }
	});
	
	Root = ReactiveComponent({
	  displayName: 'Root',
	  render: function() {
	    var current_user, fonts, header_fonts, loc, subdomain;
	    loc = fetch('location');
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    fonts = customization('font');
	    header_fonts = customization('header_font') || fonts;
	    return DIV({
	      onTouchMove: function() {
	        window.is_swipping = true;
	        return true;
	      },
	      onTouchEnd: function() {
	        window.is_swipping = false;
	        return true;
	      },
	      style: {
	        width: DOCUMENT_WIDTH()
	      },
	      onClick: this.resetSelection
	    }, StateDash(), AuthTransition(), LocationTransition(), HomepageTabTransition(), BrowserLocation(), STYLE({
	      dangerouslySetInnerHTML: {
	        __html: "#content, #content input, #content button, #content textarea {\n  font-family: " + fonts + "; \n}\n#content h1, #content h2, #content h3, #content h4, #content h1 button, #content h2 button, #content h3 button, #content h4 button {\n  font-family: " + header_fonts + ";\n}"
	      }
	    }), !subdomain.name ? LOADING_INDICATOR : DIV({
	      style: {
	        backgroundColor: 'white',
	        overflowX: 'hidden'
	      }
	    }, BrowserHacks(), Page({
	      key: "/page" + loc.url
	    })), Tooltip(), (function() {
	      var app;
	      app = fetch('/application');
	      if (app.dev) {
	        Development();
	      }
	      if (current_user.is_super_admin || app.godmode) {
	        return GodMode();
	      }
	    })());
	  },
	  resetSelection: function(e) {
	    var hist, loc, page, selected, wysiwyg_editor;
	    loc = fetch('location');
	    page = fetch("/page" + loc.url);
	    if (!fetch('auth').form && page.proposal) {
	      hist = fetch(namespaced_key('histogram', page.proposal));
	      if (get_selected_point()) {
	        window.writeToLog({
	          what: 'deselected a point',
	          details: {
	            point: get_selected_point()
	          }
	        });
	        delete loc.query_params.selected;
	        save(loc);
	      } else if (hist.selected_opinions || hist.selected_opinion || hist.originating_histogram) {
	        reset_selection_state(hist);
	      }
	    }
	    if (!fetch('auth').form && loc.url === '/') {
	      hist = fetch('filtered');
	      if (hist.selected_opinions || hist.selected_opinion || hist.originating_histogram) {
	        reset_selection_state(hist);
	      }
	    }
	    wysiwyg_editor = fetch('wysiwyg_editor');
	    if (wysiwyg_editor.showing) {
	      selected = document.getSelection();
	      if (selected.isCollapsed) {
	        wysiwyg_editor.showing = false;
	        return save(wysiwyg_editor);
	      }
	    }
	  }
	});
	
	window.Point = Point;
	
	window.Comment = Comment;
	
	window.Franklin = Root;
	
	__webpack_require__(18);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	var css_as_str, el, focus_shadow, height_cache, log_writer, logs_to_write, newest_in_cluster_on_load, size_cache, width_cache,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; },
	  hasProp = {}.hasOwnProperty;
	
	__webpack_require__(27);
	
	__webpack_require__(10);
	
	window.GoogleTranslate = ReactiveComponent({
	  displayName: 'GoogleTranslate',
	  render: function() {
	    var homepage, loc, style;
	    loc = fetch('location');
	    homepage = loc.url === '/';
	    style = customization('google_translate_style') && homepage ? customization('google_translate_style') : _.defaults({}, this.props.style, {
	      textAlign: 'center',
	      marginBottom: 10
	    });
	    return DIV({
	      key: "google_translate_element_" + this.local.key,
	      id: "google_translate_element_" + this.local.key,
	      style: style
	    });
	  },
	  insertTranslationWidget: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    return new google.translate.TranslateElement({
	      pageLanguage: subdomain.lang,
	      layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
	      multilanguagePage: true
	    }, "google_translate_element_" + this.local.key);
	  },
	  componentDidMount: function() {
	    return this.int = setInterval((function(_this) {
	      return function() {
	        var ref;
	        if ((typeof google !== "undefined" && google !== null ? (ref = google.translate) != null ? ref.TranslateElement : void 0 : void 0) != null) {
	          _this.insertTranslationWidget();
	          return clearInterval(_this.int);
	        }
	      };
	    })(this), 20);
	  },
	  componentWillUnmount: function() {
	    return clearInterval(this.int);
	  }
	});
	
	window.pad = function(num, len) {
	  var dec, i, str;
	  str = num;
	  dec = str.split('.');
	  i = 0;
	  while (i < len - dec[0].toString().length) {
	    dec[0] = "0" + dec[0];
	    i += 1;
	  }
	  return dec[0] + (dec.length > 0 ? '.' + dec[1] : '');
	};
	
	window.back_to_homepage_button = function(style, text) {
	  var hash, homepage, loc;
	  loc = fetch('location');
	  homepage = loc.url === '/';
	  hash = loc.url.split('/')[1].replace('-', '_');
	  return NAV({
	    role: 'navigation'
	  }, A({
	    className: 'back_to_homepage',
	    title: 'back to homepage',
	    key: 'back_to_homepage_button',
	    href: "/#" + hash,
	    style: _.defaults({}, style, {
	      fontSize: 43,
	      visibility: homepage || !customization('has_homepage') ? 'hidden' : 'visible',
	      color: 'black'
	    })
	  }, '<', text ? SPAN({
	    style: {
	      textDecoration: 'underline',
	      paddingLeft: 4
	    }
	  }, text) : void 0));
	};
	
	for (el in React.DOM) {
	  window[el.toUpperCase()] = React.DOM[el];
	}
	
	window.styles = "";
	
	window.TRANSITION_SPEED = 700;
	
	window.LIVE_UPDATE_INTERVAL = 3 * 60 * 1000;
	
	setInterval(function() {
	  var dependent_keys, key, proposals;
	  dependent_keys = [];
	  proposals = false;
	  for (key in arest.components_4_key.hash) {
	    if (key[0] === '/' && arest.components_4_key.get(key).length > 0 && !key.match(/\/(user|opinion|point|subdomain|application|translations)/)) {
	      if (key.match(/\/proposal\/|\/proposals\//)) {
	        proposals = true;
	      } else if (key !== '/current_user' || fetch('/current_user').logged_in) {
	        arest.serverFetch(key);
	      }
	    }
	  }
	  if (proposals) {
	    return arest.serverFetch('/proposals');
	  }
	}, LIVE_UPDATE_INTERVAL);
	
	window.POINT_MOUTH_WIDTH = 17;
	
	window.HEARTBEAT = ReactiveComponent({
	  displayName: 'heartbeat',
	  render: function() {
	    var beat;
	    beat = fetch(this.props.public_key || 'pulse');
	    if (beat.beat == null) {
	      setInterval(function() {
	        beat.beat = (beat.beat || 0) + 1;
	        return save(beat);
	      }, this.props.interval || 1000);
	    }
	    return SPAN(null);
	  }
	});
	
	window.FB_SHARE = ReactiveComponent({
	  displayName: 'FB_SHARE',
	  render: function() {
	    return IFRAME({
	      src: "https://www.facebook.com/plugins/share_button.php?href=" + (encodeURI(this.props.href)) + "&layout=button&size=large&mobile_iframe=false&appId=" + this.props.appId + "&width=73&height=28",
	      width: this.props.width || "73",
	      height: this.props.height || "28",
	      style: {
	        border: 'none',
	        overflow: 'hidden'
	      },
	      scrolling: "no",
	      frameborder: "0",
	      allowTransparency: "true"
	    });
	  }
	});
	
	window.TWEET = ReactiveComponent({
	  displayName: 'Tweet',
	  render: function() {
	    var j, len1, ref, url, url_param;
	    url = "https://platform.twitter.com/widgets/tweet_button.html?size=l&count=none&id=twitter-widget-0&lang=en";
	    ref = ['hashtags', 'original_referer', 'related', 'text', 'url'];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      url_param = ref[j];
	      if (this.props[url_param]) {
	        if (url_param === 'url') {
	          this.props[url_param] = encodeURI(this.props[url_param]);
	        }
	        url += "&" + url_param + "=" + this.props[url_param];
	      }
	    }
	    return IFRAME({
	      src: url,
	      scrolling: "no",
	      frameBorder: "0",
	      allowTransparency: "true",
	      className: "twitter-share-button twitter-tweet-button twitter-share-button twitter-count-none",
	      style: {
	        width: 80,
	        height: 28
	      }
	    });
	  }
	});
	
	window.getCoords = function(el) {
	  var docEl, offset, rect;
	  rect = el.getBoundingClientRect();
	  docEl = document.documentElement;
	  offset = {
	    top: rect.top + window.pageYOffset - docEl.clientTop,
	    left: rect.left + window.pageXOffset - docEl.clientLeft
	  };
	  return _.extend(offset, {
	    cx: offset.left + rect.width / 2,
	    cy: offset.top + rect.height / 2,
	    right: offset.left + rect.width,
	    bottom: offset.top + rect.height
	  });
	};
	
	window.asset = function(name) {
	  var a, app;
	  app = fetch('/application');
	  if (app.asset_host != null) {
	    a = (app.asset_host || '') + "/images/" + name;
	  } else {
	    a = (window.asset_host || '') + "/images/" + name;
	  }
	  return a;
	};
	
	window.opinionsForProposal = function(proposal) {
	  var opinions;
	  opinions = fetch(proposal).opinions || [];
	  return opinions;
	};
	
	window.get_all_clusters = function() {
	  var all_clusters, config, k, p, proposals, ref, subdomain, subdomain_name, v;
	  proposals = fetch('/proposals');
	  all_clusters = (function() {
	    var j, len1, ref, results;
	    ref = proposals.proposals;
	    results = [];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      p = ref[j];
	      results.push((p.cluster || 'Proposals').trim());
	    }
	    return results;
	  })();
	  subdomain = fetch('/subdomain');
	  subdomain_name = (ref = subdomain.name) != null ? ref.toLowerCase() : void 0;
	  config = customizations[subdomain_name];
	  for (k in config) {
	    v = config[k];
	    if (k.match(/list\//)) {
	      all_clusters.push(k.substring(5));
	    }
	  }
	  all_clusters = _.uniq(all_clusters);
	  return all_clusters;
	};
	
	newest_in_cluster_on_load = {};
	
	window.clustered_proposals = function(keep_as_map) {
	  var all_clusters, cluster, clusters, homepage_list_order, j, len1, len2, len3, m, n, ordered_clusters, proposal, proposals, ref, ref1, sort, time;
	  proposals = fetch('/proposals');
	  homepage_list_order = customization('homepage_list_order');
	  clusters = {};
	  all_clusters = get_all_clusters();
	  if (Object.keys(newest_in_cluster_on_load).length === 0) {
	    ref = proposals.proposals;
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      proposal = ref[j];
	      cluster = (proposal.cluster || 'Proposals').trim();
	      time = new Date(proposal.created_at).getTime();
	      if (!newest_in_cluster_on_load[cluster] || time > newest_in_cluster_on_load[cluster]) {
	        newest_in_cluster_on_load[cluster] = time;
	      }
	    }
	  }
	  for (m = 0, len2 = all_clusters.length; m < len2; m++) {
	    cluster = all_clusters[m];
	    sort = homepage_list_order.indexOf(cluster);
	    if (sort < 0) {
	      if (newest_in_cluster_on_load[cluster]) {
	        sort = homepage_list_order.length + ((new Date()).getTime() - newest_in_cluster_on_load[cluster]);
	      } else {
	        sort = 9999999999999;
	      }
	    }
	    clusters[cluster] = {
	      key: "list/" + cluster,
	      name: cluster,
	      proposals: [],
	      list_is_archived: customization('list_is_archived', "list/" + cluster),
	      sort_order: sort
	    };
	  }
	  ref1 = proposals.proposals;
	  for (n = 0, len3 = ref1.length; n < len3; n++) {
	    proposal = ref1[n];
	    cluster = (proposal.cluster || 'Proposals').trim();
	    clusters[cluster].proposals.push(proposal);
	  }
	  if (keep_as_map) {
	    return clusters;
	  }
	  ordered_clusters = _.values(clusters);
	  ordered_clusters.sort(function(a, b) {
	    return a.sort_order - b.sort_order;
	  });
	  return ordered_clusters;
	};
	
	window.clustered_proposals_with_tabs = function(current_filter) {
	  var all_clusters, cclusters, cluster, cluster_key, clusters, fails_filter, filter, filters, homepage_tabs, in_others, index, j, k, len1, len2, m, ref, ref1, ref2, ref3, ref4, to_remove, v;
	  all_clusters = clustered_proposals();
	  homepage_tabs = fetch('homepage_tabs');
	  clusters = null;
	  if (!current_filter || !customization('homepage_tabs')) {
	    current_filter = homepage_tabs.filter;
	    clusters = homepage_tabs.clusters;
	  } else {
	    filters = (function() {
	      var ref, results;
	      ref = customization('homepage_tabs');
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        results.push([k, v]);
	      }
	      return results;
	    })();
	    for (j = 0, len1 = filters.length; j < len1; j++) {
	      ref = filters[j], filter = ref[0], cclusters = ref[1];
	      if (filter === current_filter) {
	        clusters = cclusters;
	        break;
	      }
	    }
	  }
	  if (!clusters) {
	    console.error("No clusters found for " + current_filter);
	  }
	  if (current_filter && current_filter !== 'Show all') {
	    to_remove = [];
	    ref1 = all_clusters || [];
	    for (index = m = 0, len2 = ref1.length; m < len2; index = ++m) {
	      cluster = ref1[index];
	      cluster_key = "list/" + cluster.name;
	      fails_filter = current_filter && (clusters !== '*' && !(ref2 = cluster.name, indexOf.call(clusters || [], ref2) >= 0));
	      if (fails_filter && (indexOf.call(clusters || [], '*') >= 0)) {
	        in_others = [];
	        ref3 = customization('homepage_tabs');
	        for (filter in ref3) {
	          cclusters = ref3[filter];
	          in_others = in_others.concat(cclusters);
	        }
	        fails_filter && (fails_filter = (ref4 = cluster.name, indexOf.call(in_others, ref4) >= 0));
	      }
	      if (fails_filter) {
	        to_remove.push(cluster);
	      }
	    }
	    all_clusters = _.difference(all_clusters, to_remove);
	  }
	  return all_clusters;
	};
	
	window.namespaced_key = function(base_key, base_object) {
	  var namespace_key;
	  namespace_key = fetch(base_object).key;
	  if (namespace_key[0] === '/') {
	    namespace_key = namespace_key.substring(1, namespace_key.length);
	  }
	  return namespace_key + "_" + base_key;
	};
	
	window.proposal_url = function(proposal, prefer_crafting_page) {
	  var result, subdomain;
	  proposal = fetch(proposal);
	  result = '/' + proposal.slug;
	  subdomain = fetch('/subdomain');
	  if (TWO_COL() || !proposal.active || (!customization('show_crafting_page_first', proposal) && !prefer_crafting_page) || !customization('discussion_enabled', proposal)) {
	    result += '?results=true';
	  }
	  return result;
	};
	
	window.isNeutralOpinion = function(stance) {
	  return Math.abs(stance) < 0.05;
	};
	
	window.on_ajax_error = function() {
	  var root;
	  (root = fetch('root')).server_error = true;
	  return save(root);
	};
	
	window.on_client_error = function(e) {
	  if (navigator.userAgent.indexOf('PhantomJS') >= 0) {
	    return;
	  }
	  return save({
	    key: '/new/client_error',
	    stack: e.stack,
	    message: e.message || e.description,
	    name: e.name,
	    line_number: e.lineNumber,
	    column_number: e.columnNumber
	  });
	};
	
	logs_to_write = [];
	
	log_writer = null;
	
	window.writeToLog = function(entry) {
	  entry.where = fetch('location').url;
	  logs_to_write.push(entry);
	  if (!log_writer) {
	    return setTimeout(function() {
	      return log_writer = setInterval(function() {
	        var j, len1, log;
	        for (j = 0, len1 = logs_to_write.length; j < len1; j++) {
	          log = logs_to_write[j];
	          log.key = '/new/log';
	          save(log);
	        }
	        return logs_to_write = [];
	      }, 100);
	    }, 2000);
	  }
	};
	
	window.prettyDate = function(time) {
	  var date, day_diff, diff, r, subdomain;
	  subdomain = fetch('/subdomain');
	  date = new Date(time);
	  diff = ((new Date()).getTime() - date.getTime()) / 1000;
	  day_diff = Math.floor(diff / 86400);
	  if (isNaN(day_diff) || day_diff < 0) {
	    return;
	  }
	  if (subdomain.lang !== 'en') {
	    return (date.getMonth() + 1) + "/" + (date.getDay() + 1) + "/" + (date.getFullYear());
	  }
	  r = day_diff === 0 && (diff < 60 && "just now" || diff < 120 && "1 minute ago" || diff < 3600 && Math.floor(diff / 60) + " minutes ago" || diff < 7200 && "1 hour ago" || diff < 86400 && Math.floor(diff / 3600) + " hours ago") || day_diff === 1 && "Yesterday" || day_diff < 7 && day_diff + " days ago" || day_diff < 31 && Math.ceil(day_diff / 7) + " weeks ago" || ((date.getMonth() + 1) + "/" + (date.getDay() + 1) + "/" + (date.getFullYear()));
	  r = r.replace('1 days ago', '1 day ago').replace('1 weeks ago', '1 week ago').replace('1 years ago', '1 year ago');
	  return r;
	};
	
	window.shorten = function(str, max_length) {
	  max_length || (max_length = 70);
	  return "" + (str.substring(0, max_length)) + (str.length > max_length ? '...' : '');
	};
	
	window.inRange = function(val, min, max) {
	  return val <= max && val >= min;
	};
	
	window.capitalize = function(string) {
	  return string.charAt(0).toUpperCase() + string.substring(1);
	};
	
	window.capitalize_each_word = function(str) {
	  return str.replace(/\b\w/g, function(l) {
	    return l.toUpperCase();
	  });
	};
	
	window.loading_indicator = DIV({
	  className: 'loading sk-wave',
	  dangerouslySetInnerHTML: {
	    __html: "<div class=\"sk-rect sk-rect1\"></div>\n<div class=\"sk-rect sk-rect2\"></div>\n<div class=\"sk-rect sk-rect3\"></div>\n<div class=\"sk-rect sk-rect4\"></div>\n<div class=\"sk-rect sk-rect5\"></div>"
	  }
	});
	
	window.LOADING_INDICATOR = window.loading_indicator;
	
	styles += ".sk-wave {\n  margin: 40px auto;\n  width: 50px;\n  height: 40px;\n  text-align: center;\n  font-size: 10px; }\n  .sk-wave .sk-rect {\n    background-color: rgba(223, 98, 100, .5);\n    height: 100%;\n    width: 6px;\n    display: inline-block;\n    -webkit-animation: sk-waveStretchDelay 1.2s infinite ease-in-out;\n            animation: sk-waveStretchDelay 1.2s infinite ease-in-out; }\n  .sk-wave .sk-rect1 {\n    -webkit-animation-delay: -1.2s;\n            animation-delay: -1.2s; }\n  .sk-wave .sk-rect2 {\n    -webkit-animation-delay: -1.1s;\n            animation-delay: -1.1s; }\n  .sk-wave .sk-rect3 {\n    -webkit-animation-delay: -1s;\n            animation-delay: -1s; }\n  .sk-wave .sk-rect4 {\n    -webkit-animation-delay: -0.9s;\n            animation-delay: -0.9s; }\n  .sk-wave .sk-rect5 {\n    -webkit-animation-delay: -0.8s;\n            animation-delay: -0.8s; }\n\n@-webkit-keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n            transform: scaleY(0.4); }\n  20% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1); } }\n\n@keyframes sk-waveStretchDelay {\n  0%, 40%, 100% {\n    -webkit-transform: scaleY(0.4);\n            transform: scaleY(0.4); }\n  20% {\n    -webkit-transform: scaleY(1);\n            transform: scaleY(1); } }";
	
	window.shared_local_key = function(key_or_object) {
	  var key;
	  key = key_or_object.key || key_or_object;
	  if (key[0] === '/') {
	    key = key.substring(1, key.length);
	    return key + "/shared";
	  } else {
	    return key;
	  }
	};
	
	window.reset_key = function(obj_or_key, updates) {
	  var k, v;
	  updates = updates || {};
	  if (!obj_or_key.key) {
	    obj_or_key = fetch(obj_or_key);
	  }
	  for (k in obj_or_key) {
	    if (!hasProp.call(obj_or_key, k)) continue;
	    v = obj_or_key[k];
	    if (k !== 'key') {
	      delete obj_or_key[k];
	    }
	  }
	  _.extend(obj_or_key, updates);
	  return save(obj_or_key);
	};
	
	window.safe_string = function(user_content) {
	  var hyperlink_pattern;
	  user_content = user_content.replace(/(<li>|<br\s?\/?>|<p>)/g, '\n');
	  user_content = user_content.replace(/(<([^>]+)>)/ig, "");
	  hyperlink_pattern = /(^|[\s\n])((?:https?):\/\/[\-A-Z0-9+\u0026\u2019@#\/%?=()\[\]\-\$&\*~_|!:,.;']*[\-A-Z0-9+\u0026@#\/%=~()_|])/gi;
	  user_content = user_content.replace(hyperlink_pattern, "$1(*-&)link:$2(*-&)");
	  return user_content;
	};
	
	window.splitParagraphs = function(user_content, append) {
	  var idx, j, len1, para, paragraphs, pidx, results, text;
	  if (!user_content) {
	    return SPAN(null);
	  }
	  user_content = safe_string(user_content);
	  paragraphs = user_content.split(/(?:\r?\n)/g);
	  results = [];
	  for (pidx = j = 0, len1 = paragraphs.length; j < len1; pidx = ++j) {
	    para = paragraphs[pidx];
	    results.push(P({
	      key: "para-" + pidx
	    }, (function() {
	      var len2, m, ref, results1;
	      ref = para.split('(*-&)');
	      results1 = [];
	      for (idx = m = 0, len2 = ref.length; m < len2; idx = ++m) {
	        text = ref[idx];
	        if (text.substring(0, 5) === 'link:') {
	          results1.push(A({
	            key: idx,
	            href: text.substring(5, text.length),
	            target: '_blank'
	          }, text.substring(5, text.length)));
	        } else {
	          results1.push(SPAN({
	            key: idx
	          }, text));
	        }
	      }
	      return results1;
	    })(), append && pidx === paragraphs.length - 1 ? append : void 0));
	  }
	  return results;
	};
	
	width_cache = {};
	
	window.widthWhenRendered = function(str, style) {
	  var $el, key, width;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in width_cache)) {
	    _.defaults(style, {
	      display: 'inline-block'
	    });
	    $el = $("<span id='width_test'><span>" + str + "</span></span>").css(style);
	    $('#content').append($el);
	    width = $('#width_test span').width();
	    $('#width_test').remove();
	    width_cache[key] = width;
	  }
	  return width_cache[key];
	};
	
	height_cache = {};
	
	window.heightWhenRendered = function(str, style) {
	  var $el, height, key;
	  key = JSON.stringify(_.extend({
	    str: str
	  }, style));
	  if (!(key in height_cache)) {
	    $el = $("<div id='height_test'>" + str + "</div>").css(style);
	    $('#content').append($el);
	    height = $('#height_test').height();
	    $('#height_test').remove();
	    height_cache[key] = height;
	  }
	  return height_cache[key];
	};
	
	size_cache = {};
	
	window.sizeWhenRendered = function(str, style) {
	  var h, k, key, main, test, v, w;
	  main = document.getElementById('content');
	  if (!main) {
	    return {
	      width: 0,
	      height: 0
	    };
	  }
	  style || (style = {});
	  style.str = str;
	  key = JSON.stringify(style);
	  delete style.str;
	  if (!(key in size_cache)) {
	    style.display || (style.display = 'inline-block');
	    test = document.createElement("div");
	    test.innerHTML = "<div>" + str + "</div>";
	    for (k in style) {
	      v = style[k];
	      key = k.replace(/([A-Z])/g, '-$1').toLowerCase();
	      if (key === 'font-size' || key === 'max-width' || key === 'max-height') {
	        test.style[key] = v + "px";
	      } else {
	        test.style[key] = v;
	      }
	    }
	    main.appendChild(test);
	    h = test.offsetHeight;
	    w = test.offsetWidth;
	    main.removeChild(test);
	    size_cache[key] = {
	      width: w,
	      height: h
	    };
	  }
	  return size_cache[key];
	};
	
	window.translateStanceToPixelX = function(stance, width) {
	  return (stance + 1) / 2 * width;
	};
	
	window.translatePixelXToStance = function(pixel_x, width) {
	  return 2 * (pixel_x / width) - 1;
	};
	
	window.closest = function(node, check) {
	  if (!node || node === document) {
	    return false;
	  } else {
	    return check(node) || closest(node.parentNode, check);
	  }
	};
	
	window.location_origin = function() {
	  if (!window.location.origin) {
	    return window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
	  } else {
	    return window.location.origin;
	  }
	};
	
	window.parseURL = function(url) {
	  var i, parser, pathname, queries, searchObject, split;
	  parser = document.createElement('a');
	  parser.href = url;
	  pathname = parser.pathname || '/';
	  if (pathname[0] !== '/') {
	    pathname = "/" + pathname;
	  }
	  searchObject = {};
	  queries = parser.search.replace(/^\?/, '').split('&');
	  i = 0;
	  while (i < queries.length) {
	    if (queries[i].length > 0) {
	      split = queries[i].split('=');
	      searchObject[split[0]] = split[1];
	    }
	    i++;
	  }
	  return {
	    protocol: parser.protocol,
	    host: parser.host,
	    hostname: parser.hostname,
	    port: parser.port,
	    pathname: pathname,
	    search: parser.search,
	    searchObject: searchObject,
	    hash: parser.hash
	  };
	};
	
	window.css = {};
	
	css_as_str = function(attrs) {
	  return _.keys(attrs).map(function(p) {
	    return p + ": " + attrs[p];
	  }).join(';') + ';';
	};
	
	css.crossbrowserify = function(props, as_str) {
	  var j, len1, len2, len3, len4, len5, len6, m, n, o, prefix, prefixes, q, s;
	  if (as_str == null) {
	    as_str = false;
	  }
	  prefixes = ['-webkit-', '-ms-', '-mox-', '-o-'];
	  if (props.transform) {
	    for (j = 0, len1 = prefixes.length; j < len1; j++) {
	      prefix = prefixes[j];
	      props[prefix + "transform"] = props.transform;
	    }
	  }
	  if (props.transformOrigin) {
	    for (m = 0, len2 = prefixes.length; m < len2; m++) {
	      prefix = prefixes[m];
	      props[prefix + "transform-origin"] = props.transform;
	    }
	  }
	  if (props.flex) {
	    for (n = 0, len3 = prefixes.length; n < len3; n++) {
	      prefix = prefixes[n];
	      props[prefix + "flex"] = props.flex;
	    }
	  }
	  if (props.flexDirection) {
	    for (o = 0, len4 = prefixes.length; o < len4; o++) {
	      prefix = prefixes[o];
	      props[prefix + "flex-direction"] = props.flexDirection;
	    }
	  }
	  if (props.justifyContent) {
	    for (q = 0, len5 = prefixes.length; q < len5; q++) {
	      prefix = prefixes[q];
	      props[prefix + "justify-content"] = props.justifyContent;
	    }
	  }
	  if (props.display === 'flex') {
	    props.display = 'display: table-cell; -webkit-box; display: -moz-box; display: -ms-flexbox; display: -webkit-flex; display: flex';
	  }
	  if (props.transition) {
	    for (s = 0, len6 = prefixes.length; s < len6; s++) {
	      prefix = prefixes[s];
	      props[prefix + "transition"] = props.transition.replace("transform", prefix + "transform");
	    }
	  }
	  if (props.userSelect) {
	    _.extend(props, {
	      MozUserSelect: props.userSelect,
	      WebkitUserSelect: props.userSelect,
	      msUserSelect: props.userSelect
	    });
	  }
	  if (as_str) {
	    return css_as_str(props);
	  } else {
	    return props;
	  }
	};
	
	css.grayscale = function(props) {
	  if (browser.is_mobile) {
	    console.log("CAUTION: grayscale filter on mobile can cause crashes");
	  }
	  _.extend(props, {
	    WebkitFilter: 'grayscale(100%)',
	    filter: 'grayscale(100%)'
	  });
	  return props;
	};
	
	css.grab_cursor = function(selector) {
	  return selector + " {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n} " + selector + ":active {\n  cursor: move;\n  cursor: ew-resize;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n}";
	};
	
	window.cssTriangle = function(direction, color, width, height, style) {
	  var border_color, border_width;
	  style = style || {};
	  switch (direction) {
	    case 'top':
	      border_width = "0 " + (width / 2) + "px " + height + "px " + (width / 2) + "px";
	      border_color = "transparent transparent " + color + " transparent";
	      break;
	    case 'bottom':
	      border_width = height + "px " + (width / 2) + "px 0 " + (width / 2) + "px";
	      border_color = color + " transparent transparent transparent";
	      break;
	    case 'left':
	      border_width = (height / 2) + "px " + width + "px " + (height / 2) + "px 0";
	      border_color = "transparent " + color + " transparent transparent";
	      break;
	    case 'right':
	      border_width = (height / 2) + "px 0 " + (height / 2) + "px " + width + "px";
	      border_color = "transparent transparent transparent " + color;
	  }
	  _.defaults(style, {
	    width: 0,
	    height: 0,
	    borderStyle: 'solid',
	    borderWidth: border_width,
	    borderColor: border_color
	  });
	  return style;
	};
	
	window.slugify = function(text) {
	  var slug;
	  slug = text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^a-zA-Z0-9_\u3400-\u9FBF\s-]/g, '').replace(/\-\-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
	  if ((text != null ? text.length : void 0) > 0 && (slug != null ? slug.length : void 0) === 0) {
	    slug = md5(text);
	  }
	  return slug;
	};
	
	focus_shadow = 'inset 0 0 2px rgba(0,0,0,.3), 0 0 2px rgba(0,0,0,.3)';
	
	window.styles += "/* RESET\n * Eric Meyer's Reset CSS v2.0 (http://meyerweb.com/eric/tools/css/reset/)\n * http://cssreset.com\n */\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  line-height: 1.4; }\n\n\n#content .fa {\n  font-family: FontAwesome;  \n}\n\nbody, html {\n  height: 100%;\n}\nbutton {\n  line-height: 1.4;\n}\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #cccccc;\n  margin: 0;\n  padding: 0; }\n\nbody {\n  min-height: 100%; }\n\nol, ul {\n  list-style: none;\n  list-style-position: inside; }\n\nblockquote, q {\n  quotes: none; }\n\nblockquote:before, blockquote:after,\nq:before, q:after {\n  content: '';\n  content: none; }\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\n\ntd, th {vertical-align: top;}\n\nh1, h2, h3, h4, h5, h6, strong {\n  font-weight: bold; }\n\nem, i {\n  font-style: italic; }\n\nb, strong { font-weight: bold; }\n\n/* ELEMENT DEFAULTS */\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box; }\n\na {\n  color: inherit;\n  cursor: pointer;\n  text-decoration: none; }\n  a:focus {\n  }\n  a:active {\n  }  \n  a img {\n    border: none; }\n\n:focus {\n}\n.button, button, input[type='submit'] {\n  cursor: pointer;\n  text-align: center; \n  font-size: inherit;\n} .button:focus, button:focus, input[type='submit']:focus {\n} .button:active:focus, button:active:focus, input[type='submit']:active:focus{\n}\n\n\ntable {\n  border-collapse: separate; }\n\nul {\n  margin: 0;\n  list-style-type: disc; }\n\nol {\n  margin: 0;\n  list-style-type: decimal; }\n\nblockquote {\n  quotes: '\"' '\"' \"'\" \"'\"; }\n  blockquote:before {\n    content: open-quote;}\n  blockquote:after {\n    content: close-quote;}\n";
	
	window.styles += "\nbody, h1, h2, h3, h4, h5, h6 {\n  color: black; }\n\nhtml[lang='cs'] body, html[lang='cs'] input, html[lang='cs'] button, html[lang='cs'] textarea {\n  font-family: Helvetica, Verdana, Arial, 'Lucida Grande', 'Lucida Sans Unicode', sans-serif; }\n\n\n.hidden {\n  position:absolute;\n  left:-10000px;\n  top:auto;\n  width:1px;\n  height:1px;\n  overflow:hidden;}\n\na.skip:active, \na.skip:focus, \na.skip:hover {\n    position: fixed;\n    left: 0; \n    top: 0;\n    width: auto; \n    height: auto; \n    overflow: visible; \n}\n\n\n.content {\n  position: relative;\n  font-size: 16px;\n  color: black;\n  min-height: 100%; }\n\n\n.flipped {\n  -moz-transform: scaleX(-1);\n  -o-transform: scaleX(-1);\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: 'FlipH'; }\n\n.primary_button, .primary_cancel_button {\n  border-radius: 16px;\n  text-align: center;\n  padding: 3px;\n  cursor: pointer; }\n\n.primary_button {\n  color: white;\n  font-size: 29px;\n  margin-top: 14px;\n  box-shadow: 0px 1px 0px black;\n  border: none;\n  padding: 8px 36px; }\n\n.primary_button.disabled {\n  background-color: #eeeeee;\n  color: #cccccc;\n  box-shadow: none;\n  border: none;\n  cursor: wait; }\n\n.primary_cancel_button {\n  color: #888888;\n  margin-top: 0.5em; }\n\n.cancel_opinion_button {\n  float: right;\n  background: transparent;\n  border: none;\n  margin-top: 0.5em; }\n\nbutton.primary_button, input[type='submit'] {\n  display: inline-block; }\n\nselect.unstyled:not([multiple]){\n    -webkit-appearance:none;\n    -moz-appearance:none;\n    background-position:right 50%;\n    background-repeat:no-repeat;\n    background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAMCAYAAABSgIzaAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDZFNDEwNjlGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDZFNDEwNkFGNzFEMTFFMkJEQ0VDRTM1N0RCMzMyMkIiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0NkU0MTA2N0Y3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0NkU0MTA2OEY3MUQxMUUyQkRDRUNFMzU3REIzMzIyQiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PuGsgwQAAAA5SURBVHjaYvz//z8DOYCJgUxAf42MQIzTk0D/M+KzkRGPoQSdykiKJrBGpOhgJFYTWNEIiEeAAAMAzNENEOH+do8AAAAASUVORK5CYII=);\n    padding: .5em;\n    padding-right:1.5em;\n    border-radius: 16px;\n}\n";


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var __convert, convert_customization, customizations_by_file, i, j, len, len1, masthead_only, sub, text_and_masthead;
	
	window.customizations = {};
	
	customizations_by_file = {};
	
	window.db_customization_loaded = {};
	
	window._ = _;
	
	window.FUNCTION_IDENTIFIER = "#javascript\n";
	
	convert_customization = function(obj) {
	  return __convert(obj, []);
	};
	
	__convert = function(obj, path) {
	  var func, k, p, str_func, tree, v, vv;
	  if (Array.isArray(obj)) {
	    return (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = obj.length; i < len; i++) {
	        vv = obj[i];
	        results.push(__convert(vv, path));
	      }
	      return results;
	    })();
	  } else if (typeof obj === 'object') {
	    tree = {};
	    for (k in obj) {
	      v = obj[k];
	      p = path.slice();
	      p.push(k);
	      tree[k] = __convert(v, p);
	    }
	    return tree;
	  } else if (typeof obj === 'function') {
	    return "" + FUNCTION_IDENTIFIER + (obj.toString());
	  } else if (typeof obj === 'string' && obj.startsWith(FUNCTION_IDENTIFIER)) {
	    str_func = obj.substring(FUNCTION_IDENTIFIER.length);
	    func = new Function("return " + str_func)();
	    return func;
	  } else {
	    return obj;
	  }
	};
	
	window.load_customization = function(subdomain) {
	  var customizations_file_used, error, ref, stringified, subdomain_name;
	  if (!subdomain.name) {
	    return;
	  }
	  subdomain_name = (ref = subdomain.name) != null ? ref.toLowerCase() : void 0;
	  try {
	    customizations_file_used = !!customizations_by_file[subdomain_name];
	    if (customizations_file_used) {
	      console.log(subdomain_name + " config for import: \n", JSON.stringify(convert_customization(customizations_by_file[subdomain_name]), null, 2));
	    }
	    if (subdomain.customization_obj) {
	      new Function(subdomain.customization_obj)();
	      stringified = convert_customization(window.customization_obj);
	      if (fetch('/current_user').is_super_admin) {
	        subdomain.customizations = JSON.stringify(stringified, null, 2);
	        save(subdomain);
	      }
	    } else {
	      subdomain = fetch('/subdomain');
	      stringified = JSON.parse(subdomain.customizations);
	    }
	    customizations[subdomain_name] = _.extend({}, customizations_by_file[subdomain_name] || {}, convert_customization(stringified));
	    return db_customization_loaded[subdomain_name] = true;
	  } catch (error1) {
	    error = error1;
	    return console.error(error);
	  }
	};
	
	window.customization = function(field, object_or_key) {
	  var chain_of_configs, cluster_key, config, i, key, len, obj, proposal, ref, ref1, subdomain, subdomain_config, subdomain_name, value;
	  if (!!object_or_key && (object_or_key.key == null)) {
	    obj = fetch(object_or_key);
	  } else {
	    obj = object_or_key;
	  }
	  if (obj && obj.subdomain_id && ("" + obj.subdomain_id) !== ((ref = document.querySelector("meta[name='forum']")) != null ? ref.getAttribute("content") : void 0)) {
	    subdomain = fetch("/subdomain/" + obj.subdomain_id);
	  } else {
	    subdomain = fetch('/subdomain');
	  }
	  subdomain_name = (ref1 = subdomain.name) != null ? ref1.toLowerCase() : void 0;
	  if (!db_customization_loaded[subdomain_name]) {
	    load_customization(subdomain);
	  }
	  key = obj ? obj.key ? obj.key : obj : null;
	  chain_of_configs = [];
	  if (customizations[subdomain_name] != null) {
	    subdomain_config = customizations[subdomain_name];
	    if (key) {
	      if (subdomain_config[key] != null) {
	        chain_of_configs.push(subdomain_config[key]);
	      }
	      if (key.match(/\/proposal\//)) {
	        proposal = obj;
	        cluster_key = "list/" + proposal.cluster;
	        if (subdomain_config[cluster_key] != null) {
	          chain_of_configs.push(subdomain_config[cluster_key]);
	        }
	      }
	    }
	    chain_of_configs.push(subdomain_config);
	  }
	  chain_of_configs.push(customizations['default']);
	  value = void 0;
	  for (i = 0, len = chain_of_configs.length; i < len; i++) {
	    config = chain_of_configs[i];
	    value = config[field];
	    if (value != null) {
	      break;
	    }
	  }
	  return value;
	};
	
	__webpack_require__(10);
	
	__webpack_require__(8);
	
	__webpack_require__(4);
	
	__webpack_require__(1);
	
	__webpack_require__(21);
	
	__webpack_require__(9);
	
	__webpack_require__(23);
	
	__webpack_require__(14);
	
	__webpack_require__(20);
	
	customizations["default"] = {
	  point_labels: point_labels.pro_con,
	  slider_pole_labels: slider_labels.agree_disagree,
	  list_opinions_title: 'Opinions',
	  discussion_enabled: true,
	  homepage_show_search_and_sort: true,
	  list_show_new_button: true,
	  homepage_show_new_proposal_button: true,
	  homepage_default_sort_order: 'trending',
	  show_crafting_page_first: false,
	  show_histogram_on_crafting: true,
	  show_proposal_meta_data: true,
	  slider_handle: slider_handle.face,
	  slider_regions: null,
	  show_proposal_scores: true,
	  show_proposer_icon: true,
	  collapse_proposal_description_at: 300,
	  list_is_archived: false,
	  list_uncollapseable: false,
	  auth_footer: false,
	  auth_require_pledge: false,
	  has_homepage: true,
	  homepage_list_order: [],
	  font: "'Avenir Next W01', 'Avenir Next', 'Lucida Grande', 'Lucida Sans Unicode', 'Helvetica Neue', Helvetica, Verdana, sans-serif",
	  auth_questions: [],
	  SiteHeader: ShortHeader,
	  SiteFooter: DefaultFooter,
	  new_proposal_fields: function() {
	    return {
	      name: translator("engage.edit_proposal.summary_label", "Summary"),
	      description: translator("engage.edit_proposal.description_label", "Details") + (" (" + (translator('optional')) + ")"),
	      additional_fields: [],
	      create_description: function(fields) {
	        return fields.description;
	      }
	    };
	  }
	};
	
	text_and_masthead = ['educacion2025', 'ynpn', 'lsfyl', 'kealaiwikuamoo', 'iwikuamoo'];
	
	masthead_only = ["kamakakoi", "seattletimes", "kevin", "ihub", "SilverLakeNC", "Relief-Demo", "GS-Demo", "ri", "ITFeedback", "Committee-Meeting", "policyninja", "SocialSecurityWorks", "amberoon", "economist", "impacthub-demo", "mos", "Cattaca", "Airbdsm", "bitcoin-ukraine", "lyftoff", "hcao", "arlingtoncountyfair", "progressive", "design", "crm", "safenetwork", "librofm", "washingtonpost", "MSNBC", "PublicForum", "AMA-RFS", "AmySchumer", "VillaGB", "AwesomeHenri", "citySENS", "alcala", "MovilidadCDMX", "deus_ex", "neuwrite", "bitesizebio", "HowScienceIsMade", "SABF", "engagedpublic", "sabfteam", "Tunisia", "theartofco", "SGU", "radiolab", "ThisLand", "Actuality"];
	
	for (i = 0, len = text_and_masthead.length; i < len; i++) {
	  sub = text_and_masthead[i];
	  customizations_by_file[sub.toLowerCase()] = {
	    HomepageHeader: LegacyImageHeader
	  };
	}
	
	for (j = 0, len1 = masthead_only.length; j < len1; j++) {
	  sub = masthead_only[j];
	  customizations_by_file[sub.toLowerCase()] = {
	    HomepageHeader: LegacyImageHeader
	  };
	}


/***/ },
/* 3 */
/***/ function(module, exports) {

	var is_android_browser, rxaosp,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	rxaosp = window.navigator.userAgent.match(/Android.*AppleWebKit\/([\d.]+)/);
	
	is_android_browser = !!(rxaosp && rxaosp[1] < 537);
	
	window.browser = {
	  key: 'browser',
	  is_android_browser: is_android_browser,
	  is_opera_mini: !!navigator.userAgent.match(/Opera Mini/),
	  is_ie9: !!(document.documentMode && document.documentMode === 9),
	  is_iOS: !!navigator.platform.match(/(iPad|iPhone)/),
	  touch_enabled: indexOf.call(document, 'ontouchend') >= 0,
	  high_density_display: (window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), \nonly screen and (min-resolution: 1.3dppx), \nonly screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), \nonly screen and (-o-min-device-pixel-ratio: 2.6/2), \nonly screen and (min--moz-device-pixel-ratio: 1.3), \nonly screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3),
	  is_mobile: is_android_browser || navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)
	};
	
	save(browser);
	
	window.BrowserHacks = ReactiveComponent({
	  displayName: 'BrowserHacks',
	  render: function() {
	    var browser;
	    browser = fetch('browser');
	    if (browser.is_opera_mini) {
	      return DIV({
	        style: {
	          backgroundColor: 'red',
	          padding: 10,
	          textAlign: 'center',
	          color: 'white',
	          fontSize: 24
	        }
	      }, "This website does not work well with ", browser.is_android_browser ? 'the Android Browser' : 'Opera Mini', ". Please use ", A({
	        href: "https://play.google.com/store/apps/details?id=com.android.chrome&hl=en",
	        style: {
	          color: 'white',
	          textDecoration: 'underline'
	        }
	      }, 'Chrome for Android'), ' if you experience difficulty. Thanks, and sorry for the inconvenience!');
	    } else {
	      return SCRIPT({
	        type: 'text/javascript',
	        src: '//browser-update.org/update.js'
	      });
	    }
	  }
	});


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	var addEventListener, location, old_A, popstate_event, ref, relativeURLFromLocation, relativeURLFromStatebus,
	  hasProp = {}.hasOwnProperty;
	
	__webpack_require__(1);
	
	__webpack_require__(3);
	
	window.loadPage = function(url, query_params) {
	  var hash, k, loc, ref, url_parts, v;
	  loc = fetch('location');
	  loc.query_params = query_params || {};
	  url_parts = parseURL("" + (location_origin()) + url);
	  ref = url_parts.searchObject;
	  for (k in ref) {
	    v = ref[k];
	    if (k.length > 0) {
	      loc.query_params[k] = v;
	    }
	  }
	  loc.query_params = url_parts.searchObject;
	  if (loc.query_params.u) {
	    delete loc.query_params.u;
	  }
	  if (loc.query_params.t) {
	    delete loc.query_params.t;
	  }
	  hash = url_parts.hash;
	  if (hash && hash.length > 0) {
	    hash = hash.substring(1);
	    loc.seek_to_hash = hash;
	  }
	  loc.url = decodeURI(url_parts.pathname);
	  loc.hash = hash;
	  return save(loc);
	};
	
	old_A = A;
	
	window.A = React.createClass({
	  render: function() {
	    var props;
	    props = this.props;
	    if (this.props.href) {
	      this._onclick = this.props.onClick || (function() {
	        return null;
	      });
	      if (browser.is_mobile) {
	        this.props.onTouchEnd = (function(_this) {
	          return function(e) {
	            if (!is_swipping) {
	              return _this.handleClick(e);
	            }
	          };
	        })(this);
	        if (browser.is_android_browser) {
	          this.props.onClick = function(e) {
	            e.preventDefault();
	            return e.stopPropagation();
	          };
	        }
	      } else {
	        this.props.onClick = this.handleClick;
	      }
	    }
	    return old_A(props, props.children);
	  },
	  handleClick: function(event) {
	    var href, is_external_link, is_mailto, node, opened_in_new_tab;
	    node = this.getDOMNode();
	    href = node.getAttribute('href');
	    is_external_link = href.indexOf('//') > -1 || this.props.treat_as_external_link;
	    is_mailto = href.toLowerCase().indexOf('mailto') > -1;
	    opened_in_new_tab = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
	    if (!is_external_link && !opened_in_new_tab && !is_mailto && !node.getAttribute('data-nojax')) {
	      event.preventDefault();
	      event.stopPropagation();
	      loadPage(href);
	      this._onclick(event);
	      if (!this.getDOMNode().getAttribute('data-no-scroll')) {
	        window.scrollTo(0, 0);
	      }
	      return false;
	    } else {
	      return this._onclick(event);
	    }
	  }
	});
	
	window.BrowserLocation = ReactiveComponent({
	  displayName: 'BrowserLocation',
	  render: function() {
	    var doc, loc, new_location, title;
	    loc = fetch('location');
	    doc = fetch('document');
	    title = doc.title || document.title;
	    if (doc.title && document.title !== doc.title) {
	      document.title = doc.title;
	    }
	    new_location = relativeURLFromStatebus();
	    if (this.last_location !== new_location) {
	      if (relativeURLFromLocation() !== new_location) {
	        history.pushState(loc.query_params, title, new_location);
	      }
	      this.last_location = new_location;
	      writeToLog({
	        what: 'changing url',
	        where: loc.url
	      });
	    }
	    return SPAN(null);
	  },
	  componentDidUpdate: function() {
	    var int, loc;
	    loc = fetch('location');
	    if (loc.seek_to_hash) {
	      loc.seek_to_hash = false;
	      save(loc);
	      return int = setInterval(function() {
	        var docks, e, el, noop, seek_below;
	        el = null;
	        try {
	          el = document.querySelector("#" + loc.hash);
	        } catch (error) {
	          e = error;
	          noop = 1;
	        }
	        el || (el = document.querySelector("[name=\"" + loc.hash + "\"]") || document.querySelector("#p" + loc.hash));
	        if (el) {
	          docks = fetch('docking_station');
	          seek_below = docks.y_stack || 50;
	          $(window).scrollTop(getCoords(el).top - seek_below);
	          el.focus();
	          return clearInterval(int);
	        }
	      }, 100);
	    }
	  }
	});
	
	relativeURLFromLocation = function() {
	  var loc, ref, ref1, search;
	  search = (ref = location.search) != null ? ref.replace(/\%2[fF]/g, '/') : void 0;
	  loc = (ref1 = location.pathname) != null ? ref1.replace(/\%20/g, ' ') : void 0;
	  return "" + loc + search + location.hash;
	};
	
	relativeURLFromStatebus = function() {
	  var k, loc, query_params, ref, relative_url, v;
	  loc = fetch('location');
	  relative_url = loc.url;
	  if (_.keys(loc.query_params).length > 0) {
	    query_params = (function() {
	      var ref, results;
	      ref = loc.query_params;
	      results = [];
	      for (k in ref) {
	        if (!hasProp.call(ref, k)) continue;
	        v = ref[k];
	        results.push(k + "=" + v);
	      }
	      return results;
	    })();
	    relative_url += "?" + (query_params.join('&'));
	  }
	  if (((ref = loc.hash) != null ? ref.length : void 0) > 0) {
	    relative_url += "#" + loc.hash;
	  }
	  return relative_url;
	};
	
	location = window.history.location || window.location;
	
	ref = window.addEventListener ? ['addEventListener', 'popstate'] : ['attachEvent', 'onpopstate'], addEventListener = ref[0], popstate_event = ref[1];
	
	window[addEventListener](popstate_event, function(ev) {
	  return loadPage(relativeURLFromLocation());
	});
	
	loadPage(relativeURLFromLocation());


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var AccessControlled, AccessDenied, Permission, matchEmail, matchSomeRole, permit,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(4);
	
	__webpack_require__(2);
	
	Permission = {
	  PERMITTED: 1,
	  DISABLED: -1,
	  UNVERIFIED_EMAIL: -2,
	  NOT_LOGGED_IN: -3,
	  INSUFFICIENT_INFORMATION: -5,
	  INSUFFICIENT_PRIVILEGES: -4
	};
	
	permit = function(action) {
	  var answered, comment, current_user, i, len, opinion, point, proposal, question, ref, ref1, required_info, subdomain, tag, val;
	  current_user = fetch('/current_user');
	  switch (action) {
	    case 'create proposal':
	      subdomain = fetch('/subdomain');
	      if (!current_user.is_admin && !matchEmail(subdomain.roles.proposer)) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      break;
	    case 'update proposal':
	    case 'delete proposal':
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      proposal = fetch(arguments[1]);
	      if (!current_user.is_admin && (proposal.key === 'new_proposal' || !matchEmail(proposal.roles.editor))) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'publish opinion':
	      proposal = fetch(arguments[1]);
	      subdomain = fetch('/subdomain');
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer', 'opiner'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      required_info = [];
	      ref = _.where(customization('auth_questions'), {
	        required: true
	      });
	      for (i = 0, len = ref.length; i < len; i++) {
	        question = ref[i];
	        answered = false;
	        ref1 = current_user.tags;
	        for (tag in ref1) {
	          val = ref1[tag];
	          if (tag === question.tag || (question.input === "checklist" && tag.startsWith(question.tag.split('.')[0]))) {
	            answered = true;
	            break;
	          }
	        }
	        if (!answered) {
	          return Permission.INSUFFICIENT_INFORMATION;
	        }
	      }
	      break;
	    case 'update opinion':
	      proposal = fetch(arguments[1]);
	      opinion = fetch(arguments[2]);
	      if (opinion.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'create point':
	      proposal = fetch(arguments[1]);
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer'])) {
	        if (!current_user.logged_in) {
	          return Permission.NOT_LOGGED_IN;
	        } else {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	      }
	      break;
	    case 'update point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin && point.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'delete point':
	      point = fetch(arguments[1]);
	      if (!current_user.is_admin) {
	        if (point.user !== fetch('/current_user').user) {
	          return Permission.INSUFFICIENT_PRIVILEGES;
	        }
	        if (point.includers.length > 1 || (point.includers.length === 1 && point.includers[0] !== current_user.user)) {
	          return Permission.DISABLED;
	        }
	      }
	      break;
	    case 'create comment':
	      proposal = fetch(arguments[1]);
	      if (!proposal.active) {
	        return Permission.DISABLED;
	      }
	      if (!current_user.logged_in) {
	        return Permission.NOT_LOGGED_IN;
	      }
	      if (!current_user.is_admin && !matchSomeRole(proposal.roles, ['editor', 'writer', 'commenter'])) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    case 'update comment':
	      comment = fetch(arguments[1]);
	      if (!current_user.is_admin && comment.user !== fetch('/current_user').user) {
	        return Permission.INSUFFICIENT_PRIVILEGES;
	      }
	      break;
	    default:
	      console.error("Unrecognized action to permit: " + action);
	  }
	  return Permission.PERMITTED;
	};
	
	matchEmail = function(permission_list) {
	  var allowed_domain, email_or_key, i, len, ref, user;
	  user = fetch('/current_user');
	  if (indexOf.call(permission_list, '*') >= 0) {
	    return true;
	  }
	  if (ref = user.user, indexOf.call(permission_list, ref) >= 0) {
	    return true;
	  }
	  for (i = 0, len = permission_list.length; i < len; i++) {
	    email_or_key = permission_list[i];
	    if (email_or_key.indexOf('*') > -1) {
	      if (user.email) {
	        allowed_domain = email_or_key.split('@')[1];
	        if (user.email.split('@')[1] === allowed_domain) {
	          return true;
	        }
	      }
	    }
	  }
	  return false;
	};
	
	matchSomeRole = function(roles, accepted_roles) {
	  var i, len, role;
	  for (i = 0, len = accepted_roles.length; i < len; i++) {
	    role = accepted_roles[i];
	    if (matchEmail(roles[role])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	window.recourse = function(permission, goal) {
	  var auth, current_user, loc;
	  loc = fetch('location');
	  auth = fetch('auth');
	  goal = goal || ("access this " + (loc.url === '/' ? 'private forum' : 'page'));
	  switch (permission) {
	    case Permission.INSUFFICIENT_PRIVILEGES:
	      if (loc.url !== '/') {
	        return loadPage('/');
	      }
	      break;
	    case Permission.NOT_LOGGED_IN:
	      if (!auth.form) {
	        return reset_key('auth', {
	          form: 'login',
	          goal: goal,
	          ask_questions: true
	        });
	      }
	      break;
	    case Permission.UNVERIFIED_EMAIL:
	      if (auth.form !== 'verify email') {
	        reset_key('auth', {
	          form: 'verify email',
	          goal: goal
	        });
	        current_user = fetch('/current_user');
	        current_user.trying_to = 'send_verification_token';
	        return save(current_user);
	      }
	  }
	};
	
	AccessControlled = {
	  accessGranted: function() {
	    var access_attrs, current_user, local_but_not_component_unique;
	    current_user = fetch('/current_user');
	    local_but_not_component_unique = fetch("local-" + this.page.key);
	    access_attrs = ['verified', 'logged_in', 'email'];
	    if (local_but_not_component_unique._last_current_user && this.data().permission_denied) {
	      if (this._relevant_current_user_values_have_changed(access_attrs)) {
	        delete this.data().permission_denied;
	        arest.serverFetch(this.page.key);
	      }
	    }
	    if (this.data().permission_denied && this.data().permission_denied < 0) {
	      recourse(this.data().permission_denied);
	    }
	    if (this._relevant_current_user_values_have_changed(access_attrs)) {
	      local_but_not_component_unique._last_current_user = _.map(access_attrs, function(attr) {
	        return current_user[attr];
	      });
	      save(local_but_not_component_unique);
	    }
	    return !this.data().permission_denied || this.data().permission_denied > 0;
	  },
	  _relevant_current_user_values_have_changed: function(access_attrs) {
	    var current_user, el, i, idx, last_values, len, reduced_user;
	    current_user = fetch('/current_user');
	    last_values = fetch("local-" + this.page.key);
	    reduced_user = _.map(access_attrs, function(attr) {
	      return current_user[attr];
	    });
	    for (idx = i = 0, len = reduced_user.length; i < len; idx = ++i) {
	      el = reduced_user[idx];
	      if (!last_values._last_current_user || el !== last_values._last_current_user[idx]) {
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	AccessDenied = function() {
	  var user;
	  user = fetch('/current_user');
	  return DIV({
	    style: {
	      position: 'relative',
	      padding: 50
	    }
	  }, ProfileMenu(), DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto',
	      padding: '50px 100px',
	      backgroundColor: focus_color(),
	      color: 'white',
	      fontSize: 22
	    }
	  }, H1({
	    style: {
	      fontSize: 36,
	      color: 'white',
	      paddingBottom: 40
	    }
	  }, TRANSLATE({
	    id: "permissions.access_denied",
	    email: user.email
	  }, "We're sorry, but {email} doesn't have access to this private forum.")), DIV(null, TRANSLATE({
	    id: "permissions.access_denied.recourse"
	  }, "If you think you should have access, please contact the person who invited you. \nSometimes they will have granted access to a different email address. You will \neither have to create an account using that other email address, or the forum \nadministrator will have to grant this email address access.")), DIV({
	    style: {
	      marginTop: 40
	    }
	  }, TRANSLATE({
	    id: "permissions.contact_for_help",
	    link: {
	      component: A,
	      args: {
	        href: 'mailto:support@consider.it?subject=I am having trouble accessing a private forum',
	        style: {
	          textDecoration: 'underline'
	        }
	      }
	    }
	  }, "Contact us at <link>support@consider.it</link> if you need help."))));
	};
	
	window.AccessControlled = AccessControlled;
	
	window.permit = permit;
	
	window.Permission = Permission;
	
	window.AccessDenied = AccessDenied;


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	window.Tooltip = ReactiveComponent({
	  displayName: 'Tooltip',
	  render: function() {
	    var coords, size, style, tip, tooltip;
	    tooltip = fetch('tooltip');
	    if (!tooltip.coords) {
	      return SPAN(null);
	    }
	    coords = tooltip.coords;
	    tip = tooltip.tip;
	    style = _.defaults({}, this.props.style || {}, {
	      fontSize: 16,
	      padding: '4px 8px',
	      borderRadius: 8,
	      pointerEvents: 'none',
	      zIndex: 9999,
	      color: '#777',
	      backgroundColor: '#f6f6f6',
	      position: 'absolute',
	      boxShadow: '0 1px 1px rgba(0,0,0,.2)',
	      borderBottom: '1px solid #eee'
	    });
	    size = sizeWhenRendered(tip, style);
	    if (tooltip.top || (tooltip.top == null)) {
	      _.extend(style, {
	        top: coords.top - size.height - 9,
	        left: coords.left - size.width / 2
	      });
	    } else {
	      _.extend(style, {
	        top: coords.top + 9 + 20,
	        left: coords.left - size.width / 2
	      });
	    }
	    return DIV({
	      id: 'tooltip',
	      role: "tooltip",
	      style: style,
	      dangerouslySetInnerHTML: {
	        __html: tip
	      }
	    });
	  }
	});


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	__webpack_require__(28);
	
	window.Bubblemouth = function(props) {
	  var apex, bubblemouth_path, cx, full_width, id, qx1, qx2, qy1, qy2, ref, ref1, ref2, ref3, ref4, skew_x, skew_y, svg_h, svg_w, x1, x2, x3, x_pad, y1, y2, y3;
	  _.defaults(props, {
	    svg_w: 85,
	    svg_h: 100,
	    skew_x: 15,
	    skew_y: 80,
	    apex_xfrac: .5,
	    fill: 'white',
	    stroke: focus_color(),
	    stroke_width: 10,
	    dash_array: "none",
	    box_shadow: null
	  });
	  full_width = props.svg_w + 4 * props.skew_x * Math.max(.5, Math.abs(.5 - props.apex_xfrac));
	  _.defaults(props, {
	    width: full_width,
	    height: props.svg_h
	  });
	  apex = props.apex_xfrac;
	  svg_w = props.svg_w;
	  svg_h = props.svg_h;
	  skew_x = props.skew_x;
	  skew_y = props.skew_y;
	  cx = skew_x + svg_w / 2;
	  ref = [skew_x - apex * skew_x, svg_h], x1 = ref[0], y1 = ref[1];
	  ref1 = [skew_x + apex * svg_w, 0], x2 = ref1[0], y2 = ref1[1];
	  ref2 = [x1 + svg_w + skew_x, svg_h], x3 = ref2[0], y3 = ref2[1];
	  ref3 = [-skew_x + apex * (cx + 2 * skew_x), skew_y], qx1 = ref3[0], qy1 = ref3[1];
	  ref4 = [qx1 + cx, skew_y], qx2 = ref4[0], qy2 = ref4[1];
	  bubblemouth_path = "M  " + x1 + "  " + y1 + "\nQ " + qx1 + " " + qy1 + "\n   " + x2 + "  " + y2 + "\nQ " + qx2 + " " + qy2 + "\n   " + x3 + "  " + y3 + "\n";
	  id = "x" + (md5(JSON.stringify(props))) + "-" + ((Math.random() * 100000).toFixed(0));
	  x_pad = 0;
	  if (props.box_shadow) {
	    x_pad = (props.box_shadow.dx || 0) + (props.box_shadow.stdDeviation || 0);
	  }
	  return SVG({
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg",
	    width: props.width,
	    height: props.height,
	    viewBox: x_pad + " 0 " + full_width + " " + svg_h,
	    preserveAspectRatio: "none",
	    style: props.style ? props.style : void 0
	  }, DEFS(null, CLIPPATH({
	    id: id
	  }, PATH({
	    strokeWidth: props.stroke_width * 2,
	    d: bubblemouth_path
	  })), props.box_shadow ? svg.dropShadow(_.extend(props.box_shadow, {
	    id: id + "-shadow"
	  })) : void 0), props.box_shadow ? PATH({
	    key: 'shadow',
	    fill: props.fill,
	    style: {
	      filter: "url(#" + id + "-shadow)"
	    },
	    d: bubblemouth_path
	  }) : void 0, PATH({
	    key: 'stroke',
	    fill: props.fill,
	    stroke: props.stroke,
	    strokeWidth: props.stroke_width * 2,
	    clipPath: "url(#" + id + ")",
	    strokeDasharray: props.dash_array,
	    d: bubblemouth_path
	  }));
	};


/***/ },
/* 8 */
/***/ function(module, exports) {

	window.drawLogo = function(opts) {
	  var height, width;
	  opts = _.defaults(opts, {
	    main_text_color: 'white',
	    o_text_color: logo_red,
	    line_color: 'white',
	    i_dot_x: 252.25,
	    height: 60
	  });
	  opts.width || (opts.width = opts.height * 284 / 60);
	  height = opts.height;
	  width = opts.width;
	  return SVG({
	    id: 'considerit_logo',
	    width: width,
	    height: height,
	    viewBox: "0 0 284 60",
	    version: "1.1",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, TITLE({
	    id: 'considerit_logo_title'
	  }, 'Considerit Logo'), DEFS(null, CLIPPATH({
	    id: 'logo_clip'
	  }, RECT({
	    x: 0,
	    y: 0,
	    width: 284,
	    height: 45
	  })), FILTER({
	    id: "logo_shadow",
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    "in": "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    "in": "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
	    type: "matrix",
	    "in": "shadowBlurOuter1",
	    result: "shadowMatrixOuter1"
	  }), FEMERGE(null, FEMERGENODE({
	    "in": "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    "in": "SourceGraphic"
	  })))), G({
	    filter: opts.box_shadow ? 'url(#logo_shadow)' : void 0
	  }, opts.draw_line ? LINE({
	    id: 'underline',
	    x1: 8,
	    y1: 55,
	    x2: 284,
	    y2: 55,
	    stroke: opts.line_color,
	    strokeWidth: 1
	  }) : void 0, PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M18.2811874,48.356 \nC24.1163223,48.3559999 28.0501221,47.5510218 32.5084274,43.599315 \nC32.9673706,43.1801946 33.0984972,42.4018281 32.5739907,41.9827077 \nL30.2137104,37.099623 \nC29.8203305,36.740377 29.0991341,36.6805026 28.5746276,37.099623 \nC25.8209684,39.1353508 22.4772394,40.5124608 18.5434406,40.5124607 \nC14.4641389,40.5124606 9.32086755,37.716503 9.32086787,29.1762513 \nC9.32086836,20.6359996 15.4629989,17.6360006 18.2811869,17.6360001 \nC22.4641385,17.636 25.4641379,19.6359996 27.5746276,21.2528796 \nC28.0991341,21.7318743 28.7547672,21.7318743 29.2137104,21.2528796 \nL32.5739907,17.001801 \nC33.0984972,16.5228062 33.0984972,15.804314 32.5084274,15.3253193 \nC28.0501221,11.6729842 24.903082,10.236 18.2811874,10.236 \nC8.41026668,10.236 0.0764406792,17.8200837 0.0764406792,29.3558743 \nC0.0764406792,40.2729625 8.41026668,48.3560001 18.2811874,48.356 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M38.1601385,33.164 \nC38.1601385,41.444 44.7841385,48.356 52.9201385,48.356 \nC61.0561385,48.356 67.6801385,41.444 67.6801385,33.164 \nC67.6801385,25.028 61.0561385,18.116 52.9201385,18.116 \nC44.7841385,18.116 38.1601385,25.028 38.1601385,33.164 \nC38.1601385,33.164 38.1601385,25.028 38.1601385,33.164 \nZ\nM46.0081385,33.164 \nC46.0081385,29.132 49.0321385,25.892 52.9201385,25.892 \nC56.7361385,25.892 59.8321385,29.132 59.8321385,33.164 \nC59.8321385,37.268 56.7361385,40.58 52.9201385,40.58 \nC49.0321385,40.58 46.0081385,37.268 46.0081385,33.164 \nC46.0081385,33.164 46.0081385,37.268 46.0081385,33.164 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M74.0881385,46.268 \nC74.0881385,46.988 74.7361385,47.636 75.4561385,47.636 \nL80.7841385,47.636 \nC82.1521385,47.636 82.5841385,47.276 82.5841385,46.268 \nL82.5841385,30.428 \nC83.3041385,28.484 85.6081385,25.892 89.3521385,25.892 \nC92.8081385,25.892 94.7521385,28.268 94.7521385,32.012 \nL94.7521385,46.268 \nC94.7521385,46.988 95.3281385,47.636 96.1201385,47.636 \nL102.024139,47.636 \nC102.744139,47.636 103.392139,46.988 103.392139,46.268 \nL103.392139,32.444 \nC103.392139,24.956 99.7201385,18.116 90.5761385,18.116 \nC85.0321385,18.116 81.5041385,21.212 80.4241385,22.364 \nL79.4161385,19.7 \nC79.2001385,19.196 78.8401385,18.836 78.1921385,18.836 \nL75.4561385,18.836 \nC74.7361385,18.836 74.0881385,19.412 74.0881385,20.204 \nC74.0881385,20.204 74.0881385,19.412 74.0881385,20.204 \nL74.0881385,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M110.304139,45.692 \nC111.816139,46.844 115.128139,48.356 119.880139,48.356 \nC127.152139,48.356 131.328139,44.324 131.328139,39.572 \nC131.328139,33.956 127.152139,31.58 121.608139,29.42 \nC118.944139,28.34 117.648139,27.908 117.648139,26.612 \nC117.648139,25.676 118.368139,24.956 120.096139,24.956 \nC122.832139,24.956 126.072139,26.468 126.072139,26.468 \nC126.648139,26.684 127.440139,26.612 127.800139,25.964 \nL129.600139,22.292 \nC129.960139,21.572 129.600139,20.78 128.952139,20.348 \nC127.440139,19.34 124.344139,18.116 120.096139,18.116 \nC112.752139,18.116 109.512139,22.22 109.512139,26.612 \nC109.512139,31.004 112.104139,33.956 117.648139,36.116 \nC121.464139,37.628 122.472139,38.42 122.472139,39.716 \nC122.472139,40.94 121.464139,41.516 120.024139,41.516 \nC116.712139,41.516 113.472139,39.788 113.472139,39.788 \nC112.824139,39.428 112.104139,39.572 111.816139,40.292 \nL109.872139,44.18 \nC109.584139,44.756 109.872139,45.332 110.304139,45.692 \nC110.304139,45.692 109.872139,45.332 110.304139,45.692 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M137.664139,46.268 \nC137.664139,46.988 138.312139,47.636 139.032139,47.636 \nL145.008139,47.636 \nC145.728139,47.636 146.376139,46.988 146.376139,46.268 \nL146.376139,20.204 \nC146.376139,19.412 145.728139,18.836 145.008139,18.836 \nL139.032139,18.836 \nC138.312139,18.836 137.664139,19.412 137.664139,20.204 \nC137.664139,20.204 137.664139,19.412 137.664139,20.204 \nL137.664139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M166.680139,48.356 \nC172.728139,48.356 176.112139,44.036 176.112139,44.036 \nL176.832139,46.268 \nC177.048139,47.06 177.552139,47.636 178.200139,47.636 \nL181.008139,47.636 \nC181.728139,47.636 182.376139,46.988 182.376139,46.268 \nL182.376139,1.604 \nC182.376139,0.884 181.728139,0.236 181.008139,0.236 \nL174.888139,0.236 \nC174.168139,0.236 173.520139,0.884 173.520139,1.604 \nL173.520139,19.412 \nC172.224139,18.908 169.992139,18.116 167.112139,18.116 \nC158.544139,18.116 152.856139,24.812 152.856139,33.236 \nC152.856139,41.516 158.832139,48.356 166.680139,48.356 \nZ \nM161.208139,33.236 \nC161.208139,29.204 164.160139,25.892 168.192139,25.892 \nC171.792139,25.892 173.808139,27.548 173.808139,27.548 \nL173.808139,35.9 \nC173.304139,37.628 171.576139,40.58 167.760139,40.58 \nC163.944139,40.58 161.208139,37.268 161.208139,33.236 \nC161.208139,33.236 161.208139,37.268 161.208139,33.236 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M188.856139,33.236 \nC188.856139,41.516 194.976139,48.356 203.616139,48.356 \nC208.296139,48.356 211.968139,46.628 214.344139,44.396 \nC215.064139,43.82 214.920139,43.028 214.416139,42.524 \nL211.464139,39.14 \nC210.960139,38.564 210.312139,38.708 209.592139,39.14 \nC208.296139,40.076 206.208139,40.94 203.976139,40.94 \nC199.800139,40.94 197.280139,37.628 197.064139,34.676 \nL215.496139,34.676 \nC216.144139,34.676 216.792139,34.172 216.864139,33.452 \nC216.936139,32.948 217.008139,32.012 217.008139,31.508 \nC217.008139,23.732 210.960139,18.116 203.544139,18.116 \nC194.976139,18.116 188.856139,25.1 188.856139,33.236 \nC188.856139,33.236 188.856139,25.1 188.856139,33.236 \nZ \nM197.712139,29.636 \nC198.072139,26.9 200.448139,24.74 203.328139,24.74 \nC206.064139,24.74 208.368139,26.972 208.584139,29.636 \nC208.584139,29.636 208.368139,26.972 208.584139,29.636 \nL197.712139,29.636 \nZ           "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M223.056139,46.268 \nC223.056139,46.988 223.704139,47.636 224.424139,47.636 \nL229.968139,47.636 \nC230.976139,47.636 231.624139,47.276 231.624139,46.268 \nL231.624139,28.844 \nC232.128139,27.836 233.856139,25.892 236.736139,25.892 \nC237.528139,25.892 238.608139,26.252 238.824139,26.324 \nC239.400139,26.612 240.120139,26.324 240.480139,25.676 \nL243.144139,20.996 \nC244.008139,19.196 240.984139,18.116 237.600139,18.116 \nC233.136139,18.116 230.472139,21.14 229.464139,22.58 \nL228.456139,19.772 \nC228.240139,19.196 227.808139,18.836 227.160139,18.836 \nL224.424139,18.836 \nC223.704139,18.836 223.056139,19.412 223.056139,20.204 \nC223.056139,20.204 223.056139,19.412 223.056139,20.204 \nL223.056139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M247.608139,46.268 \nC247.608139,46.988 248.256139,47.636 248.976139,47.636 \nL254.952139,47.636 \nC255.672139,47.636 256.320139,46.988 256.320139,46.268 \nL256.320139,20.204 \nC256.320139,19.412 255.672139,18.836 254.952139,18.836 \nL248.976139,18.836 \nC248.256139,18.836 247.608139,19.412 247.608139,20.204 \nC247.608139,20.204 247.608139,19.412 247.608139,20.204 \nL247.608139,46.268 \nZ "
	  }), PATH({
	    fill: opts.main_text_color,
	    style: {
	      transition: 'fill 500ms'
	    },
	    clipPath: opts.clip ? "url(#logo_clip)" : void 0,
	    d: "M266.472139,39.068 \nC266.472139,44.9 268.920139,48.356 274.464139,48.356 \nC277.992139,48.356 282.672139,46.7 283.032139,46.484 \nC283.752139,46.196 284.112139,45.476 283.824139,44.756 \nL282.384139,40.22 \nC282.168139,39.5 281.592139,39.14 280.800139,39.428 \nC280.008139,39.716 278.496139,40.22 277.272139,40.22 \nC276.120139,40.22 275.040139,39.932 275.040139,37.916 \nL275.040139,26.396 \nL281.376139,26.396 \nC282.168139,26.396 282.744139,25.748 282.744139,25.028 \nL282.744139,20.204 \nC282.744139,19.412 282.168139,18.836 281.376139,18.836 \nL275.040139,18.836 \nL275.040139,10.772 \nC275.040139,10.052 274.464139,9.404 273.744139,9.404 \nL267.840139,9.476 \nC267.120139,9.476 266.472139,10.124 266.472139,10.844 \nL266.472139,18.836 \nL264.024139,18.836 \nC263.304139,18.836 262.728139,19.412 262.728139,20.204 \nL262.728139,25.028 \nC262.728139,25.748 263.304139,26.396 264.024139,26.396 \nL266.472139,26.396 \nL266.472139,39.068 \nZ"
	  }), CIRCLE({
	    id: 'i_dot',
	    style: {
	      transition: 'fill 500ms'
	    },
	    fill: opts.o_text_color,
	    cx: opts.i_dot_x,
	    cy: "55",
	    r: "4.25",
	    style: opts.transition ? css.crossbrowserify({
	      transition: 'cx 1000ms'
	    }) : void 0
	  })));
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	window.Slider = ReactiveComponent({
	  displayName: 'Slider',
	  getDefaultProps: function() {
	    return {
	      handle_height: 6,
	      base_height: 6,
	      base_endpoint: 'square',
	      base_color: 'rgb(160, 160, 160)',
	      polarized: false,
	      draw_helpers: false,
	      respond_to_click: true
	    };
	  },
	  render: function() {
	    var slider, slider_style;
	    slider = fetch(this.props.key);
	    if (this.props.draw_handle == null) {
	      this.props.draw_handle = true;
	    }
	    if (slider.value == null) {
	      _.defaults(slider, {
	        value: this.props.polarized ? -1.0 : 0,
	        has_moved: false,
	        is_moving: false
	      });
	      save(slider);
	    }
	    slider_style = _.defaults({}, this.props.slider_style || {}, {
	      width: this.props.width,
	      height: Math.max(this.props.base_height, this.props.handle_height),
	      position: 'relative'
	    });
	    return DIV({
	      className: 'slider',
	      style: slider_style,
	      onBlur: this.props.onBlur ? this.props.onBlur : void 0,
	      onFocus: this.props.onFocus ? this.props.onFocus : void 0
	    }, this.drawSliderBase(), this.props.draw_handle ? this.drawSliderHandle() : void 0);
	  },
	  drawSliderBase: function() {
	    var d, endpoint, endpoints, idx, region, slider, slider_base_style, sty, w;
	    slider = fetch(this.props.key);
	    slider_base_style = {
	      width: this.props.width,
	      height: this.props.base_height,
	      backgroundColor: this.props.base_color,
	      position: 'absolute'
	    };
	    if (typeof this.props.base_endpoint === 'string') {
	      endpoints = [this.props.base_endpoint, this.props.base_endpoint];
	    } else {
	      endpoints = this.props.base_endpoint;
	    }
	    return DIV({
	      ref: 'base',
	      style: slider_base_style,
	      onClick: this.handleMouseClick
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = endpoints.length; i < len; idx = ++i) {
	        endpoint = endpoints[idx];
	        if (endpoint === 'square') {
	          continue;
	        }
	        if (endpoint === 'sharp') {
	          results.push(DIV({
	            key: "endpoint-" + idx,
	            style: {
	              position: 'absolute',
	              left: idx === 0 ? -5 : void 0,
	              right: idx === 1 ? -5 : void 0,
	              width: 5,
	              height: slider_base_style.height,
	              backgroundColor: slider_base_style.backgroundColor
	            }
	          }, DIV({
	            style: cssTriangle((idx === 0 ? 'left' : 'right'), slider_base_style.backgroundColor, 12, 6, {
	              position: 'absolute',
	              left: idx === 0 ? -12 : void 0,
	              right: idx === 1 ? -12 : void 0
	            })
	          })));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })(), (function() {
	      var i, len, ref, results;
	      if (this.props.regions) {
	        d = this.props.width / this.props.regions.length;
	        sty = {
	          color: '#BDBDBD',
	          fontSize: 14
	        };
	        ref = this.props.regions;
	        results = [];
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          region = ref[idx];
	          w = sizeWhenRendered(region.abbrev, sty);
	          results.push(DIV({
	            style: _.extend({}, sty, {
	              color: '#BDBDBD',
	              fontSize: 14,
	              position: 'absolute',
	              left: (idx + .5) * d - w.width / 2,
	              top: 4
	            })
	          }, region.abbrev));
	        }
	        return results;
	      }
	    }).call(this));
	  },
	  drawSliderHandle: function() {
	    var base, handle_height, handle_width, slider, sliderHandle, support;
	    handle_width = handle_height = this.props.handle_height;
	    slider = fetch(this.props.key);
	    sliderHandle = this.props.handle || slider_handle.flat;
	    return DIV({
	      className: 'the_handle',
	      role: 'slider',
	      'aria-valuemin': this.props.polarized ? -1 : 0,
	      'aria-valuemax': 1,
	      'aria-valuenow': slider.value,
	      'aria-valuetext': typeof (base = this.props).readable_text === "function" ? base.readable_text(slider.value) : void 0,
	      'aria-label': this.props.label,
	      tabIndex: 0,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var amount, base1, direction, new_val, ref, ref1, ref2, ref3, ref4;
	          if ((ref = e.which) === 37 || ref === 38 || ref === 39 || ref === 40 || ref === 33 || ref === 34 || ref === 35 || ref === 36) {
	            amount = (ref1 = e.which) === 37 || ref1 === 38 || ref1 === 39 || ref1 === 40 ? .05 : (ref2 = e.which) === 33 || ref2 === 34 ? .25 : (ref3 = e.which) === 35 || ref3 === 36 ? 10000 : void 0;
	            direction = (ref4 = e.which) === 37 || ref4 === 40 || ref4 === 34 || ref4 === 36 ? -1 : 1;
	            new_val = slider.value;
	            new_val += direction * amount;
	            new_val = Math.max(new_val, (_this.props.polarized ? -1 : 0));
	            new_val = Math.min(new_val, 1);
	            if (new_val !== slider.value) {
	              slider.value = new_val;
	              save(slider);
	              if (typeof (base1 = _this.props).onMouseUpCallback === "function") {
	                base1.onMouseUpCallback(e);
	              }
	            }
	            return e.preventDefault();
	          } else if (e.which === 13 || e.which === 32) {
	            if (_this.props.onMouseUpCallback) {
	              _this.props.onMouseUpCallback(e);
	            }
	            return e.preventDefault();
	          }
	        };
	      })(this),
	      onMouseUp: this.handleMouseUp,
	      onTouchEnd: this.handleMouseUp,
	      onTouchCancel: this.handleMouseUp,
	      onMouseDown: this.handleMouseDown,
	      onTouchStart: this.handleMouseDown,
	      onTouchMove: this.handleMouseMove,
	      onBlur: (function(_this) {
	        return function() {
	          _this.local.has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function() {
	          _this.local.has_focus = true;
	          return save(_this.local);
	        };
	      })(this),
	      style: css.crossbrowserify(_.extend(this.props.handle_style || {}, {
	        width: handle_width,
	        height: handle_height,
	        top: this.props.offset ? 0 : -(handle_height - this.props.base_height) / 2,
	        position: 'relative',
	        marginLeft: -handle_width / 2,
	        zIndex: 10,
	        outline: 'none',
	        left: this.props.polarized ? this.props.width * (slider.value + 1) / 2 : this.props.width * slider.value
	      }))
	    }, sliderHandle(_.extend(this.props.handle_props || {}, {
	      value: this.props.polarized ? (slider.value + 1) / 2 : slider.value,
	      handle_height: handle_height,
	      handle_width: handle_width,
	      has_focus: this.local.has_focus
	    })), (function() {
	      var i, len, ref, results;
	      if (this.props.draw_helpers) {
	        ref = [true, false];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          support = ref[i];
	          results.push(DIV({
	            style: {
	              right: support ? -15 : void 0,
	              left: !support ? -15 : void 0,
	              position: 'absolute',
	              top: 4,
	              color: focus_color(),
	              fontSize: 12,
	              pointerEvents: 'none'
	            }
	          }, support ? '>' : '<'));
	        }
	        return results;
	      }
	    }).call(this));
	  },
	  handleMouseDown: function(e) {
	    var el, slider;
	    el = this.getDOMNode();
	    e.preventDefault();
	    slider = fetch(this.props.key);
	    slider.is_moving = true;
	    save(slider);
	    this.local.starting_adjustment = (parseInt($(e.currentTarget)[0].style.left, 10) || 0) - (e.clientX || e.touches[0].clientX);
	    save(this.local);
	    if (this.props.onMouseDownCallback) {
	      this.props.onMouseDownCallback(e);
	    }
	    $(window).on("mousemove.slider", this.handleMouseMove);
	    return $(window).on("mouseup.slider", this.handleMouseUp);
	  },
	  handleMouseMove: function(e) {
	    var clientX, slider, x;
	    e.preventDefault();
	    slider = fetch(this.props.key);
	    clientX = e.clientX || e.touches[0].clientX;
	    x = clientX + this.local.starting_adjustment;
	    x = x < 0 ? 0 : x > this.props.width ? this.props.width : x;
	    slider.has_moved = true;
	    slider.value = x / this.props.width;
	    if (this.props.polarized) {
	      slider.value = slider.value * 2 - 1;
	    }
	    slider.value = Math.round(slider.value * 10000) / 10000;
	    save(slider);
	    if (this.props.onMouseMoveCallback) {
	      return this.props.onMouseMoveCallback(e);
	    }
	  },
	  handleMouseUp: function(e) {
	    var slider;
	    slider = fetch(this.props.key);
	    if (!slider.is_moving) {
	      return;
	    }
	    e.preventDefault();
	    slider.is_moving = false;
	    save(slider);
	    if (this.props.onMouseUpCallback) {
	      this.props.onMouseUpCallback(e);
	    }
	    return $(window).off(".slider");
	  },
	  handleMouseClick: function(e) {
	    var clientX, slider, val;
	    if (this.props.respond_to_click) {
	      e.preventDefault();
	      clientX = e.clientX || e.touches[0].clientX;
	      val = (clientX - $(this.refs.base.getDOMNode()).offset().left) / this.props.width;
	      if (val < 0) {
	        val = 0;
	      }
	      if (val > 1) {
	        val = 1;
	      }
	      if (this.props.polarized) {
	        val = val * 2 - 1;
	      }
	      slider = fetch(this.props.key);
	      slider.has_moved = true;
	      slider.value = Math.round(val * 10000) / 10000;
	      save(slider);
	      if (this.props.onClickCallback) {
	        return this.props.onClickCallback(e);
	      }
	    }
	  }
	});
	
	window.slider_handle || (window.slider_handle = {});
	
	slider_handle.face = function(props) {
	  var bh, bw, direction, is_left, x, y;
	  return SVG({
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      filter: props.has_focus ? "drop-shadow(0 0 1px rgba(0,0,0,.5))" : void 0
	    }
	  }, DEFS(null, svg.innerbevel({
	    id: 'handle-innerbevel',
	    shadows: [
	      {
	        color: 'black',
	        opacity: 1.0,
	        dx: 0,
	        dy: -3,
	        stdDeviation: 3
	      }, {
	        color: 'white',
	        opacity: .25,
	        dx: 0,
	        dy: 3,
	        stdDeviation: 3
	      }
	    ]
	  })), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), G(null, CIRCLE({
	    fill: props.color,
	    filter: "url(#handle-innerbevel)",
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.detail ? G(null, (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      bw = 15;
	      bh = 2;
	      x = 50 + direction * (28 + 4 * (1 - props.value)) - (is_left ? 0 : bw);
	      y = 28 - 4 * (1 - props.value);
	      results.push(RECT({
	        x: x,
	        y: y,
	        width: bw,
	        height: bh,
	        transform: "rotate(" + (direction * (5 + 30 * Math.abs(.5 - props.value))) + " " + (x + (is_left ? bw : 0)) + " " + (y + bh) + ")",
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function() {
	    var i, len, ref, results;
	    ref = [true, false];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      is_left = ref[i];
	      direction = is_left ? -1 : 1;
	      results.push(CIRCLE({
	        cx: 50 + direction * (13 + 6 * (1 - props.value)),
	        cy: 39,
	        r: 3,
	        fill: 'white'
	      }));
	    }
	    return results;
	  })(), (function(_this) {
	    return function() {
	      var frowniness, mw, my, qx1, qy1, ref, ref1, ref2, x1, x2, y1, y2;
	      frowniness = 5;
	      mw = 40;
	      my = 65;
	      ref = [50 - mw / 2, my + frowniness * (1 - props.value)], x1 = ref[0], y1 = ref[1];
	      ref1 = [50 + mw / 2, y1], x2 = ref1[0], y2 = ref1[1];
	      ref2 = [50, my + .5 * frowniness + 2 * frowniness * (2 * props.value - 1)], qx1 = ref2[0], qy1 = ref2[1];
	      return PATH({
	        stroke: 'white',
	        fill: focus_color(),
	        strokeWidth: 3,
	        d: "M " + x1 + " " + y1 + "\nQ " + qx1 + " " + qy1 + "\n  " + x2 + " " + y2
	      });
	    };
	  })(this)()) : void 0));
	};
	
	slider_handle.triangley = function(props) {
	  var id, svg_props;
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "0 0 21 18",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10,
	      filter: props.has_focus ? "drop-shadow(0 0 3px rgba(0,0,0,.5))" : void 0
	    }
	  };
	  id = "triangley_filter-" + ((Math.random() * 1000000).toFixed(0));
	  return SVG(svg_props, DEFS(null, FILTER({
	    id: id,
	    x: "-50%",
	    y: "-50%",
	    width: "200%",
	    height: "200%",
	    filterUnits: "objectBoundingBox"
	  }, FEOFFSET({
	    dx: "0",
	    dy: "1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetOuter1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "0.5",
	    'in': "shadowOffsetOuter1",
	    result: "shadowBlurOuter1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16479563 0",
	    'in': "shadowBlurOuter1",
	    type: "matrix",
	    result: "shadowMatrixOuter1"
	  }), FEOFFSET({
	    dx: "0",
	    dy: "-1",
	    'in': "SourceAlpha",
	    result: "shadowOffsetInner1"
	  }), FEGAUSSIANBLUR({
	    stdDeviation: "1",
	    'in': "shadowOffsetInner1",
	    result: "shadowBlurInner1"
	  }), FECOMPOSITE({
	    'in': "shadowBlurInner1",
	    in2: "SourceAlpha",
	    operator: "arithmetic",
	    k2: "-1",
	    k3: "1",
	    result: "shadowInnerInner1"
	  }), FECOLORMATRIX({
	    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
	    'in': "shadowInnerInner1",
	    type: "matrix",
	    result: "shadowMatrixInner1"
	  }), FEMERGE(null, FEMERGENODE({
	    'in': "shadowMatrixOuter1"
	  }), FEMERGENODE({
	    'in': "SourceGraphic"
	  }), FEMERGENODE({
	    'in': "shadowMatrixInner1"
	  })))), G({
	    stroke: "none",
	    strokeWidth: "0",
	    fill: focus_color(),
	    fillRule: "evenodd"
	  }, PATH({
	    d: "M1,6 L20,6 L20,16 L1,16 L1,6 Z M10.5,0 L20,6 L1,6 L10.5,0 Z",
	    fill: focus_color(),
	    filter: "url(#" + id + ")"
	  })));
	};
	
	slider_handle.flat = function(props) {
	  var svg_props;
	  svg_props = {
	    height: props.handle_height,
	    width: props.handle_width,
	    viewBox: "-2 -1 104 104",
	    style: {
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      zIndex: 10,
	      filter: props.has_focus ? "drop-shadow(0 0 3px rgba(0,0,0,.5))" : void 0
	    }
	  };
	  return SVG(svg_props, DEFS(null, CLIPPATH({
	    id: 'slider-avatar-clip'
	  }, CIRCLE({
	    cx: 50,
	    cy: 50,
	    r: 48
	  }))), CIRCLE({
	    fill: props.color,
	    stroke: props.color,
	    cx: 50,
	    cy: 50,
	    r: 50
	  }), props.use_face ? (function(_this) {
	    return function() {
	      var user;
	      user = fetch(fetch('/current_user').user);
	      if (user.avatar_file_name) {
	        return IMAGE({
	          'xlink:href': avatarUrl(user, 'large'),
	          x: 2,
	          y: 2,
	          width: 96,
	          height: 96,
	          clipPath: 'url(#slider-avatar-clip)'
	        });
	      }
	    };
	  })(this)() : void 0);
	};
	
	styles += "" + (css.grab_cursor('.the_handle'));


/***/ },
/* 10 */
/***/ function(module, exports) {

	var golden_ratio_conjugate;
	
	window.focus_blue = '#2478CC';
	
	window.logo_red = "#B03A44";
	
	window.default_avatar_in_histogram_color = '#999';
	
	window.considerit_gray = '#f6f7f9';
	
	window.parseCssRgb = function(css_color_str) {
	  var rgb, test;
	  test = document.createElement('div');
	  test.style.color = css_color_str;
	  css_color_str = test.style.color;
	  if (css_color_str === 'transparent') {
	    return {
	      r: 0,
	      g: 0,
	      b: 0,
	      a: 0
	    };
	  } else {
	    rgb = /^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+),?\s*([\.\d]+)?\s*\)$/i.exec(css_color_str);
	    if (rgb) {
	      return {
	        r: parseInt(rgb[1]),
	        g: parseInt(rgb[2]),
	        b: parseInt(rgb[3]),
	        a: rgb.length > 4 && (rgb[4] != null) ? parseFloat(rgb[4]) : 1
	      };
	    } else {
	      console.error("Color " + css_color_str + " could not be parsed");
	      return {
	        r: 0,
	        g: 0,
	        b: 0
	      };
	    }
	  }
	};
	
	window.parseCssHsl = function(css_color_str) {
	  var rgb;
	  rgb = parseCssRgb(css_color_str);
	  return rgb2hsl(rgb);
	};
	
	window.rgb2hsl = function(rgb) {
	  var b, d, g, h, l, max, min, r, s;
	  r = rgb.r / 255;
	  g = rgb.g / 255;
	  b = rgb.b / 255;
	  max = Math.max(r, g, b);
	  min = Math.min(r, g, b);
	  l = (max + min) / 2;
	  if (max === min) {
	    h = s = 0;
	  } else {
	    d = max - min;
	    s = (l > 0.5 ? d / (2 - max - min) : d / (max + min));
	    switch (max) {
	      case r:
	        h = (g - b) / d + (g < b ? 6 : 0);
	        break;
	      case g:
	        h = (b - r) / d + 2;
	        break;
	      case b:
	        h = (r - g) / d + 4;
	    }
	    h /= 6;
	  }
	  return {
	    h: h,
	    s: s,
	    l: l
	  };
	};
	
	window.hsv2rgb = function(h, s, v) {
	  var b, f, g, h_i, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, t;
	  h_i = Math.floor(h * 6);
	  f = h * 6 - h_i;
	  p = v * (1 - s);
	  q = v * (1 - f * s);
	  t = v * (1 - (1 - f) * s);
	  if (h_i === 0) {
	    ref = [v, t, p], r = ref[0], g = ref[1], b = ref[2];
	  }
	  if (h_i === 1) {
	    ref1 = [q, v, p], r = ref1[0], g = ref1[1], b = ref1[2];
	  }
	  if (h_i === 2) {
	    ref2 = [p, v, t], r = ref2[0], g = ref2[1], b = ref2[2];
	  }
	  if (h_i === 3) {
	    ref3 = [p, q, v], r = ref3[0], g = ref3[1], b = ref3[2];
	  }
	  if (h_i === 4) {
	    ref4 = [t, p, v], r = ref4[0], g = ref4[1], b = ref4[2];
	  }
	  if (h_i === 5) {
	    ref5 = [v, p, q], r = ref5[0], g = ref5[1], b = ref5[2];
	  }
	  return "rgb(" + (Math.round(r * 256)) + ", " + (Math.round(g * 256)) + ", " + (Math.round(b * 256)) + ")";
	};
	
	window.addOpacity = function(color, opacity) {
	  var c;
	  c = parseCssRgb(color);
	  return "rgba(" + c.r + "," + c.g + "," + c.b + "," + opacity;
	};
	
	golden_ratio_conjugate = 0.618033988749895;
	
	window.getNiceRandomHues = function(num, seed) {
	  var h, hues, i;
	  h = seed || .5;
	  hues = [];
	  i = num;
	  while (i > 0) {
	    hues.push(h % 1);
	    h += golden_ratio_conjugate;
	    i -= 1;
	  }
	  return hues;
	};


/***/ },
/* 11 */
/***/ function(module, exports) {

	window.DropMenu = ReactiveComponent({
	  displayName: 'DropMenu',
	  render: function() {
	    var active_option_style, anchor_style, anchor_when_open_style, close_menu, idx, menu_style, menu_when_open_style, open_menu_on, option, option_style, options, render_anchor, render_option, set_active, trigger, wrapper_style;
	    open_menu_on = this.props.open_menu_on || 'focus';
	    wrapper_style = _.defaults({}, this.props.wrapper_style, {
	      position: 'relative'
	    });
	    anchor_style = _.defaults({}, this.props.anchor_style, {
	      position: 'relative',
	      background: 'transparent',
	      border: 'none',
	      cursor: 'pointer',
	      fontSize: 'inherit'
	    });
	    anchor_when_open_style = _.defaults({}, this.props.anchor_open_style, anchor_style);
	    menu_style = _.defaults({}, this.props.menu_style, {
	      listStyle: 'none',
	      position: 'absolute',
	      zIndex: 999999
	    });
	    menu_when_open_style = _.defaults({}, this.props.menu_when_open_style, menu_style);
	    option_style = _.defaults({}, this.props.option_style, {
	      cursor: 'pointer',
	      outline: 'none'
	    });
	    active_option_style = _.defaults({}, this.props.active_option_style, option_style);
	    options = this.props.options;
	    render_anchor = this.props.render_anchor;
	    render_option = this.props.render_option;
	    set_active = (function(_this) {
	      return function(idx) {
	        if (idx == null) {
	          idx = 0;
	        }
	        _this.local.active_option = idx;
	        save(_this.local);
	        return setTimeout(function() {
	          return _this.refs["menuitem-" + idx].getDOMNode().focus();
	        }, 0);
	      };
	    })(this);
	    trigger = (function(_this) {
	      return function(e) {
	        var base, selection;
	        selection = options[_this.local.active_option];
	        if (typeof (base = _this.props).selection_made_callback === "function") {
	          base.selection_made_callback(selection);
	        }
	        if (selection.href) {
	          e.currentTarget.click();
	        }
	        close_menu();
	        e.stopPropagation();
	        return e.preventDefault();
	      };
	    })(this);
	    close_menu = (function(_this) {
	      return function() {
	        document.activeElement.blur();
	        _this.local.show_menu = false;
	        return save(_this.local);
	      };
	    })(this);
	    return DIV({
	      ref: 'menu_wrap',
	      key: 'dropmenu-wrapper',
	      style: wrapper_style,
	      onTouchEnd: (function(_this) {
	        return function() {
	          _this.local.show_menu = !_this.local.show_menu;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: close_menu,
	      onBlur: (function(_this) {
	        return function(e) {
	          return setTimeout(function() {
	            var ref;
	            if (_this.refs.menu_wrap && $(document.activeElement).closest((ref = _this.refs.menu_wrap) != null ? ref.getDOMNode() : void 0).length === 0) {
	              _this.local.sort_menu = false;
	              return save(_this.local);
	            }
	          }, 0);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32 || e.which === 27) {
	            close_menu();
	            return e.preventDefault();
	          } else if (e.which === 38 || e.which === 40) {
	            if (_this.local.active_option == null) {
	              _this.local.active_option = -1;
	            }
	            if (e.which === 38) {
	              _this.local.active_option--;
	              if (_this.local.active_option < 0) {
	                _this.local.active_option = options.length - 1;
	              }
	            } else {
	              _this.local.active_option++;
	              if (_this.local.active_option > options.length - 1) {
	                _this.local.active_option = 0;
	              }
	            }
	            set_active(_this.local.active_option);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, BUTTON({
	      tabIndex: 0,
	      'aria-haspopup': "true",
	      'aria-owns': "dropMenu-" + this.local.key,
	      style: this.local.show_menu ? anchor_when_open_style : anchor_style,
	      onMouseEnter: open_menu_on === 'focus' ? (function(_this) {
	        return function(e) {
	          _this.local.show_menu = true;
	          set_active(0);
	          return save(_this.local);
	        };
	      })(this) : void 0,
	      onClick: open_menu_on !== 'focus' ? (function(_this) {
	        return function(e) {
	          _this.local.show_menu = !_this.local.show_menu;
	          if (_this.local.show_menu) {
	            set_active(0);
	          }
	          return save(_this.local);
	        };
	      })(this) : void 0,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.local.show_menu = !_this.local.show_menu;
	            if (_this.local.show_menu) {
	              set_active(0);
	            }
	            save(_this.local);
	            e.preventDefault();
	            return e.stopPropagation();
	          }
	        };
	      })(this)
	    }, render_anchor(this.local.show_menu)), UL({
	      id: "dropMenu-" + this.local.key,
	      role: "menu",
	      'aria-hidden': !this.local.show_menu,
	      hidden: !this.local.show_menu,
	      style: this.local.show_menu ? menu_when_open_style : menu_style
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = options.length; i < len; idx = ++i) {
	        option = options[idx];
	        results.push((function(_this) {
	          return function(option, idx) {
	            return LI({
	              key: option.label,
	              role: "presentation"
	            }, A({
	              ref: "menuitem-" + idx,
	              role: "menuitem",
	              tabIndex: _this.local.active_option === idx ? 0 : -1,
	              href: option.href,
	              key: option.label + "-activate",
	              'data-action': option['data-action'],
	              style: _this.local.active_option === idx ? active_option_style : option_style,
	              onClick: function(e) {
	                if (_this.local.active_option !== idx) {
	                  set_active(idx);
	                }
	                return trigger(e);
	              },
	              onTouchEnd: function(e) {
	                if (_this.local.active_option !== idx) {
	                  set_active(idx);
	                }
	                return trigger(e);
	              },
	              onKeyDown: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  return trigger(e);
	                }
	              },
	              onFocus: function(e) {
	                if (_this.local.active_option !== idx) {
	                  set_active(idx);
	                }
	                return e.stopPropagation();
	              },
	              onMouseEnter: function() {
	                if (_this.local.active_option !== idx) {
	                  return set_active(idx);
	                }
	              },
	              onBlur: function(e) {
	                _this.local.active_option = null;
	                return save(_this.local);
	              },
	              onMouseExit: function(e) {
	                _this.local.active_option = null;
	                save(_this.local);
	                return e.stopPropagation();
	              }
	            }, render_option(option, _this.local.active_option === idx)));
	          };
	        })(this)(option, idx));
	      }
	      return results;
	    }).call(this)));
	  }
	});


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	var ENABLE_SERVER_HISTOCACHE, HistoAvatars, REGION_SELECTION_VERTICAL_PADDING, REGION_SELECTION_WIDTH, calculateAvatarRadius, histo_queue, histo_run_next_job, histo_running, layoutAvatars, positionAvatars;
	
	__webpack_require__(3);
	
	__webpack_require__(1);
	
	REGION_SELECTION_WIDTH = .25;
	
	REGION_SELECTION_VERTICAL_PADDING = 30;
	
	window.reset_selection_state = function(state) {
	  var hist;
	  hist = fetch(state);
	  _.extend(hist, {
	    initialized: true,
	    highlighted_users: null,
	    selected_opinion: null,
	    selected_opinions: null,
	    selected_opinion_value: null,
	    originating_histogram: null
	  });
	  return save(hist);
	};
	
	ENABLE_SERVER_HISTOCACHE = false;
	
	window.Histogram = ReactiveComponent({
	  displayName: 'Histogram',
	  get_hist_state: function() {
	    return fetch(this.props.selection_state || this.props.key);
	  },
	  render: function() {
	    var avatar_radius, avg, base, base1, base2, dirtied, draw_selection_area, exp, filter_out, hist, histo_height, histocache_key, histogram_props, j, len, negative, o, opinions, proposal, ref, ref1, score;
	    hist = this.get_hist_state();
	    dirtied = false;
	    if (!hist.initialized) {
	      reset_selection_state(hist);
	      dirtied = true;
	    }
	    avatar_radius = calculateAvatarRadius(this.props.width, this.props.height, this.props.opinions);
	    if (this.local.avatar_size !== avatar_radius * 2) {
	      this.local.avatar_size = avatar_radius * 2;
	      save(this.local);
	      dirtied = true;
	    }
	    proposal = fetch(this.props.proposal);
	    histocache_key = this.histocache_key();
	    if (ENABLE_SERVER_HISTOCACHE && ((ref = proposal.histocache) != null ? ref[histocache_key] : void 0)) {
	      if (histocache_key !== ((ref1 = this.local.histocache) != null ? ref1.hash : void 0)) {
	        this.local.histocache = {
	          hash: histocache_key,
	          positions: proposal.histocache[histocache_key]
	        };
	        save(this.local);
	        dirtied = true;
	      }
	    }
	    this.local.dirty === dirtied;
	    if (this.props.draw_base_labels == null) {
	      this.props.draw_base_labels = true;
	    }
	    filter_out = fetch('filtered');
	    opinions = (function() {
	      var j, len, ref2, ref3, results;
	      ref2 = this.props.opinions;
	      results = [];
	      for (j = 0, len = ref2.length; j < len; j++) {
	        o = ref2[j];
	        if (filter_out.enable_comparison || !((ref3 = filter_out.users) != null ? ref3[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    }).call(this);
	    (base = this.props).enable_individual_selection && (base.enable_individual_selection = opinions.length > 0);
	    (base1 = this.props).enable_range_selection && (base1.enable_range_selection = opinions.length > 1);
	    (base2 = this.props).enable_range_selection && (base2.enable_range_selection = !filter_out.current_filter || filter_out.current_filter.label !== 'just you');
	    draw_selection_area = this.props.enable_range_selection && !hist.selected_opinion && !this.props.backgrounded && (hist.selected_opinions || (!this.local.touched && this.local.mouse_opinion_value && !this.local.hoving_over_avatar));
	    histo_height = this.props.height + ( true ? REGION_SELECTION_VERTICAL_PADDING : 0);
	    histogram_props = {
	      tabIndex: !this.props.backgrounded ? 0 : void 0,
	      className: 'histogram',
	      'aria-hidden': this.props.backgrounded,
	      'aria-labelledby': !this.props.backgrounded ? "#" + proposal.id + "-histo-label" : void 0,
	      'aria-describedby': !this.props.backgrounded ? "#" + proposal.id + "-histo-description" : void 0,
	      style: css.crossbrowserify({
	        width: this.props.width,
	        height: histo_height,
	        position: 'relative',
	        borderBottom: this.props.draw_base ? this.props.base_style || "1px solid #999" : void 0,
	        userSelect: 'none'
	      }),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var ref2, ref3;
	          if (e.which === 32) {
	            _this.local.navigating_inside = !_this.local.navigating_inside;
	            save(_this.local);
	            e.preventDefault();
	            if (_this.local.navigating_inside) {
	              return (ref2 = _this.refs["avatar-0"]) != null ? ref2.getDOMNode().focus() : void 0;
	            } else {
	              return _this.getDOMNode().focus();
	            }
	          } else if (e.which === 13 && !_this.local.navigating_inside) {
	            _this.local.navigating_inside = true;
	            if ((ref3 = _this.refs["avatar-0"]) != null) {
	              ref3.getDOMNode().focus();
	            }
	            return save(_this.local);
	          } else if (e.which === 27 && _this.local.navigating_inside) {
	            _this.local.navigating_inside = false;
	            _this.getDOMNode().focus();
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          return setTimeout(function() {
	            if (_this.local.navigating_inside && $(document.activeElement).closest(_this.getDOMNode()).length === 0) {
	              _this.local.navigating_inside = false;
	              return save(_this.local);
	            }
	          }, 0);
	        };
	      })(this)
	    };
	    score = 0;
	    for (j = 0, len = opinions.length; j < len; j++) {
	      o = opinions[j];
	      score += o.stance;
	    }
	    avg = score / opinions.length;
	    negative = score < 0;
	    if (negative) {
	      score *= -1;
	    }
	    score = pad(score.toFixed(1), 2);
	    if (avg < -.03) {
	      exp = ((-1 * avg * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.oppose", this.props.proposal));
	    } else if (avg > .03) {
	      exp = ((avg * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.support", this.props.proposal));
	    } else {
	      exp = translator("engage.slider_feedback.neutral", "Neutral");
	    }
	    if (this.props.enable_range_selection || this.props.enable_individual_selection) {
	      if (!browser.is_mobile) {
	        _.extend(histogram_props, {
	          onClick: this.onClick,
	          onMouseMove: this.onMouseMove,
	          onMouseLeave: this.onMouseLeave,
	          onMouseDown: this.onMouseDown
	        });
	      } else {
	        _.extend(histogram_props, {
	          onTouchStart: (function(_this) {
	            return function(ev) {
	              var curr_time;
	              curr_time = new Date().getTime();
	              if (_this.local.last_tapped_at && curr_time - _this.local.last_tapped_at < 300) {
	                ev.preventDefault();
	                _this.local.touched = true;
	                save(_this.local);
	                return _this.onClick(ev);
	              } else {
	                _this.local.last_tapped_at = curr_time;
	                return save(_this.local);
	              }
	            };
	          })(this),
	          onTouchMove: (function(_this) {
	            return function(ev) {
	              ev.preventDefault();
	              return _this.onMouseMove(ev);
	            };
	          })(this),
	          onTouchEnd: (function(_this) {
	            return function(ev) {
	              var curr_time;
	              curr_time = new Date().getTime();
	              _this.local.last_tapped_at = curr_time;
	              return save(_this.local);
	            };
	          })(this)
	        });
	      }
	    }
	    return DIV(histogram_props, DIV({
	      id: "#" + proposal.id + "-histo-label",
	      className: 'hidden'
	    }, TRANSLATE({
	      id: "engage.histogram.explanation",
	      num_opinions: opinions.length
	    }, "Histogram showing {num_opinions, plural, one {# opinion} other {# opinions}}")), DIV({
	      id: "#" + proposal.id + "-histo-description",
	      className: 'hidden'
	    }, TRANSLATE({
	      id: "engage.histogram.explanation_extended",
	      num_opinions: opinions.length,
	      avg_score: exp,
	      negative_pole: get_slider_label("slider_pole_labels.oppose", this.props.proposal),
	      positive_pole: get_slider_label("slider_pole_labels.support", this.props.proposal)
	    }, "{num_opinions, plural, one {one person's opinion of} other {# people's opinion, with an average of}} {avg_score} \non a spectrum from {negative_pole} to {positive_pole}. \nPress ENTER or SPACE to enable tab navigation of each person's opinion, and ESCAPE to exit the navigation.")), this.props.draw_base_labels ? this.drawHistogramLabels() : void 0,  true ? DIV({
	      style: {
	        height: this.local.region_selection_vertical_padding
	      }
	    }) : void 0, draw_selection_area ? this.drawSelectionArea() : void 0, DIV({
	      style: {
	        paddingTop: histo_height - this.props.height
	      }
	    }, HistoAvatars({
	      dirtied: dirtied,
	      highlighted_users: hist.highlighted_users,
	      selected_opinion: hist.selected_opinion,
	      selected_opinions: hist.selected_opinions,
	      avatar_size: this.local.avatar_size,
	      enable_individual_selection: this.props.enable_individual_selection,
	      enable_range_selection: this.props.enable_range_selection,
	      proposal: this.props.proposal,
	      height: this.props.height,
	      backgrounded: this.props.backgrounded,
	      opinions: this.props.opinions,
	      histocache: this.local.histocache,
	      histocache_key: this.histocache_key(),
	      navigating_inside: this.local.navigating_inside
	    })));
	  },
	  drawHistogramLabels: function() {
	    var label_style;
	    label_style = this.props.label_style || {
	      fontSize: 12,
	      fontWeight: 400,
	      color: '#999',
	      bottom: -19
	    };
	    return [
	      SPAN({
	        style: _.extend({}, label_style, {
	          position: 'absolute',
	          left: 0
	        })
	      }, get_slider_label("slider_pole_labels.oppose", this.props.proposal)), SPAN({
	        style: _.extend({}, label_style, {
	          position: 'absolute',
	          right: 0
	        })
	      }, get_slider_label("slider_pole_labels.support", this.props.proposal))
	    ];
	  },
	  drawSelectionArea: function() {
	    var anchor, base_width, hist, left, selection_left, selection_width;
	    hist = this.get_hist_state();
	    anchor = hist.selected_opinion_value || this.local.mouse_opinion_value;
	    left = ((anchor + 1) / 2 - REGION_SELECTION_WIDTH / 2) * this.props.width;
	    base_width = REGION_SELECTION_WIDTH * this.props.width;
	    selection_width = Math.min(Math.min(base_width, base_width + left), this.props.width - left);
	    selection_left = Math.max(0, left);
	    if (hist.originating_histogram && hist.originating_histogram !== this.props.key) {
	      return DIV(null);
	    }
	    return DIV({
	      style: {
	        height: this.props.height + REGION_SELECTION_VERTICAL_PADDING,
	        position: 'absolute',
	        width: selection_width,
	        backgroundColor: "rgb(246, 247, 249)",
	        cursor: 'pointer',
	        left: selection_left,
	        top: -2,
	        borderTop: "2px solid",
	        borderTopColor: hist.selected_opinions ? focus_color() : 'transparent'
	      }
	    }, !hist.selected_opinions ? DIV({
	      style: css.crossbrowserify({
	        fontSize: 12,
	        textAlign: 'center',
	        whiteSpace: 'nowrap',
	        marginTop: -3,
	        marginLeft: -4,
	        userSelect: 'none',
	        pointerEvents: 'none'
	      })
	    }, TRANSLATE("engage.histogram.select_these_opinions", 'highlight opinions')) : void 0);
	  },
	  onClick: function(ev) {
	    var has_selection, hist, is_clicking_user, is_deselection, max, min, ref, user_key, user_opinion;
	    ev.stopPropagation();
	    hist = this.get_hist_state();
	    if (this.props.backgrounded) {
	      if (this.props.on_click_when_backgrounded) {
	        return this.props.on_click_when_backgrounded();
	      }
	    } else {
	      if (ev.type === 'touchstart') {
	        this.local.mouse_opinion_value = this.getOpinionValueAtFocus(ev);
	      }
	      is_clicking_user = ev.target.className.indexOf('avatar') !== -1;
	      if (is_clicking_user) {
	        user_key = ev.target.getAttribute('data-user');
	        user_opinion = _.findWhere(this.props.opinions, {
	          user: user_key
	        });
	        is_deselection = hist.selected_opinion === user_opinion.key || ((ref = fetch('filtered').users) != null ? ref[user_key] : void 0);
	        if (is_deselection) {
	          reset_selection_state(hist);
	        } else {
	          hist.selected_opinion = user_opinion.key;
	          hist.selected_opinions = null;
	        }
	      } else {
	        max = hist.selected_opinion_value + REGION_SELECTION_WIDTH;
	        min = hist.selected_opinion_value - REGION_SELECTION_WIDTH;
	        is_deselection = (hist.originating_histogram && hist.originating_histogram !== this.props.key) || (hist.selected_opinions && (!this.local.touched || inRange(this.local.mouse_opinion_value, min, max)));
	        if (is_deselection) {
	          reset_selection_state(hist);
	          if (ev.type === 'touchstart') {
	            this.local.mouse_opinion_value = null;
	          }
	        } else if (this.props.enable_range_selection) {
	          hist.selected_opinion = null;
	          hist.selected_opinions = this.getOpinionsInCurrentRegion();
	          hist.originating_histogram = this.props.key;
	        }
	      }
	      has_selection = hist.selected_opinion || hist.selected_opinions;
	      hist.selected_opinion_value = !has_selection ? null : !is_clicking_user ? this.local.mouse_opinion_value : user_opinion.stance;
	      save(hist);
	      return save(this.local);
	    }
	  },
	  getOpinionValueAtFocus: function(ev) {
	    var h_w, h_x, m_x;
	    h_x = this.getDOMNode().getBoundingClientRect().left + window.pageXOffset;
	    h_w = this.getDOMNode().offsetWidth;
	    m_x = ev.pageX || ev.touches[0].pageX;
	    return translatePixelXToStance(m_x - h_x, h_w);
	  },
	  onMouseMove: function(ev) {
	    var hist;
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving || this.props.backgrounded || !this.props.enable_range_selection) {
	      return;
	    }
	    hist = this.get_hist_state();
	    if (hist.originating_histogram && hist.originating_histogram !== this.props.key) {
	      return;
	    }
	    ev.stopPropagation();
	    this.local.hoving_over_avatar = ev.target.className.indexOf('avatar') !== -1;
	    this.local.mouse_opinion_value = this.getOpinionValueAtFocus(ev);
	    if (this.local.mouse_opinion_value + REGION_SELECTION_WIDTH >= 1) {
	      this.local.mouse_opinion_value = 1 - REGION_SELECTION_WIDTH;
	    } else if (this.local.mouse_opinion_value - REGION_SELECTION_WIDTH <= -1) {
	      this.local.mouse_opinion_value = -1 + REGION_SELECTION_WIDTH;
	    }
	    if (hist.selected_opinions && this.local.mouse_opinion_value) {
	      hist.selected_opinions = this.getOpinionsInCurrentRegion();
	      hist.selected_opinion_value = this.local.mouse_opinion_value;
	      save(hist);
	    }
	    return save(this.local);
	  },
	  onMouseDown: function(ev) {
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving) {
	      return;
	    }
	    ev.stopPropagation();
	    return false;
	  },
	  onMouseLeave: function(ev) {
	    var hist;
	    hist = this.get_hist_state();
	    if (fetch(namespaced_key('slider', this.props.proposal)).is_moving || (hist.originating_histogram && hist.originating_histogram !== this.props.key)) {
	      return;
	    }
	    this.local.mouse_opinion_value = null;
	    return save(this.local);
	  },
	  getOpinionsInCurrentRegion: function() {
	    var all_opinions, hist, max, min, o, selected_opinions;
	    hist = this.get_hist_state();
	    all_opinions = this.props.opinions || [];
	    min = this.local.mouse_opinion_value - REGION_SELECTION_WIDTH;
	    max = this.local.mouse_opinion_value + REGION_SELECTION_WIDTH;
	    selected_opinions = (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = all_opinions.length; j < len; j++) {
	        o = all_opinions[j];
	        if (inRange(o.stance, min, max)) {
	          results.push(o.key);
	        }
	      }
	      return results;
	    })();
	    return selected_opinions;
	  },
	  histocache_key: function() {
	    var filter_out, key, o, opinions;
	    filter_out = fetch('filtered');
	    opinions = (function() {
	      var j, len, ref, ref1, results;
	      ref = this.props.opinions;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        o = ref[j];
	        if (filter_out.enable_comparison || !((ref1 = filter_out.users) != null ? ref1[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    }).call(this);
	    key = JSON.stringify(_.map(opinions, (function(_this) {
	      return function(o) {
	        return Math.round(fetch(o.key).stance * 100) / 100;
	      };
	    })(this)));
	    key += " (" + this.props.width + ", " + this.props.height + ")";
	    return md5(key);
	  },
	  try_histocache: function() {
	    var histocache_key, proposal, ref, ref1;
	    if (!ENABLE_SERVER_HISTOCACHE) {
	      return false;
	    }
	    proposal = fetch(this.props.proposal);
	    histocache_key = this.histocache_key();
	    if ((ref = proposal.histocache) != null ? ref[histocache_key] : void 0) {
	      if (histocache_key !== ((ref1 = this.local.histocache) != null ? ref1.hash : void 0)) {
	        this.local.histocache = {
	          hash: histocache_key,
	          positions: proposal.histocache[histocache_key]
	        };
	        save(this.local);
	      }
	      return true;
	    }
	    return false;
	  },
	  physicsSimulation: function() {
	    var filter_out, filtered_opinions, histocache_key, i, noop, o, opinion, opinions, proposal, ref;
	    filter_out = fetch('filtered');
	    proposal = fetch(this.props.proposal);
	    if (proposal.histocache == null) {
	      return;
	    }
	    histocache_key = this.histocache_key();
	    if (this.try_histocache()) {
	      noop = 1;
	    } else if (!this.local.dirty && histocache_key !== ((ref = this.local.histocache) != null ? ref.hash : void 0) && this.current_request !== histocache_key) {
	      filtered_opinions = (function() {
	        var j, len, ref1, ref2, results;
	        ref1 = this.props.opinions;
	        results = [];
	        for (j = 0, len = ref1.length; j < len; j++) {
	          o = ref1[j];
	          if (filter_out.enable_comparison || !((ref2 = filter_out.users) != null ? ref2[o.user] : void 0)) {
	            results.push(o);
	          }
	        }
	        return results;
	      }).call(this);
	      opinions = (function() {
	        var j, len, results;
	        results = [];
	        for (i = j = 0, len = filtered_opinions.length; j < len; i = ++j) {
	          opinion = filtered_opinions[i];
	          results.push({
	            stance: opinion.stance,
	            user: opinion.user
	          });
	        }
	        return results;
	      })();
	      setTimeout((function(_this) {
	        return function() {
	          if (_this.isMounted()) {
	            return layoutAvatars({
	              k: histocache_key,
	              w: _this.props.width,
	              h: _this.props.height,
	              o: opinions,
	              r: _this.local.avatar_size / 2,
	              abort: function() {
	                var abort;
	                abort = !_this.isMounted() || _this.current_request !== histocache_key;
	                return abort;
	              },
	              done: function(positions) {
	                if (!_this.isMounted()) {
	                  return;
	                }
	                if (Object.keys(positions).length !== 0 && _this.current_request === histocache_key) {
	                  _this.local.histocache = {
	                    hash: histocache_key,
	                    positions: positions
	                  };
	                  save(_this.local);
	                  proposal.histocache[histocache_key] = positions;
	                  return save({
	                    key: "/histogram/proposal/" + (fetch(_this.props.proposal).id) + "/" + histocache_key,
	                    positions: positions
	                  });
	                }
	              }
	            });
	          }
	        };
	      })(this), 1);
	    }
	    return this.current_request = histocache_key;
	  },
	  componentDidMount: function() {
	    return this.physicsSimulation();
	  },
	  componentDidUpdate: function() {
	    return this.physicsSimulation();
	  }
	});
	
	HistoAvatars = ReactiveComponent({
	  displayName: 'HistoAvatars',
	  render: function() {
	    var alt, avatar_style, backgrounded, backgrounded_page_avatar_style, filter_out, highlighted_users, idx, o, opinion, paragraph, paragraphs, pos, regular_avatar_style, selected_avatar_style, selected_users, stance, unselected_avatar_style, user;
	    filter_out = fetch('filtered');
	    highlighted_users = this.props.highlighted_users;
	    selected_users = this.props.selected_opinion ? [this.props.selected_opinion] : this.props.selected_opinions;
	    if (selected_users) {
	      if (highlighted_users) {
	        highlighted_users = _.intersection(highlighted_users, (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = selected_users.length; j < len; j++) {
	            o = selected_users[j];
	            results.push(fetch(o).user);
	          }
	          return results;
	        })());
	      } else {
	        highlighted_users = (function() {
	          var j, len, results;
	          results = [];
	          for (j = 0, len = selected_users.length; j < len; j++) {
	            o = selected_users[j];
	            results.push(fetch(o).user);
	          }
	          return results;
	        })();
	      }
	    }
	    regular_avatar_style = {
	      width: this.props.avatar_size,
	      height: this.props.avatar_size,
	      position: 'absolute',
	      cursor: this.props.enable_individual_selection ? 'pointer' : 'auto'
	    };
	    selected_avatar_style = _.extend({}, regular_avatar_style, {
	      zIndex: 9,
	      backgroundColor: focus_color()
	    });
	    css.crossbrowserify(selected_avatar_style);
	    unselected_avatar_style = _.extend({}, regular_avatar_style, {
	      opacity: .2
	    });
	    backgrounded_page_avatar_style = _.extend({}, unselected_avatar_style, {
	      opacity: customization('show_histogram_on_crafting', this.props.proposal) ? .1 : 0.0
	    });
	    return DIV({
	      key: this.props.histocache_key,
	      ref: 'histo',
	      style: {
	        height: this.props.height,
	        position: 'relative',
	        top: -1,
	        cursor: !this.props.backgrounded && this.props.enable_range_selection ? 'pointer' : void 0
	      }
	    }, (function() {
	      var j, k, len, len1, ref, ref1, ref2, ref3, results;
	      ref = this.props.opinions;
	      results = [];
	      for (idx = j = 0, len = ref.length; j < len; idx = ++j) {
	        opinion = ref[idx];
	        user = opinion.user;
	        backgrounded = (ref1 = filter_out.users) != null ? ref1[user] : void 0;
	        if (backgrounded && !filter_out.enable_comparison) {
	          continue;
	        }
	        o = fetch(opinion);
	        if (backgrounded || this.props.backgrounded) {
	          avatar_style = fetch('/current_user').user === user ? _.extend({}, regular_avatar_style, {
	            opacity: .25
	          }) : backgrounded_page_avatar_style;
	        } else if (highlighted_users) {
	          if (_.contains(highlighted_users, opinion.user)) {
	            avatar_style = selected_avatar_style;
	          } else {
	            avatar_style = unselected_avatar_style;
	          }
	        } else {
	          avatar_style = regular_avatar_style;
	        }
	        pos = (ref2 = this.props.histocache) != null ? (ref3 = ref2.positions) != null ? ref3[(user.key || user).split('/user/')[1]] : void 0 : void 0;
	        stance = opinion.stance;
	        if (stance > .01) {
	          alt = ((stance * 100).toFixed(0)) + "%";
	        } else if (stance < -.01) {
	          alt = "– " + ((stance * -100).toFixed(0)) + "%";
	        } else {
	          alt = translator("engage.histogram.user_is_neutral", "is neutral");
	        }
	        if (opinion.explanation) {
	          paragraphs = safe_string(opinion.explanation).split(/(?:\r?\n)/g);
	          alt += "<div style='margin-top: 12px; max-width:400px'>Their explanation:<div style='padding:4px 12px'>";
	          for (k = 0, len1 = paragraphs.length; k < len1; k++) {
	            paragraph = paragraphs[k];
	            alt += "<p style='font-style:italic'>" + paragraph + "</p>";
	          }
	          alt += '</div></div>';
	        }
	        results.push(avatar(user, {
	          ref: "avatar-" + idx,
	          focusable: this.props.navigating_inside && !this.props.backgrounded && !backgrounded,
	          hide_tooltip: this.props.backgrounded || backgrounded,
	          alt: "<user>: " + alt,
	          style: _.extend({}, avatar_style, {
	            left: pos != null ? pos[0] : void 0,
	            top: pos != null ? pos[1] : void 0
	          })
	        }));
	      }
	      return results;
	    }).call(this));
	  }
	});
	
	layoutAvatars = function(opts) {
	  histo_queue.push(opts);
	  if (!histo_running) {
	    return histo_run_next_job();
	  }
	};
	
	histo_queue = [];
	
	histo_running = null;
	
	histo_run_next_job = function(completed) {
	  if (histo_running === completed) {
	    histo_running = null;
	  }
	  if (!histo_running && histo_queue.length > 0) {
	    histo_running = histo_queue.shift();
	    return positionAvatars(histo_running);
	  }
	};
	
	positionAvatars = function(opts) {
	  var aborted, alpha, collide, decay, energy_reduced_by_swap, height, i, j, len, min_alpha, nodes, o, opinions, positions, r, stable, swap_position, targets, tick, total_ticks, width, x_force_mult, y_force_mult;
	  energy_reduced_by_swap = function(p1, p2) {
	    var p1_jealousy, p2_jealousy;
	    p1_jealousy = (p1.x - p1.x_target) * (p1.x - p1.x_target) - (p2.x - p1.x_target) * (p2.x - p1.x_target);
	    p2_jealousy = (p2.x - p2.x_target) * (p2.x - p2.x_target) - (p1.x - p2.x_target) * (p1.x - p2.x_target);
	    return p1_jealousy + p2_jealousy;
	  };
	  swap_position = function(p1, p2) {
	    var swap_x, swap_y;
	    swap_x = p1.x;
	    swap_y = p1.y;
	    p1.x = p2.x;
	    p1.y = p2.y;
	    p2.x = swap_x;
	    return p2.y = swap_y;
	  };
	  tick = function(alpha) {
	    var dx, dy, i, j, k, len, len1, n, o, q, stable;
	    stable = true;
	    q = d3.geom.quadtree(nodes);
	    for (j = 0, len = nodes.length; j < len; j++) {
	      n = nodes[j];
	      q.visit(collide(n, alpha));
	    }
	    for (i = k = 0, len1 = nodes.length; k < len1; i = ++k) {
	      o = nodes[i];
	      o.px = o.x;
	      o.py = o.y;
	      o.x += alpha * (x_force_mult * width * .001) * (o.x_target - o.x);
	      o.y += alpha * y_force_mult;
	      if (o.x < o.radius) {
	        o.x = o.radius;
	      } else if (o.x > width - o.radius) {
	        o.x = width - o.radius;
	      }
	      if (o.y < o.radius) {
	        o.y = o.radius;
	      } else if (o.y > height - o.radius) {
	        o.y = height - o.radius;
	      }
	      dx = Math.abs(o.py - o.y);
	      dy = Math.abs(o.px - o.x) > .1;
	      if (stable && Math.sqrt(dx * dx + dy * dy) > 1) {
	        stable = false;
	      }
	    }
	    return stable;
	  };
	  collide = function(p1, alpha) {
	    return function(quad, x1, y1, x2, y2) {
	      var combined_r, dist, dx, dy, neighborhood_radius, nx1, nx2, ny1, ny2, offset_x, offset_y, p2, separate_by;
	      p2 = quad.point;
	      if (quad.leaf && p2 && p2 !== p1) {
	        dx = Math.abs(p1.x - p2.x);
	        dy = Math.abs(p1.y - p2.y);
	        dist = Math.sqrt(dx * dx + dy * dy);
	        combined_r = p1.radius + p2.radius;
	        if (energy_reduced_by_swap(p1, p2) > 0) {
	          swap_position(p1, p2);
	        }
	        if (dist < combined_r) {
	          separate_by = dist === 0 ? 1 : (combined_r - dist) / combined_r;
	          offset_x = (combined_r - dx) * separate_by;
	          offset_y = (combined_r - dy) * separate_by;
	          if (p1.x < p2.x) {
	            p1.x -= offset_x / 2;
	            p2.x += offset_x / 2;
	          } else {
	            p2.x -= offset_x / 2;
	            p1.x += offset_x / 2;
	          }
	          if (p1.y < p2.y) {
	            p1.y -= offset_y / 2;
	            p2.y += offset_y / 2;
	          } else {
	            p2.y -= offset_y / 2;
	            p1.y += offset_y / 2;
	          }
	        }
	      }
	      neighborhood_radius = p1.radius;
	      nx1 = p1.x - neighborhood_radius;
	      nx2 = p1.x + neighborhood_radius;
	      ny1 = p1.y - neighborhood_radius;
	      ny2 = p1.y + neighborhood_radius;
	      return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
	    };
	  };
	  targets = {};
	  opinions = opts.o.slice();
	  width = opts.w || 400;
	  height = opts.h || 70;
	  r = calculateAvatarRadius(width, height, opinions);
	  nodes = opinions.map(function(o, i) {
	    var x, x_target, y;
	    x_target = (o.stance + 1) / 2 * width;
	    if (targets[x_target]) {
	      if (x_target > .98) {
	        x_target -= .1 * Math.random();
	      } else if (x_target < .02) {
	        x_target += .1 * Math.random();
	      }
	    }
	    targets[x_target] = 1;
	    x = x_target;
	    y = height - r;
	    return {
	      index: i,
	      radius: r,
	      x: x,
	      y: y,
	      x_target: x_target
	    };
	  });
	  stable = false;
	  alpha = .8;
	  decay = .8;
	  min_alpha = 0.0000001;
	  x_force_mult = 2;
	  y_force_mult = 2;
	  total_ticks = 0;
	  while (true) {
	    stable = tick(alpha);
	    alpha *= decay;
	    total_ticks += 1;
	    stable || (stable = alpha <= min_alpha);
	    aborted = typeof opts.abort === "function" ? opts.abort() : void 0;
	    if (stable || aborted) {
	      break;
	    }
	  }
	  if (!aborted) {
	    positions = {};
	    for (i = j = 0, len = nodes.length; j < len; i = ++j) {
	      o = nodes[i];
	      positions[parseInt(opinions[i].user.split('/user/')[1])] = [Math.round((o.x - o.radius) * 10) / 10, Math.round((o.y - o.radius) * 10) / 10];
	    }
	    if (typeof opts.done === "function") {
	      opts.done(positions);
	    }
	  }
	  return histo_run_next_job(opts);
	};
	
	calculateAvatarRadius = function(width, height, opinions) {
	  var area_per_avatar, avg, avg_inc, avg_of_moving_avg, cnt, current_region, dense_regions, effective_width, filter_out, idx, j, k, l, len, len1, len2, max_opinions, max_region, moving_avg, o, r, ratio_filled, region, reset, stance, sum, window_size;
	  filter_out = fetch('filtered');
	  if (filter_out.users && !filter_out.enable_comparison) {
	    opinions = (function() {
	      var j, len, ref, results;
	      results = [];
	      for (j = 0, len = opinions.length; j < len; j++) {
	        o = opinions[j];
	        if (!((ref = filter_out.users) != null ? ref[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	  }
	  opinions.sort(function(a, b) {
	    return a.stance - b.stance;
	  });
	  window_size = .3;
	  avg_inc = .01;
	  moving_avg = [];
	  idx = 0;
	  stance = -1.0;
	  sum = 0;
	  while (stance <= 1.0) {
	    o = idx;
	    cnt = 0;
	    while (o < opinions.length) {
	      if (opinions[o].stance < stance - window_size) {
	        idx = o;
	      } else if (opinions[o].stance > stance + window_size) {
	        break;
	      } else {
	        cnt += 1;
	      }
	      o += 1;
	    }
	    moving_avg.push(cnt);
	    stance += avg_inc;
	    sum += cnt;
	  }
	  dense_regions = [];
	  avg_of_moving_avg = sum / moving_avg.length;
	  current_region = [];
	  for (idx = j = 0, len = moving_avg.length; j < len; idx = ++j) {
	    avg = moving_avg[idx];
	    reset = idx === moving_avg.length - 1;
	    if (avg >= avg_of_moving_avg) {
	      current_region.push(idx);
	    } else {
	      reset = true;
	    }
	    if (reset && current_region.length > 0) {
	      dense_regions.push([current_region[0] * avg_inc - 1.0 - window_size, idx * avg_inc - 1.0 + window_size]);
	      current_region = [];
	    }
	  }
	  max_region = null;
	  max_opinions = 0;
	  for (k = 0, len1 = dense_regions.length; k < len1; k++) {
	    region = dense_regions[k];
	    cnt = 0;
	    for (l = 0, len2 = opinions.length; l < len2; l++) {
	      o = opinions[l];
	      if (o.stance >= region[0] && o.stance <= region[1]) {
	        cnt += 1;
	      }
	    }
	    if (cnt > max_opinions) {
	      max_opinions = cnt;
	      max_region = region;
	    }
	  }
	  ratio_filled = .5;
	  if (max_opinions > 0) {
	    effective_width = width * Math.abs(max_region[0] - max_region[1]) / 2;
	    area_per_avatar = ratio_filled * effective_width * height / max_opinions;
	    r = Math.sqrt(area_per_avatar) / 2;
	  } else {
	    r = Math.sqrt(width * height / opinions.length * ratio_filled) / 2;
	  }
	  r = Math.min(r, width / 2, height / 2);
	  return r;
	};


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	var ApplyFilters, OpinionFilter, ProposalSort, SortProposalsMenu, VerificationProcessExplanation, basic_proposal_scoring, regexes, set_comparison_mode, set_sort, sort_options, toggle_filter;
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(11);
	
	regexes = {};
	
	ApplyFilters = ReactiveComponent({
	  displayName: 'ApplyFilters',
	  render: function() {
	    var editor, filter, filter_out, filters, l, len, len1, len2, m, new_filter_out, passes, proposal, proposals, q, ref, ref1, ref2, text;
	    filters = fetch('filters');
	    filter_out = fetch('filtered');
	    filter_out.proposals || (filter_out.proposals = {});
	    proposals = fetch('/proposals');
	    new_filter_out = {};
	    ref = filters.for_proposals || [];
	    for (l = 0, len = ref.length; l < len; l++) {
	      filter = ref[l];
	      if (!regexes[filter]) {
	        regexes[filter] = new RegExp(filter, 'i');
	      }
	    }
	    ref1 = proposals.proposals;
	    for (m = 0, len1 = ref1.length; m < len1; m++) {
	      proposal = ref1[m];
	      editor = proposal_editor(proposal);
	      if (editor) {
	        editor = fetch(editor).name;
	      } else {
	        editor = "";
	      }
	      text = editor + " " + proposal.name + " " + proposal.description + " " + (prettyDate(proposal.created_at));
	      passes = true;
	      ref2 = filters.for_proposals || [];
	      for (q = 0, len2 = ref2.length; q < len2; q++) {
	        filter = ref2[q];
	        passes && (passes = !!text.match(regexes[filter]));
	      }
	      if (!passes) {
	        new_filter_out[proposal.key] = 1;
	      }
	    }
	    if (JSON.stringify(new_filter_out) !== JSON.stringify(filter_out.proposals)) {
	      filter_out.proposals = new_filter_out;
	      save(filter_out);
	    }
	    return SPAN(null);
	  }
	});
	
	window.invalidate_proposal_sorts = function() {
	  var k, ref, sort, v;
	  sort = fetch('sort_proposals');
	  ref = sort.sorts;
	  for (k in ref) {
	    v = ref[k];
	    v.force_resort = true;
	  }
	  return save(sort);
	};
	
	window.sorted_proposals = function(proposals, sort_key, require_force) {
	  var cached_order, comp, dict_proposals, filter_out, filtered, filters, k, keys, l, len, len1, len2, m, order, p, proposal, q, sort;
	  sort = fetch('sort_proposals');
	  if (sort.name == null) {
	    set_sort();
	  }
	  filters = fetch('filtered');
	  proposals = proposals.slice();
	  filter_out = fetch('filtered');
	  if (filter_out.proposals) {
	    filtered = [];
	    for (l = 0, len = proposals.length; l < len; l++) {
	      proposal = proposals[l];
	      if (filter_out.proposals[proposal.key]) {
	        filtered.push(proposal);
	      }
	    }
	    for (m = 0, len1 = filtered.length; m < len1; m++) {
	      proposal = filtered[m];
	      proposals.splice(proposals.indexOf(proposal), 1);
	    }
	  }
	  comp = sort.comp;
	  proposals = proposals.sort(comp);
	  if (require_force) {
	    sort.sorts || (sort.sorts = {});
	    keys = (function() {
	      var len2, q, ref, results;
	      ref = proposals || [];
	      results = [];
	      for (q = 0, len2 = ref.length; q < len2; q++) {
	        p = ref[q];
	        results.push(p.key);
	      }
	      return results;
	    })();
	    order = md5(keys);
	    cached_order = null;
	    if (sort_key in sort.sorts) {
	      cached_order = md5(sort.sorts[sort_key].cache);
	    } else {
	      cached_order = null;
	      sort.sorts[sort_key] = {
	        cache: [],
	        stale: true,
	        force_resort: true
	      };
	    }
	    if (cached_order === order) {
	      if (sort.sorts[sort_key].force_resort) {
	        sort.sorts[sort_key].force_resort = false;
	        sort.sorts[sort_key].stale = false;
	        save(sort);
	      }
	    } else if (sort.sorts[sort_key].force_resort || proposals.length !== sort.sorts[sort_key].cache.length) {
	      sort.sorts[sort_key].force_resort = false;
	      sort.sorts[sort_key].stale = false;
	      sort.sorts[sort_key].cache = (function() {
	        var len2, q, results;
	        results = [];
	        for (q = 0, len2 = proposals.length; q < len2; q++) {
	          p = proposals[q];
	          results.push(p.key);
	        }
	        return results;
	      })();
	      save(sort);
	    } else {
	      if (!sort.sorts[sort_key].stale) {
	        sort.sorts[sort_key].stale = true;
	        save(sort);
	      }
	      dict_proposals = {};
	      for (q = 0, len2 = proposals.length; q < len2; q++) {
	        p = proposals[q];
	        dict_proposals[p.key] = p;
	      }
	      proposals = (function() {
	        var len3, r, ref, results;
	        ref = sort.sorts[sort_key].cache;
	        results = [];
	        for (r = 0, len3 = ref.length; r < len3; r++) {
	          k = ref[r];
	          results.push(dict_proposals[k]);
	        }
	        return results;
	      })();
	    }
	  }
	  return proposals;
	};
	
	basic_proposal_scoring = function(proposal, opinion_value) {
	  var avg, differences, filtered_out, l, len, len1, m, o, opinion, opinions, std_dev, sum;
	  if (!opinion_value) {
	    opinion_value = function(o) {
	      return o.stance;
	    };
	  }
	  opinions = fetch(proposal).opinions;
	  if (!opinions || opinions.length === 0) {
	    return {
	      sum: 0,
	      avg: 0,
	      std_dev: 0,
	      opinions: []
	    };
	  }
	  filtered_out = fetch('filtered');
	  if (filtered_out.users) {
	    opinions = (function() {
	      var l, len, ref, results;
	      results = [];
	      for (l = 0, len = opinions.length; l < len; l++) {
	        o = opinions[l];
	        if (filtered_out.enable_comparison || !((ref = filtered_out.users) != null ? ref[o.user] : void 0)) {
	          results.push(o);
	        }
	      }
	      return results;
	    })();
	  }
	  sum = 0;
	  for (l = 0, len = opinions.length; l < len; l++) {
	    opinion = opinions[l];
	    sum += opinion_value(opinion);
	  }
	  avg = sum / opinions.length;
	  differences = 0;
	  for (m = 0, len1 = opinions.length; m < len1; m++) {
	    o = opinions[m];
	    differences += (o.stance - avg) * (o.stance - avg);
	  }
	  std_dev = Math.sqrt(differences / opinions.length);
	  return {
	    sum: sum,
	    avg: avg,
	    std_dev: std_dev,
	    opinions: opinions
	  };
	};
	
	sort_options = [
	  {
	    comp: function(a, b) {
	      return basic_proposal_scoring(b, (function(o) {
	        return o.stance;
	      })).avg - basic_proposal_scoring(a, (function(o) {
	        return o.stance;
	      })).avg;
	    },
	    name: 'Average Score',
	    description: "Each response is scored by the average opinion score, where opinions are on [-1, 1]."
	  }, {
	    comp: function(a, b) {
	      return basic_proposal_scoring(b, (function(o) {
	        return o.stance;
	      })).sum - basic_proposal_scoring(a, (function(o) {
	        return o.stance;
	      })).sum;
	    },
	    name: 'Total Score',
	    description: "Each response is scored by the sum of opinions, where opinions are on [-1, 1]."
	  }, {
	    name: 'Trending',
	    description: "'Total Score', except that newer opinions and responses are weighed more heavily.",
	    comp: function(a, b) {
	      var ov, val;
	      ov = function(o) {
	        var n, ot;
	        ot = new Date(o.updated_at).getTime();
	        n = Date.now();
	        return o.stance / (1 + Math.pow((n - ot) / 100000, 2));
	      };
	      val = function(proposal) {
	        var n, pt, sum;
	        sum = basic_proposal_scoring(proposal, ov).sum;
	        n = Date.now();
	        pt = new Date(proposal.created_at).getTime();
	        return sum / (1 + (n - pt) / 10000000000);
	      };
	      return val(b) - val(a);
	    }
	  }, {
	    name: 'Alphabetically',
	    comp: function(a, b) {
	      return a.name.localeCompare(b.name);
	    },
	    description: "Sort alphabetically by the response's title"
	  }, {
	    comp: function(a, b) {
	      return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
	    },
	    name: 'Newest',
	    description: "The responses submitted most recently are shown first."
	  }, {
	    name: 'Unity',
	    description: "Responses where the community is most united for or against are shown highest.",
	    comp: function(a, b) {
	      var ov, val;
	      ov = function(o) {
	        return o.stance;
	      };
	      val = function(proposal) {
	        var stats;
	        stats = basic_proposal_scoring(proposal, ov);
	        if (stats.opinions.length > 1) {
	          return Math.log(stats.opinions.length + 1) / stats.std_dev / (1 - Math.abs(stats.avg) + 1);
	        } else {
	          return -1;
	        }
	      };
	      return val(b) - val(a);
	    }
	  }, {
	    name: 'Difference',
	    description: "Responses where the community is most split are shown highest.",
	    comp: function(a, b) {
	      var ov, val;
	      ov = function(o) {
	        return o.stance;
	      };
	      val = function(proposal) {
	        var stats;
	        stats = basic_proposal_scoring(proposal, ov);
	        if (stats.opinions.length > 1) {
	          return stats.std_dev * Math.log(stats.opinions.length + 1);
	        } else {
	          return -1;
	        }
	      };
	      return val(b) - val(a);
	    }
	  }, {
	    name: 'Most Activity',
	    description: "Ranked by number of opinions and discussion.",
	    comp: function(a, b) {
	      var ov;
	      ov = function(o) {
	        return 1 + (o.point_inclusions || []).length;
	      };
	      return basic_proposal_scoring(b, ov).sum - basic_proposal_scoring(a, ov).sum;
	    }
	  }
	];
	
	set_sort = function() {
	  var def, def_sort, found, l, len, len1, loc, m, ref, s, sort;
	  sort = fetch('sort_proposals');
	  if (sort.name == null) {
	    found = false;
	    loc = fetch('location');
	    if ((ref = loc.query_params) != null ? ref.sort_by : void 0) {
	      for (l = 0, len = sort_options.length; l < len; l++) {
	        s = sort_options[l];
	        if (s.name === loc.query_params.sort_by.replace('_', ' ')) {
	          _.extend(sort, s || sort_options[2]);
	          found = true;
	          break;
	        }
	      }
	    }
	    if (!found) {
	      if (def_sort = customization('homepage_default_sort_order')) {
	        def = null;
	        for (m = 0, len1 = sort_options.length; m < len1; m++) {
	          s = sort_options[m];
	          if (s.name === def_sort) {
	            def = s;
	            break;
	          }
	        }
	        _.extend(sort, def || sort_options[2]);
	      } else {
	        _.extend(sort, sort_options[2]);
	      }
	    }
	    return save(sort);
	  }
	};
	
	ProposalSort = ReactiveComponent({
	  displayName: 'ProposalSort',
	  render: function() {
	    var filter_out, proposals, subdomain;
	    proposals = fetch('/proposals');
	    filter_out = fetch('filtered');
	    subdomain = fetch('/subdomain');
	    if (!subdomain.name) {
	      return SPAN(null);
	    }
	    return SPAN({
	      style: _.defaults(this.props.style || {})
	    }, DIV({
	      style: {
	        display: 'inline-block',
	        paddingRight: 12
	      }
	    }, SortProposalsMenu()));
	  }
	});
	
	SortProposalsMenu = ReactiveComponent({
	  displayName: 'SortProposalsMenu',
	  render: function() {
	    var sort;
	    sort = fetch('sort_proposals');
	    if (sort.name == null) {
	      set_sort();
	    }
	    return SPAN({
	      style: {
	        color: 'black',
	        fontSize: 20
	      }
	    }, TRANSLATE("engage.sort_by", "sort by"), " ", DropMenu({
	      options: sort_options,
	      open_menu_on: 'activation',
	      selection_made_callback: function(option) {
	        invalidate_proposal_sorts();
	        _.extend(sort, option);
	        return save(sort);
	      },
	      render_anchor: function() {
	        return SPAN({
	          style: {
	            fontWeight: 700
	          }
	        }, translator("engage.sort_order." + sort.name, sort.name), SPAN({
	          style: _.extend(cssTriangle('bottom', focus_color(), 8, 5, {
	            display: 'inline-block',
	            marginLeft: 4,
	            marginBottom: 2
	          }))
	        }));
	      },
	      render_option: function(option, is_active) {
	        return [
	          DIV({
	            style: {
	              fontWeight: 600,
	              fontSize: 20
	            }
	          }, translator("engage.sort_order." + option.name, option.name)), DIV({
	            style: {
	              fontSize: 12,
	              color: is_active ? 'white' : 'black'
	            }
	          }, translator("engage.sort_order." + option.name + ".description", option.description))
	        ];
	      },
	      wrapper_style: {
	        display: 'inline-block'
	      },
	      anchor_style: {
	        fontWeight: 600,
	        padding: 0,
	        display: 'inline-block',
	        color: focus_color(),
	        textTransform: 'lowercase',
	        borderRadius: 16
	      },
	      menu_style: {
	        minWidth: 500,
	        backgroundColor: '#eee',
	        border: "1px solid " + (focus_color()),
	        left: -9999,
	        top: 18,
	        borderRadius: 8,
	        fontWeight: 400,
	        overflow: 'hidden',
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)'
	      },
	      menu_when_open_style: {
	        left: 0
	      },
	      option_style: {
	        padding: '6px 12px',
	        borderBottom: "1px solid #ddd",
	        display: 'block'
	      },
	      active_option_style: {
	        color: 'white',
	        backgroundColor: focus_color()
	      }
	    }));
	  }
	});
	
	window.opinion_trickle = function() {
	  var cnt, filter_out, k, l, len, len1, m, o, prop, proposals, ref, ref1, steps, tick, u, users, v;
	  filter_out = fetch('filtered');
	  proposals = fetch('/proposals');
	  users = {};
	  ref = proposals.proposals;
	  for (l = 0, len = ref.length; l < len; l++) {
	    prop = ref[l];
	    ref1 = prop.opinions;
	    for (m = 0, len1 = ref1.length; m < len1; m++) {
	      o = ref1[m];
	      users[o.user] = o.created_at || o.updated_at;
	    }
	  }
	  users = (function() {
	    var results;
	    results = [];
	    for (k in users) {
	      v = users[k];
	      results.push([k, v]);
	    }
	    return results;
	  })();
	  users.sort(function(a, b) {
	    var i, j;
	    i = new Date(a[1]);
	    j = new Date(b[1]);
	    return i.getTime() - j.getTime();
	  });
	  users = (function() {
	    var len2, q, results;
	    results = [];
	    for (q = 0, len2 = users.length; q < len2; q++) {
	      u = users[q];
	      results.push(u[0]);
	    }
	    return results;
	  })();
	  cnt = users.length;
	  steps = 1;
	  tick = (function(_this) {
	    return function(interval) {
	      if (cnt >= 0) {
	        return setTimeout(function() {
	          var dirty, idx, len2, q, user;
	          filter_out.users = {};
	          for (idx = q = 0, len2 = users.length; q < len2; idx = ++q) {
	            user = users[idx];
	            filter_out.users[user] = 1;
	            if (idx > cnt) {
	              break;
	            }
	          }
	          cnt--;
	          tick(interval * .9);
	          steps++;
	          dirty = true;
	          return setTimeout(function() {
	            if (dirty) {
	              save(filter_out);
	              return dirty = false;
	            }
	          }, 2000);
	        }, interval);
	      }
	    };
	  })(this);
	  return tick(1000);
	};
	
	toggle_filter = function(filter) {
	  var filter_func, filter_out, l, len, ref, ref1, user, users;
	  users = fetch('/users');
	  filter_out = fetch('filtered');
	  if (!users.users) {
	    return;
	  }
	  filter_out.users = {};
	  if (filter_out.current_filter === filter) {
	    filter_out.current_filter = null;
	  } else {
	    filter_out.current_filter = filter;
	  }
	  filter_func = (ref = filter_out.current_filter) != null ? ref.pass : void 0;
	  if (filter_func) {
	    ref1 = users.users;
	    for (l = 0, len = ref1.length; l < len; l++) {
	      user = ref1[l];
	      if (!filter_func(user)) {
	        filter_out.users[user.key] = 1;
	      }
	    }
	  }
	  invalidate_proposal_sorts();
	  return save(filter_out);
	};
	
	set_comparison_mode = function(enabled) {
	  var filter_out;
	  filter_out = fetch('filtered');
	  if (enabled === null) {
	    filter_out.enable_comparison = !filter_out.enable_comparison;
	  } else {
	    filter_out.enable_comparison = enabled;
	  }
	  return save(filter_out);
	};
	
	OpinionFilter = ReactiveComponent({
	  displayName: 'OpinionFilter',
	  render: function() {
	    var current_filter, custom_filters, dfault, filter, filter_out, filters, filters_for_admin, initial_filter, is_admin, l, len, len1, m, ref, users;
	    filter_out = fetch('filtered');
	    users = fetch('/users');
	    if (!users.users) {
	      return DIV(null);
	    }
	    filters_for_admin = customization('opinion_filters_admin_only');
	    custom_filters = customization('opinion_filters');
	    if (typeof custom_filters === 'function') {
	      custom_filters = custom_filters();
	    }
	    is_admin = fetch('/current_user').is_admin;
	    filters = [
	      {
	        label: 'everyone',
	        tooltip: null,
	        pass: function(u) {
	          return true;
	        }
	      }, {
	        label: 'just you',
	        tooltip: null,
	        pass: function(u) {
	          var user;
	          user = fetch(u);
	          return user.key === fetch('/current_user').user;
	        }
	      }
	    ];
	    if (custom_filters && (!filters_for_admin || is_admin)) {
	      for (l = 0, len = custom_filters.length; l < len; l++) {
	        filter = custom_filters[l];
	        if (!filter.admin_only || is_admin) {
	          filters.push(filter);
	        }
	      }
	    }
	    if (!filter_out.current_filter) {
	      dfault = customization('opinion_filters_default') || 'everyone';
	      initial_filter = null;
	      for (m = 0, len1 = filters.length; m < len1; m++) {
	        filter = filters[m];
	        if (filter.label === dfault) {
	          initial_filter = filter;
	          break;
	        }
	      }
	      initial_filter || (initial_filter = filters[0]);
	      toggle_filter(initial_filter);
	    }
	    current_filter = filter_out.current_filter;
	    return DIV({
	      style: this.props.style || {},
	      className: 'filter_opinions_to'
	    }, DIV({
	      style: {
	        marginTop: 0,
	        lineHeight: 1
	      }
	    }, customization('verification-by-pic') ? VerificationProcessExplanation() : void 0, DIV({
	      style: {
	        fontSize: 20,
	        position: 'relative'
	      }
	    },  true ? TRANSLATE("engage.opinion_filter.label", 'show opinion of') : TRANSLATE("engage.opinion_filter.label_short", 'showing'), ": ", DropMenu({
	      options: filters,
	      open_menu_on: 'activation',
	      selection_made_callback: toggle_filter,
	      render_anchor: function() {
	        var key, ref1;
	        key = (ref1 = current_filter != null ? current_filter.label : void 0) !== 'everyone' && ref1 !== 'just you' ? "/translations/" + (fetch('/subdomain').name) : null;
	        return SPAN({
	          style: {
	            fontWeight: 'bold',
	            position: 'relative'
	          }
	        }, translator({
	          id: "opinion_filter.name." + current_filter.label,
	          key: key
	        }, current_filter.label), SPAN({
	          style: _.extend(cssTriangle('bottom', focus_color(), 8, 5, {
	            right: -12,
	            bottom: 8,
	            position: 'absolute'
	          }))
	        }));
	      },
	      render_option: function(filter, is_active) {
	        return [
	          translator({
	            id: "opinion_filter.name." + filter.label,
	            key: "/translations/" + (fetch('/subdomain').name)
	          }, filter.label), filter.tooltip ? DIV({
	            style: {
	              fontSize: 12,
	              color: is_active ? 'white' : 'black'
	            }
	          }, filter.tooltip) : void 0
	        ];
	      },
	      wrapper_style: {
	        display: 'inline-block'
	      },
	      anchor_style: {
	        fontWeight: 600,
	        padding: 0,
	        display: 'inline-block',
	        color: focus_color(),
	        borderRadius: 16,
	        textAlign: (this.props.style || {}).textAlign
	      },
	      menu_style: {
	        minWidth: 300,
	        backgroundColor: '#eee',
	        border: "1px solid " + (focus_color()),
	        left: 'auto',
	        right: -9999,
	        top: 18,
	        borderRadius: 8,
	        fontWeight: 400,
	        overflow: 'hidden',
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)',
	        textAlign: 'right'
	      },
	      menu_when_open_style: {
	        right: 0
	      },
	      option_style: {
	        padding: '6px 12px',
	        borderBottom: "1px solid #ddd",
	        display: 'block'
	      },
	      active_option_style: {
	        color: 'white',
	        backgroundColor: focus_color()
	      }
	    }), current_filter.label !== 'everyone' ? DIV({
	      style: this.props.enable_comparison_wrapper_style || {}
	    }, INPUT({
	      type: 'checkbox',
	      id: 'enable_comparison',
	      checked: filter_out.enable_comparison,
	      ref: 'enable_comparison',
	      onChange: (function(_this) {
	        return function() {
	          return set_comparison_mode(_this.refs.enable_comparison.getDOMNode().checked);
	        };
	      })(this)
	    }), LABEL({
	      htmlFor: 'enable_comparison'
	    }, TRANSLATE('engage.compare_all', "compare to everyone"))) : void 0)));
	  }
	});
	
	VerificationProcessExplanation = ReactiveComponent({
	  displayName: 'VerificationProcessExplanation',
	  render: function() {
	    var callout, para, user, users;
	    users = fetch('/users');
	    callout = "about verification";
	    return DIV({
	      style: {
	        position: 'absolute',
	        right: -sizeWhenRendered(callout, {
	          fontSize: 12
	        }).width,
	        top: -14
	      }
	    }, SPAN({
	      style: {
	        color: "#aaa",
	        fontSize: 14
	      }
	    }, SPAN({
	      style: {
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        color: this.local.describe_process ? logo_red : void 0
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.describe_process = !_this.local.describe_process;
	          return save(_this.local);
	        };
	      })(this)
	    }, callout)), this.local.describe_process ? (para = {
	      marginBottom: 20
	    }, DIV({
	      style: {
	        textAlign: 'left',
	        position: 'absolute',
	        right: 0,
	        top: 40,
	        width: 650,
	        zIndex: 999,
	        padding: "20px 40px",
	        backgroundColor: '#eee',
	        fontSize: 18
	      }
	    }, SPAN({
	      style: cssTriangle('top', '#eee', 16, 8, {
	        position: 'absolute',
	        right: 50,
	        top: -8
	      })
	    }), DIV({
	      style: para
	    }, "Filters help us understand the opinions of the stakeholder groups. Filters are conjunctive: only users that pass all active filters are shown.\nThese are the filters:"), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Users'), ". Verified users have emailed us a verification image to validate their account.  \nWe have also verified a few other people via other media channels, like Reddit. ", SPAN({
	      style: {
	        fontStyle: 'italic'
	      }
	    }, "Verification results shown below.")), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Miners'), ". Miners are ", OL({
	      style: {
	        marginLeft: 20
	      }
	    }, LI(null, 'Users who control a mining pool with > 1% amount of hashrate'), LI(null, 'Users who control > 1% amount of hashrate')), 'We verify hashrate by consulting ', A({
	      href: 'https://blockchain.info/pools',
	      target: '_blank',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'https://blockchain.info/pools'), '.'), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Developers'), ". Bitcoin developers self-report by editing their user profile. If we recognize \nsomeone as a committer or maintainer of Core or XT, we assign it. \nWe aren’t satisfied by our criteria for developer. We hope to work with \nthe community to define a more robust standard for 'reputable technical voice'."), DIV({
	      style: para
	    }, SPAN({
	      style: {
	        fontWeight: 700
	      }
	    }, 'Businesses'), ". Bitcoin businesses self-report by editing their user profile. Business accounts\nare either users who operate the business or an account that will represent that \nbusinesses' official position."), DIV({
	      style: para
	    }, "These filters aren’t perfect. If you think there is a problem, email us at ", A({
	      href: "mailto:admin@consider.it",
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'admin@consider.it'), ". We will try to make a more trustless process in the future."), DIV({
	      style: {}
	    }, DIV({
	      style: {
	        fontWeight: 600,
	        fontSize: 26
	      }
	    }, 'Verification status'), (function() {
	      var l, len, ref, ref1, ref2, results;
	      ref = users.users;
	      results = [];
	      for (l = 0, len = ref.length; l < len; l++) {
	        user = ref[l];
	        user = fetch(user);
	        if (user.tags.verified && ((ref1 = user.tags.verified.toLowerCase()) !== 'no' && ref1 !== 'false')) {
	          results.push(DIV({
	            style: {
	              marginTop: 20
	            }
	          }, DIV({
	            style: {
	              fontWeight: 600
	            }
	          }, user.name), ((ref2 = user.tags.verified) != null ? ref2.indexOf('http') : void 0) === 0 ? IMG({
	            src: user.tags.verified,
	            style: {
	              width: 400
	            }
	          }) : DIV({
	            style: {
	              fontStyle: 'italic'
	            }
	          }, user.tags.verified)));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    })()))) : void 0);
	  }
	});
	
	window.ProposalSort = ProposalSort;
	
	window.SortProposalsMenu = SortProposalsMenu;
	
	window.OpinionFilter = OpinionFilter;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var ClusterHeading, ProposalsLoading;
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(5);
	
	__webpack_require__(3);
	
	__webpack_require__(4);
	
	__webpack_require__(13);
	
	__webpack_require__(4);
	
	__webpack_require__(19);
	
	__webpack_require__(26);
	
	__webpack_require__(24);
	
	window.AuthCallout = ReactiveComponent({
	  displayName: 'AuthCallout',
	  render: function() {
	    var current_user, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    if (current_user.logged_in) {
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        width: '100%',
	        paddingBottom: 16
	      }
	    }, DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        fontSize: 24,
	        fontWeight: 600
	      }
	    }, subdomain.SSO_domain ? TRANSLATE({
	      id: 'create_account.call_out',
	      BUTTON1: {
	        component: A,
	        args: {
	          href: '/login_via_saml',
	          treat_as_external_link: true,
	          style: {
	            backgroundColor: 'transparent',
	            border: 'none',
	            fontWeight: 800,
	            textDecoration: 'underline',
	            textTransform: 'lowercase',
	            padding: 0
	          }
	        }
	      }
	    }, "Please <BUTTON1>create an account</BUTTON1> to participate") : TRANSLATE({
	      id: 'create_account.call_out',
	      BUTTON1: {
	        component: BUTTON,
	        args: {
	          'data-action': 'create',
	          onClick: (function(_this) {
	            return function(e) {
	              return reset_key('auth', {
	                form: 'create account',
	                ask_questions: true
	              });
	            };
	          })(this),
	          style: {
	            backgroundColor: 'transparent',
	            border: 'none',
	            fontWeight: 800,
	            textDecoration: 'underline',
	            textTransform: 'lowercase',
	            padding: 0
	          }
	        }
	      }
	    }, "Please <BUTTON1>create an account</BUTTON1> to participate"))));
	  }
	});
	
	window.Homepage = ReactiveComponent({
	  displayName: 'Homepage',
	  render: function() {
	    var doc, subdomain, title;
	    doc = fetch('document');
	    subdomain = fetch('/subdomain');
	    if (!subdomain.name) {
	      return SPAN(null);
	    }
	    title = subdomain.branding.masthead_header_text || subdomain.app_title || (subdomain.name + " considerit homepage");
	    if (doc.title !== title) {
	      doc.title = title;
	      save(doc);
	    }
	    return DIV({
	      key: "homepage_" + subdomain.name
	    }, SimpleHomepage());
	  }
	});
	
	window.proposal_editor = function(proposal) {
	  var e, editor, editors;
	  editors = (function() {
	    var i, len, ref, results;
	    ref = proposal.roles.editor;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      e = ref[i];
	      if (e !== '*') {
	        results.push(e);
	      }
	    }
	    return results;
	  })();
	  editor = editors.length > 0 && editors[0];
	  return editor !== '-' && editor;
	};
	
	window.column_sizes = function(args) {
	  var width;
	  args || (args = {});
	  width = args.width || HOMEPAGE_WIDTH();
	  return {
	    first: width * .6 - 50,
	    second: width * .4,
	    gutter: 50
	  };
	};
	
	window.HomepageTabUrlReflector = ReactiveComponent({
	  displayName: "HomepageTabUrlReflector"
	});
	
	window.TagHomepage = ReactiveComponent({
	  displayName: 'TagHomepage',
	  render: function() {
	    var cluster, clusters, collapsed, colors, current_user, dummy_cluster, homepage_tabs, hues, i, idx, len, proposal, proposals, show_all, users;
	    current_user = fetch('/current_user');
	    show_all = fetch('show_all_proposals');
	    users = fetch('/users');
	    proposals = fetch('/proposals');
	    proposals = proposals.proposals;
	    if (!proposals || !users.users) {
	      return ProposalsLoading();
	    }
	    clusters = get_all_clusters();
	    hues = getNiceRandomHues(clusters.length);
	    colors = {};
	    for (idx = i = 0, len = clusters.length; i < len; idx = ++i) {
	      cluster = clusters[idx];
	      colors[cluster] = hues[idx];
	    }
	    proposals = sorted_proposals(proposals, this.local.key, true);
	    homepage_tabs = fetch('homepage_tabs');
	    dummy_cluster = homepage_tabs.filter;
	    collapsed = fetch('collapsed_clusters');
	    if (collapsed["list/" + dummy_cluster] == null) {
	      collapsed["list/" + dummy_cluster] = customization('list_is_archived', "list/" + dummy_cluster);
	      save(collapsed);
	    }
	    return DIV({
	      id: 'homepagetab',
	      role: customization('homepage_tabs') ? "tabpanel" : void 0,
	      style: {
	        margin: '45px auto',
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative'
	      }
	    }, customization('auth_callout') ? AuthCallout() : void 0, ManualProposalResort({
	      sort_key: this.local.key
	    }), ClusterHeading({
	      cluster: {
	        key: "list/" + dummy_cluster,
	        name: dummy_cluster,
	        proposals: [],
	        list_is_archived: customization('list_is_archived', "list/" + dummy_cluster)
	      },
	      proposals_count: proposals.length
	    }), UL(null, (function() {
	      var j, len1, results;
	      results = [];
	      for (idx = j = 0, len1 = proposals.length; j < len1; idx = ++j) {
	        proposal = proposals[idx];
	        if (idx > 20 && !show_all.show_all) {
	          continue;
	        }
	        cluster = proposal.cluster || 'Proposals';
	        results.push(CollapsedProposal({
	          key: "collapsed" + proposal.key,
	          proposal: proposal,
	          show_category: true,
	          category_color: hsv2rgb(colors[cluster], .7, .8)
	        }));
	      }
	      return results;
	    })(), (show_all.show_all || proposals.length <= 20) && customization('list_show_new_button', "list/" + dummy_cluster) ? LI({
	      key: "newlist/" + dummy_cluster,
	      style: {
	        margin: 0,
	        padding: 0,
	        listStyle: 'none',
	        display: 'inline-block',
	        marginBottom: 20,
	        marginTop: 6
	      }
	    }, NewProposal({
	      cluster_name: dummy_cluster,
	      local: this.local.key,
	      label_style: {}
	    })) : void 0), !show_all.show_all && proposals.length > 20 ? BUTTON({
	      style: {
	        backgroundColor: '#f9f9f9',
	        width: HOMEPAGE_WIDTH(),
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        paddingTop: 10,
	        paddingBottom: 10,
	        fontWeight: 600,
	        textAlign: 'center',
	        marginTop: 40,
	        border: 'none',
	        fontSize: 22
	      },
	      onMouseDown: (function(_this) {
	        return function() {
	          show_all.show_all = true;
	          return save(show_all);
	        };
	      })(this)
	    }, translator("engage.show_hidden_proposals", 'Show all proposals')) : void 0);
	  }
	});
	
	window.SimpleHomepage = ReactiveComponent({
	  displayName: 'SimpleHomepage',
	  render: function() {
	    var cluster, clusters, collapsed, current_user, homepage_tabs, i, index, len, proposals, ref, ref1, ref2, ref3, subdomain, view;
	    subdomain = fetch('/subdomain');
	    homepage_tabs = fetch('homepage_tabs');
	    if ((ref = customization('homepage_tab_views')) != null ? ref[homepage_tabs.filter] : void 0) {
	      view = customization('homepage_tab_views')[homepage_tabs.filter]();
	      if (typeof view === 'function') {
	        view = view();
	      }
	      return view;
	    }
	    proposals = fetch('/proposals');
	    current_user = fetch('/current_user');
	    if (!proposals.proposals) {
	      return ProposalsLoading();
	    }
	    clusters = clustered_proposals_with_tabs();
	    collapsed = fetch('collapsed_clusters');
	    for (i = 0, len = clusters.length; i < len; i++) {
	      cluster = clusters[i];
	      if (collapsed[cluster.key] == null) {
	        collapsed[cluster.key] = customization('list_is_archived', cluster.key);
	        save(collapsed);
	      }
	    }
	    return DIV({
	      id: 'homepagetab',
	      role: customization('homepage_tabs') ? "tabpanel" : void 0,
	      style: {
	        margin: '45px auto',
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative'
	      }
	    }, customization('homepage_tabs') && ((ref1 = customization('homepage_tab_headers')) != null ? ref1[homepage_tabs.filter] : void 0) ? customization('homepage_tab_headers')[homepage_tabs.filter]() : void 0, customization('auth_callout') && ((ref2 = homepage_tabs.filter) !== 'About' && ref2 !== 'FAQ') ? AuthCallout() : void 0, DIV(null, (function() {
	      var j, len1, ref3, results;
	      ref3 = clusters || [];
	      results = [];
	      for (index = j = 0, len1 = ref3.length; j < len1; index = ++j) {
	        cluster = ref3[index];
	        results.push(Cluster({
	          key: "list/" + cluster.name,
	          cluster: cluster,
	          index: index
	        }));
	      }
	      return results;
	    })(), permit('create proposal') > 0 && customization('homepage_show_new_proposal_button') && ((ref3 = homepage_tabs.filter) !== 'About' && ref3 !== 'FAQ') && (!subdomain.SSO_domain || current_user.logged_in) ? A({
	      style: {
	        color: logo_red,
	        marginTop: 35,
	        display: 'inline-block',
	        borderBottom: "1px solid " + logo_red
	      },
	      href: '/proposal/new'
	    }, translator('engage.add_new_proposal_button', "Create new proposal")) : void 0));
	  },
	  typeset: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'RANDOM2015' && $('.MathJax').length === 0) {
	      return MathJax.Hub.Queue(["Typeset", MathJax.Hub, ".proposal_homepage_name"]);
	    }
	  },
	  componentDidMount: function() {
	    return this.typeset();
	  },
	  componentDidUpdate: function() {
	    return this.typeset();
	  }
	});
	
	window.HomepageTabTransition = ReactiveComponent({
	  displayName: "HomepageTabTransition",
	  render: function() {
	    var clusters, filter, filters, homepage_tab, homepage_tabs, i, k, len, loc, ref, v;
	    if (customization('homepage_tabs')) {
	      loc = fetch('location');
	      homepage_tab = fetch('homepage_tabs');
	      filters = (function() {
	        var ref, results;
	        ref = customization('homepage_tabs');
	        results = [];
	        for (k in ref) {
	          v = ref[k];
	          results.push([k, v]);
	        }
	        return results;
	      })();
	      if (!customization('homepage_tabs_no_show_all') && !customization('homepage_tabs')['Show all']) {
	        filters.unshift(["Show all", '*']);
	      }
	      homepage_tabs = fetch('homepage_tabs');
	      if ((homepage_tabs.filter == null) || (loc.query_params.tab && loc.query_params.tab !== homepage_tabs.filter)) {
	        if (loc.query_params.tab) {
	          homepage_tab.filter = decodeURI(loc.query_params.tab);
	        } else {
	          homepage_tabs.filter = customization('homepage_default_tab') || 'Show all';
	        }
	        for (i = 0, len = filters.length; i < len; i++) {
	          ref = filters[i], filter = ref[0], clusters = ref[1];
	          if (filter === homepage_tabs.filter) {
	            homepage_tabs.clusters = clusters;
	            break;
	          }
	        }
	        save(homepage_tabs);
	      }
	      if (loc.url !== '/' && loc.query_params.tab) {
	        delete loc.query_params.tab;
	        save(loc);
	      } else if (loc.url === '/' && loc.query_params.tab !== homepage_tab.filter) {
	        loc.query_params.tab = homepage_tab.filter;
	        save(loc);
	      }
	    }
	    return SPAN(null);
	  }
	});
	
	window.HomepageTabs = ReactiveComponent({
	  displayName: 'HomepageTabs',
	  render: function() {
	    var clusters, filter, filters, homepage_tabs, idx, k, subdomain, v;
	    homepage_tabs = fetch('homepage_tabs');
	    filters = (function() {
	      var ref, results;
	      ref = customization('homepage_tabs');
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        results.push([k, v]);
	      }
	      return results;
	    })();
	    if (!customization('homepage_tabs_no_show_all') && !customization('homepage_tabs')['Show all']) {
	      filters.unshift(["Show all", '*']);
	    }
	    subdomain = fetch('/subdomain');
	    return DIV({
	      style: _.defaults({}, this.props.wrapper_style || {}, {
	        width: '100%',
	        zIndex: 2,
	        position: 'relative',
	        top: 2,
	        marginTop: 20
	      })
	    }, A({
	      name: 'active_tab'
	    }), UL({
	      role: 'tablist',
	      style: _.defaults({}, this.props.list_style || {}, {
	        width: this.props.width || 900,
	        margin: 'auto',
	        textAlign: subdomain.name === 'HALA' ? 'left' : 'center',
	        listStyle: 'none'
	      })
	    }, (function() {
	      var i, len, ref, results;
	      results = [];
	      for (idx = i = 0, len = filters.length; i < len; idx = ++i) {
	        ref = filters[idx], filter = ref[0], clusters = ref[1];
	        results.push((function(_this) {
	          return function(filter, clusters) {
	            var base, current, featured, hovering, ref1, tab_name, tab_style, tab_wrapper_style;
	            current = homepage_tabs.filter === filter;
	            hovering = _this.local.hovering === filter;
	            featured = _this.props.featured === filter;
	            tab_name = ((ref1 = customization('homepage_tab_render')) != null ? typeof ref1[filter] === "function" ? ref1[filter]() : void 0 : void 0) || filter;
	            tab_style = _.defaults({}, _this.props.tab_style || {}, {
	              cursor: 'pointer',
	              position: 'relative',
	              fontSize: 16,
	              fontWeight: 600,
	              color: 'white',
	              padding: '10px 20px 4px 20px'
	            });
	            tab_wrapper_style = _.defaults({}, _this.props.tab_wrapper_style || {}, {
	              display: 'inline-block',
	              position: 'relative'
	            });
	            if (current) {
	              _.extend(tab_style, {
	                backgroundColor: 'rgba(255,255,255,.2)',
	                opacity: 1
	              }, _this.props.active_style || {});
	              _.extend(tab_wrapper_style, _this.props.active_tab_wrapper_style || {});
	            }
	            if (hovering) {
	              _.extend(tab_style, {
	                opacity: 1
	              }, _this.props.hover_style || _this.props.active_style || {});
	              _.extend(tab_wrapper_style, _this.props.hovering_tab_wrapper_style || {});
	            }
	            return LI({
	              tabIndex: 0,
	              role: 'tab',
	              style: tab_wrapper_style,
	              'aria-controls': 'homepagetab',
	              'aria-selected': current,
	              onMouseEnter: function() {
	                if (homepage_tabs.filter !== filter) {
	                  _this.local.hovering = filter;
	                  return save(_this.local);
	                }
	              },
	              onMouseLeave: function() {
	                _this.local.hovering = null;
	                return save(_this.local);
	              },
	              onKeyDown: function(e) {
	                if (e.which === 13 || e.which === 32) {
	                  e.currentTarget.click();
	                  return e.preventDefault();
	                }
	              },
	              onClick: function() {
	                var loc;
	                loc = fetch('location');
	                loc.query_params.tab = filter;
	                save(loc);
	                return document.activeElement.blur();
	              }
	            }, H4({
	              style: tab_style
	            }, translator({
	              id: "homepage_tab." + tab_name,
	              key: "/translations/" + subdomain.name
	            }, tab_name)), featured ? typeof (base = _this.props).featured_insertion === "function" ? base.featured_insertion() : void 0 : void 0);
	          };
	        })(this)(filter, clusters));
	      }
	      return results;
	    }).call(this)));
	  }
	});
	
	window.ManualProposalResort = ReactiveComponent({
	  displayName: 'ManualProposalResort',
	  render: function() {
	    var ref, sort;
	    sort = fetch('sort_proposals');
	    if (!((ref = sort.sorts) != null ? ref[this.props.sort_key].stale : void 0)) {
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        position: 'fixed',
	        width: '100%',
	        bottom: 0,
	        left: 0,
	        zIndex: 100,
	        backgroundColor: '#ddd',
	        textAlign: 'center',
	        fontSize: 26,
	        padding: '8px 0'
	      }
	    }, TRANSLATE({
	      id: "engage.re-sort_list",
	      button: {
	        component: BUTTON,
	        args: {
	          style: {
	            color: focus_color(),
	            fontSize: 26,
	            textDecoration: 'underline',
	            fontWeight: 'bold',
	            border: 'none',
	            backgroundColor: 'transparent',
	            padding: 0
	          },
	          onClick: invalidate_proposal_sorts,
	          onKeyDown: (function(_this) {
	            return function(e) {
	              if (e.which === 13 || e.which === 32) {
	                invalidate_proposal_sorts();
	                return e.preventDefault();
	              }
	            };
	          })(this)
	        }
	      }
	    }, "<button>Re-sort this list</button> if you want. It is out of order."));
	  }
	});
	
	window.Cluster = ReactiveComponent({
	  displayName: 'Cluster',
	  render: function() {
	    var cluster, cluster_key, collapsed, current_user, idx, is_collapsed, proposal, proposals, subdomain;
	    cluster = this.props.cluster;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    fetch('homepage_you_updated_proposal');
	    collapsed = fetch('collapsed_clusters');
	    is_collapsed = !!collapsed[this.props.key];
	    proposals = sorted_proposals(cluster.proposals, this.local.key, true);
	    if (!proposals) {
	      return SPAN(null);
	    }
	    cluster_key = "list/" + cluster.name;
	    return ARTICLE({
	      key: cluster.name,
	      id: cluster.name && cluster.name ? cluster.name.toLowerCase() : void 0,
	      style: {
	        marginBottom: !is_collapsed ? 28 : void 0,
	        position: 'relative'
	      }
	    }, A({
	      name: cluster.name && cluster.name ? cluster.name.toLowerCase().replace(/ /g, '_') : void 0
	    }), ManualProposalResort({
	      sort_key: this.local.key
	    }), ClusterHeading({
	      cluster: cluster,
	      proposals_count: proposals.length
	    }), customization('questionaire', cluster_key) && !is_collapsed ? Questionaire({
	      cluster_key: cluster_key
	    }) : !is_collapsed ? UL(null, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = proposals.length; i < len; idx = ++i) {
	        proposal = proposals[idx];
	        results.push(CollapsedProposal({
	          key: "collapsed" + proposal.key,
	          proposal: proposal
	        }));
	      }
	      return results;
	    })(), customization('list_show_new_button', cluster_key) ? LI({
	      key: "new" + cluster_key,
	      style: {
	        margin: 0,
	        padding: 0,
	        listStyle: 'none',
	        display: 'inline-block',
	        marginBottom: 20,
	        marginTop: 6
	      }
	    }, NewProposal({
	      cluster_name: cluster.name,
	      local: this.local.key,
	      label_style: {}
	    })) : void 0) : void 0, customization('footer', cluster_key) && !is_collapsed ? customization('footer', cluster_key)() : void 0);
	  }
	});
	
	ClusterHeading = ReactiveComponent({
	  displayName: 'ClusterHeading',
	  render: function() {
	    var DIVIDER, HEADING, LABEL_ENCLOSE, cluster, cluster_key, collapsed, desc, description, description_style, heading_style, heading_text, histo_title, idx, is_collapsed, list_items_title, list_uncollapseable, para, subdomain, th, toggle_list, tw;
	    cluster = this.props.cluster;
	    cluster_key = "list/" + cluster.name;
	    collapsed = fetch('collapsed_clusters');
	    is_collapsed = !!collapsed[cluster_key];
	    subdomain = fetch('/subdomain');
	    tw = is_collapsed ? 15 : 20;
	    th = is_collapsed ? 20 : 15;
	    list_uncollapseable = customization('list_uncollapseable', cluster_key);
	    list_items_title = customization('list_items_title', cluster_key) || cluster.name || 'Proposals';
	    heading_text = customization('list_label', cluster_key) || list_items_title;
	    if (heading_text === 'Show all') {
	      heading_text = translator("engage.all_proposals_list", "All Proposals");
	    } else {
	      if (heading_text === "Proposals") {
	        heading_text = translator("engage.default_proposals_list", "Proposals");
	      } else {
	        heading_text = translator({
	          id: "proposal_list." + heading_text,
	          key: "/translations/" + subdomain.name
	        }, heading_text);
	      }
	    }
	    heading_style = _.defaults({}, customization('list_label_style', cluster_key), {
	      fontSize: 36,
	      fontWeight: 700,
	      fontStyle: 'oblique'
	    });
	    if (heading_text.replace(/^\s+|\s+$/g, '').length === 0) {
	      heading_style.fontSize = 0;
	    }
	    description = customization('list_description', cluster_key) || customization('list_one_line_desc', cluster_key);
	    description_style = customization('list_description_style', cluster_key);
	    DIVIDER = customization('list_divider', cluster_key);
	    HEADING = H1;
	    LABEL_ENCLOSE = list_uncollapseable ? DIV : BUTTON;
	    toggle_list = function() {
	      if (!list_uncollapseable) {
	        collapsed[cluster_key] = !collapsed[cluster_key];
	        return save(collapsed);
	      }
	    };
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        marginBottom: 16
	      }
	    }, typeof DIVIDER === "function" ? DIVIDER() : void 0, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, H1({
	      style: heading_style
	    }, LABEL_ENCLOSE({
	      tabIndex: !list_uncollapseable ? 0 : void 0,
	      'aria-label': heading_text + ". " + (translator('Expand or collapse list.')),
	      'aria-pressed': !collapsed[cluster_key],
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.hover_label = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.hover_label = false;
	          return save(_this.local);
	        };
	      })(this),
	      style: {
	        padding: 0,
	        margin: 0,
	        border: 'none',
	        backgroundColor: 'transparent',
	        fontWeight: heading_style.fontWeight,
	        cursor: !list_uncollapseable ? 'pointer' : void 0,
	        textAlign: 'left',
	        color: heading_style.color,
	        position: 'relative',
	        fontFamily: heading_style.fontFamily,
	        fontStyle: heading_style.fontStyle,
	        textDecoration: heading_style.textDecoration
	      },
	      onKeyDown: !list_uncollapseable ? function(e) {
	        if (e.which === 13 || e.which === 32) {
	          toggle_list();
	          return e.preventDefault();
	        }
	      } : void 0,
	      onClick: !list_uncollapseable ? function(e) {
	        toggle_list();
	        return document.activeElement.blur();
	      } : void 0
	    }, heading_text, !list_uncollapseable ? SPAN({
	      'aria-hidden': true,
	      style: cssTriangle((is_collapsed ? 'right' : 'bottom'), heading_style.color || 'black', tw, th, {
	        position: 'absolute',
	        left: -tw - 20,
	        top: 16,
	        width: tw,
	        height: th,
	        display: this.local.hover_label || is_collapsed ? 'inline-block' : 'none',
	        outline: 'none'
	      })
	    }) : void 0)), !is_collapsed ? description ? DIV({
	      style: _.defaults({}, description_style || {}, {
	        fontSize: 18,
	        fontWeight: 400,
	        color: '#444',
	        marginTop: 6
	      })
	    }, (function() {
	      var i, len, results;
	      if (_.isFunction(description)) {
	        return description();
	      } else {
	        desc = description;
	        if (typeof desc === 'string') {
	          desc = [description];
	        }
	        results = [];
	        for (idx = i = 0, len = desc.length; i < len; idx = ++i) {
	          para = desc[idx];
	          results.push(DIV({
	            key: idx,
	            style: {
	              marginBottom: 10
	            },
	            dangerouslySetInnerHTML: {
	              __html: para
	            }
	          }));
	        }
	        return results;
	      }
	    })()) : widthWhenRendered(heading_text, heading_style) <= column_sizes().first + column_sizes().gutter ? (histo_title = customization('list_opinions_title', cluster_key), DIV({
	      style: {
	        width: column_sizes().second,
	        display: 'inline-block',
	        verticalAlign: 'top',
	        marginLeft: column_sizes().margin,
	        whiteSpace: 'nowrap',
	        position: 'absolute',
	        top: 0,
	        right: 0,
	        textAlign: 'right',
	        fontWeight: heading_style.fontWeight,
	        color: heading_style.color,
	        fontSize: heading_style.fontSize,
	        fontStyle: 'oblique'
	      }
	    }, TRANSLATE({
	      id: "engage.list_opinions_title." + histo_title,
	      key: histo_title === customizations["default"].list_opinions_title ? '/translations' : "/translations/" + subdomain.name
	    }, histo_title))) : void 0 : void 0), this.props.proposals_count > 0 && !customization('questionaire', cluster_key) && !is_collapsed && !customization('list_no_filters', cluster_key) ? list_actions({
	      cluster: cluster,
	      add_new: customization('list_show_new_button', cluster_key) && !is_collapsed && this.props.proposals_count > 4,
	      can_sort: customization('homepage_show_search_and_sort') && this.props.proposals_count > 8
	    }) : void 0);
	  }
	});
	
	window.list_actions = function(props) {
	  var add_new, permitted;
	  add_new = props.add_new;
	  if (add_new) {
	    permitted = permit('create proposal');
	    add_new && (add_new = permitted > 0 || permitted === Permission.NOT_LOGGED_IN);
	  }
	  return DIV({
	    style: {
	      marginTop: 12,
	      marginBottom: 50
	    }
	  }, add_new ? SPAN(null, A({
	    style: {
	      textDecoration: 'underline',
	      fontSize: 20,
	      color: focus_color(),
	      fontFamily: customization('font'),
	      fontStyle: 'normal',
	      fontWeight: 700
	    },
	    onClick: (function(_this) {
	      return function(e) {
	        var show_all;
	        show_all = fetch('show_all_proposals');
	        show_all.show_all = true;
	        save(show_all);
	        e.stopPropagation();
	        return setTimeout(function() {
	          return $("[name='add_new_" + props.cluster.name + "']").ensureInView();
	        }, 1);
	      };
	    })(this)
	  }, translator("engage.add_new_proposal_to_list", 'add new'))) : void 0, props.can_sort && add_new ? SPAN({
	    style: {
	      padding: '0 24px',
	      fontSize: 20
	    }
	  }, '|') : void 0, props.can_sort ? SortProposalsMenu() : void 0, OpinionFilter({
	    style: {
	      display: 'inline-block',
	      float: 'right',
	      maxWidth: column_sizes().second,
	      textAlign: 'right'
	    },
	    enable_comparison_wrapper_style: {
	      position: 'absolute',
	      right: 0,
	      bottom: -20,
	      fontSize: 14,
	      zIndex: 99
	    }
	  }), DIV({
	    style: {
	      clear: 'both'
	    }
	  }));
	};
	
	ProposalsLoading = ReactiveComponent({
	  displayName: 'ProposalLoading',
	  render: function() {
	    var negative;
	    if (this.local.cnt == null) {
	      this.local.cnt = 0;
	    }
	    negative = Math.floor(this.local.cnt / 284) % 2 === 1;
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        padding: '60px',
	        textAlign: 'center',
	        fontStyle: 'italic',
	        fontSize: 24
	      }
	    }, DIV({
	      style: {
	        position: 'relative',
	        top: 6,
	        left: 3
	      }
	    }, drawLogo({
	      height: 50,
	      main_text_color: logo_red,
	      o_text_color: logo_red,
	      clip: false,
	      draw_line: true,
	      line_color: logo_red,
	      i_dot_x: negative ? 284 - this.local.cnt % 284 : this.local.cnt % 284,
	      transition: false
	    })), translator("loading_indicator", "Loading...there is much to consider!"));
	  },
	  componentWillMount: function() {
	    return this.int = setInterval((function(_this) {
	      return function() {
	        _this.local.cnt += 1;
	        return save(_this.local);
	      };
	    })(this), 10);
	  },
	  componentWillUnmount: function() {
	    return clearInterval(this.int);
	  }
	});


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(6);
	
	window.WatchStar = ReactiveComponent({
	  displayName: 'WatchStar',
	  render: function() {
	    var current_user, hide_tooltip, icon, label, proposal, show_tooltip, size, style, watch_color, watching;
	    current_user = fetch('/current_user');
	    proposal = this.props.proposal;
	    size = this.props.size || 30;
	    icon = this.props.icon || 'fa-star';
	    watch_color = this.props.watch_color || logo_red;
	    label = this.props.label || function(watching) {
	      if (watching) {
	        return "Stop getting notifications for this proposal";
	      } else {
	        return "Get notifications";
	      }
	    };
	    watching = current_user.subscriptions[proposal.key] === 'watched';
	    style = {
	      opacity: this.local.hover_watch !== proposal.key && !watching ? .35 : void 0,
	      color: watching ? watch_color : "#888",
	      width: size,
	      height: size,
	      cursor: 'pointer',
	      backgroundColor: 'transparent',
	      border: 'none',
	      margin: 0,
	      padding: 0
	    };
	    show_tooltip = (function(_this) {
	      return function() {
	        var tooltip;
	        _this.local.hover_watch = proposal.key;
	        save(_this.local);
	        tooltip = fetch('tooltip');
	        tooltip.coords = $(_this.getDOMNode()).offset();
	        tooltip.tip = label(watching);
	        return save(tooltip);
	      };
	    })(this);
	    hide_tooltip = (function(_this) {
	      return function() {
	        var tooltip;
	        _this.local.hover_watch = null;
	        save(_this.local);
	        tooltip = fetch('tooltip');
	        tooltip.coords = null;
	        return save(tooltip);
	      };
	    })(this);
	    return BUTTON({
	      'aria-hidden': true,
	      'aria-label': label(watching),
	      'aria-describedby': this.local.hover_watch ? 'tooltip' : void 0,
	      'aria-pressed': watching,
	      className: "fa " + (watching ? icon : icon + "-o"),
	      style: _.extend({}, style, this.props.style || {}),
	      onMouseEnter: show_tooltip,
	      onFocus: show_tooltip,
	      onMouseLeave: hide_tooltip,
	      onBlur: hide_tooltip,
	      onClick: (function(_this) {
	        return function() {
	          if (!current_user.subscriptions[proposal.key]) {
	            current_user.subscriptions[proposal.key] = 'watched';
	          } else {
	            delete current_user.subscriptions[proposal.key];
	          }
	          return save(current_user);
	        };
	      })(this)
	    });
	  }
	});


/***/ },
/* 16 */
/***/ function(module, exports) {

	(function () {
	
	    // ****************
	    // Public API
	    var cache = {}
	    function fetch(url, defaults) {
	        //if (window.watch && watch(url)) console.trace()
	
	        if (!url) return null
	        if (url.key) url = url.key   // If user passes key as object
	
	        window.record_dependence && record_dependence(url)
	
	        // Return the cached version if it exists
	        if (cache[url]) return cache[url]
	
	        // Else, start a serverFetch in the background and return stub.
	        if (url[0] === '/')
	            server_fetch(url)
	
	        update_cache(extend({key: url}, defaults))
	        return cache[url]
	    }
	
	    /*  Updates cache and saves to server.
	     *  You can pass a callback that will run when the saves have finished.
	     */
	    function save(object, continuation) {
	        update_cache(object)
	
	        // Save all the objects
	        if (object.key && object.key[0] == '/')
	            server_save(object, continuation)
	        else
	            if (continuation) continuation()
	    }
	
	    /*  Deletes from server (if it's there) and removes from cache
	     *  You can pass a callback that will run when the delete has finished.
	     */
	    function destroy(key, continuation) {
	        if (!key) return
	
	        // Save all the objects
	        if (key[0] == '/')
	            server_destroy(key, continuation)
	        else {
	            // Just remove the key from the cache if this state is
	            // owned by the client.  Note that this won't clean up
	            // references to this object in e.g. any lists. The Client
	            // is responsible for updating all the relevant
	            // references.
	            delete cache[key]
	            if (continuation) continuation()
	        }
	    }
	
	
	    // ================================
	    // == Internal funcs
	
	    var new_index = 0
	    var affected_keys = new Set()
	    var re_render_timer = null
	    function update_cache(object) {
	        function recurse(object) {
	            // Recurses into object and folds it into the cache.
	
	            // If this object has a key, update the cache for it
	            var key = object && object.key
	            if (key) {
	                // Change /new/thing to /new/thing/45
	                if (key.match(new RegExp('^/new/'))     // Starts with /new/
	                    && !key.match(new RegExp('/\\d+$'))) // Doesn't end in a /number
	                    key = object.key = key + '/' + new_index++
	
	                var cached = cache[key]
	                if (!cached)
	                    // This object is new.  Let's cache it.
	                    cache[key] = object
	                else if (object !== cached)
	                    // Else, mutate cache to match the object.
	                    for (var k in object)          // Mutating in place preserves
	                        cache[key][k] = object[k]  // pointers to this object
	
	                // Remember this key for re-rendering
	                affected_keys.add(key)
	            }
	
	            // Now recurse into this object.
	            //  - Through each element in arrays
	            //  - And each property on objects
	            if (Array.isArray(object))
	                for (var i=0; i < object.length; i++)
	                    object[i] = recurse(object[i])
	            else if (typeof(object) === 'object' && object !== null)
	                for (var k in object)
	                    object[k] = recurse(object[k])
	
	            // Return the new cached representation of this object
	            return cache[key] || object
	        }
	
	        recurse(object)
	
	        // Now initiate the re-rendering, if there isn't a timer already going
	        re_render_timer = re_render_timer || setTimeout(function () {
	            re_render_timer = null
	            var keys = affected_keys.all()
	            affected_keys.clear()
	            if (keys.length > 0) {
	                var re_render = (window.re_render || function () {
	                    console.log('You need to implement re_render()') })
	                re_render(keys)
	            }
	        })
	    }
	
	    var outstanding_fetches = {}
	    function server_fetch(key) {
	        // Error check
	        if (outstanding_fetches[key]) {
	            console.error('Duplicate request for '+key)
	            return
	        }
	
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            delete outstanding_fetches[key]
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                if (window.arest.trans_in)
	                    result = arest.trans_in(result)
	                update_cache(result)
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	
	        }
	
	        // Open request
	        outstanding_fetches[key] = request
	        request.open('GET', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	
	        request.send(null)
	    }
	
	    var pending_saves = {} // Stores xmlhttprequest of any key being saved
	                           // (Note: This shim will fail in many situations...)
	    function server_save(object, continuation) {
	        if (pending_saves[object.key]) {
	            console.log('Yo foo, aborting', object.key)
	            pending_saves[object.key].abort()
	            delete pending_saves[object.key]
	        }
	
	        var original_key = object.key
	        
	        // Special case for /new.  Grab the pieces of the URL.
	        var pattern = new RegExp("/new/([^/]+)/(\\d+)")
	        var match = original_key.match(pattern)
	        var url = (match && '/' + match[1]) || original_key
	
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            // No longer pending
	            delete pending_saves[original_key]
	
	            if (request.status === 200) {
	                var result = JSON.parse(request.responseText)
	                // console.log('New save result', result)
	                // Handle /new/stuff
	                deep_map(function (obj) {
	                    match = obj.key && obj.key.match(/(.*)\?original_id=(\d+)$/)
	                    if (match && match[2]) {
	                        // Let's map the old and new together
	                        var new_key = match[1]                // It's got a fresh key
	                        cache[new_key] = cache[original_key]  // Point them at the same thing
	                        obj.key = new_key                     // And it's no longer "/new/*"
	                    }
	                },
	                        result)
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                window.ajax_error && window.ajax_error()
	        }
	
	        object = clone(object)
	        object['authenticity_token'] = csrf()
	
	        // Open request
	        var POST_or_PUT = match ? 'POST' : 'PUT'
	        request.open(POST_or_PUT, url, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(object))
	
	        // Remember it
	        pending_saves[original_key] = request
	    }
	
	    function server_destroy(key, continuation) {
	        // Build request
	        var request = new XMLHttpRequest()
	        request.onload = function () {
	            if (request.status === 200) {
	                console.log('Destroy returned for', key)
	                var result = JSON.parse(request.responseText)
	                delete cache[key]
	                update_cache(result)
	                if (continuation) continuation()
	            }
	            else if (request.status === 500)
	                if (window.on_ajax_error) window.on_ajax_error()
	            else {
	                // TODO: give user feedback that DELETE failed
	                console.log('DELETE of', key, 'failed!')
	            }
	
	        }
	
	        payload = {'authenticity_token': csrf()}
	
	        // Open request
	        request.open('DELETE', key, true)
	        request.setRequestHeader('Accept','application/json')
	        request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
	        request.setRequestHeader('X-CSRF-Token', csrf())
	        request.setRequestHeader('X-Requested-With','XMLHttpRequest')
	        request.send(JSON.stringify(payload))
	    }
	
	    // This is used in a specific hack.  I need to work on it.
	    function clear_matching_objects (match_key_func) {
	        // Clears all keys where match_key_func(key) returns true
	        for (key in cache)
	            if (match_key_func(key))
	                delete cache[key]
	    }
	
	
	    var csrf_token = null
	    function csrf(new_token) {
	        if (new_token) csrf_token = new_token
	        if (csrf_token) return csrf_token
	        var metas = document.getElementsByTagName('meta')
	        for (i=0; i<metas.length; i++) { 
	            if (metas[i].getAttribute("name") == "csrf-token") { 
	                return metas[i].getAttribute("content");
	            } 
	        } 
	        return ""
	    }
	
	    window.loading_indicator = React.DOM.div({style: {height: '100%', width: '100%'},
	                                       className: 'loading'}, 'Loading')
	    function error_indicator(message) {
	        return React.DOM.div(null, 'Error! ' + message)
	    }
	
	    // ****************
	    // Wrapper for React Components
	    var components = {}                  // Indexed by 'component/0', 'component/1', etc.
	    var components_count = 0
	    var dirty_components = {}
	    var execution_context = []  // The stack of components that are being rendered
	    function ReactiveComponent(component) {
	        // STEP 1: Define get() and save()
	        component.fetch = component.data = component.get = function (key, defaults) {
	            if (!this._lifeCycleState || this._lifeCycleState == 'UNMOUNTED')
	                throw Error('Component ' + this.name + ' (' + this.local_key
	                            + ') is tryin to get data(' + key + ') after it died.')
	
	            if (key === undefined)    key = this.mounted_key || this.name
	            if (!key)                 return null
	            // if (!key)    throw TypeError('Component mounted onto a null key. '
	            //                              + this.name + ' ' + this.local_key)
	            if (key.key) key = key.key   // If user passes key as object
	            return fetch(key, defaults)  // Call into main activerest
	        }
	        component.save = save                  // Call into main activerest
	        
	
	        // STEP 2: Wrap all the component's methods
	        function wrap(obj, method, before, after) {
	            var original_method = obj[method]
	            if (!(original_method || before || after)) return
	            obj[method] = function() {
	                before && before.apply(this, arguments)
	                if (this.local_key !== undefined)
	                    // We only want to set the execution context on wrapped methods
	                    // that are called on live instance.  getDefaultProps(), for
	                    // instance, is called when defining a component class, but not
	                    // on actual instances.  You can't render new components from
	                    // within there, so we don't need to track the execution context.
	                    execution_context = this.props.parents.concat([this.local_key])
	
	                try {
	                    var result = original_method && original_method.apply(this, arguments)
	                } catch (e) {
	                    execution_context = []
	                    if (this.is_waiting()){
	                        // console.log('waiting for', this.name, 'missing', this.is_waiting())
	                        return loading_indicator
	                    }
	                    else {
	                        // Then let's re-cause the error, but without catching it
	                        original_method.apply(this, arguments)
	                        console.assert(false) // this cannot happen unless method has side effects
	                    }
	                }
	
	                execution_context = []
	                after && after.apply(this, arguments)
	
	                return result
	            }
	        }
	
	        // We register the component when mounting it into the DOM
	        wrap(component, 'componentWillMount',
	             function () { 
	
	                 // STEP 1. Register the component's basic info
	                 if (component.displayName === undefined)
	                     throw 'Component needs a displayName'
	                 this.name = component.displayName.toLowerCase().replace(' ', '_')
	                 this.local_key = 'component/' + components_count++
	                 components[this.local_key] = this
	
	                 // You can pass an object in as a key if you want:
	                 if (this.props.key && this.props.key.key)
	                     this.props.key = this.props.key.key
	
	                 // XXX Putting this into WillMount probably won't let you use the
	                 // mounted_key inside getInitialState!  But you should be using
	                 // activerest state anyway, right?
	                 this.mounted_key = this.props.key
	
	                 // STEP 2: Create shortcuts e.g. `this.foo' for all parents up the
	                 // tree, and this component's local key
	                 function add_shortcut (obj, shortcut_name, to_key) {
	                     //console.log('Giving '+obj.name+' shorcut @'+shortcut_name+'='+to_key)
	                     delete obj[name]
	                     Object.defineProperty(obj, shortcut_name, {
	                         get: function () { return obj.get(to_key) },
	                         configurable: true })
	                 }
	
	                 // ...first for @local
	                 add_shortcut(this, 'local', this.local_key)
	                 
	                 // ...and now for all parents
	                 var parents = this.props.parents.concat([this.local_key])
	                 for (var i=0; i<parents.length; i++) {
	                     var name = components[parents[i]].name
	                     var key = components[parents[i]].props.key
	                     if (!key && cache[name] !== undefined)
	                         key = name
	                     add_shortcut(this, name, key)
	                 }
	             })
	
	        wrap(component, 'render', function () {
	            // Render will need to clear the component's old
	            // dependencies before rendering and finding new ones
	            clear_component_dependencies(this.local_key)
	            delete dirty_components[this.local_key]
	        })
	
	        wrap(component, 'componentDidMount')
	        wrap(component, 'componentDidUpdate')
	        wrap(component, 'getDefaultProps')
	        //wrap(component, 'componentWillReceiveProps')
	        wrap(component, 'componentWillUnmount', function () {
	            // Clean up
	            clear_component_dependencies(this.local_key)
	            delete cache[this.local_key]
	            delete components[this.local_key]
	            delete dirty_components[this.local_key]
	        })
	        component.shouldComponentUpdate = function (next_props, next_state) {
	            // This component definitely needs to update if it is marked as dirty
	            if (dirty_components[this.local_key] !== undefined) return true
	
	            // Otherwise, we'll check to see if its state or props
	            // have changed.  We can do so by simply serializing them
	            // and then comparing them.  But ignore React's 'children'
	            // prop, because it often has a circular reference.
	            next_props = clone(next_props); this_props = clone(this.props)
	            delete next_props['children']; delete this_props['children']
	            return JSON.stringify([next_state, next_props]) != JSON.stringify([this.state, this_props])
	        }
	        
	        component.is_waiting = function () {
	            // Does this component depend on any keys that are being
	            // requested?
	            var dependent_keys = keys_4_component.get(this.local_key)
	            for (var i=0; i<dependent_keys.length; i++)
	                if (outstanding_fetches[dependent_keys[i]])
	                    return dependent_keys[i]
	            return false
	        }
	
	        window.waiting_for = function(obj_or_key) {
	            return !!outstanding_fetches[obj_or_key.key || obj_or_key]
	        }
	
	        // STEP 3: Configure the global function hooks for React
	        window.re_render = react_rerender
	        window.record_dependence = record_component_dependence
	
	        // Now create the actual React class with this definition, and
	        // return it.
	        var react_class = React.createClass(component)
	        var result = function (props, children) {
	            props = props || {}
	            props.parents = execution_context.slice()
	            return react_class(props, children)
	        }
	        // Give it the same prototype as the original class so that it
	        // passes React.isValidClass() inspection
	        result.prototype = react_class.prototype
	        return result
	    }
	
	
	    // *****************
	    // Dependency-tracking for React components
	    var keys_4_component = new One_To_Many() // Maps component to its dependence keys
	    var components_4_key = new One_To_Many() // Maps key to its dependent components
	    function react_rerender (keys) {
	        // Re-renders only the components that depend on `keys'
	
	        // First we determine the components that will need to be updated
	        for (var i = 0; i < keys.length; i++) {
	            affected_components = components_4_key.get(keys[i])
	            for (var j = 0; j < affected_components.length; j++)
	                dirty_components[affected_components[j]] = true
	        }
	
	        // Then we sweep through and update them
	        for (var comp_key in dirty_components)
	            // the check on both dirty_components and components is a PATCH
	            // for a possible inconsistency between dirty_components and components
	            // that occurs if a component has a componentWillUnmount method.
	            if (dirty_components[comp_key] && components[comp_key]) // Since one component might update another
	                components[comp_key].forceUpdate()
	    }
	    function record_component_dependence(key) {
	        // Looks up current component from the execution context
	        if (execution_context.length > 0) {
	            var component = execution_context[execution_context.length-1]
	            keys_4_component.add(component, key)  // Track dependencies
	            components_4_key.add(key, component)  // both ways
	        }
	    }
	    function clear_component_dependencies(component) {
	        var depends_on_keys = keys_4_component.get(component)
	        for (var i=0; i<depends_on_keys.length; i++)
	            components_4_key.del(depends_on_keys[i], component)
	        keys_4_component.delAll(component)
	    }
	
	
	    // ****************
	    // Utility for React Components
	    function One_To_Many() {
	        var hash = this.hash = {}
	        this.get = function (k) { return Object.keys(hash[k] || {}) }
	        this.add = function (k, v) {
	            if (hash[k] === undefined)
	                hash[k] = {}
	            hash[k][v] = true
	        }
	        this.del = function (k, v) {
	            delete hash[k][v]
	        }
	        this.delAll = function (k) { hash[k] = {} }
	    }
	    function Set() {
	        var hash = {}
	        this.add = function (a) { hash[a] = true }
	        this.all = function () { return Object.keys(hash) }
	        this.clear = function () { hash = {} }
	    }
	
	
	    // ******************
	    // General utility funcs
	    function clone(obj) {
	        if (obj == null) return obj
	        var copy = obj.constructor()
	        for (var attr in obj)
	            if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
	        return copy
	    }
	    function extend(obj, with_obj) {
	        if (with_obj === undefined) return obj
	        for (var attr in with_obj)
	            if (!obj.hasOwnProperty(attr)) obj[attr] = with_obj[attr]
	        return obj
	    }
	    function deep_map(func, object) {
	        // This function isn't actually a full "deep map" yet.
	        // Limitations: It only applies func to OBJECTS (not arrays or
	        // atoms), and doesn't return anything.
	        if (Array.isArray(object))
	            for (var i=0; i < object.length; i++)
	                deep_map(func, object[i])
	        else if (typeof(object) === 'object' && object !== null) {
	            func(object)
	            for (var k in object)
	                deep_map(func, object[k])
	        }
	    }
	    function error(e, name) {
	        console.error('In', name + ':', e.stack)
	        if (window.on_client_error)
	            window.on_client_error(e)
	    }
	
	    function key_id(string) {
	        return string.match(/\/[^\/]+\/(\d+)/)[1]
	    }
	
	    // Camelcased API options
	    var updateCache=update_cache, serverFetch=server_fetch,
	        serverSave=server_save, serverDestroy=server_destroy
	
	    // Export the public API
	    window.ReactiveComponent = ReactiveComponent
	    window.fetch = fetch
	    window.save = save
	    window.destroy = destroy
	
	    // Make the private methods accessible under "window.arest"
	    vars = [['cache', cache], ['fetch',fetch], ['save',save], ['server_fetch', server_fetch], ['serverFetch', serverFetch], ['server_save', server_save], ['serverSave',serverSave], ['update_cache',update_cache], ['updateCache',updateCache], ['csrf',csrf], ['keys_4_component',keys_4_component], ['components_4_key', components_4_key], ['components',components], ['execution_context',execution_context], ['One_To_Many',One_To_Many], ['clone',clone], ['dirty_components', dirty_components], ['affected_keys',affected_keys], ['clear_matching_objects',clear_matching_objects], ['deep_map', deep_map], ['key_id', key_id]]
	    window.arest = {}
	    for (var i=0; i<vars.length; i++)
	        window.arest[vars[i][0]] = vars[i][1]
	
	})()


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var hide_tooltip, show_tooltip, user_name;
	
	__webpack_require__(1);
	
	__webpack_require__(6);
	
	__webpack_require__(2);
	
	window.avatarUrl = function(user, img_size) {
	  user = fetch(user);
	  return (fetch('/application').asset_host || '') + "/system/avatars/" + ((user.key.split('/')[2]) + "/" + img_size + "/" + user.avatar_file_name);
	};
	
	user_name = function(user, anon) {
	  user = fetch(user);
	  if (anon || !user.name || user.name.trim().length === 0) {
	    return 'Anonymous';
	  } else {
	    return user.name;
	  }
	};
	
	show_tooltip = function(e) {
	  var anonymous, current_user, filter, filters, i, icon, len, name, tooltip, user;
	  if (e.target.getAttribute('data-user') && e.target.getAttribute('data-tooltip')) {
	    user = fetch(e.target.getAttribute('data-user'));
	    anonymous = e.target.getAttribute('data-anonymous') === 'true';
	    current_user = fetch('/current_user');
	    name = e.target.getAttribute('data-tooltip');
	    if (!anonymous && (filters = customization('opinion_filters')) && (!customization('opinion_filters_admin_only') || current_user.is_admin)) {
	      for (i = 0, len = filters.length; i < len; i++) {
	        filter = filters[i];
	        if (!filter.admin_only || current_user.is_admin) {
	          if (filter.icon && filter.pass(user)) {
	            if (typeof filter.icon !== 'string') {
	              icon = filter.icon(user);
	            } else {
	              icon = filter.icon;
	            }
	            name += '<div style="font-style: italic; padding: 4px 0 0 0px">' + icon + "</div>";
	          }
	        }
	      }
	    }
	    tooltip = fetch('tooltip');
	    tooltip.coords = $(e.target).offset();
	    tooltip.tip = name;
	    save(tooltip);
	    return e.preventDefault();
	  }
	};
	
	hide_tooltip = function(e) {
	  var tooltip;
	  if (e.target.getAttribute('data-user') && e.target.getAttribute('data-tooltip')) {
	    if (e.target.getAttribute('data-title')) {
	      e.target.setAttribute('title', e.target.getAttribute('data-title'));
	      e.target.removeAttribute('data-title');
	    }
	    tooltip = fetch('tooltip');
	    tooltip.coords = null;
	    return save(tooltip);
	  }
	};
	
	document.addEventListener("mouseover", show_tooltip);
	
	document.addEventListener("mouseout", hide_tooltip);
	
	$('body').on('focusin', '.avatar', show_tooltip);
	
	$('body').on('focusout', '.avatar', hide_tooltip);
	
	window.avatar = function(user, props) {
	  var add_initials, alt, anonymous, attrs, current_user, ff, fontsize, id, img_size, name, ref, show_avatar, style, tag, thumbnail, tooltip, use_large_image;
	  props = _.extend({}, props);
	  if (!user.key) {
	    if (user === ((ref = arest.cache['/current_user']) != null ? ref.user : void 0)) {
	      user = fetch(user);
	    } else if (arest.cache[user]) {
	      user = arest.cache[user];
	    } else {
	      fetch(user);
	      return SPAN(null);
	    }
	  }
	  anonymous = (props.anonymous != null) && props.anonymous;
	  id = anonymous ? "avatar-hidden" : "avatar-" + (user.key.split('/')[2]);
	  style = _.extend({}, props.style);
	  img_size = props.img_size || 'small';
	  show_avatar = !anonymous && !!user.avatar_file_name;
	  if (img_size === 'small' && (style != null ? style.width : void 0) >= 50 && !browser.is_ie9) {
	    img_size = 'large';
	  }
	  use_large_image = img_size !== 'small' && show_avatar;
	  if (use_large_image) {
	    props.src = avatarUrl(user, img_size);
	  } else if (show_avatar) {
	    props.src = avatarUrl(user, img_size);
	  } else {
	    current_user = fetch('/current_user');
	    if (current_user.user === user.key) {
	      thumbnail = current_user.b64_thumbnail || avatarUrl(user, 'small');
	      if ((thumbnail != null) && img_size === 'small') {
	        props.src = thumbnail;
	      }
	    } else {
	      style.content = "''";
	    }
	  }
	  if (show_avatar) {
	    style.backgroundColor = 'white';
	  }
	  add_initials = false && !user.avatar_file_name && style.width > 8;
	  if (add_initials) {
	    style.textAlign = 'center';
	  }
	  tag = props.src == null ? SPAN : IMG;
	  name = user_name(user, anonymous);
	  alt = props.alt;
	  if (props.alt != null) {
	    delete props.alt;
	  }
	  tooltip = (alt != null ? alt.replace('<user>', name) : void 0) || name;
	  attrs = _.extend({}, props, {
	    key: user.key,
	    className: "avatar " + (props.className || ''),
	    'data-user': user.key,
	    'data-tooltip': !props.hide_tooltip ? tooltip : void 0,
	    'data-anon': anonymous,
	    style: style,
	    tabIndex: props.focusable ? 0 : -1
	  });
	  if (tag === IMG) {
	    attrs.alt = "";
	  }
	  return tag(attrs, add_initials ? (fontsize = style.width / 2, ff = 'monaco,Consolas,"Lucida Console",monospace', name === 'Anonymous' ? name = '?' : void 0, name.length === 2 ? name = "" + name[0][0] + name[1][0] : name = "" + name[0][0], DIV({
	    style: {
	      color: 'white',
	      pointerEvents: 'none',
	      fontSize: fontsize,
	      position: 'relative',
	      fontFamily: ff,
	      top: .3 * fontsize,
	      overflow: 'hidden'
	    }
	  }, name, DIV({
	    className: 'hidden'
	  }, tooltip))) : void 0);
	};
	
	window.Avatar = ReactiveComponent({
	  displayName: 'Avatar',
	  render: function() {
	    return avatar(this.data(), this.props);
	  }
	});
	
	styles += ".avatar {\n  position: relative;\n  vertical-align: top;\n  background-color: transparent;\n  border: none;\n  display: inline-block;\n  margin: 0;\n  padding: 0;\n  border-radius: 50%;\n  background-size: cover;\n  background-color: " + default_avatar_in_histogram_color + "; \n  user-select: none; \n  -moz-user-select: none; \n  -webkit-user-select: none;\n  -ms-user-select: none;}\n  .avatar.avatar_anonymous {\n    cursor: default; \n}\n/* for styling icon of broken images */\nimg.avatar:after { \n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f7954c; \n  border-radius: 50%;\n  content: \"\";\n}\n";


/***/ },
/* 18 */
/***/ function(module, exports) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	(function() {
	  var app, app_meta, i, len, meta, metas, style;
	  app = 'franklin';
	  metas = document.getElementsByTagName('meta');
	  app_meta = null;
	  for (i = 0, len = metas.length; i < len; i++) {
	    meta = metas[i];
	    if (meta.getAttribute('name') === 'app') {
	      app = meta.getAttribute('content');
	      app_meta = meta;
	      break;
	    }
	  }
	  if (!app) {
	    throw "Application not defined";
	  }
	  style = document.createElement('style');
	  style.type = 'text/css';
	  if (style.styleSheet) {
	    style.styleSheet.cssText = window.styles;
	  } else {
	    style.appendChild(document.createTextNode(window.styles));
	  }
	  document.body.appendChild(style);
	  switch (app) {
	    case 'franklin':
	      if (indexOf.call(document, 'ontouchend') >= 0) {
	        React.initializeTouchEvents(true);
	      }
	      return React.renderComponent(Franklin({
	        key: 'root'
	      }), document.getElementById('content'));
	    case 'proposal_embed':
	      return React.renderComponent(ProposalEmbed({
	        key: app_meta.getAttribute('proposal')
	      }), document.getElementById('content'));
	  }
	})();


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	var pad;
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(12);
	
	__webpack_require__(9);
	
	__webpack_require__(5);
	
	__webpack_require__(15);
	
	__webpack_require__(7);
	
	pad = function(num, len) {
	  var dec, i, str;
	  str = num;
	  dec = str.split('.');
	  i = 0;
	  while (i < len - dec[0].toString().length) {
	    dec[0] = "0" + dec[0];
	    i += 1;
	  }
	  return dec[0] + (dec.length > 0 ? '.' + dec[1] : '');
	};
	
	window.CollapsedProposal = ReactiveComponent({
	  displayName: 'CollapsedProposal',
	  render: function() {
	    var avg, base, can_edit, can_opine, cluster, col_sizes, current_user, draw_slider, editor, everyone, filter_out, hide_tooltip, icons, just_you, negative, o, opinions, options, proposal, ref, ref1, ref2, ref3, score, score_w, show_author_name_in_meta_data, show_proposal_scores, show_tooltip, slider, slider_interpretation, slider_regions, val, watching, your_opinion;
	    proposal = fetch(this.props.proposal);
	    options = this.props.options;
	    col_sizes = column_sizes({
	      width: this.props.width
	    });
	    current_user = fetch('/current_user');
	    watching = current_user.subscriptions[proposal.key] === 'watched';
	    if (!watching && fetch('homepage_filter').watched) {
	      return;
	    }
	    your_opinion = fetch(proposal.your_opinion);
	    if (your_opinion != null ? your_opinion.published : void 0) {
	      can_opine = permit('update opinion', proposal, your_opinion);
	    } else {
	      can_opine = permit('publish opinion', proposal);
	    }
	    draw_slider = can_opine > 0 || (your_opinion != null ? your_opinion.published : void 0);
	    icons = customization('show_proposer_icon', proposal) && !this.props.hide_icons;
	    slider_regions = customization('slider_regions', proposal);
	    show_proposal_scores = !this.props.hide_scores && customization('show_proposal_scores', proposal);
	    opinions = opinionsForProposal(proposal);
	    if (draw_slider) {
	      slider = fetch("homepage_slider" + proposal.key);
	    } else {
	      slider = null;
	    }
	    if (slider && your_opinion && slider.value !== your_opinion.stance && !slider.has_moved) {
	      slider.value = your_opinion.stance;
	      if (your_opinion.stance) {
	        slider.has_moved = true;
	      }
	      save(slider);
	    }
	    can_edit = permit('update proposal', proposal) > 0;
	    just_you = ((ref = fetch('filtered').current_filter) != null ? ref.label : void 0) === 'just you';
	    everyone = ((ref1 = fetch('filtered').current_filter) != null ? ref1.label : void 0) === 'everyone';
	    slider_interpretation = (function(_this) {
	      return function(value) {
	        if (value > .03) {
	          return ((value * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.support", proposal));
	        } else if (value < -.03) {
	          return (-1 * (value * 100).toFixed(0)) + "% " + (get_slider_label("slider_pole_labels.oppose", proposal));
	        } else {
	          return translator("engage.slider_feedback.neutral", "Neutral");
	        }
	      };
	    })(this);
	    return LI({
	      key: proposal.key,
	      id: 'p' + (proposal.slug || ("" + proposal.id)).replace('-', '_'),
	      style: _.defaults({}, this.props.wrapper_style || {}, {
	        minHeight: 84,
	        position: 'relative',
	        margin: "0 0 " + (can_edit ? '0' : '15px') + " 0",
	        padding: 0,
	        listStyle: 'none'
	      }),
	      onMouseEnter: (function(_this) {
	        return function() {
	          if (draw_slider) {
	            _this.local.hover_proposal = proposal.key;
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          if (draw_slider && !slider.is_moving) {
	            _this.local.hover_proposal = null;
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function() {
	          if (draw_slider) {
	            _this.local.hover_proposal = proposal.key;
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function() {
	          if (draw_slider && !slider.is_moving) {
	            _this.local.hover_proposal = null;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, DIV({
	      style: {
	        width: col_sizes.first,
	        display: 'inline-block',
	        verticalAlign: 'top',
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        position: 'absolute',
	        left: icons ? -40 - 18 : void 0,
	        top: icons ? 4 : void 0
	      }
	    }, icons ? (editor = proposal_editor(proposal), proposal.pic ? A({
	      href: proposal_url(proposal),
	      'aria-hidden': true,
	      tabIndex: -1
	    }, IMG({
	      src: proposal.pic,
	      style: {
	        height: 40,
	        width: 40,
	        borderRadius: 0,
	        backgroundColor: '#ddd'
	      }
	    })) : editor ? A({
	      href: proposal_url(proposal),
	      'aria-hidden': true,
	      tabIndex: -1
	    }, Avatar({
	      key: editor,
	      user: editor,
	      style: {
	        height: 40,
	        width: 40,
	        borderRadius: 0,
	        backgroundColor: '#ddd'
	      }
	    })) : SPAN({
	      style: {
	        height: 50,
	        width: 50,
	        display: 'inline-block',
	        verticalAlign: 'top',
	        border: "2px dashed #ddd"
	      }
	    })) : (typeof (base = this.props).icon === "function" ? base.icon() : void 0) || SVG({
	      style: {
	        position: 'relative',
	        left: -22,
	        top: 3
	      },
	      width: 8,
	      viewBox: '0 0 200 200'
	    }, CIRCLE({
	      cx: 100,
	      cy: 100,
	      r: 80,
	      fill: '#000000'
	    }))), DIV({
	      style: {
	        display: 'inline-block',
	        fontWeight: 400,
	        paddingBottom: !can_edit ? 20 : 4,
	        width: col_sizes.first
	      }
	    }, A({
	      className: 'proposal proposal_homepage_name',
	      style: _.defaults({}, this.props.name_style || {}, {
	        fontWeight: 600,
	        textDecoration: 'underline',
	        color: '#000',
	        fontSize: 20
	      }),
	      href: proposal_url(proposal, just_you)
	    }, proposal.name), DIV({
	      style: {
	        fontSize: 12,
	        color: 'black',
	        marginTop: 4
	      }
	    }, customization('proposal_meta_data') ? customization('proposal_meta_data')(proposal) : !this.props.hide_metadata && customization('show_proposal_meta_data') ? (show_author_name_in_meta_data = !icons && (editor = proposal_editor(proposal)) && editor === proposal.user, SPAN({
	      style: {
	        paddingRight: 16
	      }
	    }, !show_author_name_in_meta_data ? TRANSLATE('engage.proposal_metadata_date_added', "Added: ") : void 0, prettyDate(proposal.created_at), SPAN({
	      style: {
	        padding: '0 8px'
	      }
	    }, '|'), show_author_name_in_meta_data ? [
	      SPAN({
	        style: {}
	      }, TRANSLATE({
	        id: 'engage.proposal_author',
	        name: (ref2 = fetch(editor)) != null ? ref2.name : void 0
	      }, " by {name}")), SPAN({
	        style: {
	          padding: '0 8px'
	        }
	      }, '|')
	    ] : void 0, customization('discussion_enabled', proposal) ? A({
	      href: proposal_url(proposal, true),
	      style: {
	        cursor: 'pointer'
	      }
	    }, TRANSLATE({
	      id: "engage.point_count",
	      cnt: proposal.point_count
	    }, "{cnt, plural, one {# consideration} other {# considerations}}"), proposal.active ? [
	      SPAN({
	        style: {
	          padding: '0 8px'
	        }
	      }, '|'), SPAN({
	        style: {
	          textDecoration: 'underline'
	        }
	      }, TRANSLATE({
	        id: "engage.add_your_own"
	      }, "add a consideration"))
	    ] : void 0) : void 0)) : void 0, this.props.show_category && proposal.cluster ? (cluster = proposal.cluster, fetch('/subdomain').name === 'dao' && proposal.cluster === 'Proposals' ? cluster = 'Ideas' : void 0, cluster === "Proposals" ? cluster = translator("engage.default_proposals_list", "Proposals") : cluster = translator({
	      id: "proposal_list." + cluster,
	      key: "/translations/" + (fetch('/subdomain').name)
	    }, cluster), SPAN({
	      style: {
	        padding: '1px 2px',
	        fontStyle: 'italic'
	      }
	    }, cluster)) : void 0, !proposal.active ? SPAN({
	      style: {
	        padding: '0 16px'
	      }
	    }, TRANSLATE("engage.proposal_closed.short", 'closed')) : void 0), can_edit ? DIV({
	      style: {
	        visibility: !this.local.hover_proposal ? 'hidden' : void 0,
	        position: 'relative',
	        top: -2
	      }
	    }, A({
	      href: proposal.key + "/edit",
	      style: {
	        marginRight: 10,
	        color: focus_color(),
	        backgroundColor: 'transparent',
	        padding: 0,
	        fontSize: 12
	      }
	    }, TRANSLATE('engage.edit_button', 'edit')), permit('delete proposal', proposal) > 0 ? BUTTON({
	      style: {
	        marginRight: 10,
	        color: focus_color(),
	        backgroundColor: 'transparent',
	        border: 'none',
	        padding: 0,
	        fontSize: 12
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (confirm('Delete this proposal forever?')) {
	            destroy(proposal.key);
	            return loadPage('/');
	          }
	        };
	      })(this)
	    }, TRANSLATE('engage.delete_button', 'delete')) : void 0) : void 0)), DIV({
	      style: {
	        display: 'inline-block',
	        position: 'relative',
	        top: -26,
	        verticalAlign: 'top',
	        width: col_sizes.second,
	        marginLeft: col_sizes.gutter
	      }
	    }, Histogram({
	      key: "histogram-" + proposal.slug,
	      proposal: proposal,
	      opinions: opinions,
	      width: col_sizes.second,
	      height: 40,
	      enable_individual_selection: !browser.is_mobile,
	      enable_range_selection: everyone && !browser.is_mobile,
	      draw_base: true,
	      draw_base_labels: !slider_regions,
	      selection_state: 'filtered'
	    }), Slider({
	      base_height: 0,
	      draw_handle: !!draw_slider,
	      key: "homepage_slider" + proposal.key,
	      width: col_sizes.second,
	      polarized: true,
	      regions: slider_regions,
	      respond_to_click: false,
	      base_color: 'transparent',
	      handle: slider_handle.triangley,
	      handle_height: 18,
	      handle_width: 21,
	      handle_style: {
	        opacity: ((ref3 = fetch('filtered').current_filter) != null ? ref3.label : void 0) !== "just you" && !browser.is_mobile && this.local.hover_proposal !== proposal.key && !this.local.slider_has_focus ? 0 : 1
	      },
	      offset: true,
	      handle_props: {
	        use_face: false
	      },
	      label: translator({
	        id: "sliders.instructions",
	        negative_pole: get_slider_label("slider_pole_labels.oppose", proposal),
	        positive_pole: get_slider_label("slider_pole_labels.support", proposal)
	      }, "Express your opinion on a slider from {negative_pole} to {positive_pole}"),
	      onBlur: (function(_this) {
	        return function(e) {
	          _this.local.slider_has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.slider_has_focus = true;
	          return save(_this.local);
	        };
	      })(this),
	      readable_text: slider_interpretation,
	      onMouseUpCallback: (function(_this) {
	        return function(e) {
	          var mouse_over_element, prev_offset, prev_scroll, update;
	          if (your_opinion.stance !== slider.value) {
	            prev_offset = _this.getDOMNode().offsetTop;
	            prev_scroll = window.scrollY;
	            your_opinion.stance = slider.value;
	            your_opinion.published = true;
	            save(your_opinion);
	            window.writeToLog({
	              what: 'move slider',
	              details: {
	                proposal: proposal.key,
	                stance: slider.value
	              }
	            });
	            _this.local.slid = 1000;
	            update = fetch('homepage_you_updated_proposal');
	            update.dummy = !update.dummy;
	            save(update);
	          }
	          mouse_over_element = closest(e.target, function(node) {
	            return node === _this.getDOMNode();
	          });
	          if (_this.local.hover_proposal === proposal.key && !mouse_over_element) {
	            _this.local.hover_proposal = null;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    })), (function() {
	      var j, len1;
	      if (show_proposal_scores) {
	        score = 0;
	        filter_out = fetch('filtered');
	        opinions = (function() {
	          var j, len1, ref4, results;
	          results = [];
	          for (j = 0, len1 = opinions.length; j < len1; j++) {
	            o = opinions[j];
	            if (filter_out.enable_comparison || !((ref4 = filter_out.users) != null ? ref4[o.user] : void 0)) {
	              results.push(o);
	            }
	          }
	          return results;
	        })();
	        for (j = 0, len1 = opinions.length; j < len1; j++) {
	          o = opinions[j];
	          score += o.stance;
	        }
	        avg = score / opinions.length;
	        negative = score < 0;
	        if (negative) {
	          score *= -1;
	        }
	        score = pad(score.toFixed(1), 2);
	        val = "0000 opinion" + (opinions.length !== 1 ? 's' : '');
	        score_w = widthWhenRendered(' opinion' + (opinions.length !== 1 ? 's' : ''), {
	          fontSize: 12
	        }) + widthWhenRendered("0000", {
	          fontSize: 20
	        });
	        show_tooltip = (function(_this) {
	          return function() {
	            var tooltip;
	            if (opinions.length > 0) {
	              tooltip = fetch('tooltip');
	              tooltip.coords = $(_this.refs.score.getDOMNode()).offset();
	              tooltip.tip = translator({
	                id: "engage.proposal_score_summary.explanation",
	                percentage: Math.round(avg * 100)
	              }, "Average rating is {percentage}%");
	              return save(tooltip);
	            }
	          };
	        })(this);
	        hide_tooltip = (function(_this) {
	          return function() {
	            var tooltip;
	            tooltip = fetch('tooltip');
	            tooltip.coords = null;
	            return save(tooltip);
	          };
	        })(this);
	        return DIV({
	          'aria-hidden': true,
	          ref: 'score',
	          style: {
	            position: 'absolute',
	            right: -18 - score_w,
	            top: 23,
	            textAlign: 'left'
	          },
	          onFocus: show_tooltip,
	          onMouseEnter: show_tooltip,
	          onBlur: hide_tooltip,
	          onMouseLeave: hide_tooltip
	        }, SPAN({
	          style: {
	            color: '#999',
	            fontSize: 20,
	            cursor: 'default',
	            lineHeight: 1
	          }
	        }, TRANSLATE({
	          id: "engage.proposal_score_summary",
	          small: {
	            component: SPAN,
	            args: {
	              style: {
	                color: '#999',
	                fontSize: 12,
	                cursor: 'default',
	                verticalAlign: 'baseline'
	              }
	            }
	          },
	          num_opinions: opinions.length
	        }, "{num_opinions, plural, =0 {<small>no opinions</small>} one {# <small>opinion</small>} other {# <small>opinions</small>} }")));
	      }
	    }).call(this));
	  }
	});


/***/ },
/* 20 */
/***/ function(module, exports) {

	var fully_firmly_slightly_scale;
	
	window.passes_tags = function(user, tags) {
	  var i, len, passes, ref, ref1, ref2, tag;
	  if (typeof tags === 'string') {
	    tags = [tags];
	  }
	  user = fetch(user);
	  passes = true;
	  for (i = 0, len = tags.length; i < len; i++) {
	    tag = tags[i];
	    passes && (passes = (user != null ? (ref = user.tags) != null ? ref[tag] : void 0 : void 0) && !((ref1 = ("" + (user != null ? (ref2 = user.tags) != null ? ref2[tag] : void 0 : void 0)).toLowerCase()) === 'no' || ref1 === 'false'));
	  }
	  return passes;
	};
	
	window.passes_tag_filter = function(user, tag, regex) {
	  var ref, ref1;
	  user = fetch(user);
	  return user != null ? (ref = user.tags) != null ? (ref1 = ref[tag]) != null ? ref1.match(regex) : void 0 : void 0 : void 0;
	};
	
	window.cluster_link = function(href, anchor) {
	  anchor || (anchor = href);
	  return "<a href='" + href + "' target='_blank' style='font-weight: 600; text-decoration:underline'>" + anchor + "</a>";
	};
	
	window.point_labels = {
	  pro_con: {
	    translate: true,
	    pro: 'pro',
	    pros: 'pros',
	    con: 'con',
	    cons: 'cons',
	    your_header: "Give your {arguments}",
	    other_header: "Others' {arguments}",
	    top_header: "Top {arguments}",
	    your_cons_header: null,
	    your_pros_header: null
	  },
	  strengths_weaknesses: {
	    translate: true,
	    pro: 'strength',
	    pros: 'strengths',
	    con: 'weakness',
	    cons: 'weaknesses',
	    your_header: "{arguments}",
	    other_header: "{arguments} observed",
	    top_header: "Top {arguments}"
	  }
	};
	
	window.get_point_label = function(id, proposal) {
	  var conf, prop, ref, val;
	  prop = ((ref = id.split('.')) != null ? ref[1] : void 0) || id;
	  if (proposal) {
	    conf = customization('point_labels', proposal);
	  } else {
	    conf = customization('point_labels');
	  }
	  val = conf[prop];
	  if (!val) {
	    return "";
	  } else {
	    if (conf.translate) {
	      return translator("point_labels." + val, val);
	    } else {
	      return translator({
	        id: "point_labels." + val,
	        key: "/translations/" + (fetch('/subdomain').name)
	      }, val);
	    }
	  }
	};
	
	window.get_slider_label = function(id, proposal) {
	  var conf, label, ref, side;
	  side = ((ref = id.split('.')) != null ? ref[1] : void 0) || id;
	  if (proposal) {
	    conf = customization('slider_pole_labels', proposal);
	  } else {
	    conf = customization('slider_pole_labels');
	  }
	  label = conf[side];
	  if (!label) {
	    return "";
	  } else {
	    if (conf.translate) {
	      return translator("sliders.pole." + label, label);
	    } else {
	      return translator({
	        id: "sliders.pole." + label,
	        key: "/translations/" + (fetch('/subdomain').name)
	      }, label);
	    }
	  }
	};
	
	fully_firmly_slightly_scale = function(value, proposal) {
	  var degree, strength_of_opinion, valence;
	  if (Math.abs(value) < 0.02) {
	    return translator({
	      id: "sliders.feedback.neutral"
	    }, "You are neutral");
	  } else {
	    valence = get_slider_label((value > 0 ? 'support' : 'oppose'), proposal);
	    degree = Math.abs(value);
	    strength_of_opinion = degree > .999 ? "Fully" : degree > .5 ? "Firmly" : "Slightly";
	    return translator({
	      id: "sliders.feedback." + strength_of_opinion,
	      strength_of_opinion: strength_of_opinion,
	      valence: valence
	    }, "You " + strength_of_opinion + " {valence}");
	  }
	};
	
	window.slider_labels = {
	  agree_disagree: {
	    translate: true,
	    support: 'Agree',
	    oppose: 'Disagree',
	    slider_feedback: fully_firmly_slightly_scale
	  },
	  support_oppose: {
	    translate: true,
	    support: 'Support',
	    oppose: 'Oppose',
	    slider_feedback: fully_firmly_slightly_scale
	  },
	  priority: {
	    translate: true,
	    support: 'High Priority',
	    oppose: 'Low Priority'
	  },
	  important_unimportant: {
	    translate: true,
	    support: 'Important',
	    oppose: 'Unimportant'
	  },
	  relevance: {
	    support: 'Big impact!',
	    oppose: 'No impact on me'
	  },
	  interested: {
	    support: 'Interested',
	    oppose: 'Uninterested'
	  },
	  yes_no: {
	    support: 'Yes',
	    oppose: 'No'
	  },
	  strong_weak: {
	    support: 'Strong',
	    oppose: 'Weak'
	  },
	  promising_weak: {
	    support: 'Promising',
	    oppose: 'Weak'
	  },
	  ready_not_ready: {
	    support: 'Ready',
	    oppose: 'Not ready'
	  },
	  plus_minus: {
	    support: '+',
	    oppose: '–'
	  },
	  effective_ineffective: {
	    support: 'Effective',
	    oppose: 'Ineffective'
	  }
	};
	
	window.ExpandableSection = ReactiveComponent({
	  displayName: 'ExpandableSection',
	  render: function() {
	    var expanded, label, symbol, text;
	    label = this.props.label;
	    text = this.props.text;
	    expanded = this.local.expanded;
	    symbol = expanded ? 'fa-chevron-down' : 'fa-chevron-right';
	    return DIV(null, DIV({
	      onClick: (function(_this) {
	        return function() {
	          _this.local.expanded = !_this.local.expanded;
	          return save(_this.local);
	        };
	      })(this),
	      style: {
	        fontWeight: 600,
	        color: this.props.text_color || 'black',
	        cursor: 'pointer',
	        marginTop: 12,
	        fontSize: 22
	      }
	    }, SPAN({
	      className: "fa " + symbol,
	      style: {
	        opacity: .7,
	        position: 'relative',
	        left: -3,
	        paddingRight: 6,
	        display: 'inline-block',
	        width: 20
	      }
	    }), SPAN({
	      style: {}
	    }, label)), expanded ? text : void 0);
	  }
	});
	
	window.ShortHeader = function(opts) {
	  var homepage, hsl, is_light, loc, subdomain;
	  subdomain = fetch('/subdomain');
	  loc = fetch('location');
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  homepage = loc.url === '/';
	  opts || (opts = {});
	  _.defaults(opts, customization('forum_header') || {}, {
	    background: customization('background') || subdomain.branding.primary_color,
	    text: customization('prompt') || subdomain.branding.masthead_header_text || subdomain.app_title,
	    external_link: subdomain.external_project_url,
	    logo_src: subdomain.branding.logo,
	    logo_height: 50,
	    min_height: 70,
	    padding: '8px 0',
	    padding_left_icon: 20
	  });
	  hsl = parseCssHsl(opts.background);
	  is_light = hsl.l > .75;
	  return DIV({
	    style: {
	      background: opts.background
	    }
	  }, DIV({
	    style: {
	      position: 'relative',
	      padding: opts.padding,
	      minHeight: opts.min_height,
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      width: homepage ? HOMEPAGE_WIDTH() : void 0,
	      margin: homepage ? 'auto' : void 0
	    }
	  }, DIV({
	    style: {
	      paddingLeft: !homepage ? opts.padding_left_icon : 0,
	      paddingRight: 20,
	      height: opts.logo_height ? opts.logo_height : void 0,
	      display: 'flex',
	      alignItems: 'center'
	    }
	  }, opts.logo_src ? A({
	    href: !homepage ? '/' : opts.external_link,
	    style: {
	      fontSize: 0,
	      cursor: !homepage && !opts.external_link ? 'default' : void 0,
	      verticalAlign: 'middle',
	      display: 'block'
	    }
	  }, IMG({
	    src: opts.logo_src,
	    alt: subdomain.name + " logo",
	    style: {
	      height: opts.logo_height
	    }
	  })) : void 0, !homepage ? DIV({
	    style: {
	      paddingRight: 18,
	      position: opts.logo_src ? 'absolute' : void 0,
	      bottom: opts.logo_src ? -30 : void 0,
	      left: opts.logo_src ? 7 : void 0
	    }
	  }, back_to_homepage_button({
	    color: !is_light && !opts.logo_src ? 'white' : void 0,
	    fontSize: 18,
	    fontWeight: 600,
	    display: 'inline'
	  }, TRANSLATE("engage.navigate_back_to_homepage", 'homepage'))) : void 0), opts.text ? H2({
	    style: {
	      color: !is_light ? 'white' : void 0,
	      marginLeft: opts.logo_src ? 35 : void 0,
	      paddingRight: 90,
	      fontSize: 32,
	      fontWeight: 400
	    }
	  }, opts.text) : void 0));
	};
	
	window.LegacyImageHeader = function(opts) {
	  var homepage, hsl, is_light, loc, subdomain;
	  subdomain = fetch('/subdomain');
	  loc = fetch('location');
	  homepage = loc.url === '/';
	  if (!subdomain.name) {
	    return SPAN(null);
	  }
	  opts || (opts = {});
	  _.defaults(opts, {
	    background_color: subdomain.branding.primary_color,
	    background_image_url: subdomain.branding.masthead,
	    text: subdomain.branding.masthead_header_text,
	    external_link: subdomain.external_project_url
	  });
	  if (!opts.background_image_url) {
	    throw 'LegacyImageHeader can\'t be used without a branding masthead';
	  }
	  hsl = parseCssHsl(opts.background_color);
	  is_light = hsl.l > .75;
	  return DIV(null, IMG({
	    alt: opts.background_image_alternative_text,
	    src: opts.background_image_url,
	    style: {
	      width: '100%'
	    }
	  }), homepage && opts.external_link ? A({
	    href: opts.external_link,
	    style: {
	      display: 'block',
	      position: 'absolute',
	      left: 10,
	      top: 17,
	      color: !is_light ? 'white' : void 0,
	      fontSize: 18
	    }
	  }, '< project homepage') : back_to_homepage_button({
	    position: 'relative',
	    marginLeft: 20,
	    display: 'inline-block',
	    color: !is_light ? 'white' : void 0,
	    verticalAlign: 'middle',
	    marginTop: 5
	  }), opts.text ? H1({
	    style: {
	      color: 'white',
	      margin: 'auto',
	      fontSize: 60,
	      fontWeight: 700,
	      position: 'relative',
	      top: 50
	    }
	  }, opts.text) : void 0);
	};
	
	window.HawaiiHeader = function(opts) {
	  var background_color, homepage, hsl, is_light, subdomain, subtitle_is_html;
	  homepage = fetch('location').url === '/';
	  subdomain = fetch('/subdomain');
	  background_color = opts.background_color || (subdomain.branding.primary_color && subdomain.branding.primary_color !== '' ? subdomain.branding.primary_color : void 0) || '#000';
	  hsl = parseCssHsl(opts.background_color || "#ffffff");
	  is_light = hsl.l > .75;
	  opts || (opts = {});
	  _.defaults(opts, {
	    background_color: background_color,
	    background_image_url: opts.background_image_url || subdomain.branding.masthead,
	    logo: subdomain.branding.logo,
	    logo_width: 200,
	    title: '<title is required>',
	    subtitle: null,
	    title_style: {},
	    subtitle_style: {},
	    tab_style: {},
	    homepage_button_style: {}
	  });
	  _.defaults(opts.title_style, {
	    fontSize: 47,
	    color: is_light ? 'black' : 'white',
	    fontWeight: 300,
	    display: 'inline-block'
	  });
	  _.defaults(opts.subtitle_style, {
	    position: 'relative',
	    fontSize: 22,
	    color: is_light ? 'black' : 'white',
	    marginTop: 0,
	    opacity: .7,
	    textAlign: 'center'
	  });
	  _.defaults(opts.homepage_button_style, {
	    display: 'inline-block',
	    color: is_light ? 'black' : 'white',
	    position: 'absolute',
	    left: -80,
	    fontSize: opts.title_style.fontSize,
	    fontWeight: 400,
	    paddingLeft: 25,
	    paddingRight: 25,
	    cursor: fetch('location').url !== '/' ? 'pointer' : void 0
	  });
	  return DIV({
	    style: {
	      position: 'relative',
	      padding: "30px 0",
	      backgroundPosition: 'center',
	      backgroundSize: 'cover',
	      backgroundImage: "url(" + opts.background_image_url + ")",
	      backgroundColor: opts.background_color
	    }
	  }, STYLE(null, '.profile_anchor.login {font-size: 26px; padding-top: 16px;}\np {margin-bottom: 1em}'), DIV({
	    style: {
	      margin: 'auto',
	      width: HOMEPAGE_WIDTH(),
	      position: 'relative',
	      textAlign: homepage ? 'center' : void 0
	    }
	  }, back_to_homepage_button(opts.homepage_button_style), homepage && opts.logo ? IMG({
	    alt: opts.logo_alternative_text,
	    src: opts.logo,
	    style: {
	      width: opts.logo_width,
	      display: 'block',
	      margin: 'auto',
	      paddingTop: 20
	    }
	  }) : void 0, H1({
	    style: opts.title_style
	  }, opts.title), homepage && opts.subtitle ? (subtitle_is_html = opts.subtitle.indexOf('<') > -1 && opts.subtitle.indexOf('>') > -1, DIV({
	    style: opts.subtitle_style,
	    dangerouslySetInnerHTML: subtitle_is_html ? {
	      __html: opts.subtitle
	    } : void 0
	  }, !subtitle_is_html ? opts.subtitle : void 0)) : void 0, homepage && customization('homepage_tabs') ? DIV({
	    style: {
	      position: 'relative',
	      margin: '62px auto 0 auto',
	      width: HOMEPAGE_WIDTH()
	    }
	  }, HomepageTabs({
	    tab_style: opts.tab_style,
	    tab_wrapper_style: _.defaults({}, opts.tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color,
	      margin: '0 6px'
	    }),
	    active_style: _.defaults({}, opts.tab_active_style || {}, {
	      backgroundColor: 'white',
	      color: 'black'
	    }),
	    active_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    hovering_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    wrapper_style: _.defaults({}, opts.tabs_wrapper_style || {}, {
	      marginTop: 80,
	      top: 0
	    }),
	    list_style: opts.tabs_list_style || {}
	  })) : void 0));
	};
	
	window.SeattleHeader = function(opts) {
	  var HEADING, active_style, external_link_style, homepage, idx, paragraph, paragraph_style, quote_style, section, section_heading_style, subdomain;
	  homepage = fetch('location').url === '/';
	  subdomain = fetch('/subdomain');
	  opts || (opts = {});
	  _.defaults(opts, {
	    external_link: subdomain.branding.external_project_url,
	    background_color: '#fff',
	    background_image_url: subdomain.branding.masthead,
	    external_link_style: {},
	    quote_style: {},
	    paragraph_style: {},
	    section_heading_style: {}
	  });
	  paragraph_style = _.defaults(opts.paragraph_style, {
	    fontSize: 18,
	    color: '#444',
	    paddingTop: 10,
	    display: 'block'
	  });
	  quote_style = _.defaults(opts.quote_style, {
	    fontStyle: 'italic',
	    margin: 'auto',
	    padding: "40px 40px",
	    fontSize: paragraph_style.fontSize,
	    color: paragraph_style.color
	  });
	  section_heading_style = _.defaults(opts.section_heading_style, {
	    display: 'block',
	    fontWeight: 400,
	    fontSize: 28,
	    color: 'black'
	  });
	  external_link_style = _.defaults(opts.external_link_style, {
	    display: 'block',
	    position: 'absolute',
	    top: 22,
	    left: 20,
	    color: "#0B4D92"
	  });
	  if (!homepage) {
	    return DIV({
	      style: {
	        backgroundColor: 'white'
	      }
	    }, DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        fontSize: 43,
	        padding: '10px 0'
	      }
	    }, A({
	      href: '/'
	    }, '< ', SPAN({
	      style: {
	        fontSize: 32,
	        position: 'relative',
	        left: 5
	      }
	    }, 'Homepage'))));
	  }
	  return DIV({
	    style: {
	      position: 'relative'
	    }
	  }, opts.external_link ? A({
	    href: opts.external_link,
	    target: '_blank',
	    style: opts.external_link_style
	  }, I({
	    className: 'fa fa-chevron-left',
	    style: {
	      display: 'inline-block',
	      marginRight: 5
	    }
	  }), opts.external_link_anchor || opts.external_link) : void 0, opts.background_image_url ? IMG({
	    alt: opts.background_image_alternative_text,
	    style: _.defaults({}, opts.image_style, {
	      width: '100%',
	      display: 'block'
	    }),
	    src: opts.background_image_url
	  }) : void 0, DIV({
	    style: {
	      padding: '20px 0'
	    }
	  }, DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto'
	    }
	  }, opts.quote ? DIV({
	    style: quote_style
	  }, "“" + opts.quote.what + "”", opts.quote.who ? DIV({
	    style: {
	      paddingLeft: '70%',
	      paddingTop: 10
	    }
	  }, "– " + opts.quote.who) : void 0) : void 0, DIV(null, (function() {
	    var i, len, ref, results;
	    ref = opts.sections;
	    results = [];
	    for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	      section = ref[idx];
	      results.push(DIV({
	        style: {
	          marginBottom: 20
	        }
	      }, section.label ? (HEADING = idx === 0 ? H1 : DIV, HEADING({
	        style: _.defaults({}, section.label_style || {}, section_heading_style)
	      }, section.label)) : void 0, DIV(null, (function() {
	        var j, len1, ref1, results1;
	        ref1 = section.paragraphs || [];
	        results1 = [];
	        for (j = 0, len1 = ref1.length; j < len1; j++) {
	          paragraph = ref1[j];
	          results1.push(SPAN({
	            style: paragraph_style,
	            dangerouslySetInnerHTML: {
	              __html: paragraph
	            }
	          }));
	        }
	        return results1;
	      })())));
	    }
	    return results;
	  })()), opts.salutation ? DIV({
	    style: _.extend({}, paragraph_style, {
	      marginTop: 10
	    })
	  }, opts.salutation.text ? DIV({
	    style: {
	      marginBottom: 18
	    }
	  }, opts.salutation.text) : void 0, A({
	    href: opts.external_link ? opts.external_link : void 0,
	    target: '_blank',
	    style: {
	      display: 'block',
	      marginBottom: 8
	    }
	  }, opts.salutation.image ? IMG({
	    src: opts.salutation.image,
	    alt: '',
	    style: {
	      height: 70
	    }
	  }) : opts.salutation.from), opts.salutation.after ? DIV({
	    style: _.extend({}, paragraph_style, {
	      margin: 0
	    }),
	    dangerouslySetInnerHTML: {
	      __html: opts.salutation.after
	    }
	  }) : void 0) : void 0, opts.login_callout ? AuthCallout() : void 0, opts.closed ? DIV({
	    style: {
	      marginTop: 40,
	      backgroundColor: "#F06668",
	      color: 'white',
	      fontSize: 28,
	      textAlign: 'center',
	      padding: "30px 42px"
	    }
	  }, "The comment period is now closed. Thank you for your input!") : void 0), customization('homepage_tabs') ? (active_style = _.defaults({}, opts.tab_active_style || {}, {
	    opacity: 1,
	    borderColor: seattle_vars.teal,
	    backgroundColor: 'white'
	  }), DIV({
	    style: {
	      borderBottom: "1px solid " + active_style.borderColor
	    }
	  }, DIV({
	    style: {
	      width: HOMEPAGE_WIDTH(),
	      margin: 'auto'
	    }
	  }, HomepageTabs({
	    tab_style: _.defaults({}, opts.tab_style || {}, {
	      padding: '10px 30px 0px 30px',
	      color: seattle_vars.teal,
	      border: '1px solid',
	      borderBottom: 'none',
	      borderColor: 'transparent',
	      fontSize: 18,
	      fontWeight: 700,
	      opacity: 0.3
	    }),
	    hover_style: {
	      opacity: 1
	    },
	    tab_wrapper_style: _.defaults({}, opts.tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    active_style: active_style,
	    active_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    hovering_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    wrapper_style: _.defaults({}, opts.tabs_wrapper_style || {}),
	    list_style: opts.tabs_list_style || {}
	  })))) : void 0));
	};
	
	window.PhotoBanner = function(opts) {
	  var homepage, ref, subdomain;
	  homepage = fetch('location').url === '/';
	  subdomain = fetch('/subdomain');
	  if (opts == null) {
	    opts = {};
	  }
	  if (opts.tab_background_color == null) {
	    opts.tab_background_color = '#666';
	  }
	  if (!homepage) {
	    return DIV({
	      style: {
	        backgroundColor: 'white'
	      }
	    }, DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        fontSize: 43,
	        padding: '10px 0'
	      }
	    }, A({
	      href: '/'
	    }, '< ', SPAN({
	      style: {
	        fontSize: 32,
	        position: 'relative',
	        left: 5
	      }
	    }, 'Homepage'))));
	  }
	  return DIV(null, DIV({
	    style: {
	      backgroundImage: opts.backgroundImage || ((ref = subdomain.branding) != null ? ref.masthead : void 0),
	      backgroundSize: 'cover',
	      paddingTop: 140
	    }
	  }, DIV({
	    style: _.defaults({}, opts.header_style || {}, {
	      padding: '48px 48px 48px 48px',
	      width: HOMEPAGE_WIDTH(),
	      maxWidth: 720,
	      margin: 'auto',
	      backgroundColor: 'rgba(0, 85, 150, .8)',
	      color: 'white',
	      position: 'relative',
	      top: 0
	    })
	  }, DIV({
	    style: _.defaults({}, opts.header_text_style || {}, {
	      fontSize: 56,
	      fontWeight: 800,
	      fontStyle: 'oblique',
	      textAlign: 'center',
	      paddingBottom: 28
	    }),
	    dangerouslySetInnerHTML: {
	      __html: opts.header
	    }
	  }), DIV(null, typeof opts.supporting_text === "function" ? opts.supporting_text() : void 0)), customization('homepage_tabs') ? HomepageTabs({
	    tab_style: _.defaults({}, opts.tab_style || {}, {
	      textTransform: 'uppercase',
	      fontStyle: 'oblique',
	      fontWeight: 600,
	      fontSize: 20,
	      padding: '10px 16px 4px'
	    }),
	    tab_wrapper_style: _.defaults({}, opts.tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color,
	      margin: '0 6px'
	    }),
	    active_style: _.defaults({}, opts.tab_active_style || {}, {
	      backgroundColor: 'white',
	      color: 'black'
	    }),
	    active_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    hovering_tab_wrapper_style: _.defaults({}, opts.active_tab_wrapper_style || {}, {
	      backgroundColor: opts.tab_background_color
	    }),
	    wrapper_style: _.defaults({}, opts.tabs_wrapper_style || {}, {
	      marginTop: 80,
	      top: 0
	    }),
	    list_style: opts.tabs_list_style || {}
	  }) : void 0));
	};


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	var big_button;
	
	__webpack_require__(1);
	
	window.Footer = ReactiveComponent({
	  displayName: 'Footer',
	  render: function() {
	    return FOOTER({
	      style: {
	        position: 'relative',
	        zIndex: 0
	      }
	    }, customization('SiteFooter')());
	  }
	});
	
	big_button = function() {
	  return {
	    backgroundColor: logo_red,
	    boxShadow: "0 4px 0 0 black",
	    fontWeight: 700,
	    color: 'white',
	    padding: '6px 60px',
	    display: 'inline-block',
	    fontSize: 24,
	    border: 'none',
	    borderRadius: 12
	  };
	};
	
	window.DefaultFooter = ReactiveComponent({
	  displayName: 'Footer',
	  render: function() {
	    var base, separator, subdomain;
	    subdomain = fetch('/subdomain');
	    separator = SPAN({
	      style: {
	        padding: '0 6px',
	        color: '#ccc'
	      }
	    }, '|');
	    return DIV(null, typeof (base = customization('footer_bonus')) === "function" ? base() : void 0, DIV({
	      style: {
	        paddingTop: 140,
	        backgroundColor: 'white'
	      }
	    }), DIV({
	      style: {
	        paddingTop: 80,
	        backgroundColor: "#F4F4F4",
	        borderTop: "1px solid #" + 737373,
	        padding: '45px 0 15px 0',
	        position: 'relative',
	        zIndex: 3
	      }
	    }, DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        margin: 'auto'
	      }
	    }, DIV({
	      style: {
	        position: 'relative',
	        margin: 'auto',
	        textAlign: 'center',
	        top: -70
	      }
	    }, BUTTON({
	      onClick: function() {
	        return scrollTo(0, 0);
	      },
	      onKeyPress: function(e) {
	        if (e.which === 13 || e.which === 32) {
	          e.preventDefault();
	          return scrollTo(0, 0);
	        }
	      },
	      style: _.extend({}, big_button(), {
	        backgroundColor: '#717171'
	      })
	    }, translator('footer.back_to_top_button', 'Back to top'))), DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, TechnologyByConsiderit({
	      size: 26
	    }), BR(null), DIV({
	      style: {
	        marginBottom: 18
	      }
	    }, A({
	      href: 'https://github.com/Considerit/ConsiderIt',
	      style: {
	        textDecoration: 'underline',
	        fontWeight: 600,
	        fontSize: 14
	      },
	      target: '_blank'
	    }, "Consider.it is Open Source", IMG({
	      src: asset('product_page/github_logo.png'),
	      style: {
	        height: 18,
	        paddingLeft: 6,
	        verticalAlign: 'middle'
	      }
	    })), ' | ', A({
	      href: 'https://consider.it',
	      style: {
	        display: 'inline-block',
	        textDecoration: 'underline',
	        fontSize: 14,
	        marginTop: 10,
	        fontWeight: 600
	      }
	    }, translator({
	      id: "footer.created_your_own_forum"
	    }, 'Create your own forum')))), DIV({
	      style: {
	        color: '#303030',
	        fontSize: 11,
	        textAlign: 'center',
	        marginTop: 20
	      }
	    }, SPAN(null, DIV({
	      style: {
	        display: 'inline-block'
	      }
	    }, '© 2019 Consider.it. All rights reserved. ', TRANSLATE({
	      id: 'footer.policies',
	      privacy_link: {
	        component: A,
	        args: {
	          href: '/privacy_policy',
	          style: {
	            textDecoration: 'underline'
	          }
	        }
	      },
	      terms_link: {
	        component: A,
	        args: {
	          href: '/terms_of_service',
	          style: {
	            textDecoration: 'underline'
	          }
	        }
	      }
	    }, "<privacy_link>Privacy</privacy_link> and <terms_link>Terms</terms_link>.")), SPAN({
	      style: {
	        marginLeft: 40,
	        display: 'inline-block'
	      }
	    }, TRANSLATE({
	      id: "footer.bug_reports",
	      link: {
	        component: A,
	        args: {
	          style: {
	            textDecoration: 'underline'
	          },
	          href: 'mailto:hello@consider.it'
	        }
	      }
	    }, "Report bugs to <link>help@consider.it</link>")), !customization('google_translate_style') || fetch('location').url !== '/' ? DIV({
	      style: {
	        marginLeft: 40,
	        display: 'inline-block'
	      }
	    }, GoogleTranslate()) : void 0)))));
	  }
	});
	
	__webpack_require__(8);
	
	window.TechnologyByConsiderit = ReactiveComponent({
	  displayName: 'TechnologyByConsiderit',
	  render: function() {
	    var base;
	    (base = this.props).size || (base.size = 20);
	    return DIV({
	      style: {
	        textAlign: 'left',
	        display: 'inline-block',
	        fontSize: this.props.size
	      }
	    }, "Technology by ", A({
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.hover = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.hover = false;
	          return save(_this.local);
	        };
	      })(this),
	      href: 'http://consider.it',
	      target: '_blank',
	      title: 'Consider.it\'s homepage',
	      style: {
	        position: 'relative',
	        top: 6,
	        left: 3
	      }
	    }, drawLogo({
	      height: this.props.size + 5,
	      main_text_color: logo_red,
	      o_text_color: logo_red,
	      clip: false,
	      draw_line: true,
	      line_color: logo_red,
	      i_dot_x: this.local.hover ? 142 : null,
	      transition: true
	    })));
	  }
	});


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	__webpack_require__(30);
	
	window.Button = function(props, text, callback) {
	  var style;
	  style = {
	    backgroundColor: focus_color(),
	    borderRadius: 8,
	    color: 'white',
	    padding: '3px 10px',
	    display: 'inline-block',
	    fontWeight: 600,
	    textAlign: 'center',
	    cursor: 'pointer',
	    border: 'none'
	  };
	  props.style = _.extend(style, props.style || {});
	  props.onClick = callback;
	  props.onKeyDown = function(e) {
	    if (e.which === 13 || e.which === 32) {
	      callback(e);
	      e.stopPropagation();
	      return e.preventDefault();
	    }
	  };
	  return BUTTON(props, text);
	};
	
	window.AutoGrowTextArea = ReactiveComponent({
	  displayName: 'AutoGrowTextArea',
	  onChange: function(e) {
	    var base;
	    if (typeof (base = this.props).onChange === "function") {
	      base.onChange(e);
	    }
	    return this.checkAndSetHeight();
	  },
	  componentDidMount: function() {
	    return this.checkAndSetHeight();
	  },
	  componentDidUpdate: function() {
	    return this.checkAndSetHeight();
	  },
	  checkAndSetHeight: function() {
	    var client_height, h, max_height, scroll_height;
	    scroll_height = this.getDOMNode().scrollHeight;
	    max_height = this.props.max_height || 600;
	    client_height = this.getDOMNode().clientHeight;
	    if (scroll_height > client_height) {
	      h = Math.min(scroll_height + 5, max_height);
	      if (h !== this.local.height) {
	        this.local.height = h;
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange();
	        }
	        return save(this.local);
	      }
	    }
	  },
	  render: function() {
	    if (!this.local.height) {
	      this.local.height = this.props.min_height;
	    }
	    return this.transferPropsTo(TEXTAREA({
	      onChange: this.onChange,
	      rows: 1,
	      style: _.extend({
	        padding: '4px 8px'
	      }, this.props.style || {}, {
	        height: this.local.height
	      })
	    }));
	  }
	});
	
	window.CharacterCountTextInput = ReactiveComponent({
	  displayName: 'CharacterCountTextInput',
	  render: function() {
	    var class_name, count_style;
	    if (this.local.count == null) {
	      this.local.count = (this.props.defaultValue || "").length;
	    }
	    count_style = this.props.count_style || {};
	    class_name = "is_counted";
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, SPAN({
	      'aria-hidden': true,
	      style: count_style
	    }, this.props.maxLength - this.local.count), SPAN({
	      className: 'hidden'
	    }, translator({
	      id: "engage.character_counter",
	      characters_left: this.props.maxLength - this.local.count
	    }, "{characters_left, plural, one {# character} other {# characters}} left")), this.transferPropsTo(TEXTAREA({
	      className: class_name,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.count = $(_this.getDOMNode()).find('textarea').val().length;
	          return save(_this.local);
	        };
	      })(this)
	    })));
	  }
	});
	
	window.WysiwygEditor = ReactiveComponent({
	  displayName: 'WysiwygEditor',
	  render: function() {
	    var button, idx, my_data, ref, subdomain, toolbar_items, wysiwyg_editor;
	    my_data = fetch(this.props.key);
	    subdomain = fetch('/subdomain');
	    wysiwyg_editor = fetch('wysiwyg_editor');
	    this.supports_Quill = !!Quill;
	    if (!this.local.initialized) {
	      my_data.html = this.props.html;
	      this.local.initialized = true;
	      save(this.local);
	      save(my_data);
	    }
	    this.show_placeholder = (!my_data.html || (((ref = this.editor) != null ? ref.getText().trim().length : void 0) === 0)) && !!this.props.placeholder;
	    toolbar_items = [
	      {
	        className: "ql-list fa fa-list-ul",
	        value: 'bullet',
	        title: 'Bulleted list'
	      }, {
	        className: "ql-list fa fa-list-ol",
	        value: 'ordered',
	        title: 'Numbered list'
	      }, {
	        className: "ql-bold fa fa-bold",
	        title: 'Bold selected text'
	      }, {
	        className: "ql-link fa fa-link",
	        title: 'Hyperlink selected text'
	      }
	    ];
	    if (fetch('/current_user').is_admin) {
	      toolbar_items.push({
	        className: 'fa fa-code',
	        title: 'Directly edit HTML',
	        onClick: (function(_this) {
	          return function() {
	            _this.local.edit_code = true;
	            return save(_this.local);
	          };
	        })(this)
	      });
	    }
	    return DIV({
	      id: this.props.key,
	      style: {
	        position: 'relative'
	      },
	      onClick: function(ev) {
	        return ev.stopPropagation();
	      }
	    }, this.local.edit_code || !this.supports_Quill ? AutoGrowTextArea({
	      style: {
	        width: '100%',
	        fontSize: 18
	      },
	      defaultValue: fetch(this.props.key).html,
	      onChange: (function(_this) {
	        return function(e) {
	          my_data = fetch(_this.props.key);
	          my_data.html = e.target.value;
	          return save(my_data);
	        };
	      })(this)
	    }) : DIV(null, Dock({
	      dock_on_zoomed_screens: true,
	      skip_jut: true,
	      dummy: wysiwyg_editor.showing
	    }, DIV({
	      ref: 'toolbar',
	      role: 'toolbar',
	      'title': 'Rich text markup',
	      'aria-orientation': 'vertical',
	      id: 'toolbar',
	      tabIndex: 0,
	      style: {
	        position: 'absolute',
	        width: 30,
	        left: -32,
	        top: 0,
	        display: 'block',
	        visibility: wysiwyg_editor.showing !== this.props.key ? 'hidden' : void 0
	      },
	      onFocus: (function(_this) {
	        return function(e) {
	          if (!_this.local.focused_toolbar_item && !_this.local.just_unfocused) {
	            if (_this.local.focused_toolbar_item == null) {
	              _this.local.focused_toolbar_item = 0;
	              save(_this.local);
	            }
	            return _this.refs["toolbaritem-" + _this.local.focused_toolbar_item].getDOMNode().focus();
	          }
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var i, ref1, ref2;
	          if ((ref1 = e.which) === 37 || ref1 === 38 || ref1 === 39 || ref1 === 40) {
	            i = _this.local.focused_toolbar_item;
	            if ((ref2 = e.which) === 37 || ref2 === 38) {
	              i--;
	              if (i < 0) {
	                i = toolbar_items.length - 1;
	              }
	            } else {
	              i++;
	              if (i > toolbar_items.length - 1) {
	                i = 0;
	              }
	            }
	            _this.local.focused_toolbar_item = i;
	            save(_this.local);
	            _this.refs["toolbaritem-" + i].getDOMNode().focus();
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, (function() {
	      var j, len, results;
	      results = [];
	      for (idx = j = 0, len = toolbar_items.length; j < len; idx = ++j) {
	        button = toolbar_items[idx];
	        results.push((function(_this) {
	          return function(idx) {
	            return BUTTON({
	              ref: "toolbaritem-" + idx,
	              tabIndex: _this.local.focused_toolbar_item === idx ? 0 : -1,
	              className: button.className,
	              'aria-label': button.title,
	              style: {
	                fontSize: 14,
	                width: 28,
	                textAlign: 'center',
	                cursor: 'pointer',
	                padding: 2,
	                border: '1px solid #aaa',
	                borderRadius: 3,
	                backgroundColor: 'transparent',
	                display: 'block',
	                marginBottom: 4
	              },
	              title: button.title,
	              value: button.value ? button.value : void 0,
	              onClick: button.onClick ? button.onClick : void 0,
	              onFocus: function(e) {
	                _this.local.focused_toolbar_item = idx;
	                save(_this.local);
	                return e.stopPropagation();
	              },
	              onBlur: function(e) {
	                e.stopPropagation();
	                _this.local.focused_toolbar_item = null;
	                _this.local.just_unfocused = true;
	                setTimeout(function() {
	                  return _this.local.just_unfocused = false;
	                }, 0);
	                save(_this.local);
	                return setTimeout(function() {
	                  if ($(document.activeElement).closest(_this.getDOMNode()).length === 0) {
	                    wysiwyg_editor = fetch('wysiwyg_editor');
	                    wysiwyg_editor.showing = false;
	                    return save(wysiwyg_editor);
	                  }
	                }, 0);
	              }
	            });
	          };
	        })(this)(idx));
	      }
	      return results;
	    }).call(this))), DIV({
	      style: _.extend({}, this.props.container_style, {
	        outline: fetch('wysiwyg_editor').showing === this.props.key ? "2px solid " + (focus_color()) : void 0
	      }),
	      className: 'proposal_details'
	    }, DIV({
	      id: 'editor',
	      dangerouslySetInnerHTML: {
	        __html: this.props.html
	      },
	      onFocus: (function(_this) {
	        return function(e) {
	          wysiwyg_editor = fetch('wysiwyg_editor');
	          wysiwyg_editor.showing = _this.props.key;
	          return save(wysiwyg_editor);
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function() {
	          return setTimeout(function() {
	            if ($(document.activeElement).closest(_this.getDOMNode()).length === 0) {
	              wysiwyg_editor = fetch('wysiwyg_editor');
	              wysiwyg_editor.showing = false;
	              return save(wysiwyg_editor);
	            }
	          }, 0);
	        };
	      })(this),
	      style: this.props.style
	    }))));
	  },
	  componentDidMount: function() {
	    var getHTML, keyboard;
	    if (!this.supports_Quill) {
	      return;
	    }
	    getHTML = (function(_this) {
	      return function() {
	        return _this.getDOMNode().querySelector(".ql-editor").innerHTML;
	      };
	    })(this);
	    this.editor = new Quill($(this.getDOMNode()).find('#editor')[0], {
	      modules: {
	        toolbar: {
	          container: $(this.getDOMNode()).find('#toolbar')[0]
	        }
	      },
	      styles: true,
	      placeholder: this.show_placeholder ? this.props.placeholder : ''
	    });
	    keyboard = this.editor.getModule('keyboard');
	    delete keyboard.bindings[9];
	    return this.editor.on('text-change', (function(_this) {
	      return function(delta, old_contents, source) {
	        var my_data, node, removeStyles;
	        my_data = fetch(_this.props.key);
	        my_data.html = getHTML();
	        if (source === 'user' && my_data.html.indexOf(' style') > -1) {
	          removeStyles = function(el) {
	            var child, j, len, ref, results;
	            el.removeAttribute('style');
	            if (el.childNodes.length > 0) {
	              ref = el.childNodes;
	              results = [];
	              for (j = 0, len = ref.length; j < len; j++) {
	                child = ref[j];
	                if (child.nodeType === 1) {
	                  results.push(removeStyles(child));
	                } else {
	                  results.push(void 0);
	                }
	              }
	              return results;
	            }
	          };
	          node = _this.editor.root;
	          removeStyles(node);
	          my_data.html = getHTML();
	        }
	        return save(my_data);
	      };
	    })(this));
	  }
	});
	
	styles += "html .ql-container{\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  padding: 0;\n  overflow-x: visible;\n  overflow-y: visible;\n}\n.ql-editor {\n  min-height: 120px;\n  outline: none;\n}\n.ql-editor.ql-blank::before{\n  content: attr(data-placeholder);\n  pointer-events: none;\n  position: absolute;\n  color: rgba(0,0,0,.4);\n  font-weight: 500;\n}\n\n\n\n.ql-container {\n  box-sizing: border-box;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n\n.ql-editor {\n  box-sizing: border-box;\n  cursor: text;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor li::before {\n  display: inline-block;\n  margin-right: 0.3em;\n  text-align: right;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n}\n.ql-editor ol li,\n.ql-editor ul li {\n  padding-left: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-num;\n}\n.ql-editor ol li:before {\n  content: counter(list-num, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  pointer-events: none;\n  position: absolute;\n}";


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(25);
	
	__webpack_require__(2);
	
	window.Header = ReactiveComponent({
	  displayName: 'Header',
	  render: function() {
	    var auth, base, current_user, ref, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    auth = fetch('auth');
	    if (auth.form && ((ref = auth.form) !== 'edit profile')) {
	      return SPAN(null);
	    }
	    return HEADER(null, typeof (base = customization('header_bonus')) === "function" ? base() : void 0, DIV({
	      style: {
	        position: 'relative',
	        zIndex: 2,
	        margin: '0 auto',
	        backgroundColor: 'white'
	      }
	    }, ProfileMenu(), customization('google_translate_style') && fetch('location').url === '/' ? DIV({
	      style: {
	        position: 'absolute',
	        left: 40
	      }
	    }, GoogleTranslate()) : void 0, fetch('location').url === '/' && customization('HomepageHeader') ? customization('HomepageHeader').apply(this) : customization('SiteHeader').apply(this), DIV({
	      style: {
	        backgroundColor: '#eee',
	        color: '#f00',
	        padding: '5px 20px',
	        display: this.root.server_error ? 'block' : 'none'
	      }
	    }, translator("engage.server_error", 'Warning: there was a server error!'))));
	  }
	});


/***/ },
/* 24 */
/***/ function(module, exports) {

	window.NewProposal = ReactiveComponent({
	  displayName: 'NewProposal',
	  render: function() {
	    var adding, additional_field, base, bullet, cluster_key, cluster_name, cluster_slug, cluster_state, current_user, editor, error, label_style, loc, needs_to_login, permitted, proposal_fields, ref, w;
	    cluster_name = this.props.cluster_name || 'Proposals';
	    cluster_key = "list/" + cluster_name;
	    cluster_state = fetch(this.props.local);
	    loc = fetch('location');
	    if (cluster_name === 'Blocksize Survey') {
	      return SPAN(null);
	    }
	    current_user = fetch('/current_user');
	    if (cluster_state.adding_new_proposal !== cluster_name && loc.query_params.new_proposal === encodeURIComponent(cluster_name)) {
	      cluster_state.adding_new_proposal = cluster_name;
	      save(cluster_state);
	    }
	    adding = cluster_state.adding_new_proposal === cluster_name;
	    cluster_slug = slugify(cluster_name);
	    permitted = permit('create proposal');
	    needs_to_login = permitted === Permission.NOT_LOGGED_IN;
	    permitted = permitted > 0;
	    (base = this.local).category || (base.category = cluster_name);
	    if (!permitted && !needs_to_login) {
	      return SPAN(null);
	    }
	    proposal_fields = customization('new_proposal_fields', cluster_name)();
	    label_style = {
	      fontWeight: 400,
	      fontSize: 14,
	      display: 'block'
	    };
	    if (customization('show_proposer_icon', cluster_key) && adding) {
	      editor = current_user.user;
	      bullet = Avatar({
	        key: editor,
	        user: editor,
	        img_size: 'large',
	        style: {
	          height: 50,
	          width: 50,
	          marginRight: 8,
	          borderRadius: 0,
	          backgroundColor: '#ddd'
	        }
	      });
	    } else {
	      bullet = SVG({
	        width: 8,
	        viewBox: '0 0 200 200',
	        style: {
	          marginRight: 7 + (!adding ? 6 : 0),
	          marginLeft: 6,
	          verticalAlign: 'top',
	          paddingTop: 13
	        }
	      }, CIRCLE({
	        cx: 100,
	        cy: 100,
	        r: 80,
	        fill: '#000000'
	      }));
	    }
	    if (!adding) {
	      return BUTTON({
	        name: "add_new_" + cluster_name,
	        className: 'add_new_proposal',
	        style: _.defaults(this.props.label_style || {}, {
	          cursor: 'pointer',
	          backgroundColor: '#e7e7e7',
	          border: 'none',
	          fontSize: 20,
	          fontWeight: 600,
	          padding: '6px 36px 6px 16px',
	          textDecoration: 'underline',
	          borderRadius: 8,
	          marginLeft: -44
	        }),
	        onClick: (function(_this) {
	          return function(e) {
	            loc.query_params.new_proposal = encodeURIComponent(cluster_name);
	            save(loc);
	            if (permitted) {
	              cluster_state.adding_new_proposal = cluster_name;
	              save(cluster_state);
	              return setTimeout(function() {
	                return $("#" + cluster_slug + "-name").focus();
	              }, 0);
	            } else {
	              e.stopPropagation();
	              return reset_key('auth', {
	                form: 'login',
	                goal: 'add a new proposal',
	                ask_questions: true
	              });
	            }
	          };
	        })(this)
	      }, A({
	        name: "new_" + cluster_name
	      }), bullet, permitted ? translator("engage.add_new_proposal_to_list", 'add new') : translator("engage.login_to_add_new_proposal", 'Log in to share an idea'));
	    } else {
	      w = column_sizes().first;
	      return DIV({
	        style: {
	          position: 'relative',
	          padding: '6px 8px',
	          marginLeft: customization('show_proposer_icon', cluster_key) ? -76 : -36
	        }
	      }, A({
	        name: "new_" + cluster_name
	      }), customization('new_proposal_tips', cluster_key) ? this.drawTips(customization('new_proposal_tips', cluster_key)) : void 0, bullet, DIV({
	        style: {
	          position: 'relative',
	          display: 'inline-block'
	        }
	      }, LABEL({
	        style: _.extend({}, label_style, {
	          position: 'absolute',
	          left: 8,
	          top: -18
	        }),
	        htmlFor: cluster_slug + "-name"
	      }, proposal_fields.name), CharacterCountTextInput({
	        id: cluster_slug + "-name",
	        maxLength: 240,
	        name: 'name',
	        pattern: '^.{3,}',
	        'aria-label': translator("engage.edit_proposal.summary.placeholder", 'Clear and concise summary'),
	        placeholder: translator("engage.edit_proposal.summary.placeholder", 'Clear and concise summary'),
	        required: 'required',
	        count_style: {
	          position: 'absolute',
	          right: 0,
	          top: -18,
	          fontSize: 14
	        },
	        style: {
	          fontSize: 20,
	          width: w,
	          border: "1px solid #ccc",
	          outline: 'none',
	          padding: '6px 8px',
	          fontWeight: 600,
	          color: '#000',
	          minHeight: 75,
	          resize: 'vertical'
	        }
	      })), DIV({
	        style: {
	          position: 'relative',
	          marginLeft: customization('show_proposer_icon', cluster_key) ? 58 : 21
	        }
	      }, DIV(null, LABEL({
	        style: _.extend({}, label_style, {
	          marginLeft: 8
	        }),
	        htmlFor: cluster_slug + "-details"
	      }, proposal_fields.description), WysiwygEditor({
	        id: cluster_slug + "-details",
	        key: "description-new-proposal-" + cluster_slug,
	        'aria-label': translator("engage.edit_proposal.description.placeholder", 'Add details here'),
	        container_style: {
	          padding: '6px 8px',
	          border: '1px solid #ccc'
	        },
	        style: {
	          fontSize: 16,
	          width: w - 8 * 2,
	          marginBottom: 8,
	          minHeight: 120
	        }
	      })), (function() {
	        var i, len, ref, results;
	        ref = proposal_fields.additional_fields;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          additional_field = ref[i];
	          results.push(DIV(null, LABEL({
	            style: _.extend({}, label_style, {
	              marginLeft: 8
	            }),
	            htmlFor: cluster_slug + "-" + additional_field
	          }, proposal_fields[additional_field]), WysiwygEditor({
	            id: cluster_slug + "-" + additional_field,
	            key: additional_field + "-new-proposal-" + cluster_slug,
	            'aria-label': proposal_fields[additional_field],
	            container_style: {
	              padding: '6px 8px',
	              border: '1px solid #ccc'
	            },
	            style: {
	              fontSize: 16,
	              width: w - 8 * 2,
	              marginBottom: 8,
	              minHeight: 120
	            }
	          })));
	        }
	        return results;
	      })(), (function(_this) {
	        return function() {
	          var available_clusters, clust;
	          available_clusters = (function() {
	            var i, len, ref, results;
	            ref = get_all_clusters();
	            results = [];
	            for (i = 0, len = ref.length; i < len; i++) {
	              clust = ref[i];
	              if (customization('list_show_new_button', "list/" + clust)) {
	                results.push(clust);
	              }
	            }
	            return results;
	          })();
	          if ((!current_user.is_admin && available_clusters.length <= 1) || customization('hide_category_for_new', cluster_key)) {
	            return INPUT({
	              type: 'hidden',
	              value: cluster_name,
	              ref: 'category'
	            });
	          } else {
	            return DIV(null, DIV({
	              style: {
	                marginTop: 8
	              }
	            }, LABEL({
	              style: _.extend({}, label_style, {
	                marginLeft: 8
	              }),
	              htmlFor: cluster_slug + "-category"
	            }, TRANSLATE("engage.edit_proposal.category_select_label", 'Category')), SELECT({
	              id: cluster_slug + "-category",
	              style: {
	                fontSize: 18,
	                width: w
	              },
	              value: _this.local.category,
	              ref: 'category',
	              onChange: function(e) {
	                _this.local.category = e.target.value;
	                return save(_this.local);
	              }
	            }, [
	              current_user.is_admin ? [
	                OPTION({
	                  style: {
	                    fontStyle: 'italic'
	                  },
	                  value: 'new category'
	                }, 'Create new category'), OPTION({
	                  disabled: "disabled"
	                }, '--------')
	              ] : void 0, (function() {
	                var i, len, results;
	                results = [];
	                for (i = 0, len = available_clusters.length; i < len; i++) {
	                  clust = available_clusters[i];
	                  results.push(OPTION({
	                    value: clust
	                  }, clust));
	                }
	                return results;
	              })()
	            ])), current_user.is_admin && _this.local.category === 'new category' ? INPUT({
	              type: 'text',
	              ref: 'new_category',
	              placeholder: 'category name',
	              style: {
	                fontSize: 16,
	                padding: '4px 6px',
	                marginTop: 4,
	                display: 'block'
	              }
	            }) : void 0);
	          }
	        };
	      })(this)(), ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	        role: 'alert',
	        style: {
	          fontSize: 18,
	          color: 'darkred',
	          backgroundColor: '#ffD8D8',
	          padding: 10,
	          marginTop: 10
	        }
	      }, (function() {
	        var i, len, ref1, results;
	        ref1 = this.local.errors;
	        results = [];
	        for (i = 0, len = ref1.length; i < len; i++) {
	          error = ref1[i];
	          results.push(DIV(null, I({
	            className: 'fa fa-exclamation-circle',
	            style: {
	              paddingRight: 9
	            }
	          }), SPAN(null, error)));
	        }
	        return results;
	      }).call(this)) : void 0, DIV({
	        style: {
	          marginTop: 14
	        }
	      }, BUTTON({
	        className: 'submit_new_proposal',
	        style: {
	          backgroundColor: focus_color(),
	          color: 'white',
	          cursor: 'pointer',
	          padding: '4px 16px',
	          display: 'inline-block',
	          marginRight: 12,
	          border: 'none',
	          boxShadow: '0 1px 1px rgba(0,0,0,.9)',
	          fontWeight: 600
	        },
	        onClick: (function(_this) {
	          return function() {
	            var active, category, description, field, fields, hide_on_homepage, i, len, name, proposal, ref1;
	            name = $(_this.getDOMNode()).find("#" + cluster_slug + "-name").val();
	            fields = {
	              description: fetch("description-new-proposal-" + cluster_slug).html
	            };
	            ref1 = proposal_fields.additional_fields;
	            for (i = 0, len = ref1.length; i < len; i++) {
	              field = ref1[i];
	              fields[field] = fetch(field + "-new-proposal-" + cluster_slug).html;
	            }
	            description = proposal_fields.create_description(fields);
	            active = true;
	            hide_on_homepage = false;
	            category = _this.refs.category.getDOMNode().value;
	            if (current_user.is_admin && _this.local.category === 'new category') {
	              category = _this.refs.new_category.getDOMNode().value || cluster_name;
	            }
	            proposal = {
	              key: '/new/proposal',
	              name: name,
	              description: description,
	              cluster: category,
	              active: active,
	              hide_on_homepage: hide_on_homepage
	            };
	            InitializeProposalRoles(proposal);
	            proposal.errors = [];
	            _this.local.errors = [];
	            save(_this.local);
	            return save(proposal, function() {
	              var ref2;
	              if (((ref2 = proposal.errors) != null ? ref2.length : void 0) === 0) {
	                cluster_state.adding_new_proposal = null;
	                save(cluster_state);
	                delete loc.query_params.new_proposal;
	                return save(loc);
	              } else {
	                _this.local.errors = proposal.errors;
	                return save(_this.local);
	              }
	            });
	          };
	        })(this)
	      }, translator('engage.done_button', 'Done')), BUTTON({
	        style: {
	          color: '#888',
	          cursor: 'pointer',
	          backgroundColor: 'transparent',
	          border: 'none',
	          padding: 0,
	          fontSize: 'inherit'
	        },
	        onClick: (function(_this) {
	          return function() {
	            cluster_state.adding_new_proposal = null;
	            save(cluster_state);
	            delete loc.query_params.new_proposal;
	            return save(loc);
	          };
	        })(this)
	      }, translator('engage.cancel_button', 'cancel')))));
	    }
	  },
	  componentDidMount: function() {
	    return this.ensureIsInViewPort();
	  },
	  componentDidUpdate: function() {
	    return this.ensureIsInViewPort();
	  },
	  ensureIsInViewPort: function() {
	    var is_selected, loc, local;
	    loc = fetch('location');
	    local = fetch(this.props.local);
	    is_selected = loc.query_params.new_proposal === encodeURIComponent(this.props.cluster_name || 'Proposals');
	    if (is_selected) {
	      if (browser.is_mobile) {
	        return $(this.getDOMNode()).moveToTop({
	          scroll: false
	        });
	      } else {
	        return $(this.getDOMNode()).ensureInView({
	          scroll: false
	        });
	      }
	    }
	  },
	  drawTips: function(tips) {
	    var guidelines_h, guidelines_w, mobile;
	    mobile = browser.is_mobile;
	    if (mobile) {
	      return SPAN(null);
	    }
	    guidelines_w = mobile ? 'auto' : 330;
	    guidelines_h = 300;
	    return DIV({
	      style: {
	        position: mobile ? 'relative' : 'absolute',
	        right: -guidelines_w - 20,
	        width: guidelines_w,
	        color: focus_color(),
	        zIndex: 1,
	        marginBottom: mobile ? 20 : void 0,
	        backgroundColor: mobile ? 'rgba(255,255,255,.85)' : void 0,
	        fontSize: 14
	      }
	    }, !mobile ? SVG({
	      width: guidelines_w + 28,
	      height: guidelines_h,
	      viewBox: "-4 0 " + (guidelines_w + 20 + 9) + " " + guidelines_h,
	      style: css.crossbrowserify({
	        position: 'absolute',
	        transform: 'scaleX(-1)',
	        left: -20
	      })
	    }, PATH({
	      stroke: focus_color(),
	      strokeWidth: 1,
	      fill: "#FFF",
	      d: "M" + guidelines_w + ",33\nL" + guidelines_w + ",0\nL1,0\nL1," + guidelines_h + " \nL" + guidelines_w + "," + guidelines_h + " \nL" + guidelines_w + ",58\nL" + (guidelines_w + 20) + ",48\nL" + guidelines_w + ",33 \nZ"
	    })) : void 0, DIV({
	      style: {
	        padding: !mobile ? '14px 18px' : void 0,
	        position: 'relative',
	        marginLeft: 5
	      }
	    }, SPAN({
	      style: {
	        fontWeight: 600,
	        fontSize: 24
	      }
	    }, "Tips"), UL({
	      style: {
	        listStylePosition: 'outside',
	        marginLeft: 16,
	        marginTop: 5
	      }
	    }, (function() {
	      var i, len, results, tip;
	      tips = customization('new_proposal_tips');
	      results = [];
	      for (i = 0, len = tips.length; i < len; i++) {
	        tip = tips[i];
	        results.push(LI({
	          style: {
	            paddingBottom: 3,
	            fontSize: PORTRAIT_MOBILE() ? 24 : LANDSCAPE_MOBILE() ? 14 : void 0
	          }
	        }, tip));
	      }
	      return results;
	    })())));
	  }
	});


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	
	__webpack_require__(11);
	
	window.ProfileMenu = ReactiveComponent({
	  displayName: 'ProfileMenu',
	  render: function() {
	    var current_user, hsl, is_admin, is_moderator, is_super, light_background, menu_options, subdomain;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    is_admin = current_user.is_admin;
	    is_moderator = current_user.is_moderator;
	    is_super = current_user.is_super_admin;
	    menu_options = [
	      {
	        href: '/edit_profile',
	        label: 'Edit Profile'
	      }, {
	        href: '/dashboard/email_notifications',
	        label: 'Email Settings'
	      }, is_admin ? {
	        href: '/dashboard/data_import_export',
	        label: 'Import / Export Data'
	      } : null, is_admin ? {
	        href: '/dashboard/application',
	        label: 'App Settings'
	      } : null, is_super ? {
	        href: '/dashboard/customizations',
	        label: 'Customizations'
	      } : null, is_admin ? {
	        href: '/dashboard/roles',
	        label: 'User Roles'
	      } : null, is_super ? {
	        href: '/dashboard/tags',
	        label: 'User Tags'
	      } : null, is_moderator ? {
	        href: '/dashboard/moderate',
	        label: 'Moderate'
	      } : null, {
	        label: 'Log out',
	        'data-action': 'logout'
	      }
	    ];
	    menu_options = _.compact(menu_options);
	    hsl = parseCssHsl(subdomain.branding.primary_color);
	    light_background = hsl.l > .75;
	    return DIV({
	      id: 'user_nav',
	      style: _.defaults({}, customization('profile_menu_style') || {}, this.props.style || {}, {
	        position: 'absolute',
	        zIndex: 5,
	        right: 30,
	        fontSize: 26,
	        top: 17
	      })
	    }, current_user.logged_in ? DropMenu({
	      options: menu_options,
	      selection_made_callback: function(option) {
	        if (option.label === 'Log out') {
	          return logout();
	        }
	      },
	      render_anchor: function(menu_showing) {
	        return [
	          Avatar({
	            key: current_user.user,
	            hide_tooltip: true,
	            className: 'userbar_avatar',
	            style: {
	              height: 35,
	              width: 35,
	              marginRight: 7,
	              marginTop: 1
	            }
	          }), I({
	            className: 'fa fa-caret-down',
	            style: {
	              visibility: menu_showing ? 'hidden' : void 0
	            }
	          })
	        ];
	      },
	      render_option: function(option) {
	        if (option.label === 'Log out') {
	          return translator("auth.log_out", "Log out");
	        } else {
	          return translator("user_menu.option." + option.label, option.label);
	        }
	      },
	      anchor_style: {
	        color: !light_background ? 'white' : void 0,
	        zIndex: 9999999999,
	        backgroundColor: 'rgba(255,255,255, .1)',
	        boxShadow: '0px 1px 1px rgba(0,0,0,.1)',
	        borderRadius: 8,
	        padding: '3px 4px'
	      },
	      anchor_when_open_style: {
	        backgroundColor: 'transparent',
	        boxShadow: 'none'
	      },
	      menu_style: {
	        left: 'auto',
	        right: -9999,
	        margin: '-42px 0 0 -8px',
	        padding: "56px 14px 8px 8px",
	        backgroundColor: '#eee',
	        textAlign: 'right'
	      },
	      menu_when_open_style: {
	        right: 0
	      },
	      option_style: {
	        color: focus_color(),
	        position: 'relative',
	        bottom: 8,
	        paddingLeft: 27,
	        display: 'block',
	        whiteSpace: 'nowrap'
	      },
	      active_option_style: {
	        color: 'black'
	      }
	    }) : fetch('/subdomain').SSO_domain ? A({
	      href: '/login_via_saml',
	      treat_as_external_link: true,
	      style: {
	        color: !light_background ? 'white' : void 0,
	        backgroundColor: 'transparent',
	        border: 'none',
	        textDecoration: 'none'
	      }
	    }, translator("auth.log_in", "Log in")) : BUTTON({
	      className: 'profile_anchor login',
	      'data-action': 'login',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'login',
	            ask_questions: true
	          });
	        };
	      })(this),
	      style: {
	        color: !light_background ? 'white' : void 0,
	        backgroundColor: 'transparent',
	        border: 'none'
	      }
	    }, translator("auth.log_in", "Log in")));
	  },
	  bitcoinVerification: function() {
	    var current_user, dd, mm, subdomain, today, yyyy;
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 10,
	        left: -315
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.show_verify = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.show_verify = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, DIV({
	      style: {
	        backgroundColor: focus_color(),
	        color: 'white',
	        fontWeight: 600,
	        padding: '4px 12px',
	        fontSize: 21,
	        borderRadius: !this.local.show_verify ? 8 : void 0,
	        position: 'relative',
	        cursor: 'pointer'
	      }
	    }, SPAN({
	      style: cssTriangle('right', focus_color(), 10, 12, {
	        position: 'absolute',
	        right: -10,
	        top: 12
	      })
	    }), 'Please verify you are human!'), this.local.show_verify ? (today = new Date(), dd = today.getDate(), mm = today.getMonth() + 1, yyyy = today.getFullYear(), dd < 10 ? dd = '0' + dd : void 0, mm < 10 ? mm = '0' + mm : void 0, today = yyyy + '/' + mm + '/' + dd, DIV({
	      style: {
	        width: 650,
	        position: 'absolute',
	        right: 0,
	        zIndex: 999,
	        padding: 40,
	        backgroundColor: 'white',
	        boxShadow: '0 1px 2px rgba(0,0,0,.3)',
	        fontSize: 21
	      }
	    }, DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "To verify you are human, write on a piece of paper:"), DIV({
	      style: {
	        marginBottom: 20,
	        marginLeft: 50
	      }
	    }, current_user.name, BR(null), "bitcoin.consider.it", BR(null), today), DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "Then take a photo of yourself with it, and email the photo to ", A({
	      href: 'mailto:verify@consider.it',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'verify@consider.it'), ". This photo will be publicly visible proof that you are real!"), DIV({
	      style: {
	        marginBottom: 20
	      }
	    }, "Yours,", BR(null), "The Admins"), IMG({
	      src: asset('bitcoin/verify example.jpg'),
	      style: {
	        width: 570
	      }
	    }), IMG({
	      src: asset('bitcoin/verification-travis.jpg'),
	      style: {
	        width: 570
	      }
	    }), IMG({
	      src: asset('bitcoin/KevinBitcoin.jpg'),
	      style: {
	        width: 570
	      }
	    }))) : void 0);
	  }
	});
	
	styles += ".profile_menu_wrap:hover .profile_anchor{ color: inherit; }";


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	__webpack_require__(2);
	
	__webpack_require__(5);
	
	window.Questionaire = ReactiveComponent({
	  displayName: 'Questionaire',
	  render: function() {
	    var all_proposals, cluster_key, clusters, current_user, group, groups, i, idx, j, k, l, len, len1, len2, len3, list_name, proposal, ref, ref1, ref2, ref3, response, selection_limit;
	    cluster_key = this.props.cluster_key;
	    groups = customization('groups', cluster_key);
	    clusters = clustered_proposals(true);
	    current_user = fetch('/current_user');
	    if ((this.local.top_response == null) && customization('select_top', cluster_key)) {
	      for (i = 0, len = groups.length; i < len; i++) {
	        group = groups[i];
	        list_name = group.split('/')[1];
	        ref1 = ((ref = clusters[list_name]) != null ? ref.proposals : void 0) || [];
	        for (j = 0, len1 = ref1.length; j < len1; j++) {
	          response = ref1[j];
	          if (response.your_opinion.published && response.your_opinion.stance === 1.0) {
	            this.local.top_response = response.key;
	          }
	        }
	      }
	    }
	    selection_limit = 5;
	    if (this.local.total_selected == null) {
	      this.local.total_selected = 0;
	      for (k = 0, len2 = groups.length; k < len2; k++) {
	        group = groups[k];
	        list_name = group.split('/')[1];
	        ref3 = ((ref2 = clusters[list_name]) != null ? ref2.proposals : void 0) || [];
	        for (l = 0, len3 = ref3.length; l < len3; l++) {
	          response = ref3[l];
	          if (response.your_opinion.published) {
	            this.local.total_selected += 1;
	          }
	        }
	      }
	    }
	    return DIV({
	      style: {}
	    }, !current_user.logged_in ? DIV({
	      style: {
	        fontSize: 18,
	        fontWeight: 400,
	        marginBottom: 24
	      }
	    }, 'You must ', BUTTON({
	      'data-action': 'create',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'create account',
	            ask_questions: true
	          });
	        };
	      })(this),
	      style: {
	        backgroundColor: 'transparent',
	        border: 'none',
	        fontWeight: 700,
	        textDecoration: 'underline',
	        textTransform: 'lowercase',
	        padding: 0
	      }
	    }, t('create an account')), ' or ', BUTTON({
	      'data-action': 'create',
	      onClick: (function(_this) {
	        return function(e) {
	          return reset_key('auth', {
	            form: 'login',
	            ask_questions: true
	          });
	        };
	      })(this),
	      style: {
	        backgroundColor: 'transparent',
	        border: 'none',
	        fontWeight: 700,
	        textDecoration: 'underline',
	        padding: 0,
	        textTransform: 'lowercase'
	      }
	    }, translator("auth.log_in", 'Log in')), ' before answering this question.') : void 0, DIV({
	      style: {
	        opacity: !current_user.logged_in ? .7 : void 0
	      }
	    }, (function() {
	      var len4, m, results;
	      results = [];
	      for (m = 0, len4 = groups.length; m < len4; m++) {
	        group = groups[m];
	        list_name = group.split('/')[1];
	        results.push(DIV({
	          style: {
	            marginBottom: 24
	          }
	        }, H4({
	          style: {
	            fontWeight: 400,
	            fontSize: 16,
	            marginBottom: 8,
	            fontStyle: 'italic'
	          }
	        }, customization('list_label', group)), UL({
	          style: {
	            listStyle: 'none'
	          }
	        }, (function() {
	          var len5, n, ref4, ref5, results1;
	          ref5 = ((ref4 = clusters[list_name]) != null ? ref4.proposals : void 0) || [];
	          results1 = [];
	          for (n = 0, len5 = ref5.length; n < len5; n++) {
	            response = ref5[n];
	            fetch(response.your_opinion);
	            results1.push((function(_this) {
	              return function(response) {
	                var disabled;
	                disabled = !current_user.logged_in || (!response.your_opinion.published && selection_limit && selection_limit <= _this.local.total_selected);
	                return LI({
	                  style: {
	                    opacity: disabled ? .5 : void 0
	                  }
	                }, INPUT({
	                  type: 'checkbox',
	                  id: slugify(response.name),
	                  style: {
	                    fontSize: 32,
	                    cursor: !disabled ? 'pointer' : void 0
	                  },
	                  disabled: disabled,
	                  defaultChecked: response.your_opinion.published,
	                  onChange: function() {
	                    var opinion;
	                    opinion = response.your_opinion;
	                    if ($("#" + (slugify(response.name))).is(':checked')) {
	                      opinion.published = true;
	                      opinion.stance = 0.25;
	                      _this.local.total_selected += 1;
	                      save(_this.local);
	                    } else {
	                      opinion.published = false;
	                      _this.local.total_selected -= 1;
	                      save(_this.local);
	                      if (_this.local.top_response === response.key) {
	                        _this.local.top_response = null;
	                        save(_this.local);
	                      }
	                    }
	                    return save(opinion);
	                  }
	                }), LABEL({
	                  htmlFor: slugify(response.name),
	                  style: {
	                    fontSize: 16,
	                    cursor: !disabled ? 'pointer' : void 0
	                  }
	                }, response.name));
	              };
	            })(this)(response));
	          }
	          return results1;
	        }).call(this))));
	      }
	      return results;
	    }).call(this), customization('select_top', cluster_key) && current_user.logged_in ? DIV({
	      style: {}
	    }, H3({
	      style: {
	        fontWeight: 800,
	        fontSize: 24,
	        marginBottom: 8
	      }
	    }, customization('select_top', cluster_key)), this.local.total_selected === 0 ? DIV({
	      style: {
	        fontStyle: 'italic',
	        fontSize: 18
	      }
	    }, "First, choose your top 5 priorities above!") : void 0, UL({
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var len4, m, results;
	      results = [];
	      for (m = 0, len4 = groups.length; m < len4; m++) {
	        group = groups[m];
	        list_name = group.split('/')[1];
	        results.push((function() {
	          var len5, n, ref4, ref5, results1;
	          ref5 = ((ref4 = clusters[list_name]) != null ? ref4.proposals : void 0) || [];
	          results1 = [];
	          for (n = 0, len5 = ref5.length; n < len5; n++) {
	            response = ref5[n];
	            if (!response.your_opinion.published) {
	              continue;
	            }
	            results1.push((function(_this) {
	              return function(response) {
	                return LI({
	                  style: {}
	                }, INPUT({
	                  type: 'radio',
	                  id: 'radio-' + slugify(response.name),
	                  style: {
	                    fontSize: 32,
	                    cursor: 'pointer'
	                  },
	                  checked: response.key === _this.local.top_response,
	                  onChange: function() {
	                    var len6, len7, o, opinion, p, r, ref6, ref7;
	                    for (o = 0, len6 = groups.length; o < len6; o++) {
	                      group = groups[o];
	                      list_name = group.split('/')[1];
	                      ref7 = ((ref6 = clusters[list_name]) != null ? ref6.proposals : void 0) || [];
	                      for (p = 0, len7 = ref7.length; p < len7; p++) {
	                        r = ref7[p];
	                        if (r.your_opinion.published && r.id !== response.id) {
	                          r.your_opinion.stance = 0.25;
	                          save(r.your_opinion);
	                        }
	                      }
	                    }
	                    opinion = response.your_opinion;
	                    opinion.stance = 1.0;
	                    _this.local.top_response = response.key;
	                    save(_this.local);
	                    return save(opinion);
	                  }
	                }), LABEL({
	                  htmlFor: 'radio-' + slugify(response.name),
	                  style: {
	                    fontSize: 16,
	                    cursor: 'pointer'
	                  }
	                }, response.name));
	              };
	            })(this)(response));
	          }
	          return results1;
	        }).call(this));
	      }
	      return results;
	    }).call(this)), this.local.top_response ? (response = fetch(this.local.top_response), DIV({
	      key: 'explanation' + this.local.top_response,
	      style: {
	        marginTop: 18,
	        marginLeft: 24
	      }
	    }, H4({
	      style: {
	        fontSize: 16,
	        fontWeight: 400,
	        marginBottom: 4,
	        fontStyle: 'italic'
	      }
	    }, 'How would this tool be most useful to you? What would it include? What outcome would you like to achieve from using this tool? Please be as specific as possible.'), AutoGrowTextArea({
	      defaultValue: response.your_opinion.explanation,
	      onChange: (function(_this) {
	        return function(e) {
	          var pending_save;
	          response.your_opinion.explanation = e.target.value;
	          if (!_this.pending_save) {
	            pending_save = true;
	            return setTimeout(function() {
	              this.pending_save = false;
	              return save(response.your_opinion);
	            }, 1000);
	          }
	        };
	      })(this),
	      style: {
	        width: '100%',
	        fontSize: 16,
	        padding: '4px 8px',
	        border: '1px solid #ddd',
	        maxWidth: 600,
	        minHeight: 120
	      }
	    }))) : void 0) : void 0, (function(_this) {
	      return function() {
	        var complete;
	        complete = function() {
	          document.activeElement.blur();
	          _this.local.flash = 'Thanks! Your response has been saved. Feel free to change your answers.';
	          setTimeout(function() {
	            _this.local.saved = true;
	            _this.local.flash = null;
	            return save(_this.local);
	          }, 5000);
	          return save(_this.local);
	        };
	        return DIV({
	          style: {
	            visibility: !current_user.logged_in ? 'hidden' : void 0
	          }
	        }, BUTTON({
	          className: 'primary_button',
	          onClick: complete,
	          style: {
	            backgroundColor: focus_color()
	          },
	          onKeyPress: function(e) {
	            if (e.which === 32 || e.which === 13) {
	              return complete();
	            }
	          }
	        }, _this.local.saved ? "Update" : "Done!"), _this.local.flash ? DIV({
	          style: {
	            fontSize: 16,
	            color: 'black',
	            marginTop: 4
	          }
	        }, _this.local.flash) : void 0);
	      };
	    })(this)()), (function() {
	      var len4, m, ref4;
	      if (current_user.is_admin) {
	        all_proposals = [];
	        for (m = 0, len4 = groups.length; m < len4; m++) {
	          group = groups[m];
	          list_name = group.split('/')[1];
	          all_proposals = all_proposals.concat(((ref4 = clusters[list_name]) != null ? ref4.proposals : void 0) || []);
	        }
	        return DIV({
	          style: {
	            marginTop: 20
	          }
	        }, list_actions({
	          add_new: false
	        }), H1({
	          style: _.extend({}, customization('list_label_style'), {
	            fontSize: 32,
	            fontWeight: 600
	          })
	        }, 'Results'), UL(null, (function() {
	          var len5, n, ref5, results;
	          ref5 = sorted_proposals(all_proposals);
	          results = [];
	          for (idx = n = 0, len5 = ref5.length; n < len5; idx = ++n) {
	            proposal = ref5[idx];
	            results.push(CollapsedProposal({
	              key: "collapsed" + proposal.key,
	              proposal: proposal
	            }));
	          }
	          return results;
	        })()));
	      }
	    })());
	  }
	});


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var fn, i, len, lvar, ref, responsive, setResponsive;
	
	__webpack_require__(3);
	
	setResponsive = function() {
	  var body_width, content_width, decision_board_width, document_width, full_width, gutter, h, homepage_width, k, new_vals, point_font_size, point_width, portrait, proposal_histo_width, reasons_region_width, responsive, results, two_col, v, w, whitespace;
	  responsive = fetch('responsive_vars');
	  w = window.innerWidth;
	  h = window.innerHeight;
	  portrait = h > w;
	  two_col = w < 1080 || browser.is_mobile;
	  document_width = Math.max(900, w);
	  gutter = Math.max(80, w / 10);
	  content_width = document_width - 2 * gutter;
	  whitespace = Math.max(100, w / 10);
	  body_width = two_col ? content_width - 2 * gutter : content_width - 2 * gutter - 2 * whitespace;
	  body_width = Math.min(body_width, 700);
	  proposal_histo_width = 60 * Math.floor(body_width / 60);
	  decision_board_width = body_width + 4;
	  point_width = two_col ? body_width / 2 - 38 : decision_board_width / 2 - 30;
	  reasons_region_width = !two_col ? decision_board_width + 2 * point_width + 76 : decision_board_width;
	  point_font_size = 14;
	  homepage_width = Math.min(content_width, 900);
	  homepage_width = 60 * Math.floor(homepage_width / 60);
	  full_width = Math.max(550, Math.min(1120, w - 2 * 40));
	  if (browser.is_mobile && portrait) {
	    point_font_size += 4;
	  }
	  new_vals = {
	    DOCUMENT_WIDTH: document_width,
	    WINDOW_WIDTH: w,
	    GUTTER: gutter,
	    WHITESPACE: whitespace,
	    BODY_WIDTH: body_width,
	    PROPOSAL_HISTO_WIDTH: proposal_histo_width,
	    DECISION_BOARD_WIDTH: decision_board_width,
	    POINT_WIDTH: point_width,
	    REASONS_REGION_WIDTH: reasons_region_width,
	    POINT_FONT_SIZE: point_font_size,
	    AUTH_WIDTH: browser.is_mobile ? content_width : Math.max(decision_board_width, 680),
	    TWO_COL: two_col,
	    SLIDER_HANDLE_SIZE: two_col ? 65 : 25,
	    CONTENT_WIDTH: content_width,
	    PORTRAIT_MOBILE: portrait && browser.is_mobile,
	    LANDSCAPE_MOBILE: !portrait && browser.is_mobile,
	    HOMEPAGE_WIDTH: homepage_width,
	    SAAS_PAGE_WIDTH: full_width
	  };
	  results = [];
	  for (k in new_vals) {
	    v = new_vals[k];
	    if (responsive[k] !== v) {
	      _.extend(responsive, new_vals);
	      save(responsive);
	      break;
	    } else {
	      results.push(void 0);
	    }
	  }
	  return results;
	};
	
	setResponsive();
	
	$(window).on("resize.responsive_vars", setResponsive);
	
	responsive = fetch('responsive_vars');
	
	ref = _.keys(responsive);
	fn = function(lvar) {
	  return window[lvar] = function() {
	    return fetch('responsive_vars')[lvar];
	  };
	};
	for (i = 0, len = ref.length; i < len; i++) {
	  lvar = ref[i];
	  fn(lvar);
	}


/***/ },
/* 28 */
/***/ function(module, exports) {

	window.svg = {
	  setSize: function(base_width, base_height, props) {
	    if (props.width && (props.height == null)) {
	      return props.height = props.width * base_height / base_width;
	    } else if (props.height && (props.width == null)) {
	      return props.width = props.height * base_width / base_height;
	    }
	  },
	  dropShadow: function(props) {
	    return FILTER({
	      id: props.id
	    }, FEOFFSET({
	      "in": "SourceAlpha",
	      dx: props.dx,
	      dy: props.dy,
	      result: "offsetblur"
	    }), FEGAUSSIANBLUR({
	      "in": 'offsetblur',
	      stdDeviation: props.stdDeviation,
	      result: 'blur2'
	    }), FECOLORMATRIX({
	      "in": 'blur2',
	      result: 'color',
	      type: 'matrix',
	      values: "0 0 0 0  0\n0 0 0 0  0 \n0 0 0 0  0 \n0 0 0 " + props.opacity + " 0"
	    }), FEMERGE(null, FEMERGENODE({
	      "in": 'color'
	    }), FEMERGENODE({
	      "in": 'SourceGraphic'
	    })));
	  },
	  innerbevel: function(props) {
	    var idx, shadow;
	    return FILTER({
	      id: props.id,
	      x0: "-50%",
	      y0: "-50%",
	      width: "200%",
	      height: "200%"
	    }, (function() {
	      var i, len, ref, results;
	      ref = props.shadows;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        shadow = ref[idx];
	        results.push([
	          FEGAUSSIANBLUR({
	            "in": 'SourceAlpha',
	            stdDeviation: shadow.stdDeviation,
	            result: "blur" + idx
	          }), FEOFFSET({
	            dy: shadow.dy,
	            dx: shadow.dx
	          }), FECOMPOSITE({
	            in2: 'SourceAlpha',
	            operator: "arithmetic",
	            k2: "-1",
	            k3: "1",
	            result: "shadowDiff"
	          }), FEFLOOD({
	            floodColor: shadow.color,
	            floodOpacity: shadow.opacity
	          }), FECOMPOSITE({
	            in2: "shadowDiff",
	            operator: "in"
	          }), FECOMPOSITE({
	            in2: idx === 0 ? 'SourceGraphic' : "result" + (idx - 1),
	            operator: "over",
	            result: "result" + idx
	          })
	        ]);
	      }
	      return results;
	    })());
	  }
	};


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var DEVELOPMENT_LANGUAGE, IN_SITU_TRANSLATOR, TranslationsDash, TranslationsForLang, editable_translation, promote_temporary_translations, regexp_tmatch, regexp_tsplit;
	
	__webpack_require__(2);
	
	window.translation_progress = function(lang, key_prefix) {
	  var dev_language, k, messages, translated, translations, v;
	  key_prefix || (key_prefix = '/translations');
	  translations = fetch(key_prefix + "/" + lang);
	  dev_language = fetch(key_prefix + "/en");
	  messages = (function() {
	    var ref, ref1, ref2, ref3, results;
	    results = [];
	    for (k in dev_language) {
	      v = dev_language[k];
	      if (((ref = v.txt) != null ? ref.length : void 0) > 0 || ((ref1 = v.proposals) != null ? (ref2 = ref1[0]) != null ? (ref3 = ref2.txt) != null ? ref3.length : void 0 : void 0 : void 0) > 0) {
	        results.push(k);
	      }
	    }
	    return results;
	  })();
	  translated = (function() {
	    var ref, ref1, ref2, ref3, results;
	    results = [];
	    for (k in translations) {
	      v = translations[k];
	      if (((ref = v.txt) != null ? ref.length : void 0) > 0 || ((ref1 = v.proposals) != null ? (ref2 = ref1[0]) != null ? (ref3 = ref2.txt) != null ? ref3.length : void 0 : void 0 : void 0) > 0) {
	        results.push(k);
	      }
	    }
	    return results;
	  })();
	  return translated.length / messages.length;
	};
	
	regexp_tsplit = /<(\w+)>[^<]+<\/[\w|\s]+>/g;
	
	regexp_tmatch = /<(\w+)>([^<]+)<\/[\w|\s]+>/g;
	
	window.TRANSLATE = function(args, native_text) {
	  var def, i, lang_used, len, match, matches, message, part, parts, ref, target_lang, tr, translation;
	  if (typeof args === "string") {
	    if (native_text) {
	      args = {
	        id: args
	      };
	    } else {
	      native_text = args;
	      args = {};
	    }
	  }
	  tr = fetch('translations');
	  args.return_lang_used = true;
	  ref = T(args, native_text), message = ref.message, lang_used = ref.lang_used, target_lang = ref.target_lang;
	  if (message.indexOf('<') > -1) {
	    parts = message.split(regexp_tsplit);
	    matches = {};
	    while (match = regexp_tmatch.exec(message)) {
	      matches[match[1]] = match[2];
	    }
	    translation = [];
	    for (i = 0, len = parts.length; i < len; i++) {
	      part = parts[i];
	      if (part in matches && part in args) {
	        def = args[part];
	        if (args.as_html) {
	          translation.push("<" + def.component + " " + def.args + ">" + matches[part] + "</" + def.component + ">");
	        } else {
	          translation.push(def.component(def.args, matches[part]));
	        }
	      } else {
	        translation.push(part);
	      }
	    }
	  } else {
	    translation = message;
	  }
	  if (!tr.in_situ_translations) {
	    return translation;
	  } else {
	    return IN_SITU_TRANSLATOR(_.extend({
	      lang_used: lang_used,
	      target_lang: target_lang,
	      message: message,
	      native_text: native_text
	    }, args), translation);
	  }
	};
	
	IN_SITU_TRANSLATOR = ReactiveComponent({
	  displayName: 'InSituTranslator',
	  render: function() {
	    var available_languages, id, key, message_style, target_lang, translated, updated_translations;
	    key = this.props.key || '/translations';
	    target_lang = this.props.target_lang;
	    translated = this.props.lang_used === target_lang;
	    id = this.props.id || this.props.native_text;
	    available_languages = fetch('/translations').available_languages;
	    return SPAN({
	      style: {
	        backgroundColor: translated ? "rgba(166, 195, 151, .5)" : "rgba(251,124,124,.5)",
	        position: 'relative'
	      },
	      onMouseOver: (function(_this) {
	        return function() {
	          _this.local.show_translator = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, this.props.children, this.local.show_translator ? (updated_translations = get_temporary_translations(target_lang, key), message_style = {
	      fontWeight: 700
	    }, DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        fontSize: 14,
	        width: 300,
	        padding: '4px 8px',
	        backgroundColor: 'white',
	        border: "1px solid #ccc"
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          return e.preventDefault();
	        };
	      })(this)
	    }, DIV({
	      style: {}
	    }, "English message: ", DIV({
	      style: message_style
	    }, "" + this.props.native_text)), DIV({
	      style: {
	        marginTop: 8
	      }
	    }, LABEL(null, available_languages[target_lang] + " translation:"), editable_translation(id, updated_translations, message_style)), BUTTON({
	      className: "primary_button",
	      style: {
	        backgroundColor: focus_color(),
	        fontSize: 14
	      },
	      onClick: (function(_this) {
	        return function() {
	          promote_temporary_translations(target_lang, key);
	          _this.local.show_translator = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Save"), BUTTON({
	      style: {
	        backgroundColor: 'none',
	        border: 'none',
	        color: '#888'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_translator = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Cancel"))) : void 0);
	  }
	});
	
	DEVELOPMENT_LANGUAGE = 'en';
	
	window.T = window.t = window.translator = function(args, native_text) {
	  var e, i, id, j, lang, lang_used, langs, len, len1, message, proposal, ref, ref1, ref2, ref3, ref4, ref5, subdomain, translations, translations_key_prefix, translations_native, translator, u, user;
	  subdomain = fetch('/subdomain');
	  if (typeof args === "string") {
	    if (native_text) {
	      args = {
	        id: args
	      };
	    } else {
	      native_text = args;
	      args = {};
	    }
	  }
	  id = args.id || native_text;
	  translations_key_prefix = args.key || "/translations";
	  translations_native = fetch(translations_key_prefix + "/" + DEVELOPMENT_LANGUAGE);
	  if (waiting_for(translations_native)) {
	    return '...';
	  }
	  native_text = native_text.replace(/\n/g, "");
	  if (((ref = translations_native[id]) != null ? ref.txt : void 0) !== native_text) {
	    console.log('updating', {
	      id: id,
	      native_text: native_text,
	      saved: (ref1 = translations_native[id]) != null ? ref1.txt : void 0
	    }, ((ref2 = translations_native[id]) != null ? ref2.txt : void 0) === native_text);
	    translations_native[id] || (translations_native[id] = {});
	    translations_native[id].txt = native_text;
	    save(translations_native);
	  }
	  user = {};
	  langs = [user.lang, subdomain.lang, DEVELOPMENT_LANGUAGE].filter(function(l) {
	    return l != null;
	  });
	  if (langs.length > 1) {
	    langs = Array.from(new Set(langs));
	  }
	  lang_used = null;
	  message = null;
	  for (i = 0, len = langs.length; i < len; i++) {
	    lang = langs[i];
	    translations = fetch(translations_key_prefix + "/" + lang);
	    if (translations[id] != null) {
	      message = translations[id].txt;
	      if (((ref3 = translations[id].proposals) != null ? ref3.length : void 0) > 0) {
	        u = fetch('/current_user').user;
	        ref4 = translations[id].proposals;
	        for (j = 0, len1 = ref4.length; j < len1; j++) {
	          proposal = ref4[j];
	          if (proposal.u === u) {
	            message = proposal.txt;
	          }
	        }
	      }
	      if (message) {
	        lang_used = lang;
	        break;
	      }
	    }
	  }
	  try {
	    translator = new IntlMessageFormat.IntlMessageFormat(message, lang_used);
	    message = translator.format(args);
	  } catch (error) {
	    e = error;
	    console.error("Error translating " + id, {
	      error: e,
	      message: message,
	      native_text: native_text
	    });
	    message = (ref5 = translations_native[id]) != null ? ref5.txt : void 0;
	  }
	  if (args.return_lang_used) {
	    return {
	      message: message,
	      lang_used: lang_used,
	      target_lang: langs[0]
	    };
	  } else {
	    return message;
	  }
	};
	
	TranslationsDash = ReactiveComponent({
	  displayName: 'TranslationsDash',
	  render: function() {
	    var all_langs, current_user, k, local, subdomain, translations, v;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    translations = fetch('/translations');
	    if (!translations.available_languages) {
	      return DIV();
	    }
	    local = fetch('translations');
	    all_langs = (function() {
	      var ref, results;
	      ref = translations.available_languages;
	      results = [];
	      for (k in ref) {
	        v = ref[k];
	        if (k !== DEVELOPMENT_LANGUAGE) {
	          results.push([k, v]);
	        }
	      }
	      return results;
	    })();
	    if (current_user.is_super_admin) {
	      all_langs.push(['pseudo-en', "Pseudo English (for testing)"]);
	    }
	    if (!local.translating_lang) {
	      if (subdomain.lang && subdomain.lang !== 'en') {
	        local.translating_lang = subdomain.lang;
	      } else {
	        local.translating_lang = all_langs[0][0];
	      }
	    }
	    return DIV(null, DashHeader({
	      name: 'Translations'
	    }), DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: '0px auto'
	      }
	    }, DIV({
	      style: {}
	    }, "ConsiderIt's native development language is English (en). Please help us translate it to your language!"), DIV({
	      style: {
	        marginTop: 24
	      }
	    }, "Which language do you wish to translate for?", SELECT({
	      value: local.translating_lang,
	      style: {
	        fontSize: 20,
	        marginLeft: 14,
	        display: 'inline-block'
	      },
	      onChange: (function(_this) {
	        return function(ev) {
	          local.translating_lang = ev.target.value;
	          return save(local);
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      results = [];
	      for (i = 0, len = all_langs.length; i < len; i++) {
	        ref = all_langs[i], k = ref[0], v = ref[1];
	        results.push(OPTION({
	          value: k
	        }, v + " (" + k + ")"));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        fontSize: 12
	      }
	    }, "Is your language not available? Email us at hello@consider.it to get your language added.")), DIV({
	      style: {
	        marginTop: 24
	      }
	    }, LABEL({
	      htmlFor: 'insitutranslations'
	    }, "Enable in-situ translations?"), INPUT({
	      id: 'insitutranslations',
	      type: 'checkbox',
	      checked: fetch('translations').in_situ_translations,
	      style: {
	        fontSize: 36
	      },
	      onChange: (function(_this) {
	        return function() {
	          var tr;
	          tr = fetch('translations');
	          tr.in_situ_translations = !tr.in_situ_translations;
	          return save(tr);
	        };
	      })(this)
	    }), DIV({
	      style: {
	        fontSize: 12
	      }
	    }, "In-situ mode lets you browse the rest of the site and add some translations in context.")), current_user.is_super_admin ? DIV({
	      style: {
	        marginTop: 24
	      }
	    }, "Add a new language", DIV(null, INPUT({
	      style: {
	        fontSize: 18
	      },
	      type: 'text',
	      ref: 'newlang_abbrev',
	      placeholder: 'Abbreviation'
	    }), INPUT({
	      type: 'text',
	      ref: 'newlang_label',
	      placeholder: 'Full Name',
	      style: {
	        margin: '0 8px',
	        fontSize: 18
	      }
	    }), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var abbrev, label;
	          abbrev = _this.refs.newlang_abbrev.getDOMNode().value;
	          label = _this.refs.newlang_label.getDOMNode().value;
	          if (!(abbrev in translations.available_languages)) {
	            translations.available_languages[abbrev] = label;
	            save(translations);
	            _this.refs.newlang_abbrev.getDOMNode().value = "";
	            return _this.refs.newlang_label.getDOMNode().value = "";
	          }
	        };
	      })(this)
	    }, "Add"))) : void 0, local.translating_lang ? DIV(null, TranslationsForLang({
	      key: "translations_for_" + local.translating_lang,
	      translation_key_prefix: "/translations",
	      lang: local.translating_lang
	    }), TranslationsForLang({
	      key: "forum_translations_for_" + local.translating_lang,
	      translation_key_prefix: "/translations/" + subdomain.name,
	      lang: local.translating_lang,
	      forum_specific: true
	    }), DIV({
	      style: {
	        position: 'fixed',
	        bottom: 0,
	        left: 0,
	        width: WINDOW_WIDTH(),
	        zIndex: 999,
	        backgroundColor: 'rgba(220,220,220,.8)',
	        textAlign: 'center',
	        padding: '8px'
	      }
	    }, BUTTON({
	      className: 'primary_button',
	      style: {
	        backgroundColor: focus_color(),
	        marginTop: 0,
	        fontSize: 22
	      },
	      onClick: (function(_this) {
	        return function() {
	          promote_temporary_translations(local.translating_lang, "/translations");
	          return promote_temporary_translations(local.translating_lang, "/translations/" + subdomain.name);
	        };
	      })(this)
	    }, "Save Changes"), fetch('translations_interface').saved_successfully ? DIV({
	      style: {
	        color: 'green',
	        marginTop: 10
	      }
	    }, "Successfully saved") : void 0)) : void 0));
	  }
	});
	
	TranslationsForLang = ReactiveComponent({
	  displayName: 'TranslationsForLang',
	  render: function() {
	    var available_languages, col, cols, current_user, i, idx, k, lang, len, name, name1, names, native_messages, rows, section, sections, sp, to_translate, translations, updated_translations, v;
	    lang = this.props.lang;
	    available_languages = fetch("/translations").available_languages;
	    native_messages = fetch(this.props.translation_key_prefix + "/" + DEVELOPMENT_LANGUAGE);
	    translations = fetch(this.props.translation_key_prefix + "/" + lang);
	    if (waiting_for(native_messages) || waiting_for(translations)) {
	      return DIV();
	    }
	    to_translate = (function() {
	      var results;
	      results = [];
	      for (k in native_messages) {
	        v = native_messages[k];
	        if (k !== 'key') {
	          results.push(k);
	        }
	      }
	      return results;
	    })();
	    if (to_translate.length === 0) {
	      return DIV();
	    }
	    updated_translations = get_temporary_translations(lang, this.props.translation_key_prefix);
	    sections = {};
	    for (i = 0, len = to_translate.length; i < len; i++) {
	      name = to_translate[i];
	      sp = name.split('.');
	      if (sp.length > 1) {
	        sections[name1 = sp[0]] || (sections[name1] = []);
	        sections[sp[0]].push(name);
	      } else {
	        sections.misc || (sections.misc = []);
	        sections.misc.push(name);
	      }
	    }
	    current_user = fetch('/current_user');
	    if (this.props.forum_specific) {
	      cols = ['Message', "Translation. Leave blank if Message already " + available_languages[lang]];
	    } else {
	      cols = ['Message in English', "Translation to " + available_languages[lang]];
	    }
	    return DIV({
	      style: {
	        marginTop: 36
	      }
	    }, H2({
	      style: {
	        fontSize: 22,
	        marginBottom: 12
	      }
	    }, TRANSLATE({
	      id: "translations.language_header",
	      percent_complete: Math.round(translation_progress(lang, this.props.translation_key_prefix) * 100),
	      language: available_languages[lang]
	    }, "Translations for {language} ({percent_complete}% completed)")), current_user.is_super_admin ? BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          var idx, proposal, ref;
	          for (name in updated_translations) {
	            v = updated_translations[name];
	            if (((ref = v.proposals) != null ? ref.length : void 0) > 0) {
	              idx = v.proposals.length - 1;
	              proposal = v.proposals[idx];
	              v.txt = proposal.txt;
	              v.u = proposal.u;
	              v.proposals.splice(idx, 1);
	            }
	          }
	          return save(updated_translations);
	        };
	      })(this)
	    }, "Accept all proposed translations") : void 0, TABLE({
	      style: {
	        width: HOMEPAGE_WIDTH()
	      }
	    }, TBODY(null, (function() {
	      var fn, j, len1, results;
	      results = [];
	      for (section in sections) {
	        names = sections[section];
	        names.sort();
	        rows = [];
	        rows.push(TR(null, TD({
	          colSpan: cols.length,
	          style: {
	            fontSize: 24,
	            paddingTop: 12
	          }
	        }, section.toUpperCase().replace(/\_/g, ' '), DIV({
	          style: {
	            fontSize: 12,
	            marginBottom: 8
	          }
	        }, "Translation strings support ICU format for e.g. pluralization. For complicated translations, you may wish to ", A({
	          href: "http://format-message.github.io/icu-message-format-for-translators/editor.html",
	          target: '_blank',
	          style: {
	            textDecoration: 'underline'
	          }
	        }, "use this helper"), "."))));
	        rows.push(TR({
	          style: {
	            backgroundColor: '#dfdfdf'
	          }
	        }, (function() {
	          var j, len1, results1;
	          results1 = [];
	          for (j = 0, len1 = cols.length; j < len1; j++) {
	            col = cols[j];
	            results1.push(TH({
	              style: {
	                textAlign: 'left',
	                padding: "4px 6px"
	              }
	            }, col));
	          }
	          return results1;
	        })()));
	        fn = (function(_this) {
	          return function(name, idx) {
	            var no_id, proposal, ref;
	            no_id = name === native_messages[name].txt;
	            return rows.push(TR({
	              key: "row-id-" + name,
	              style: {
	                backgroundColor: idx % 2 === 1 ? '#f8f8f8' : void 0
	              }
	            }, TD({
	              style: {
	                padding: "2px 4px",
	                width: "40%"
	              }
	            }, (function(name, idx) {
	              var hide_tooltip, show_tooltip;
	              show_tooltip = function() {
	                var node, tooltip;
	                tooltip = fetch('tooltip');
	                node = _this.refs["message-" + name + "-" + idx];
	                if (node) {
	                  tooltip.coords = $(node.getDOMNode()).offset();
	                  tooltip.tip = no_id ? 'no ID' : name;
	                  return save(tooltip);
	                }
	              };
	              hide_tooltip = function() {
	                var tooltip;
	                tooltip = fetch('tooltip');
	                tooltip.coords = null;
	                return save(tooltip);
	              };
	              return DIV({
	                ref: "message-" + name + "-" + idx,
	                onFocus: show_tooltip,
	                onMouseEnter: show_tooltip,
	                onBlur: hide_tooltip,
	                onMouseLeave: hide_tooltip
	              }, "" + native_messages[name].txt);
	            })(name, idx)), TD({
	              style: {
	                width: '58%',
	                padding: "2px 4px",
	                position: 'relative'
	              }
	            }, editable_translation(name, updated_translations), current_user.is_super_admin ? (function(name) {
	              return BUTTON({
	                style: {
	                  fontSize: 14,
	                  backgroundColor: 'transparent',
	                  border: 'none',
	                  color: '#ccc',
	                  position: 'absolute',
	                  right: -25,
	                  padding: '4px'
	                },
	                onClick: function() {
	                  delete native_messages[name];
	                  delete updated_translations[name];
	                  save(updated_translations);
	                  return save(native_messages);
	                }
	              }, "x");
	            })(name) : void 0, current_user.is_super_admin && ((ref = updated_translations[name]) != null ? ref.proposals : void 0) ? UL({
	              style: {}
	            }, (function() {
	              var len2, m, ref1, results1;
	              ref1 = updated_translations[name].proposals;
	              results1 = [];
	              for (idx = m = 0, len2 = ref1.length; m < len2; idx = ++m) {
	                proposal = ref1[idx];
	                results1.push((function(_this) {
	                  return function(proposal, name, idx) {
	                    var proposer;
	                    if (proposal.u) {
	                      proposer = fetch(proposal.u);
	                    } else {
	                      proposer = current_user;
	                    }
	                    return LI({
	                      style: {
	                        padding: "2px 0px 8px 0px",
	                        listStyle: 'none'
	                      }
	                    }, DIV({
	                      style: {}
	                    }, proposal.txt), SPAN({
	                      style: {
	                        fontSize: 14,
	                        color: "#aaa",
	                        paddingRight: 4
	                      }
	                    }, "by " + (proposer.name || proposer.user)), BUTTON({
	                      style: {
	                        borderRadius: 8
	                      },
	                      onClick: function() {
	                        updated_translations[name].txt = proposal.txt;
	                        updated_translations[name].u = proposal.u;
	                        updated_translations[name].proposals.splice(idx, 1);
	                        return save(updated_translations);
	                      }
	                    }, "Ok"), BUTTON({
	                      style: {
	                        backgroundColor: 'transparent',
	                        display: 'inline-block',
	                        marginLeft: 20,
	                        border: 'none',
	                        color: '#999',
	                        textDecoration: 'underline',
	                        fontSize: 14
	                      },
	                      onClick: function() {
	                        updated_translations[name].proposals.splice(idx, 1);
	                        return save(updated_translations);
	                      }
	                    }, "reject"));
	                  };
	                })(this)(proposal, name, idx));
	              }
	              return results1;
	            }).call(_this)) : void 0)));
	          };
	        })(this);
	        for (idx = j = 0, len1 = names.length; j < len1; idx = ++j) {
	          name = names[idx];
	          fn(name, idx);
	        }
	        results.push(rows);
	      }
	      return results;
	    }).call(this))));
	  }
	});
	
	window.get_temporary_translations = function(lang, key) {
	  var translations;
	  key || (key = '/translations');
	  translations = fetch(key + "/" + lang);
	  return _.defaults(fetch("local" + translations.key), JSON.parse(JSON.stringify(translations)));
	};
	
	editable_translation = function(id, updated_translations, style) {
	  var accepted, current_user, i, len, proposal, proposed, ref, ref1, ref2, ref3, ref4, val;
	  current_user = fetch('/current_user');
	  accepted = proposed = val = null;
	  if ((ref = updated_translations[id]) != null ? ref.txt : void 0) {
	    accepted = val = updated_translations[id].txt;
	  }
	  if ((ref1 = updated_translations[id]) != null ? ref1.proposals : void 0) {
	    ref2 = updated_translations[id].proposals;
	    for (i = 0, len = ref2.length; i < len; i++) {
	      proposal = ref2[i];
	      if (proposal.u === current_user.user) {
	        proposed = val = proposal.txt;
	      }
	    }
	  }
	  return SPAN({
	    key: id + "-" + ((ref3 = updated_translations[id]) != null ? (ref4 = ref3.proposals) != null ? ref4.length : void 0 : void 0)
	  }, accepted && proposed ? DIV(null, DIV({
	    style: {
	      fontStyle: 'italic',
	      fontSize: 14
	    }
	  }, "Current translation:"), accepted, DIV({
	    style: {
	      fontStyle: 'italic',
	      marginTop: 12,
	      fontSize: 14
	    }
	  }, "Your proposed translation:")) : void 0, AutoGrowTextArea({
	    defaultValue: val,
	    style: _.defaults(style || {}, {
	      verticalAlign: 'top',
	      fontSize: 'inherit',
	      width: '100%',
	      borderColor: '#ddd'
	    }),
	    onChange: function(e) {
	      var base, found, j, len1, ref5, trans;
	      trans = e.target.value;
	      updated_translations[id] || (updated_translations[id] = {});
	      if (current_user.is_super_admin) {
	        updated_translations[id].txt = trans;
	        updated_translations[id].u = current_user.user;
	      } else {
	        (base = updated_translations[id]).proposals || (base.proposals = []);
	        found = false;
	        ref5 = updated_translations[id].proposals;
	        for (j = 0, len1 = ref5.length; j < len1; j++) {
	          proposal = ref5[j];
	          if (proposal.u === current_user.user) {
	            proposal.txt = trans;
	            found = true;
	            break;
	          }
	        }
	        if (!found) {
	          updated_translations[id].proposals.unshift({
	            txt: trans,
	            u: current_user.user
	          });
	        }
	      }
	      return save(updated_translations);
	    }
	  }));
	};
	
	promote_temporary_translations = function(lang, key) {
	  var translations, updated_translations;
	  key || (key = '/translations');
	  translations = fetch(key + "/" + lang);
	  updated_translations = fetch("local" + translations.key);
	  Object.assign(translations, updated_translations);
	  translations.key = key + "/" + lang;
	  return save(translations, function() {
	    var trans_UI;
	    trans_UI = fetch('translations_interface');
	    trans_UI.saved_successfully = true;
	    save(trans_UI);
	    return _.delay(function() {
	      trans_UI.saved_successfully = false;
	      return save(trans_UI);
	    }, 4000);
	  });
	};
	
	window.TranslationsDash = TranslationsDash;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var debug, dockingStation, realDimensions,
	  hasProp = {}.hasOwnProperty,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	__webpack_require__(3);
	
	__webpack_require__(1);
	
	window.Dock = ReactiveComponent({
	  displayName: 'Dock',
	  render: function() {
	    var dock, positioning_method, ref, style, x, y;
	    dock = fetch(this.key);
	    if (dock.docked) {
	      ref = [dock.x, dock.y], x = ref[0], y = ref[1];
	      positioning_method = browser.is_mobile ? 'absolute' : 'fixed';
	      style = {
	        top: 0,
	        position: positioning_method,
	        WebkitBackfaceVisibility: "hidden",
	        transform: "translate(" + x + "px, " + y + "px)",
	        zIndex: 999999 - this.local.stack_priority,
	        width: '100%'
	      };
	    }
	    return this.transferPropsTo(DIV(null, DIV({
	      style: {
	        height: dock.docked ? this.local.placeholder_height : 0
	      }
	    }), DIV({
	      ref: 'dock_child',
	      style: css.crossbrowserify(style || {})
	    }, this.props.children)));
	  },
	  componentWillMount: function() {
	    var dock;
	    this.key = this.props.key != null ? this.props.key : this.local.key;
	    dock = fetch(this.key, {
	      docked: false,
	      y: void 0,
	      x: void 0
	    });
	    return save(dock);
	  },
	  componentDidMount: function() {
	    var $el, element_height, jut_above, jut_below, last_dom, placeholder_height, ref, serializer;
	    $el = $(this.refs.dock_child.getDOMNode()).children(':visible');
	    this.local.stack_priority = $el.offset().top;
	    placeholder_height = (ref = $el[0].style.position) === 'absolute' || ref === 'fixed' ? 0 : $el.outerHeight();
	    this.local.placeholder_height = placeholder_height;
	    save(this.local);
	    element_height = jut_above = jut_below = last_dom = null;
	    serializer = new XMLSerializer();
	    return dockingStation.register(this.key, (function(_this) {
	      return function() {
	        var base, current_dom, ref1;
	        $el = $(_this.refs.dock_child.getDOMNode()).children(':visible');
	        current_dom = serializer.serializeToString($el[0]) + _this.props.skip_jut;
	        if (current_dom !== last_dom) {
	          ref1 = !_this.props.skip_jut ? realDimensions($el) : [$el.height(), 0, 0], element_height = ref1[0], jut_above = ref1[1], jut_below = ref1[2];
	          last_dom = current_dom;
	        }
	        return {
	          start: _.isFunction(_this.props.start) ? _this.props.start() : $(_this.getDOMNode()).offset().top + (_this.props.start || 0),
	          stop: (typeof (base = _this.props).stop === "function" ? base.stop() : void 0) || 2e308,
	          dock_on_zoom: _this.props.dock_on_zoomed_screens != null ? _this.props.dock_on_zoomed_screens : true,
	          skip_docking: _this.props.dockable && !_this.props.dockable(),
	          stack_priority: _this.local.stack_priority,
	          jut_above: jut_above,
	          height: element_height,
	          constraints: _this.props.constraints || [],
	          docked_key: _this.props.docked_key,
	          offset_parent: browser.is_mobile ? $(_this.getDOMNode()).offsetParent().offset().top : void 0
	        };
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    return dockingStation.unregister(this.key);
	  }
	});
	
	debug = false;
	
	dockingStation = {
	  registry: {},
	  listening_to_scroll_events: false,
	  component_history: {},
	  viewport: {},
	  register: function(key, info_callback) {
	    dockingStation.registry[key] = info_callback;
	    dockingStation.component_history[key] = {
	      previous: {},
	      on_dock: {}
	    };
	    if (!dockingStation.listening_to_scroll_events) {
	      $(window).on("scroll.dockingStation", function() {
	        return dockingStation.user_scrolled = true;
	      });
	      $(window).on("resize.dockingStation", dockingStation.onResize);
	      dockingStation.check_resize_interval = setInterval(dockingStation.onCheckStickyResize, 500);
	      dockingStation.listening_to_scroll_events = true;
	      return dockingStation.interval = setInterval(function() {
	        if (dockingStation.user_scrolled) {
	          dockingStation.user_scrolled = false;
	          return dockingStation.onScroll();
	        }
	      }, 100);
	    }
	  },
	  unregister: function(key) {
	    delete dockingStation.registry[key];
	    if (_.keys(dockingStation.registry).length === 0) {
	      $(window).off(".dockingStation");
	      dockingStation.listening_to_scroll_events = false;
	      clearInterval(dockingStation.check_resize_interval);
	      dockingStation.check_resize_interval = null;
	      clearInterval(dockingStation.interval);
	      return dockingStation.interval = null;
	    }
	  },
	  onScroll: function() {
	    var max_change;
	    dockingStation.updateViewport();
	    max_change = dockingStation.viewport.last.top != null ? Math.abs(dockingStation.viewport.top - dockingStation.viewport.last.top) : 2e308;
	    return dockingStation.layout(max_change);
	  },
	  onResize: function() {
	    var max_change;
	    dockingStation.updateViewport();
	    max_change = Math.abs(dockingStation.viewport.height - dockingStation.viewport.last.height);
	    return dockingStation.layout(max_change);
	  },
	  onCheckStickyResize: function() {
	    var dock, height_change, k, ref, results, v;
	    ref = dockingStation.registry;
	    results = [];
	    for (k in ref) {
	      if (!hasProp.call(ref, k)) continue;
	      v = ref[k];
	      dock = fetch(k);
	      if (dock.docked && v().height !== dockingStation.component_history[k].previous.height) {
	        height_change = v().height - dockingStation.component_history[k].previous.height;
	        if (debug) {
	          console.log("HEIGHT RESIZE at most " + height_change);
	        }
	        dockingStation.layout(Math.abs(height_change));
	        break;
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  },
	  updateViewport: function() {
	    return dockingStation.viewport = {
	      last: {
	        top: dockingStation.viewport.top,
	        height: dockingStation.viewport.height
	      },
	      top: document.documentElement.scrollTop || document.body.scrollTop,
	      height: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
	    };
	  },
	  layout: function(max_change) {
	    var dock, docked, docks, k, l, len, len1, m, ref, ref1, ref2, undocked, v, x, y, y_pos, y_stack;
	    docks = {};
	    ref = dockingStation.registry;
	    for (k in ref) {
	      if (!hasProp.call(ref, k)) continue;
	      v = ref[k];
	      docks[k] = v();
	      docks[k].key = k;
	    }
	    ref1 = dockingStation.determineIfDocked(docks), docked = ref1[0], undocked = ref1[1], y_stack = ref1[2];
	    for (l = 0, len = undocked.length; l < len; l++) {
	      k = undocked[l];
	      if (fetch(k).docked) {
	        dockingStation.toggleDocked(k, docks[k]);
	      }
	    }
	    if (docked.length > 0) {
	      y_pos = dockingStation.solveForY(docked, docks, max_change);
	      for (m = 0, len1 = docked.length; m < len1; m++) {
	        k = docked[m];
	        dock = fetch(k);
	        dockingStation.component_history[k].previous = _.extend(docks[k], {
	          calculated_y: y_pos[k].value
	        });
	        ref2 = dockingStation.adjustForDevice(y_pos[k].value, docks[k]), x = ref2[0], y = ref2[1];
	        if (dock.y !== y || dock.x !== x) {
	          if (debug) {
	            console.log("UPDATING " + dock.key);
	          }
	          dock.y = y;
	          dock.x = x;
	          if (!dock.docked) {
	            dockingStation.toggleDocked(k, docks[k]);
	          }
	          save(dock);
	        }
	      }
	      docks = fetch('docking_station');
	      if (docks.y_stack !== y_stack) {
	        docks.y_stack = y_stack;
	        return save(docks);
	      }
	    }
	  },
	  determineIfDocked: function(docks) {
	    var dimensions, docked, is_docked, l, len, sorted, undocked, v, y_stack, zoomed_or_small;
	    docked = [];
	    undocked = [];
	    zoomed_or_small = window.innerWidth / $(window).width() < .95 || screen.width <= 700;
	    sorted = _.sortBy(_.values(docks), function(v) {
	      return v.stack_priority;
	    });
	    y_stack = 0;
	    for (l = 0, len = sorted.length; l < len; l++) {
	      v = sorted[l];
	      if (v.skip_docking || (!v.dock_on_zoom && zoomed_or_small)) {
	        is_docked = false;
	      } else {
	        dimensions = fetch(v.key).docked ? dockingStation.component_history[v.key].on_dock : {
	          height: v.height,
	          jut_above: v.jut_above
	        };
	        is_docked = dockingStation.viewport.top + y_stack + dimensions.jut_above >= v.start;
	      }
	      if (is_docked) {
	        y_stack += dimensions.height;
	        docked.push(v.key);
	      } else {
	        undocked.push(v.key);
	      }
	    }
	    return [docked, undocked, y_stack];
	  },
	  toggleDocked: function(k, v) {
	    var dock, external_docked, is_docked;
	    dock = fetch(k);
	    is_docked = !dock.docked;
	    dock.docked = is_docked;
	    if (!is_docked) {
	      dock.y = dock.x = null;
	      dockingStation.component_history[k].previous = {};
	    } else {
	      dockingStation.component_history[k].on_dock = v;
	    }
	    save(dock);
	    if (v.docked_key != null) {
	      external_docked = fetch(v.docked_key);
	      external_docked.docked = is_docked;
	      save(external_docked);
	    }
	    if (debug) {
	      return console.log("Toggled " + k + " to " + dock.docked);
	    }
	  },
	  solveForY: function(docked, docks, max_change) {
	    var c, dock, i, j, k, l, len, len1, len2, m, n, previous_calculated_y, scroll_distance, sk, solver, sorted, sv, v, y_pos, y_stack;
	    c = cassowary;
	    solver = new c.SimplexSolver();
	    scroll_distance = Math.abs(dockingStation.viewport.top - dockingStation.viewport.last.top);
	    if (scroll_distance > 0) {
	      dockingStation.scrolling_down = dockingStation.viewport.top > dockingStation.viewport.last.top;
	    }
	    if (debug) {
	      console.log("viewport height: ", dockingStation.viewport.height);
	    }
	    y_stack = 0;
	    sorted = (function() {
	      var results;
	      results = [];
	      for (k in docks) {
	        if (!hasProp.call(docks, k)) continue;
	        v = docks[k];
	        if (indexOf.call(docked, k) >= 0) {
	          results.push(v);
	        }
	      }
	      return results;
	    })();
	    sorted = _.sortBy(sorted, function(v) {
	      return v.stack_priority;
	    });
	    y_pos = {};
	    for (l = 0, len = sorted.length; l < len; l++) {
	      v = sorted[l];
	      y_pos[v.key] = new c.Variable;
	    }
	    for (i = m = 0, len1 = sorted.length; m < len1; i = ++m) {
	      v = sorted[i];
	      if (debug) {
	        console.log("**" + v.key + " constraints**");
	      }
	      k = v.key;
	      dock = fetch(k);
	      previous_calculated_y = dockingStation.component_history[k].previous.calculated_y;
	      if (debug) {
	        console.log("\tSTART: " + k + " >= " + v.start + ", strong");
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, v.start, c.Strength.strong));
	      if (v.stop !== 2e308) {
	        if (debug) {
	          console.log("\tSTOP: " + k + " <= " + v.stop + " - " + v.height + ", strong");
	        }
	        solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, v.stop - v.height, c.Strength.strong));
	      }
	      if ((max_change != null) && (previous_calculated_y != null)) {
	        if (debug) {
	          console.log("\tBOUNDED BY MAX CHANGE: |" + k + " - " + previous_calculated_y + "| <= " + max_change + ", strong");
	        }
	        solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, previous_calculated_y + max_change, c.Strength.strong));
	        solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, previous_calculated_y - max_change, c.Strength.strong));
	      }
	      if (debug) {
	        console.log("\tTOP OF COMPONENT VISIBLE: \n" + k + " >= " + dockingStation.viewport.top + " + " + v.jut_above + " + " + y_stack + ", \n" + (dockingStation.scrolling_down ? 'weak' : 'medium'));
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, dockingStation.viewport.top + v.jut_above + y_stack, dockingStation.scrolling_down ? c.Strength.weak : c.Strength.medium));
	      y_stack += v.height;
	      if (debug) {
	        console.log("\tBOTTOM OF COMPONENT VISIBLE: \n" + k + " + " + v.height + " <= " + dockingStation.viewport.top + " + " + dockingStation.viewport.height + ", \n" + (dockingStation.scrolling_down ? 'medium' : 'weak'));
	      }
	      solver.addConstraint(new c.Inequality(y_pos[k], c.LEQ, dockingStation.viewport.top + dockingStation.viewport.height - v.height, dockingStation.scrolling_down ? c.Strength.medium : c.Strength.weak));
	      for (j = n = 0, len2 = sorted.length; n < len2; j = ++n) {
	        sv = sorted[j];
	        sk = sv.key;
	        if (j < i && indexOf.call(v.constraints, sk) >= 0) {
	          if (debug) {
	            console.log("\tRELATIONAL: \n" + k + " >= " + sk + " + " + sv.height + " + " + v.jut_above + " - " + sv.jut_above + "}, required");
	          }
	          solver.addConstraint(new c.Inequality(y_pos[k], c.GEQ, c.plus(y_pos[sk], sv.height + v.jut_above - sv.jut_above), c.Strength.required));
	          solver.addConstraint(new c.Equation(y_pos[k], c.plus(y_pos[sk], sv.height + v.jut_above - sv.jut_above), c.Strength.strong));
	        }
	      }
	    }
	    solver.resolve();
	    if (debug) {
	      for (k in y_pos) {
	        if (!hasProp.call(y_pos, k)) continue;
	        v = y_pos[k];
	        console.info(k + ": " + v.value);
	      }
	    }
	    return y_pos;
	  },
	  adjustForDevice: function(y, v) {
	    var x;
	    if (browser.is_mobile) {
	      y -= v.offset_parent;
	      x = 0;
	    } else {
	      y -= dockingStation.viewport.top;
	      x = -$(window).scrollLeft();
	    }
	    return [x, y];
	  },
	  initialize: function() {
	    return dockingStation.updateViewport();
	  }
	};
	
	dockingStation.initialize();
	
	realDimensions = function($el) {
	  var jut_above, jut_below, max_top, min_top, offset, recurse, ref, tar;
	  tar = $el.is('.opinion_region');
	  recurse = function($e, min_top, max_top) {
	    var child, h, l, len, ref, ref1, t;
	    t = $e.offset().top;
	    h = $e.height();
	    if (h === 0 || $e[0].style.display === 'none') {
	      return [min_top, max_top];
	    }
	    if (min_top > t) {
	      min_top = t;
	    }
	    if (t + h > max_top) {
	      max_top = t + h;
	    }
	    ref = $e.children();
	    for (l = 0, len = ref.length; l < len; l++) {
	      child = ref[l];
	      ref1 = recurse($(child), min_top, max_top), min_top = ref1[0], max_top = ref1[1];
	    }
	    return [min_top, max_top];
	  };
	  ref = recurse($el, 2e308, 0), min_top = ref[0], max_top = ref[1];
	  offset = $el.offset().top;
	  jut_above = offset - min_top;
	  jut_below = max_top - (offset + $el.height());
	  return [max_top - min_top, jut_above, jut_below];
	};


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var AppSettingsDash, CodeMirrorTextArea, CustomizationsDash, DataDash, DirectMessage, ModerateItem, ModerationDash, ModerationOptions;
	
	__webpack_require__(22);
	
	__webpack_require__(1);
	
	window.DashHeader = ReactiveComponent({
	  displayName: 'DashHeader',
	  render: function() {
	    var doc, subdomain;
	    doc = fetch('document');
	    if (doc.title !== this.props.name) {
	      doc.title = this.props.name;
	      save(doc);
	    }
	    subdomain = fetch('/subdomain');
	    return DIV({
	      style: {
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, H1({
	      style: {
	        fontSize: 28,
	        padding: '20px 0',
	        fontWeight: 400
	      }
	    }, TRANSLATE({
	      id: "admin.dash_header." + this.props.name
	    }, this.props.name))));
	  }
	});
	
	DataDash = ReactiveComponent({
	  displayName: 'DataDash',
	  render: function() {
	    var a, auth_questions, current_user, error, query, subdomain, success, table, tables;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    tables = ['Users', 'Proposals', 'Opinions', 'Points', 'Comments'];
	    return DIV(null, DashHeader({
	      name: 'Export Data'
	    }), DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: '15px auto'
	      }
	    }, subdomain.plan || current_user.is_super_admin ? (query = '', auth_questions = customization('auth_questions'), auth_questions ? (auth_questions = (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = auth_questions.length; j < len; j++) {
	        a = auth_questions[j];
	        results.push(a.tag);
	      }
	      return results;
	    })(), query = "?" + (auth_questions.join('&'))) : void 0, DIV(null, "Export data from Considerit. A download will begin in a couple seconds after hitting export. The zip file contains four spreadsheets: opinions, points, proposals, and users.", DIV({
	      style: {
	        marginTop: 20,
	        display: 'block'
	      }
	    }), A({
	      style: {
	        backgroundColor: focus_color()
	      },
	      href: "/dashboard/export" + query,
	      "data-nojax": true,
	      className: 'primary_button'
	    }, 'Export'))) : DIV({
	      style: {
	        fontStyle: 'italic'
	      }
	    }, "Data export is only available for paid plans. Contact ", A({
	      href: 'mailto:hello@consider.it',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'hello@consider.it'), ' to inquire about a paid plan.')), DashHeader({
	      name: 'Import Data'
	    }), DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: '15px auto'
	      }
	    }, P({
	      style: {
	        marginBottom: 6
	      }
	    }, "Import data into Considerit. The spreadsheet should be in comma separated value format (.csv)."), DIV(null, P({
	      style: {
	        marginBottom: 6
	      }
	    }, "To refer to a User, use their email address. For example, if you’re uploading points, in the user column, refer to the author via their email address. "), P({
	      style: {
	        marginBottom: 6
	      }
	    }, "To refer to a Proposal, refer to its url. "), P({
	      style: {
	        marginBottom: 6
	      }
	    }, "To refer to a Point, make up an id for it and use that."), P({
	      style: {
	        marginBottom: 6
	      }
	    }, "You do not have to upload every file, just what you need to. Importing the same spreadsheet multiple times is ok.")), FORM({
	      action: '/dashboard/data_import_export'
	    }, TABLE(null, TBODY(null, (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = tables.length; j < len; j++) {
	        table = tables[j];
	        results.push(TR(null, TD({
	          style: {
	            paddingTop: 20,
	            textAlign: 'right'
	          }
	        }, LABEL({
	          style: {
	            whiteSpace: 'nowrap'
	          },
	          htmlFor: table + "-file"
	        }, table + " (.csv)"), DIV(null), A({
	          style: {
	            textDecoration: 'underline',
	            fontSize: 12
	          },
	          href: "/example_import_csvs/" + (table.toLowerCase()) + ".csv",
	          'data-nojax': true
	        }, 'Example')), TD({
	          style: {
	            padding: '20px 0 0 20px'
	          }
	        }, INPUT({
	          id: table + "-file",
	          name: (table.toLowerCase()) + "-file",
	          type: 'file',
	          style: {
	            backgroundColor: focus_color(),
	            color: 'white',
	            fontWeight: 700,
	            borderRadius: 8,
	            padding: 6
	          }
	        }))));
	      }
	      return results;
	    })(), current_user.is_super_admin ? [
	      TR(null, TD(null), TD({
	        style: {
	          padding: '20px 0 20px 20px'
	        }
	      }, INPUT({
	        type: 'checkbox',
	        name: 'generate_inclusions',
	        id: 'generate_inclusions'
	      }), LABEL({
	        htmlFor: 'generate_inclusions'
	      }, "Generate opinions & inclusions of points?\nIt requires a proposal file; for each proposal in the file, this option will increase by \n2x the number of existing opinions. Each simulated opinion will include two points. \nStances and inclusions will not be assigned randomly, but rather following a \nrich-get-richer model. You can use this option multiple times. This option is only good for demos."))), TR(null, TD(null), TD({
	        style: {
	          padding: '20px 0 20px 20px'
	        }
	      }, INPUT({
	        type: 'checkbox',
	        name: 'assign_pics',
	        id: 'assign_pics'
	      }), LABEL({
	        htmlFor: 'assign_pics'
	      }, "Assign a random profile picture for users without an avatar url")))
	    ] : void 0, TR(null, TD(null), TD({
	      style: {
	        padding: '20px 0 0 20px'
	      }
	    }, BUTTON({
	      id: 'submit_import',
	      className: 'primary_button',
	      style: {
	        backgroundColor: focus_color()
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.preventDefault();
	          $('html, #submit_import').css('cursor', 'wait');
	          return $(_this.getDOMNode()).find('form').ajaxSubmit({
	            type: 'POST',
	            data: {
	              authenticity_token: current_user.csrf,
	              trying_to: 'update_avatar_hack'
	            },
	            success: function(data) {
	              if (data[0].errors) {
	                _this.local.successes = null;
	                _this.local.errors = data[0].errors;
	                return save(_this.local);
	              } else {
	                $('html, #submit_import').css('cursor', '');
	                arest.clear_matching_objects(function(key) {
	                  return key.match(/\/page\//);
	                });
	                _this.local.errors = null;
	                _this.local.successes = data[0];
	                return save(_this.local);
	              }
	            },
	            error: function(result) {
	              $('html, #submit_import').css('cursor', '');
	              _this.local.successes = null;
	              _this.local.errors = ['Unknown error parsing the files. Email tkriplean@gmail.com.'];
	              return save(_this.local);
	            }
	          });
	        };
	      })(this)
	    }, 'Done. Upload!')))))), this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#FFE2E2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops! There are errors in the uploaded files:'), (function() {
	      var j, len, ref, results;
	      ref = this.local.errors;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        error = ref[j];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0, this.local.successes ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#E2FFE2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Success! Here\'s what happened:'), (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = tables.length; j < len; j++) {
	        table = tables[j];
	        if (this.local.successes[table.toLowerCase()]) {
	          results.push(DIV(null, H1({
	            style: {
	              fontSize: 15,
	              fontWeight: 300
	            }
	          }, table), (function() {
	            var l, len1, ref, results1;
	            ref = this.local.successes[table.toLowerCase()];
	            results1 = [];
	            for (l = 0, len1 = ref.length; l < len1; l++) {
	              success = ref[l];
	              results1.push(DIV({
	                style: {
	                  marginTop: 10
	                }
	              }, success));
	            }
	            return results1;
	          }).call(this)));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this)) : void 0));
	  }
	});
	
	AppSettingsDash = ReactiveComponent({
	  displayName: 'AppSettingsDash',
	  render: function() {
	    var current_user, error, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    return DIV({
	      className: 'app_settings_dash'
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".app_settings_dash { font-size: 18px }\n.app_settings_dash input[type=\"text\"], .app_settings_dash textarea { border: 1px solid #aaa; display: block; width: " + (HOMEPAGE_WIDTH()) + "px; font-size: 18px; padding: 4px 8px; } \n.app_settings_dash .input_group { margin-bottom: 12px; }"
	      }
	    }), DashHeader({
	      name: 'Application Settings'
	    }), subdomain.name ? DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: '20px auto'
	      }
	    }, DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'app_title'
	    }, 'The name of this application'), INPUT({
	      id: 'app_title',
	      type: 'text',
	      name: 'app_title',
	      defaultValue: subdomain.app_title,
	      placeholder: 'Shows in email subject lines and in the window title.'
	    })), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'external_project_url'
	    }, 'Project url'), INPUT({
	      id: 'external_project_url',
	      type: 'text',
	      name: 'external_project_url',
	      defaultValue: subdomain.external_project_url,
	      placeholder: 'A link to the main project\'s homepage, if any.'
	    })), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'lang'
	    }, 'Primary Language'), SELECT({
	      id: 'lang',
	      type: 'text',
	      name: 'lang',
	      defaultValue: subdomain.lang,
	      style: {
	        fontSize: 18,
	        marginLeft: 12,
	        display: 'inline-block'
	      }
	    }, (function(_this) {
	      return function() {
	        var abbrev, available_languages, label, results;
	        available_languages = Object.assign({}, fetch('/translations').available_languages || {});
	        if (current_user.is_super_admin) {
	          available_languages['pseudo-en'] = "Pseudo English (for testing)";
	        }
	        results = [];
	        for (abbrev in available_languages) {
	          label = available_languages[abbrev];
	          results.push(OPTION({
	            value: abbrev
	          }, label));
	        }
	        return results;
	      };
	    })(this)()), (subdomain.lang != null) && subdomain.lang !== 'en' ? DIV({
	      style: {
	        fontSize: 12
	      }
	    }, TRANSLATE({
	      id: "translations.link",
	      percent_complete: Math.round(translation_progress(subdomain.lang) * 100),
	      language: (fetch('/translations').available_languages || {})[subdomain.lang],
	      link: {
	        component: A,
	        args: {
	          href: "/dashboard/translations",
	          style: {
	            textDecoration: 'underline',
	            color: focus_color(),
	            fontWeight: 700
	          }
	        }
	      }
	    }, "Translations for {language} are {percent_complete}% completed. Help improve the translations <link>here</link>.")) : void 0, DIV({
	      style: {
	        fontSize: 12
	      }
	    }, "Is your preferred language not available? Email us at hello@consider.it to help us create a translation.")), subdomain.plan || current_user.is_super_admin ? DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'google_analytics_code'
	    }, "Google analytics. Add your Google analytics tracking code."), INPUT({
	      id: 'google_analytics_code',
	      type: 'text',
	      name: 'google_analytics_code',
	      defaultValue: subdomain.google_analytics_code,
	      placeholder: 'Google Analytics tracking code'
	    })) : DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'google_analytics_code'
	    }, "Google analytics tracking code"), DIV({
	      style: {
	        fontStyle: 'italic',
	        fontSize: 15
	      }
	    }, "Only available for paid plans. Email ", A({
	      href: 'mailto:hello@consider.it',
	      style: {
	        textDecoration: 'underline'
	      }
	    }, 'hello@consider.it'), ' to inquire further.')), current_user.is_super_admin ? DIV(null, DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'plan'
	    }, 'Account Plan (0,1,2)'), INPUT({
	      id: 'plan',
	      type: 'text',
	      name: 'plan',
	      defaultValue: subdomain.plan,
	      placeholder: '0 for free plan, 1 for custom, 2 for consulting.'
	    })), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'masthead_header_text'
	    }, 'Masthead header text'), INPUT({
	      id: 'masthead_header_text',
	      type: 'text',
	      name: 'masthead_header_text',
	      defaultValue: subdomain.branding.masthead_header_text,
	      placeholder: 'This will be shown in bold white text across the top of the header.'
	    })), DIV({
	      className: 'input_group'
	    }, LABEL({
	      htmlFor: 'primary_color'
	    }, 'Primary color (CSS format)'), INPUT({
	      id: 'primary_color',
	      type: 'text',
	      name: 'primary_color',
	      defaultValue: subdomain.branding.primary_color,
	      placeholder: 'The primary brand color. Needs to be dark.'
	    }))) : void 0, FORM({
	      id: 'subdomain_files',
	      action: '/update_images_hack'
	    }, current_user.is_super_admin ? DIV({
	      className: 'input_group'
	    }, DIV(null, LABEL({
	      htmlFor: 'masthead'
	    }, 'Masthead background image. Should be pretty large.')), INPUT({
	      id: 'masthead',
	      type: 'file',
	      name: 'masthead',
	      onChange: (function(_this) {
	        return function(ev) {
	          return _this.submit_masthead = true;
	        };
	      })(this)
	    })) : void 0, DIV({
	      className: 'input_group'
	    }, DIV(null, LABEL({
	      htmlFor: 'logo'
	    }, 'Logo')), INPUT({
	      id: 'logo',
	      type: 'file',
	      name: 'logo',
	      onChange: (function(_this) {
	        return function(ev) {
	          return _this.submit_logo = true;
	        };
	      })(this)
	    }))), DIV({
	      className: 'input_group'
	    }, BUTTON({
	      className: 'primary_button button',
	      style: {
	        backgroundColor: focus_color()
	      },
	      onClick: this.submit
	    }, 'Save')), this.local.save_complete ? DIV({
	      style: {
	        color: 'green'
	      }
	    }, 'Saved.') : void 0, this.local.file_errors ? DIV({
	      style: {
	        color: 'red'
	      }
	    }, 'Error uploading files!') : void 0, this.local.errors ? this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#FFE2E2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops!'), (function() {
	      var j, len, ref, results;
	      ref = this.local.errors;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        error = ref[j];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0 : void 0) : void 0);
	  },
	  submit: function() {
	    var current_user, f, fields, j, len, subdomain, submitting_files;
	    submitting_files = this.submit_logo || this.submit_masthead;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    fields = ['about_page_url', 'notifications_sender_email', 'app_title', 'external_project_url', 'plan', 'google_analytics_code', 'lang'];
	    for (j = 0, len = fields.length; j < len; j++) {
	      f = fields[j];
	      subdomain[f] = $(this.getDOMNode()).find("#" + f).val();
	    }
	    if (current_user.is_super_admin) {
	      subdomain.branding = {
	        primary_color: $('#primary_color').val(),
	        masthead_header_text: $('#masthead_header_text').val()
	      };
	    }
	    this.local.save_complete = this.local.file_errors = false;
	    save(this.local);
	    return save(subdomain, (function(_this) {
	      return function() {
	        if (subdomain.errors) {
	          _this.local.errors = subdomain.errors;
	        }
	        if (!submitting_files) {
	          _this.local.save_complete = true;
	        }
	        save(_this.local);
	        if (submitting_files) {
	          current_user = fetch('/current_user');
	          return $('#subdomain_files').ajaxSubmit({
	            type: 'PUT',
	            data: {
	              authenticity_token: current_user.csrf
	            },
	            success: function() {
	              return location.reload();
	            },
	            error: function() {
	              _this.local.file_errors = true;
	              return save(_this.local);
	            }
	          });
	        }
	      };
	    })(this));
	  }
	});
	
	CustomizationsDash = ReactiveComponent({
	  displayName: 'CustomizationsDash',
	  render: function() {
	    var base, base1, base2, code_properties, compare_to, current_user, error, id, j, js, k, len, other_subs, ref, ref1, sub, subdomain, subdomains, v;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    subdomains = fetch('/subdomains');
	    if (this.local.compare_to == null) {
	      this.local.compare_to = '';
	      save(this.local);
	    }
	    other_subs = [];
	    ref = subdomains.subs;
	    for (j = 0, len = ref.length; j < len; j++) {
	      sub = ref[j];
	      if (!(((ref1 = sub.customizations) != null ? ref1.length : void 0) > 0 && sub.name !== subdomain.name)) {
	        continue;
	      }
	      other_subs.push([sub.name.toLowerCase(), sub.customizations]);
	      if (sub.name.toLowerCase() === this.local.compare_to) {
	        compare_to = sub.customizations;
	      }
	    }
	    other_subs.sort(function(a, b) {
	      if (a[0] < b[0]) {
	        return -1;
	      } else if (a[0] > b[0]) {
	        return 1;
	      } else {
	        return 0;
	      }
	    });
	    if (!subdomain.name || !current_user.is_super_admin || !subdomains.subs) {
	      return SPAN(null);
	    }
	    if (typeof CodeMirror === "undefined" || CodeMirror === null) {
	      location.reload();
	      return SPAN(null);
	    }
	    if ((base = this.local).current_value == null) {
	      base.current_value = subdomain.customizations;
	    }
	    if ((base1 = this.local).customization_filter == null) {
	      base1.customization_filter = '';
	    }
	    if ((base2 = this.local).property_changes == null) {
	      base2.property_changes = {};
	    }
	    try {
	      code_properties = (function() {
	        var ref2, results;
	        ref2 = JSON.parse(subdomain.customizations);
	        results = [];
	        for (k in ref2) {
	          v = ref2[k];
	          if (typeof v === 'string' && v.startsWith(FUNCTION_IDENTIFIER)) {
	            results.push([k, v]);
	          }
	        }
	        return results;
	      })();
	    } catch (error1) {
	      error = error1;
	      code_properties = [];
	      console.error(error);
	    }
	    return DIV({
	      style: {
	        width: '90%',
	        margin: '20px auto'
	      },
	      className: 'customizations'
	    }, STYLE({
	      dangerouslySetInnerHTML: {
	        __html: ".customizations .CodeMirror {\n  height: 500px;\n  font-size: 14px;\n  border: 1px solid #ddd;\n}\n"
	      }
	    }), DIV({
	      className: 'input_group'
	    }, DIV({
	      style: {
	        display: 'inline-block',
	        width: this.local.compare_to !== '' ? '58%' : '75%',
	        verticalAlign: 'top'
	      }
	    }, H1({
	      style: {
	        fontStyle: 'italic',
	        fontSize: 44,
	        fontWeight: 600
	      }
	    }, "Customizations for " + subdomain.name + ".consider.it:"), DIV(null, CodeMirrorTextArea({
	      id: 'customizations',
	      key: md5(subdomain.customizations),
	      default_value: subdomain.customizations || "\n\n\n\n\n\n\n",
	      onChange: (function(_this) {
	        return function(val) {
	          return _this.local.current_value = val;
	        };
	      })(this)
	    })), DIV({
	      className: 'input_group'
	    }, BUTTON({
	      className: 'primary_button button',
	      onClick: (function(_this) {
	        return function() {
	          return _this.submit();
	        };
	      })(this),
	      style: {
	        backgroundColor: focus_color()
	      }
	    }, 'Save')), this.local.save_complete ? DIV({
	      style: {
	        color: 'green'
	      }
	    }, 'Saved.') : void 0, this.local.errors ? this.local.errors && this.local.errors.length > 0 ? DIV({
	      style: {
	        borderRadius: 8,
	        margin: 20,
	        padding: 20,
	        backgroundColor: '#FFE2E2'
	      }
	    }, H1({
	      style: {
	        fontSize: 18
	      }
	    }, 'Ooops!'), (function() {
	      var l, len1, ref2, results;
	      ref2 = this.local.errors;
	      results = [];
	      for (l = 0, len1 = ref2.length; l < len1; l++) {
	        error = ref2[l];
	        results.push(DIV({
	          style: {
	            marginTop: 10
	          }
	        }, error));
	      }
	      return results;
	    }).call(this)) : void 0 : void 0), DIV({
	      style: {
	        display: 'inline-block',
	        width: this.local.compare_to === '' ? '22%' : '38%',
	        verticalAlign: 'top',
	        marginLeft: '2%'
	      }
	    }, INPUT({
	      style: {
	        width: '100%'
	      },
	      placeholder: 'Filter to subs with customization containing...',
	      ref: 'customization_filter',
	      type: 'text',
	      defaultValue: '',
	      onKeyUp: (function(_this) {
	        return function(e) {
	          _this.local.customization_filter = _this.refs.customization_filter.getDOMNode().value;
	          return save(_this.local);
	        };
	      })(this)
	    }), DIV({
	      style: {
	        fontStyle: 'italic'
	      }
	    }, "Compare to ", SELECT({
	      value: this.local.compare_to,
	      style: {
	        width: 80
	      },
	      onChange: (function(_this) {
	        return function(ev) {
	          _this.local.compare_to = ev.target.value;
	          return save(_this.local);
	        };
	      })(this)
	    }, (function() {
	      var l, len1, ref2, results;
	      results = [];
	      for (l = 0, len1 = other_subs.length; l < len1; l++) {
	        ref2 = other_subs[l], sub = ref2[0], id = ref2[1];
	        if (this.local.customization_filter.length === 0 || id.toLowerCase().indexOf(this.local.customization_filter.toLowerCase()) > -1) {
	          results.push(OPTION({
	            value: sub
	          }, sub));
	        }
	      }
	      return results;
	    }).call(this)), ".consider.it:"), !!compare_to ? CodeMirrorTextArea({
	      key: compare_to,
	      id: 'comparison',
	      default_value: compare_to
	    }) : void 0)), code_properties.length > 0 ? DIV({
	      style: {
	        marginTop: 50
	      }
	    }, H2({
	      style: {
	        fontSize: 36
	      }
	    }, "Easier code-editing sections"), (function() {
	      var ref2, results;
	      ref2 = JSON.parse(subdomain.customizations);
	      results = [];
	      for (k in ref2) {
	        v = ref2[k];
	        if (typeof v === 'string' && v.startsWith(FUNCTION_IDENTIFIER)) {
	          js = v.substring(FUNCTION_IDENTIFIER.length);
	          results.push(DIV(null, H3({
	            style: {
	              fontSize: 24,
	              marginTop: 36
	            }
	          }, k), DIV(null, CodeMirrorTextArea({
	            key: (md5(subdomain.customizations)) + "-" + k,
	            default_value: js,
	            onChange: (function(_this) {
	              return function(k) {
	                return function(val) {
	                  _this.local.property_changes[k] = val;
	                  return save(_this.local);
	                };
	              };
	            })(this)(k)
	          })), DIV({
	            className: 'input_group'
	          }, BUTTON({
	            className: 'primary_button button',
	            onClick: (function(_this) {
	              return function(k) {
	                return function() {
	                  if (k in _this.local.property_changes) {
	                    return _this.submit_change(k, _this.local.property_changes[k], true);
	                  }
	                };
	              };
	            })(this)(k),
	            style: {
	              backgroundColor: focus_color(),
	              opacity: !(k in this.local.property_changes) ? .5 : void 0,
	              cursor: !(k in this.local.property_changes) ? 'default' : void 0
	            },
	            disabled: !(k in this.local.property_changes) ? true : void 0
	          }, 'Save'))));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this)) : void 0, DIV(null, DIV({
	      style: {
	        marginTop: 20,
	        marginBottom: 5,
	        cursor: 'pointer',
	        fontWeight: 600,
	        color: '#666',
	        textDecoration: 'underline'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_shared = !_this.local.show_shared;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Shared code and variables to use in customizations"), this.local.show_shared ? CodeMirrorTextArea({
	      key: 'shared_code',
	      default_value: subdomain.shared_code
	    }) : void 0), DIV(null, DIV({
	      style: {
	        marginTop: 20,
	        marginBottom: 5,
	        cursor: 'pointer',
	        fontWeight: 600,
	        color: '#666',
	        textDecoration: 'underline'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.show_doc = !_this.local.show_doc;
	          return save(_this.local);
	        };
	      })(this)
	    }, "Variable documentation"), this.local.show_doc ? DIV({
	      style: {
	        marginTop: 10
	      }
	    }, A({
	      href: "https://docs.google.com/spreadsheets/d/1gn1PuF98i4eD8x0E4YHmtBAcEdau9W13cJ7fh6MF3u8/edit#gid=0",
	      target: '_blank',
	      style: {
	        display: 'block',
	        textDecoration: 'underline',
	        color: focus_color(),
	        marginBottom: 5
	      }
	    }, "Load documentation in own tab"), ".", IFRAME({
	      width: '100%',
	      height: 1500,
	      src: "https://docs.google.com/spreadsheets/d/1gn1PuF98i4eD8x0E4YHmtBAcEdau9W13cJ7fh6MF3u8/pubhtml?widget=true&amp;headers=false"
	    })) : void 0));
	  },
	  submit_change: function(property, value, is_javascript) {
	    var customizations, new_json, subdomain;
	    subdomain = fetch('/subdomain');
	    if (is_javascript) {
	      value = "" + FUNCTION_IDENTIFIER + value;
	    }
	    customizations = JSON.parse(subdomain.customizations);
	    customizations[property] = value;
	    new_json = JSON.stringify(customizations, null, 2);
	    return this.submit(new_json);
	  },
	  submit: function(value) {
	    var subdomain;
	    if (value == null) {
	      value = this.local.current_value;
	    }
	    subdomain = fetch('/subdomain');
	    subdomain.customizations = value;
	    this.local.save_complete = false;
	    save(this.local);
	    return save(subdomain, (function(_this) {
	      return function() {
	        if (subdomain.errors) {
	          _this.local.errors = subdomain.errors;
	        }
	        _this.local.save_complete = true;
	        save(_this.local);
	        return db_customization_loaded[subdomain.name] = false;
	      };
	    })(this));
	  }
	});
	
	CodeMirrorTextArea = ReactiveComponent({
	  displayName: 'CodeMirrorTextArea',
	  render: function() {
	    return TEXTAREA({
	      id: this.props.id,
	      name: this.props.id,
	      ref: 'field',
	      defaultValue: this.props.default_value
	    });
	  },
	  componentDidMount: function() {
	    var betterTab;
	    betterTab = function(cm) {
	      var o;
	      if (cm.somethingSelected()) {
	        return cm.indentSelection('add');
	      } else {
	        o = cm.getOption("indentWithTabs") ? "\t" : Array(cm.getOption("indentUnit") + 1).join(" ");
	        return cm.replaceSelection(o, "end", "+input");
	      }
	    };
	    this.m = CodeMirror.fromTextArea(this.refs.field.getDOMNode(), _.defaults(this.props.opts || {}, {
	      lineNumbers: true,
	      matchBrackets: true,
	      indentUnit: 2,
	      mode: 'coffeescript',
	      extraKeys: {
	        Tab: betterTab
	      }
	    }));
	    if (this.props.onChange) {
	      return this.m.on('change', (function(_this) {
	        return function() {
	          return _this.props.onChange(_this.m.getValue());
	        };
	      })(this));
	    }
	  },
	  componentWillUnmount: function() {
	    return this.m.getTextArea().remove();
	  }
	});
	
	ModerationDash = ReactiveComponent({
	  displayName: 'ModerationDash',
	  render: function() {
	    var all_items, base, category, dash, default_show, failed, i, item, items, itms, j, l, len, len1, len2, m, model, moderations, passed, quarantined, ref, ref1, ref2, reviewable, select_class, show_category, subdomain, toggle_show;
	    moderations = this.data().moderations;
	    subdomain = fetch('/subdomain');
	    (base = this.local).model || (base.model = 'Proposal');
	    dash = fetch('moderation_dash');
	    all_items = {};
	    ref = ['Point', 'Comment', 'Proposal'];
	    for (j = 0, len = ref.length; j < len; j++) {
	      model = ref[j];
	      passed = [];
	      reviewable = [];
	      quarantined = [];
	      failed = [];
	      moderations[model] || (moderations[model] = []);
	      moderations[model].sort(function(a, b) {
	        return new Date(fetch(b.moderatable).created_at) - new Date(fetch(a.moderatable).created_at);
	      });
	      ref1 = moderations[model];
	      for (l = 0, len1 = ref1.length; l < len1; l++) {
	        i = ref1[l];
	        fetch(i.key);
	        if ((i.status == null) || i.updated_since_last_evaluation) {
	          reviewable.push(i);
	        } else if (i.status === 1) {
	          passed.push(i);
	        } else if (i.status === 0) {
	          failed.push(i);
	        } else if (i.status === 2) {
	          quarantined.push(i);
	        }
	      }
	      all_items[model] = [['Pending', reviewable, true], ['Quarantined', quarantined, true], ['Failed', failed, true], ['Passed', passed, false]];
	    }
	    items = all_items[this.local.model];
	    this.items = items;
	    if (!dash.selected_task && items.length > 0) {
	      for (m = 0, len2 = items.length; m < len2; m++) {
	        ref2 = items[m], category = ref2[0], itms = ref2[1];
	        if (itms.length > 0) {
	          dash.selected_task = itms[0].key;
	          save(dash);
	          break;
	        }
	      }
	    }
	    if (dash.transition) {
	      this.selectNext();
	    }
	    return DIV(null, DIV(null, ModerationOptions(), UL({
	      style: {
	        listStyle: 'none',
	        margin: '20px auto',
	        textAlign: 'center'
	      }
	    }, (function() {
	      var len3, n, ref3, results;
	      ref3 = ['Point', 'Comment', 'Proposal'];
	      results = [];
	      for (n = 0, len3 = ref3.length; n < len3; n++) {
	        model = ref3[n];
	        select_class = (function(_this) {
	          return function(model) {
	            _this.local.model = model;
	            return save(_this.local);
	          };
	        })(this);
	        results.push((function(_this) {
	          return function(model) {
	            return LI({
	              style: {
	                display: 'inline-block'
	              }
	            }, BUTTON({
	              style: {
	                backgroundColor: _this.local.model === model ? '#444' : 'transparent',
	                color: _this.local.model === model ? 'white' : '#aaa',
	                fontSize: 36,
	                marginRight: 32,
	                border: 'none',
	                borderRadius: 4,
	                fontWeight: 600,
	                fontStyle: 'oblique'
	              },
	              onClick: function() {
	                return select_class(model);
	              },
	              onKeyPress: function(e) {
	                var ref4;
	                if ((ref4 = e.which) === 13 || ref4 === 32) {
	                  select_class(model);
	                  return e.preventDefault();
	                }
	              }
	            }, "Review " + model + "s", " (" + all_items[model][0][1].length + ")"));
	          };
	        })(this)(model));
	      }
	      return results;
	    }).call(this)), DIV(null, (function() {
	      var len3, n, ref3, results;
	      results = [];
	      for (n = 0, len3 = items.length; n < len3; n++) {
	        ref3 = items[n], category = ref3[0], itms = ref3[1], default_show = ref3[2];
	        if (itms.length > 0) {
	          show_category = (this.local["show_" + category] != null ? this.local["show_" + category] : default_show);
	          toggle_show = (function(_this) {
	            return function(category, show_category) {
	              return function() {
	                _this.local["show_" + category] = !show_category;
	                return save(_this.local);
	              };
	            };
	          })(this)(category, show_category);
	          results.push(DIV({
	            style: {
	              marginTop: 20,
	              key: category
	            }
	          }, H1({
	            style: {
	              fontSize: 24,
	              fontStyle: 'oblique',
	              fontWeight: 600,
	              textAlign: 'center',
	              backgroundColor: '#e0e0e0',
	              margin: '20px 0',
	              cursor: 'pointer'
	            },
	            onClick: toggle_show
	          }, category, " (" + itms.length + ")", A({
	            style: {
	              color: '#aaa',
	              fontWeight: 400,
	              fontStyle: 'oblique',
	              verticalAlign: 'middle',
	              paddingRight: 10,
	              paddingLeft: 40,
	              textDecoration: 'underline'
	            }
	          }, show_category ? 'Hide' : 'Show')), show_category ? UL({
	            style: {}
	          }, (function() {
	            var len4, p, results1;
	            results1 = [];
	            for (p = 0, len4 = itms.length; p < len4; p++) {
	              item = itms[p];
	              results1.push(LI({
	                'data-id': item.key,
	                key: item.key,
	                style: {
	                  position: 'relative',
	                  listStyle: 'none'
	                },
	                onClick: (function(_this) {
	                  return function(item) {
	                    return function() {
	                      dash.selected_task = item.key;
	                      save(dash);
	                      return setTimeout(function() {
	                        return $("[data-id='" + item.key + "']").ensureInView();
	                      }, 1);
	                    };
	                  };
	                })(this)(item)
	              }, ModerateItem({
	                key: item.key,
	                selected: dash.selected_task === item.key
	              })));
	            }
	            return results1;
	          }).call(this)) : void 0));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this))));
	  },
	  selectNext: function() {
	    return this._select(false);
	  },
	  selectPrev: function() {
	    return this._select(true);
	  },
	  _select: function(reverse) {
	    var all_items, category, dash, default_show, get_next, item, items, j, l, len, len1, ref, show_category, tasks;
	    dash = fetch('moderation_dash');
	    get_next = false;
	    all_items = !reverse ? this.items : this.items.slice().reverse();
	    for (j = 0, len = all_items.length; j < len; j++) {
	      ref = all_items[j], category = ref[0], items = ref[1], default_show = ref[2];
	      tasks = !reverse ? items : items.slice().reverse();
	      show_category = (this.local["show_" + category] != null ? this.local["show_" + category] : default_show);
	      if (!show_category) {
	        continue;
	      }
	      for (l = 0, len1 = tasks.length; l < len1; l++) {
	        item = tasks[l];
	        if (get_next) {
	          dash.selected_task = item.key;
	          dash.transition = null;
	          save(dash);
	          setTimeout((function(_this) {
	            return function() {
	              return $("[data-id='" + item.key + "']").ensureInView();
	            };
	          })(this), 1);
	          return;
	        } else if (item.key === dash.selected_task) {
	          get_next = true;
	        }
	      }
	    }
	  },
	  componentDidMount: function() {
	    return $(document).on('keyup.dash', (function(_this) {
	      return function(e) {
	        if (e.keyCode === 40) {
	          _this.selectNext();
	        }
	        if (e.keyCode === 38) {
	          return _this.selectPrev();
	        }
	      };
	    })(this));
	  },
	  componentWillUnmount: function() {
	    return $(document).off('keyup.dash');
	  }
	});
	
	ModerateItem = ReactiveComponent({
	  displayName: 'ModerateItem',
	  render: function() {
	    var author, class_name, clust, comment, comments, current_user, details, header, href, item, item_header, judge, moderatable, point, proposal, selected, tease;
	    item = this.data();
	    class_name = item.moderatable_type;
	    moderatable = fetch(item.moderatable);
	    author = fetch(moderatable.user);
	    if (class_name === 'Point') {
	      point = moderatable;
	      proposal = fetch(moderatable.proposal);
	      tease = (moderatable.nutshell.substring(0, 120)) + "...";
	      header = moderatable.nutshell;
	      details = moderatable.text;
	      href = "/" + proposal.slug + "?results=true&selected=" + point.key;
	    } else if (class_name === 'Comment') {
	      point = fetch(moderatable.point);
	      proposal = fetch(point.proposal);
	      comments = fetch("/comments/" + point.id);
	      tease = (moderatable.body.substring(0, 120)) + "...";
	      header = moderatable.body;
	      details = '';
	      href = "/" + proposal.slug + "?results=true&selected=" + point.key;
	    } else if (class_name === 'Proposal') {
	      proposal = moderatable;
	      tease = (proposal.name.substring(0, 120)) + "...";
	      header = proposal.name;
	      details = moderatable.description;
	      href = "/" + proposal.slug;
	    }
	    current_user = fetch('/current_user');
	    selected = this.props.selected;
	    item_header = {
	      fontWeight: 700,
	      fontSize: 22
	    };
	    return DIV({
	      style: {
	        cursor: selected ? 'auto' : 'pointer',
	        margin: 'auto',
	        borderLeft: "4px solid " + (selected ? focus_color() : 'transparent'),
	        padding: '8px 14px',
	        maxWidth: 700,
	        marginBottom: selected ? 40 : 12
	      }
	    }, DIV({
	      style: {
	        marginLeft: 70,
	        position: 'relative'
	      }
	    }, DIV(null, class_name === 'Comment' && selected ? DIV({
	      style: {
	        opacity: .5
	      }
	    }, BUBBLE_WRAP({
	      title: point.nutshell,
	      anon: point.hide_name,
	      user: point.user,
	      body: point.text,
	      width: '100%'
	    }), (function() {
	      var j, len, ref, results;
	      ref = _.uniq(_.map(comments.comments, function(c) {
	        return c.key;
	      }).concat(moderatable.key));
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        comment = ref[j];
	        if (comment !== moderatable.key) {
	          results.push(BUBBLE_WRAP({
	            title: fetch(comment).body,
	            user: fetch(comment).user,
	            width: '100%'
	          }));
	        }
	      }
	      return results;
	    })()) : void 0, BUBBLE_WRAP({
	      title: selected ? header : tease,
	      body: selected ? moderatable.description : '',
	      anon: !!moderatable.hide_name,
	      user: moderatable.user,
	      width: '100%'
	    }), DIV(null, "by " + author.name, selected ? A({
	      style: {
	        textDecoration: 'underline',
	        padding: '0 8px'
	      },
	      target: '_blank',
	      href: href,
	      'data-nojax': true
	    }, "View " + class_name) : void 0, selected && !moderatable.hide_name && !this.local.messaging ? BUTTON({
	      style: {
	        marginLeft: 8,
	        textDecoration: 'underline',
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.messaging = moderatable;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Message author') : void 0)), selected && this.local.messaging ? DirectMessage({
	      to: this.local.messaging.user,
	      parent: this.local,
	      sender_mask: 'Moderator'
	    }) : void 0), selected && class_name === 'Proposal' ? DIV({
	      style: {
	        marginTop: 8,
	        marginLeft: 63
	      }
	    }, SELECT({
	      style: {
	        fontSize: 18
	      },
	      value: proposal.cluster,
	      ref: 'category',
	      onChange: (function(_this) {
	        return function(e) {
	          proposal.cluster = e.target.value;
	          return save(proposal);
	        };
	      })(this)
	    }, (function() {
	      var j, len, ref, results;
	      ref = get_all_clusters();
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        clust = ref[j];
	        results.push(OPTION({
	          value: clust
	        }, clust));
	      }
	      return results;
	    })())) : void 0, selected ? (judge = (function(_this) {
	      return function(judgement) {
	        var dash;
	        dash = fetch('moderation_dash');
	        dash.transition = item.key;
	        save(dash);
	        return setTimeout(function() {
	          item.status = judgement;
	          return save(item);
	        }, 1);
	      };
	    })(this), DIV({
	      style: {
	        margin: '10px 0px 20px 63px',
	        position: 'relative'
	      }
	    }, STYLE(null, ".moderation { font-weight: 600; border-radius: 8px; padding: 6px 12px; display: inline-block; margin-right: 10px; box-shadow: 0px 1px 2px rgba(0,0,0,.4)}\n.moderation label, .moderation input { font-size: 22px; cursor: pointer }"), DIV({
	      className: 'moderation',
	      style: {
	        backgroundColor: '#81c765'
	      },
	      onClick: function() {
	        return judge(1);
	      }
	    }, INPUT({
	      name: 'moderation',
	      type: 'radio',
	      id: 'pass',
	      defaultChecked: item.status === 1
	    }), LABEL({
	      htmlFor: 'pass'
	    }, 'Pass')), DIV({
	      className: 'moderation',
	      style: {
	        backgroundColor: '#ffc92a'
	      },
	      onClick: function() {
	        return judge(2);
	      }
	    }, INPUT({
	      name: 'moderation',
	      type: 'radio',
	      id: 'quar',
	      defaultChecked: item.status === 2
	    }), LABEL({
	      htmlFor: 'quar'
	    }, 'Quarantine')), DIV({
	      className: 'moderation',
	      style: {
	        backgroundColor: '#f94747'
	      },
	      onClick: function() {
	        return judge(0);
	      }
	    }, INPUT({
	      name: 'moderation',
	      type: 'radio',
	      id: 'fail',
	      defaultChecked: item.status === 0
	    }), LABEL({
	      htmlFor: 'fail'
	    }, 'Fail')))) : void 0, selected ? DIV({
	      style: {
	        marginLeft: 63,
	        fontStyle: 'italic'
	      }
	    }, item.updated_since_last_evaluation ? SPAN({
	      style: {}
	    }, "Updated since last moderation") : item.status === 1 ? SPAN({
	      style: {}
	    }, "Passed by " + (fetch(item.user).name) + " on " + (new Date(item.updated_at).toDateString())) : item.status === 2 ? SPAN({
	      style: {}
	    }, "Quarantined by " + (fetch(item.user).name) + " on " + (new Date(item.updated_at).toDateString())) : item.status === 0 ? SPAN({
	      style: {}
	    }, "Failed by " + (fetch(item.user).name) + " on " + (new Date(item.updated_at).toDateString())) : void 0) : void 0);
	  }
	});
	
	ModerationOptions = ReactiveComponent({
	  displayName: 'ModerationOptions',
	  render: function() {
	    var expanded, field, idx, model, moderation_options, subdomain;
	    subdomain = fetch('/subdomain');
	    expanded = subdomain.moderated_classes.length === 0 || this.local.edit_settings;
	    return DIV({
	      style: {
	        textAlign: !expanded ? 'right' : void 0,
	        paddingRight: !expanded ? 30 : void 0
	      }
	    }, !expanded ? BUTTON({
	      style: {
	        backgroundColor: 'transparent',
	        fontSize: 24,
	        border: 'none',
	        textDecoration: 'underline',
	        color: '#aaa',
	        fontStyle: 'oblique'
	      },
	      onClick: (function(_this) {
	        return function() {
	          _this.local.edit_settings = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Edit moderation settings') : DIV({
	      style: {
	        padding: 50
	      }
	    }, (function() {
	      var j, len, ref, results;
	      ref = ['points', 'comments', 'proposals'];
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        model = ref[j];
	        moderation_options = ["Do not moderate " + model, "Do not publicly post " + model + " until moderation", "Post " + model + " immediately, but withhold email notifications until moderation", "Post " + model + " immediately, catch bad ones afterwards"];
	        results.push(FIELDSET({
	          style: {
	            marginBottom: 12
	          }
	        }, LEGEND({
	          style: {
	            fontSize: 24
	          }
	        }, capitalize(model)), (function() {
	          var l, len1, results1;
	          results1 = [];
	          for (idx = l = 0, len1 = moderation_options.length; l < len1; idx = ++l) {
	            field = moderation_options[idx];
	            results1.push(DIV({
	              style: {
	                marginLeft: 18,
	                fontSize: 18,
	                cursor: 'pointer'
	              },
	              onClick: (function(_this) {
	                return function(idx, model) {
	                  return function() {
	                    subdomain["moderate_" + model + "_mode"] = idx;
	                    return save(subdomain, function() {
	                      return arest.serverFetch('/page/dashboard/moderate');
	                    });
	                  };
	                };
	              })(this)(idx, model)
	            }, INPUT({
	              style: {
	                cursor: 'pointer'
	              },
	              type: 'radio',
	              name: "moderate_" + model + "_mode",
	              id: "moderate_" + model + "_mode_" + idx,
	              defaultChecked: subdomain["moderate_" + model + "_mode"] === idx
	            }), LABEL({
	              style: {
	                cursor: 'pointer',
	                paddingLeft: 8
	              },
	              htmlFor: "moderate_" + model + "_mode_" + idx
	            }, field)));
	          }
	          return results1;
	        }).call(this)));
	      }
	      return results;
	    }).call(this), BUTTON({
	      onClick: (function(_this) {
	        return function() {
	          _this.local.edit_settings = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'close')));
	  }
	});
	
	styles += ".moderatable_item br {\n  padding-bottom: 0.5em; }\n.moderatable_item p, \n.moderatable_item ul, \n.moderatable_item ol, \n.moderatable_item table {\n  margin-bottom: 0.5em; }\n.moderatable_item td {\n  padding: 0 3px; }\n.moderatable_item li {\n  list-style: outside; }\n.moderatable_item ol li {\n  list-style-type: decimal; }  \n.moderatable_item ul,\n.moderatable_item ol, {\n  padding-left: 20px;\n  margin-left: 20px; }\n.moderatable_item a {\n  text-decoration: underline; }\n.moderatable_item blockquote {\n  opacity: 0.7;\n  padding: 10px 20px; }\n.moderatable_item table {\n  padding: 20px 0px; }";
	
	DirectMessage = ReactiveComponent({
	  displayName: 'DirectMessage',
	  render: function() {
	    var text_style;
	    text_style = {
	      width: 500,
	      fontSize: 16,
	      display: 'block',
	      padding: '4px 8px'
	    };
	    return DIV({
	      style: {
	        margin: '18px 0',
	        padding: '15px 20px',
	        backgroundColor: 'white',
	        width: 550,
	        backgroundColor: considerit_gray,
	        boxShadow: "0 2px 4px rgba(0,0,0,.4)"
	      }
	    }, DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL(null, 'To: ', fetch(this.props.to).name)), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      htmlFor: 'message_subject'
	    }, 'Subject'), AutoGrowTextArea({
	      id: 'message_subject',
	      className: 'message_subject',
	      placeholder: 'Subject line',
	      min_height: 25,
	      style: text_style
	    })), DIV({
	      style: {
	        marginBottom: 8
	      }
	    }, LABEL({
	      htmlFor: 'message_body'
	    }, 'Body'), AutoGrowTextArea({
	      id: 'message_body',
	      className: 'message_body',
	      placeholder: 'Email message',
	      min_height: 75,
	      style: text_style
	    })), Button({}, 'Send', this.submitMessage), BUTTON({
	      style: {
	        marginLeft: 8,
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onClick: ((function(_this) {
	        return function() {
	          _this.props.parent.messaging = null;
	          return save(_this.props.parent);
	        };
	      })(this))
	    }, 'cancel'));
	  },
	  submitMessage: function() {
	    var $el, attrs;
	    $el = $(this.getDOMNode());
	    attrs = {
	      recipient: this.props.to,
	      subject: $el.find('.message_subject').val(),
	      body: $el.find('.message_body').val(),
	      sender_mask: this.props.sender_mask || fetch('/current_user').name,
	      authenticity_token: fetch('/current_user').csrf
	    };
	    return $.ajax('/dashboard/message', {
	      data: attrs,
	      type: 'POST',
	      success: (function(_this) {
	        return function() {
	          _this.props.parent.messaging = null;
	          return save(_this.props.parent);
	        };
	      })(this)
	    });
	  }
	});
	
	window.ModerationDash = ModerationDash;
	
	window.AppSettingsDash = AppSettingsDash;
	
	window.DataDash = DataDash;
	
	window.DashHeader = DashHeader;
	
	window.CustomizationsDash = CustomizationsDash;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var Auth, ensureCurrentUserAvatar;
	
	__webpack_require__(4);
	
	__webpack_require__(7);
	
	__webpack_require__(2);
	
	__webpack_require__(1);
	
	window.logout = function() {
	  var auth, current_user, ref;
	  current_user = fetch('/current_user');
	  current_user.logged_in = false;
	  current_user.trying_to = 'logout';
	  auth = fetch('auth');
	  if (auth.form && ((ref = auth.form) === 'edit profile')) {
	    loadPage('/');
	  }
	  reset_key(auth);
	  return save(current_user, (function(_this) {
	    return function() {
	      return location.reload();
	    };
	  })(this));
	};
	
	window.auth_ghost_gray = '#a1a1a1';
	
	window.auth_text_gray = '#444';
	
	Auth = ReactiveComponent({
	  displayName: 'Auth',
	  render: function() {
	    var auth, current_user;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!this.local.last_auth || this.local.auth !== auth.auth) {
	      this.local.last_auth = auth;
	      current_user.errors = [];
	      this.local.errors = [];
	      save(this.local);
	      return SPAN(null);
	    }
	    if (!auth.form) {
	      return SPAN(null);
	    }
	    return DIV({
	      style: {
	        background: auth.form !== 'edit profile' && !this.props.naked ? customization('background') || focus_color() : void 0
	      }
	    }, auth.form !== 'edit profile' && !this.props.naked ? A({
	      href: 'https://consider.it',
	      target: '_blank',
	      style: {
	        position: 'absolute',
	        left: 10,
	        top: 10
	      }
	    }, drawLogo({
	      height: 35,
	      main_text_color: 'white',
	      o_text_color: 'white',
	      clip: false,
	      draw_line: true,
	      line_color: 'white',
	      transition: true
	    })) : void 0, DIV({
	      style: {
	        margin: "0 auto",
	        padding: !this.props.naked ? '4em 0' : void 0,
	        position: 'relative',
	        zIndex: 0,
	        width: AUTH_WIDTH()
	      }
	    }, this.buildAuthForm()));
	  },
	  buildAuthForm: function() {
	    var auth, current_user, goal, subdomain, verification_sent_message;
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    goal = null;
	    if (auth.goal) {
	      goal = translator("auth.login_goal." + (auth.goal.toLowerCase()), auth.goal);
	    }
	    verification_sent_message = translator('auth.verification_sent', 'We just emailed you a verification code. Copy / paste it below.');
	    switch (auth.form) {
	      case 'login':
	        return [this.headerAndBorder(goal, translator("auth.login.heading", 'Introduce Yourself'), this.body())];
	      case 'create account':
	      case 'create account via invitation':
	        return [this.headerAndBorder(goal, translator('auth.create.heading', 'Create an account'), this.body())];
	      case 'edit profile':
	        return [
	          this.headerAndBorder(goal, translator("auth.update_profile.heading", "Update Your Profile"), this.body()), this.local.saved_successfully ? (subdomain.SSO_domain ? loadPage('/') : void 0, DIV({
	            style: {
	              textAlign: 'center',
	              backgroundColor: 'white',
	              color: '#888'
	            }
	          }, translator("auth.successful_update", "Updated successfully"))) : void 0
	        ];
	      case 'reset password':
	        return [
	          this.headerAndBorder(null, translator("auth.reset_password.heading", 'Reset Your Password'), this.body(verification_sent_message)), DIV({
	            style: {
	              marginTop: 20,
	              color: 'white',
	              textAlign: 'center'
	            }
	          }, TRANSLATE({
	            id: "auth.reset_password.help",
	            link: {
	              component: A,
	              args: {
	                target: '_blank',
	                href: 'https://vimeo.com/198802322',
	                style: {
	                  textDecoration: 'underline',
	                  fontWeight: 600
	                }
	              }
	            }
	          }, 'Having trouble resetting your password? Watch this brief <link>video tutorial</link>.'))
	        ];
	      case 'verify email':
	        return [this.headerAndBorder(goal, translator('auth.verify_email.heading', 'Verify Your Email'), this.body(verification_sent_message))];
	      case 'user questions':
	        return [this.headerAndBorder(goal, translator('auth.more_info.heading', 'Your hosts request more info'), this.body())];
	      default:
	        throw "Unrecognized authentication form " + auth.form;
	    }
	  },
	  headerAndBorder: function(goal, task, body) {
	    var auth, button;
	    auth = fetch('auth');
	    if (auth.form === 'login') {
	      button = translator("auth.log_in", 'Log in');
	    } else {
	      button = translator("auth.submit", 'Submit');
	    }
	    return DIV(null, DIV({
	      style: {
	        width: AUTH_WIDTH(),
	        position: 'relative',
	        margin: 'auto',
	        top: 5
	      }
	    }, DIV({
	      style: {
	        textAlign: 'center',
	        position: 'relative',
	        display: this.props.naked ? 'none' : void 0
	      }
	    }, goal ? DIV({
	      style: {
	        fontWeight: 600,
	        fontSize: 18,
	        transform: 'translateY(6px)',
	        color: 'white'
	      }
	    }, goal) : void 0, H1({
	      style: {
	        display: 'inline-block',
	        position: 'relative',
	        fontWeight: 'bold',
	        fontSize: 48,
	        whiteSpace: 'nowrap',
	        color: auth.form !== 'edit profile' ? 'white' : void 0,
	        marginBottom: 10
	      }
	    }, task))), DIV({
	      className: this.local.submitting ? ' waiting' : '',
	      style: {
	        padding: '2.5em 80px 1.5em 80px',
	        fontSize: 18,
	        boxShadow: auth.form !== 'edit profile' ? '0 2px 4px rgba(0,0,0,.4)' : void 0,
	        backgroundColor: 'white',
	        position: 'relative'
	      }
	    }, body, this.submitButton(button, true)), this.form_footer());
	  },
	  body: function(additional_instructions) {
	    var auth, avatar_field, code_label, code_placeholder, current_user, default_terms, email_field, email_label, error, errors, full_name_placeholder, idx, name_label, password_label, password_placeholder, pic_prompt, pledge, pledges, primary_color, ref, ref1, ref2, render_field, render_host_questions, section_heading_style, subsection_heading_style, terms;
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    primary_color = this.props.primary_color || focus_color();
	    name_label = translator('auth.create.name_label', 'Your name');
	    email_label = translator('auth.login.email_label', 'Your email');
	    password_label = translator('auth.login.password_label', 'Your password');
	    password_placeholder = translator('auth.login.password.placeholder', 'password');
	    pic_prompt = translator('auth.create.pic_prompt', 'Your picture');
	    full_name_placeholder = translator('auth.create.full_name.placeholder', 'first and last name or pseudonym');
	    code_label = translator('auth.code_entry', 'Code');
	    code_placeholder = translator('auth.code_entry.placeholder', 'verification code from email');
	    section_heading_style = {
	      color: '#888',
	      fontSize: 24,
	      display: 'block',
	      fontWeight: 700,
	      fontStyle: 'oblique'
	    };
	    subsection_heading_style = {
	      display: 'block'
	    };
	    render_field = function(label, render, label_style) {
	      var field_id, ref, ref1, ref2;
	      field_id = (render != null ? (ref = render.props) != null ? ref.id : void 0 : void 0) || (render != null ? (ref1 = render[0]) != null ? (ref2 = ref1.props) != null ? ref2.id : void 0 : void 0 : void 0);
	      if (field_id) {
	        field_id = field_id.replace('user_avatar_form', 'user_avatar');
	      }
	      label_style || (label_style = section_heading_style);
	      return DIV({
	        style: {
	          marginBottom: 8
	        }
	      }, LABEL({
	        htmlFor: field_id,
	        style: section_heading_style
	      }, label), render);
	    };
	    render_host_questions = (function(_this) {
	      return function() {
	        var field_id, host_framing, host_questions, label, render;
	        host_questions = _this.userQuestionInputs();
	        if (host_questions.length > 0) {
	          host_framing = customization('host_questions_framing');
	          return DIV({
	            style: {
	              padding: "24px 24px",
	              backgroundColor: "#eee",
	              marginTop: 18
	            }
	          }, H4({
	            style: _.extend({}, section_heading_style, {
	              marginBottom: 18
	            })
	          }, translator('auth.host_questions.heading', 'Questions from the forum host')), host_framing ? DIV({
	            style: {
	              fontSize: 14,
	              marginBottom: 12
	            },
	            dangerouslySetInnerHTML: {
	              __html: host_framing
	            }
	          }) : void 0, UL({
	            style: {
	              padding: "6px 0px",
	              listStyle: 'none'
	            }
	          }, (function() {
	            var i, len, ref, ref1, ref2, ref3, results;
	            results = [];
	            for (i = 0, len = host_questions.length; i < len; i++) {
	              ref = host_questions[i], label = ref[0], render = ref[1];
	              field_id = (render != null ? (ref1 = render.props) != null ? ref1.id : void 0 : void 0) || (render != null ? (ref2 = render[0]) != null ? (ref3 = ref2.props) != null ? ref3.id : void 0 : void 0 : void 0);
	              results.push(LI({
	                style: {
	                  marginBottom: 8
	                }
	              }, LABEL({
	                htmlFor: field_id,
	                style: subsection_heading_style
	              }, label), render));
	            }
	            return results;
	          })()));
	        }
	      };
	    })(this);
	    return DIV(null, additional_instructions ? DIV({
	      style: {
	        color: auth_text_gray,
	        marginBottom: 18
	      }
	    }, additional_instructions) : void 0, (function() {
	      switch (auth.form) {
	        case 'login':
	          return DIV(null, render_field("" + email_label, this.inputBox('email', 'email@address.com', 'email')), render_field("" + password_label, [this.inputBox('password', password_placeholder, 'password'), this.resetPasswordLink()]));
	        case 'create account':
	        case 'create account via invitation':
	          if (avatar_field = this.avatarInput()) {
	            avatar_field = [pic_prompt, avatar_field];
	          }
	          if (auth.form === 'create account') {
	            email_field = [email_label, this.inputBox('email', 'email@address.com', 'email')];
	          } else {
	            email_field = [
	              email_label, DIV({
	                style: {
	                  color: auth_text_gray,
	                  padding: '4px 8px'
	                }
	              }, current_user.email)
	            ];
	          }
	          pledges = this.getPledges();
	          return DIV(null, render_field(email_field[0], email_field[1]), render_field(password_label, this.inputBox('password', password_label, 'password')), render_field(name_label, this.inputBox('name', full_name_placeholder)), render_field(avatar_field[0], avatar_field[1]), render_host_questions(), pledges.length > 0 ? DIV({
	            style: {
	              marginTop: 18,
	              padding: "24px 24px",
	              backgroundColor: "#eee"
	            }
	          }, H4({
	            style: _.extend({}, section_heading_style, {
	              marginBottom: 18
	            })
	          }, translator('auth.create.pledge_heading', 'Participation Pledge')), UL({
	            style: {
	              padding: "6px 0px",
	              listStyle: 'none'
	            }
	          }, (function() {
	            var i, len, results;
	            results = [];
	            for (idx = i = 0, len = pledges.length; i < len; idx = ++i) {
	              pledge = pledges[idx];
	              results.push(LI({
	                style: {
	                  marginBottom: 8
	                }
	              }, INPUT({
	                className: "pledge-input",
	                type: 'checkbox',
	                id: "pledge-" + idx,
	                name: "pledge-" + idx,
	                style: {
	                  fontSize: 24,
	                  verticalAlign: 'top',
	                  marginLeft: 0
	                }
	              }), LABEL({
	                style: {
	                  display: 'inline-block',
	                  width: '90%',
	                  paddingLeft: 8
	                },
	                htmlFor: "pledge-" + idx,
	                dangerouslySetInnerHTML: {
	                  __html: pledge
	                }
	              })));
	            }
	            return results;
	          })())) : void 0);
	        case 'edit profile':
	          avatar_field = this.avatarInput();
	          if (avatar_field) {
	            avatar_field = [pic_prompt, avatar_field];
	          }
	          return DIV(null, !fetch('/subdomain').SSO_domain ? render_field(email_label, this.inputBox('email', 'email@address.com', 'email')) : void 0, !fetch('/subdomain').SSO_domain ? render_field(password_label, this.inputBox('password', password_label, 'password')) : void 0, render_field(name_label, this.inputBox('name', full_name_placeholder)), render_field(avatar_field[0], avatar_field[1]), render_host_questions());
	        case 'reset password':
	          return DIV(null, render_field('', INPUT({
	            name: 'user[verification_code]',
	            disabled: true,
	            style: {
	              display: 'none'
	            }
	          })), render_field('', INPUT({
	            type: 'password',
	            name: 'user[password]',
	            disabled: true,
	            style: {
	              display: 'none'
	            }
	          })), render_field(code_label + ":", this.inputBox('verification_code', code_placeholder)), render_field((translator('auth.reset_password.new_pass', 'New password')) + ":", this.inputBox('password', translator('auth.reset_password.new_pass.placeholder', "choose a new password"), 'password')));
	        case 'verify email':
	          return render_field(code_label + ":", this.inputBox('verification_code', code_placeholder));
	        case 'user questions':
	          return render_host_questions();
	        default:
	          throw "Unrecognized authentication form " + auth.form;
	      }
	    }).call(this), ((ref = auth.form) === 'create account' || ref === 'create account via invitation') || (((ref1 = auth.form) === 'user questions' || ref1 === 'edit profile') && !this.local.agreed_to_terms) ? (this.local.agreed_to_terms == null ? (this.local.agreed_to_terms = !!current_user.tags['considerit_terms.editable'], save(this.local)) : void 0, default_terms = TRANSLATE({
	      id: 'auth.create.agree_to_terms',
	      as_html: true,
	      privacy_link: {
	        component: "a",
	        args: "href='/privacy_policy' style='text-decoration: underline'"
	      },
	      terms_link: {
	        component: "a",
	        args: "href='/terms_of_service' style='text-decoration: underline'"
	      }
	    }, "I agree to the Consider.it <privacy_link>Privacy Policy</privacy_link> and <terms_link>Terms</terms_link>."), terms = customization('terms') || default_terms.join(''), DIV({
	      style: {
	        marginTop: 24
	      }
	    }, INPUT({
	      id: slugify("considerit_terms.editableinputBox"),
	      key: "considerit_terms.editable_inputBox",
	      type: 'checkbox',
	      style: {
	        fontSize: 24,
	        verticalAlign: 'top'
	      },
	      checked: this.local.tags['considerit_terms.editable'],
	      onChange: (function(_this) {
	        return function(event) {
	          _this.local.tags = _this.local.tags || {};
	          _this.local.tags['considerit_terms.editable'] = _this.local.agreed_to_terms = event.target.checked;
	          return save(_this.local);
	        };
	      })(this)
	    }), LABEL({
	      htmlFor: slugify("considerit_terms.editableinputBox"),
	      style: {
	        fontSize: 18,
	        paddingLeft: 8
	      },
	      dangerouslySetInnerHTML: {
	        __html: terms
	      }
	    }))) : void 0, customization('auth_footer') ? (auth = fetch('auth'), auth.ask_questions && ((ref2 = auth.form) === 'create account' || ref2 === 'create account via invitation' || ref2 === 'user questions') ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('auth_footer')
	      }
	    }) : void 0) : void 0, customization('login_footer') ? (auth = fetch('auth'), auth.form === 'login' ? DIV({
	      style: {
	        fontSize: 13,
	        color: auth_text_gray,
	        padding: '16px 0'
	      },
	      dangerouslySetInnerHTML: {
	        __html: customization('login_footer')
	      }
	    }) : void 0) : void 0, (current_user.errors || []).length > 0 || this.local.errors.length > 0 ? (errors = current_user.errors.concat(this.local.errors || []), DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = errors.length; i < len; i++) {
	        error = errors[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    })())) : void 0);
	  },
	  form_footer: function() {
	    var auth, cancel_auth, ref, ref1, toggle, toggle_to;
	    auth = fetch('auth');
	    if (auth.form === 'create account') {
	      toggle_to = translator("auth.log_in", 'Log in');
	    } else {
	      toggle_to = translator("auth.login.toggle_to_create", 'Create an account');
	    }
	    toggle = (function(_this) {
	      return function(e) {
	        var current_user;
	        current_user = fetch('/current_user');
	        auth.form = auth.form === 'create account' ? 'login' : 'create account';
	        current_user.errors = [];
	        _this.local.errors = [];
	        save(auth);
	        save(_this.local);
	        return setTimeout(function() {
	          return $('#user_email')[0].focus();
	        }, 0);
	      };
	    })(this);
	    return DIV({
	      style: {
	        textAlign: 'center'
	      }
	    }, (ref = auth.form) === 'create account' || ref === 'login' ? DIV({
	      style: {
	        marginTop: 23,
	        width: '100%'
	      }
	    }, SPAN({
	      style: {
	        color: 'white',
	        fontWeight: 300,
	        fontSize: 24
	      }
	    }, auth.form === 'create account' ? TRANSLATE('auth.create.should_you_be_here', 'Already have an account?') : TRANSLATE('auth.login.should_you_be_here', 'Not registered?')), " ", BUTTON({
	      className: 'toggle_auth',
	      style: {
	        display: 'inline-block',
	        color: 'white',
	        textDecoration: 'underline',
	        fontWeight: 600,
	        fontSize: 24,
	        backgroundColor: 'transparent',
	        border: 'none',
	        padding: 0
	      },
	      onClick: toggle,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            toggle(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, toggle_to)) : void 0, ((ref1 = auth.form) !== 'edit profile') && !this.props.disable_cancel && (location.pathname !== '/' || auth.goal !== "access this private forum") ? (cancel_auth = (function(_this) {
	      return function(e) {
	        if (auth.form === 'verify email' || location.pathname === '/proposal/new') {
	          loadPage('/');
	        }
	        if (auth.form === 'verify email') {
	          setTimeout(logout, 1);
	        }
	        return reset_key(auth);
	      };
	    })(this), BUTTON({
	      style: {
	        color: 'white',
	        position: 'absolute',
	        cursor: 'pointer',
	        right: -100,
	        top: 40,
	        padding: 10,
	        fontSize: 24,
	        backgroundColor: 'transparent',
	        border: 'none',
	        opacity: .7
	      },
	      title: translator('engage.cancel_button', 'cancel'),
	      onClick: cancel_auth,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            cancel_auth(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, translator('engage.cancel_button', 'cancel'))) : void 0);
	  },
	  submitButton: function(action) {
	    var primary_color;
	    primary_color = this.props.primary_color || '#676767';
	    return BUTTON({
	      style: {
	        fontSize: 36,
	        display: 'block',
	        width: '100%',
	        fontWeight: 700,
	        backgroundColor: primary_color,
	        textAlign: 'center',
	        borderRadius: 8,
	        boxShadow: '0 2px 4px rgba(0,0,0,.2)',
	        marginTop: 20
	      },
	      className: 'primary_button' + (this.local.submitting ? ' disabled' : ''),
	      onClick: this.submitAuth,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            _this.submitAuth(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, action);
	  },
	  inputBox: function(name, placeholder, type, onChange, pattern) {
	    var auth, current_user, ref;
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!onChange) {
	      onChange = (function(_this) {
	        return function(event) {
	          if (type === 'email') {
	            _this.local[name] = current_user[name] = event.target.value.trim();
	          } else {
	            _this.local[name] = current_user[name] = event.target.value;
	          }
	          return save(_this.local);
	        };
	      })(this);
	    }
	    if (this.local[name] !== current_user[name]) {
	      this.local[name] = current_user[name];
	      save(this.local);
	      return SPAN(null);
	    }
	    return INPUT({
	      id: 'user_' + name,
	      className: 'auth_text_input',
	      style: {
	        marginBottom: 6,
	        width: '100%',
	        border: "1px solid #ccc",
	        padding: '10px 14px',
	        fontSize: browser.is_mobile ? 36 : 20,
	        display: 'inline-block',
	        backgroundColor: '#f2f2f2'
	      },
	      value: (ref = auth.form) === 'edit profile' ? this.local[name] : null,
	      name: "user[" + name + "]",
	      key: name + "_inputBox",
	      'aria-label': name === 'password' ? placeholder : void 0,
	      required: "required",
	      type: type || 'text',
	      onChange: onChange,
	      onKeyPress: (function(_this) {
	        return function(event) {
	          if (event.which === 13) {
	            return _this.submitAuth(event);
	          }
	        };
	      })(this),
	      pattern: pattern,
	      autoComplete: name === 'verification_code' ? 'off' : void 0
	    });
	  },
	  avatarInput: function() {
	    var base, current_user, user;
	    if (window.FormData) {
	      current_user = fetch('/current_user');
	      user = fetch(fetch('/current_user').user);
	      if ((base = this.local).preview == null) {
	        base.preview = user.avatar_file_name || current_user.b64_thumbnail || current_user.avatar_remote_url;
	      }
	      return FORM({
	        id: 'user_avatar_form',
	        action: '/update_user_avatar_hack'
	      }, HEARTBEAT({
	        public_key: 'preview_refresher'
	      }), DIV({
	        style: {
	          height: 60,
	          width: 60,
	          borderRadius: '50%',
	          backgroundColor: '#e6e6e6',
	          overflow: 'hidden',
	          display: 'inline-block',
	          marginRight: 18,
	          marginTop: 3
	        }
	      }, IMG({
	        key: fetch('preview_refresher').beat,
	        alt: '',
	        id: 'avatar_preview',
	        style: {
	          width: 60,
	          display: !this.local.preview ? 'none' : void 0
	        },
	        src: this.local.newly_uploaded ? this.local.newly_uploaded : user.avatar_file_name ? avatarUrl(user, 'large') : current_user.b64_thumbnail ? current_user.b64_thumbnail : current_user.avatar_remote_url ? current_user.avatar_remote_url : null
	      }), !this.local.preview ? SVG({
	        width: 60,
	        viewBox: "0 0 100 100",
	        style: {
	          position: 'relative',
	          top: 8
	        }
	      }, PATH({
	        fill: "#ccc",
	        d: "M64.134,50.642c-0.938-0.75-1.93-1.43-2.977-2.023c8.734-6.078,10.867-18.086,4.797-26.805  c-6.086-8.727-18.086-10.875-26.82-4.797c-8.719,6.086-10.867,18.086-4.781,26.812c1.297,1.867,2.922,3.484,4.781,4.789  c-1.039,0.594-2.039,1.273-2.977,2.023c-6.242,5.031-11.352,11.312-15.023,18.438c-0.906,1.75-1.75,3.539-2.555,5.344  c17.883,16.328,45.266,16.328,63.133,0c-0.789-1.805-1.641-3.594-2.547-5.344C75.509,61.954,70.384,55.673,64.134,50.642z"
	      })) : void 0), INPUT({
	        id: 'user_avatar',
	        name: "avatar",
	        type: "file",
	        style: {
	          marginTop: 24,
	          verticalAlign: 'top'
	        },
	        onChange: (function(_this) {
	          return function(ev) {
	            var input, reader;
	            _this.submit_avatar_form = true;
	            input = $('#user_avatar')[0];
	            if (input.files && input.files[0]) {
	              reader = new FileReader();
	              reader.onload = function(e) {
	                _this.local.preview = true;
	                _this.local.newly_uploaded = e.target.result;
	                save(_this.local);
	                return $("#avatar_preview").attr('src', e.target.result);
	              };
	              return reader.readAsDataURL(input.files[0]);
	            } else {
	              return $("#avatar_preview").attr('src', asset('no_image_preview.png'));
	            }
	          };
	        })(this)
	      }));
	    } else {
	      return null;
	    }
	  },
	  getPledges: function() {
	    if (!customization('auth_require_pledge')) {
	      return [];
	    } else if (customization('pledge')) {
	      return customization('pledge');
	    } else {
	      return [translator('auth.create.pledge.one_account', 'I will use only one account'), translator('auth.create.pledge.no_attacks', 'I will not attack or mock others')];
	    }
	  },
	  resetPasswordLink: function() {
	    var reset;
	    reset = (function(_this) {
	      return function(e) {
	        var current_user;
	        current_user = fetch('/current_user');
	        current_user.trying_to = 'send_password_reset_token';
	        return save(current_user, function() {
	          var ref;
	          if (((ref = current_user.errors) != null ? ref.length : void 0) > 0) {
	            return arest.updateCache(current_user);
	          } else {
	            return reset_key('auth', {
	              form: 'reset password'
	            });
	          }
	        });
	      };
	    })(this);
	    return DIV({
	      style: {
	        textAlign: 'right',
	        width: '100%'
	      }
	    }, BUTTON({
	      style: {
	        textDecoration: 'underline',
	        color: '#737373',
	        backgroundColor: 'transparent',
	        border: 'none',
	        fontSize: 12,
	        padding: 0,
	        fontWeight: 300,
	        position: 'relative',
	        top: -8
	      },
	      onClick: reset,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            reset(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, translator('auth.forgot_password.link', 'Help! I forgot my password')));
	  },
	  userQuestionInputs: function() {
	    var auth, current_user, i, input, inputs, key, label, len, op, option, question, questions, ref, ref1, subdomain, value;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    auth = fetch('auth');
	    if (!current_user.tags) {
	      return DIV();
	    }
	    if (auth.ask_questions && ((ref = auth.form) === 'edit profile' || ref === 'create account' || ref === 'create account via invitation' || ref === 'user questions')) {
	      questions = customization('auth_questions').slice();
	    } else {
	      questions = [];
	    }
	    if (this.local.tags !== current_user.tags) {
	      this.local.tags = current_user.tags;
	      save(this.local);
	      return SPAN(null);
	    }
	    inputs = [];
	    for (i = 0, len = questions.length; i < len; i++) {
	      question = questions[i];
	      label = "" + question.question;
	      switch (question.input) {
	        case 'text':
	          input = INPUT({
	            style: _.defaults(question.input_style || {}, {
	              marginBottom: 6,
	              width: 300,
	              border: "1px solid " + auth_ghost_gray,
	              padding: '5px 10px',
	              fontSize: 18
	            }),
	            key: question.tag + "_inputBox",
	            id: slugify(question.tag + "inputBox"),
	            type: 'text',
	            value: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question),
	            onKeyPress: (function(_this) {
	              return function(event) {
	                if (event.which === 13) {
	                  return _this.submitAuth(event);
	                }
	              };
	            })(this)
	          });
	          break;
	        case 'boolean':
	          input = DIV({
	            style: {
	              marginBottom: 10
	            }
	          }, INPUT({
	            id: slugify(question.tag + "inputBox"),
	            key: question.tag + "_inputBox",
	            type: 'checkbox',
	            style: {
	              fontSize: 24,
	              verticalAlign: 'top',
	              marginLeft: 0
	            },
	            checked: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.checked;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question)
	          }), LABEL({
	            htmlFor: slugify(question.tag + "inputBox"),
	            style: {
	              display: 'inline-block',
	              width: '90%',
	              paddingLeft: 8
	            },
	            dangerouslySetInnerHTML: {
	              __html: question.question
	            }
	          }));
	          label = '';
	          break;
	        case 'checklist':
	          input = DIV({
	            style: {
	              marginBottom: 10
	            }
	          }, (function() {
	            var j, len1, ref1, results;
	            ref1 = question.options;
	            results = [];
	            for (j = 0, len1 = ref1.length; j < len1; j++) {
	              option = ref1[j];
	              key = (question.tag.substring(0, question.tag.length - '.editable'.length)) + ":" + option + " .editable";
	              results.push(DIV(null, INPUT({
	                id: slugify(key + "-inputBox"),
	                key: key + "_inputBox",
	                type: 'checkbox',
	                style: {
	                  fontSize: 24,
	                  verticalAlign: 'top',
	                  marginLeft: 0
	                },
	                checked: this.local.tags[key],
	                onChange: (function(_this) {
	                  return function(question, option, key) {
	                    return function(event) {
	                      _this.local.tags = _this.local.tags || {};
	                      _this.local.tags[key] = current_user.tags[key] = event.target.checked;
	                      return save(_this.local);
	                    };
	                  };
	                })(this)(question, option, key)
	              }), LABEL({
	                htmlFor: slugify(key + "-inputBox"),
	                style: {
	                  display: 'inline-block',
	                  width: '90%',
	                  paddingLeft: 8
	                },
	                dangerouslySetInnerHTML: {
	                  __html: option
	                }
	              })));
	            }
	            return results;
	          }).call(this));
	          break;
	        case 'dropdown':
	          input = SELECT({
	            id: slugify(question.tag + "inputBox"),
	            key: question.tag + "_inputBox",
	            style: _.defaults(question.input_style || {}, {
	              fontSize: 18,
	              marginTop: 4,
	              maxWidth: '100%'
	            }),
	            value: this.local.tags[question.tag],
	            onChange: (function(_this) {
	              return function(question) {
	                return function(event) {
	                  _this.local.tags = _this.local.tags || {};
	                  _this.local.tags[question.tag] = current_user.tags[question.tag] = event.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(question)
	          }, [
	            OPTION({
	              value: '',
	              selected: true,
	              disabled: true,
	              hidden: true
	            }), (function() {
	              var j, len1, ref1, results;
	              ref1 = question.options;
	              results = [];
	              for (j = 0, len1 = ref1.length; j < len1; j++) {
	                value = ref1[j];
	                results.push(OPTION({
	                  value: value
	                }, value));
	              }
	              return results;
	            })()
	          ]);
	          break;
	        default:
	          throw "Unsupported question type: " + question.input + " for " + question.tag;
	      }
	      if (!question.required && ((ref1 = question.input) !== 'boolean' && ref1 !== 'checklist')) {
	        op = DIV({
	          style: {
	            color: '#888',
	            fontSize: 12
	          }
	        }, translator('optional'));
	        label = [op, label];
	      }
	      inputs.push([label, input]);
	    }
	    return inputs;
	  },
	  submitAuth: function(ev) {
	    var $el, auth, current_user, has_response, i, is_valid_input, len, question, questions, ref, ref1, ref2, subdomain;
	    ev.preventDefault();
	    $el = $(this.getDOMNode());
	    subdomain = fetch('/subdomain');
	    auth = fetch('auth');
	    current_user = fetch('/current_user');
	    this.local.errors = [];
	    if (auth.ask_questions && ((ref = auth.form) !== 'login' && ref !== 'reset password' && ref !== 'verify email')) {
	      questions = customization('auth_questions');
	      for (i = 0, len = questions.length; i < len; i++) {
	        question = questions[i];
	        if (question.required) {
	          has_response = ((ref1 = question.input) === 'boolean' || ref1 === 'checklist') || !!current_user.tags[question.tag];
	          if (!has_response || (question.require_checked && !current_user.tags[question.tag])) {
	            this.local.errors.push(translator({
	              id: 'auth.validation.missing_answer',
	              question: question.question
	            }, "{question} required!"));
	          }
	          is_valid_input = true;
	          if (question.validation) {
	            is_valid_input = question.validation(current_user.tags[question.tag]);
	          }
	          if (!is_valid_input && has_response) {
	            this.local.errors.push(translator({
	              id: 'auth.validation.invalid_answer',
	              response: current_user.tags[question.tag],
	              question: question.question
	            }, "{response} isn't a valid answer to " + question + "!"));
	          }
	        }
	      }
	      save(this.local);
	    }
	    if (auth.ask_questions && ((ref2 = auth.form) !== 'login' && ref2 !== 'reset password' && ref2 !== 'verify email') && !this.local.agreed_to_terms) {
	      this.local.errors.push(translator('auth.validation.agree_to_terms', "To proceed, you must agree to the terms"));
	    }
	    if (this.local.errors.length === 0) {
	      this.local.submitting = true;
	      save(this.local);
	      current_user.signed_pledge = $el.find('.pledge-input').length === $el.find('.pledge-input:checked').length;
	      current_user.trying_to = auth.form;
	      save(current_user, (function(_this) {
	        return function() {
	          var ref3, ref4;
	          if ((ref3 = auth.form) === 'create account' || ref3 === 'edit profile') {
	            ensureCurrentUserAvatar();
	          }
	          if ((ref4 = auth.form) === 'edit profile') {
	            _this.local.saved_successfully = current_user.errors.length + _this.local.errors.length === 0;
	          } else if (current_user.logged_in) {
	            if (auth.goal === 'Save your Opinion') {
	              setTimeout((function() {
	                return updateProposalMode('results', 'after_save');
	              }), 700);
	            }
	            reset_key(auth);
	          }
	          _this.local.submitting = false;
	          return save(_this.local);
	        };
	      })(this));
	      if (this.submit_avatar_form) {
	        return $('#user_avatar_form').ajaxSubmit({
	          type: 'PUT',
	          data: {
	            authenticity_token: current_user.csrf,
	            trying_to: 'update_avatar_hack'
	          }
	        });
	      }
	    } else {
	      return save(this.local);
	    }
	  },
	  componentDidMount: function() {
	    return writeToLog({
	      what: 'accessed authentication'
	    });
	  }
	});
	
	ensureCurrentUserAvatar = function(attempts) {
	  if (attempts == null) {
	    attempts = 0;
	  }
	  return $.getJSON('/user_avatar_hack', (function(_this) {
	    return function(response) {
	      var current_user, ref;
	      current_user = fetch('/current_user');
	      if ((response != null ? (ref = response[0]) != null ? ref.b64_thumbnail : void 0 : void 0) && current_user.b64_thumbnail !== response[0].b64_thumbnail) {
	        $('head').append("<style type=\"text/css\">#avatar-" + current_user.id + " { background-image: url('" + response[0].b64_thumbnail + "');}</style>");
	        current_user.b64_thumbnail = response[0].b64_thumbnail;
	        return save(current_user);
	      } else if (attempts < 20) {
	        return _.delay(function() {
	          return ensureCurrentUserAvatar(attempts + 1);
	        }, 1000);
	      }
	    };
	  })(this));
	};
	
	styles += "\n.auth_text_input::-webkit-input-placeholder{\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input:-moz-placeholder{\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input::-moz-placeholder {\n  color: " + auth_ghost_gray + ";\n} \n.auth_text_input::-ms-input-placeholder {\n  color: " + auth_ghost_gray + ";\n}";
	
	window.Auth = Auth;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var Development;
	
	__webpack_require__(1);
	
	Development = ReactiveComponent({
	  displayName: 'Development',
	  render: function() {
	    var hues, idx, s, sub, subdomains;
	    if (!this.local.search) {
	      this.local.search = '';
	    }
	    if (this.local.only_with_activity == null) {
	      this.local.only_with_activity = true;
	    }
	    subdomains = fetch('/subdomains').subs;
	    if (this.is_waiting()) {
	      return SPAN(null);
	    }
	    subdomains = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = subdomains.length; i < len; i++) {
	        s = subdomains[i];
	        if ((!this.local.only_with_activity || s.activity) && (!this.local.highlight_customized || s.customizations)) {
	          results.push(s);
	        }
	      }
	      return results;
	    }).call(this);
	    hues = getNiceRandomHues(subdomains.length);
	    subdomains.sort(function(a, b) {
	      if (a.name.toLowerCase() > b.name.toLowerCase()) {
	        return 1;
	      } else {
	        return -1;
	      }
	    });
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        left: 0,
	        top: 0,
	        opacity: this.local.hover_top ? 1 : 0,
	        backgroundColor: 'black',
	        color: 'white',
	        padding: 15
	      },
	      tabIndex: 0,
	      onTouchEnd: (function(_this) {
	        return function(e) {
	          _this.local.hover_top = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseEnter: (function(_this) {
	        return function(e) {
	          _this.getDOMNode().focus();
	          _this.local.hover_top = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function(e) {
	          _this.local.search = '';
	          _this.local.hover_top = _this.local.hover_second = false;
	          return save(_this.local);
	        };
	      })(this),
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 27) {
	            _this.local.search = '';
	            _this.local.hover_top = _this.local.hover_second = false;
	            save(_this.local);
	          } else if (e.which === 8 || e.which === 46) {
	            _this.local.search = _this.local.search.substring(0, _this.local.search.length - 1);
	          } else if (e.which === 9) {
	            _this.local.only_with_activity = !_this.local.only_with_activity;
	          } else if (e.which === 32) {
	            _this.local.highlight_customized = !_this.local.highlight_customized;
	          } else if (e.key.length === 1 && /[a-zA-Z0-9-_ ]/.test(e.key)) {
	            _this.local.search += e.key;
	          }
	          save(_this.local);
	          return e.preventDefault();
	        };
	      })(this)
	    }, this.local.hover_top ? DIV(null, UL({
	      style: {
	        listStyle: 'none',
	        display: 'inline-block'
	      }
	    }, LI({
	      style: {
	        paddingLeft: 20,
	        backgroundColor: 'black',
	        color: 'white',
	        display: 'inline-block'
	      }
	    }, this.local.search)), DIV({
	      style: {
	        width: '100%'
	      }
	    }, UL(null, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = subdomains.length; i < len; idx = ++i) {
	        sub = subdomains[idx];
	        results.push(LI({
	          style: {
	            display: 'inline-block',
	            listStyle: 'none'
	          }
	        }, A({
	          href: "/change_subdomain/" + sub.id,
	          'data-nojax': false,
	          style: {
	            padding: "4px 8px",
	            fontSize: 18,
	            backgroundColor: hsv2rgb(hues[idx], .7, .5),
	            color: 'white',
	            display: 'inline-block',
	            opacity: this.local.search.length > 0 && sub.name.toLowerCase().indexOf(this.local.search.toLowerCase()) === -1 ? .3 : void 0
	          }
	        }, sub.name)));
	      }
	      return results;
	    }).call(this)))) : void 0);
	  },
	  componentDidMount: function() {
	    return document.addEventListener("keypress", function(e) {
	      var cur_idx, i, idx, key, len, next_idx, ref, sub, subdomain, subdomains;
	      key = (e && e.keyCode) || e.keyCode;
	      if (key === 14) {
	        subdomains = fetch('/subdomains');
	        subdomain = fetch('/subdomain');
	        cur_idx = -1;
	        ref = subdomains.subs;
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          sub = ref[idx];
	          if (sub.id === subdomain.id) {
	            cur_idx = idx;
	          }
	        }
	        next_idx = cur_idx + 1;
	        if (next_idx >= subdomains.subs.length) {
	          next_idx = 0;
	        }
	        return window.location = "/change_subdomain/" + subdomains.subs[next_idx].id;
	      }
	    });
	  }
	});
	
	window.Development = Development;


/***/ },
/* 34 */
/***/ function(module, exports) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	window.EditComment = ReactiveComponent({
	  displayName: 'EditComment',
	  render: function() {
	    var error, permitted, ref;
	    permitted = permit('create comment', this.proposal);
	    return DIV({
	      className: 'comment_entry',
	      onKeyDown: function(e) {
	        if (e.which === 32 || e.which === 13) {
	          return e.stopPropagation();
	        }
	      }
	    }, DIV({
	      style: {
	        fontWeight: 'bold',
	        color: '#666'
	      }
	    }, (fetch('/current_user').name || 'You') + ':'), Avatar({
	      style: {
	        position: 'absolute',
	        width: 50,
	        height: 50,
	        backgroundColor: permitted < 0 ? 'transparent' : void 0,
	        border: permitted < 0 ? '1px dashed grey' : void 0
	      },
	      key: fetch('/current_user').user,
	      hide_tooltip: true
	    }), permitted === Permission.DISABLED ? SPAN({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px'
	      }
	    }, translator('engage.comment_period_closed', 'Comments closed')) : permitted === Permission.INSUFFICIENT_PRIVILEGES ? SPAN({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px'
	      }
	    }, translator('engage.permissions.no_comment', 'Sorry, you do not have permission to comment')) : permitted < 0 ? A({
	      style: {
	        position: 'absolute',
	        margin: '14px 0 0 70px',
	        cursor: 'pointer',
	        zIndex: 1
	      },
	      onTouchEnd: (function(_this) {
	        return function(e) {
	          return e.stopPropagation();
	        };
	      })(this),
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          if (permitted === Permission.NOT_LOGGED_IN) {
	            return reset_key('auth', {
	              form: 'login',
	              goal: 'Write a comment'
	            });
	          } else if (permitted === Permission.UNVERIFIED_EMAIL) {
	            reset_key('auth', {
	              form: 'verify email',
	              goal: 'Write a comment'
	            });
	            current_user.trying_to = 'send_verification_token';
	            return save(current_user);
	          }
	        };
	      })(this)
	    }, permitted === Permission.NOT_LOGGED_IN ? DIV(null, BUTTON({
	      style: {
	        textDecoration: 'underline',
	        color: focus_color(),
	        fontSize: browser.is_mobile ? 18 : void 0,
	        backgroundColor: 'transparent',
	        padding: 0,
	        border: 'none'
	      }
	    }, translator('engage.permissions.login_to_comment', 'Log in to write a comment')), indexOf.call(this.proposal.roles.commenter, '*') < 0 ? DIV({
	      style: {
	        fontSize: 11
	      }
	    }, 'Only some email addresses are authorized to comment.') : void 0) : permitted === Permission.UNVERIFIED_EMAIL ? DIV(null, translator('engage.permissions.verify_account_to_comment', "Verify your account to write a comment")) : void 0) : void 0, DIV({
	      style: {
	        marginLeft: 60
	      }
	    }, AutoGrowTextArea({
	      ref: 'comment_input',
	      name: 'new comment',
	      'aria-label': permitted > 0 ? translator('engage.comment_input_placeholder', 'Write a comment') : '',
	      placeholder: permitted > 0 ? translator('engage.comment_input_placeholder', 'Write a comment') : '',
	      disabled: permitted < 0,
	      onChange: (function(_this) {
	        return function(e) {
	          _this.local.new_comment = e.target.value;
	          return save(_this.local);
	        };
	      })(this),
	      defaultValue: this.props.fresh ? null : this.data().body,
	      min_height: 80,
	      style: {
	        width: '100%',
	        lineHeight: 1.4,
	        fontSize: PORTRAIT_MOBILE() ? 50 : LANDSCAPE_MOBILE() ? 30 : 16,
	        border: permitted < 0 ? 'dashed 1px' : void 0
	      }
	    })), ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10,
	        marginBottom: 10,
	        marginLeft: 60
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.errors;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        error = ref1[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, permitted > 0 ? Button({
	      style: {
	        marginLeft: 60,
	        padding: '8px 16px',
	        fontSize: browser.is_mobile ? 24 : void 0
	      },
	      'data-action': 'save-comment'
	    }, translator("engage.save_comment_button", 'Save comment'), (function(_this) {
	      return function(e) {
	        var comment;
	        e.stopPropagation();
	        if (_this.props.fresh) {
	          comment = {
	            key: '/new/comment',
	            body: _this.local.new_comment,
	            user: fetch('/current_user').user,
	            point: "/point/" + _this.props.point
	          };
	        } else {
	          comment = _this.data();
	          comment.body = _this.local.new_comment;
	          comment.editing = false;
	        }
	        if (!comment.body || comment.body.length === 0) {
	          _this.local.errors = ["Comment can't be empty"];
	          return save(_this.local);
	        } else {
	          return save(comment, function() {
	            var ref1;
	            if (((ref1 = comment.errors) != null ? ref1.length : void 0) > 0) {
	              _this.local.errors = comment.errors;
	            }
	            $(_this.refs.comment_input.getDOMNode()).val('');
	            _this.local.new_comment = null;
	            return save(_this.local);
	          });
	        }
	      };
	    })(this)) : void 0);
	  }
	});


/***/ },
/* 35 */
/***/ function(module, exports) {

	window.EditPoint = ReactiveComponent({
	  displayName: 'EditPoint',
	  render: function() {
	    var error, mobile, parent, parent_offset, ref, style, textarea_style;
	    this.local = this.data(this.local_key, {
	      sign_name: this.props.fresh ? true : !this.data().hide_name,
	      add_details: false
	    });
	    mobile = browser.is_mobile;
	    if (mobile) {
	      textarea_style = {
	        width: '100%',
	        overflow: 'hidden',
	        fontSize: PORTRAIT_MOBILE() ? 50 : 30,
	        padding: '4px 6px'
	      };
	      parent = $("#proposal-" + this.proposal.id);
	      parent_offset = parent.length > 0 ? parent.offset().top : 0;
	      style = {
	        position: 'absolute',
	        top: 0,
	        left: 50,
	        height: '100%',
	        width: WINDOW_WIDTH() - 100,
	        backgroundColor: 'rgba(255,255,255,.85)',
	        fontSize: 20,
	        zIndex: 99999999,
	        padding: (this.scrollY - parent_offset) + "px 50px 100px 50px"
	      };
	    } else {
	      textarea_style = {
	        width: mobile ? '75%' : '100%',
	        overflow: 'hidden',
	        fontSize: mobile ? 30 : 14,
	        padding: '4px 6px'
	      };
	      style = {
	        position: 'relative',
	        fontSize: 14,
	        zIndex: 1,
	        marginTop: TWO_COL() ? 40 : void 0,
	        marginBottom: 15
	      };
	    }
	    return DIV({
	      className: 'edit_point',
	      style: style,
	      'aria-describedby': 'tips_for_new_point'
	    }, DIV({
	      style: {
	        position: 'relative'
	      }
	    }, this.drawTips(), CharacterCountTextInput({
	      id: 'nutshell',
	      maxLength: 180,
	      name: 'nutshell',
	      pattern: '^.{3,}',
	      'aria-label': translator('engage.point_summary_placeholder', 'A succinct summary of your point.'),
	      placeholder: translator('engage.point_summary_placeholder', 'A succinct summary of your point.'),
	      required: 'required',
	      defaultValue: this.props.fresh ? null : this.data().nutshell,
	      style: _.extend({}, textarea_style, {
	        minHeight: 75
	      }),
	      count_style: {
	        position: 'absolute',
	        right: 0,
	        top: -21
	      }
	    }), INPUT({
	      id: 'is_pro',
	      name: 'is_pro',
	      type: 'hidden',
	      value: "" + (this.props.valence === 'pros')
	    })), DIV(null, AutoGrowTextArea({
	      id: 'text',
	      name: 'fulltext',
	      'aria-label': translator('engage.point_description_placeholder', 'Add background or evidence.'),
	      placeholder: translator('engage.point_description_placeholder', 'Add background or evidence.'),
	      min_height: PORTRAIT_MOBILE() ? 150 : 80,
	      defaultValue: this.props.fresh ? null : this.data().text,
	      style: textarea_style,
	      onHeightChange: (function(_this) {
	        return function() {
	          var s;
	          s = fetch('reasons_height_adjustment');
	          s.edit_point_height = $(_this.getDOMNode()).height();
	          return save(s);
	        };
	      })(this)
	    })), ((ref = this.local.errors) != null ? ref.length : void 0) > 0 ? DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var i, len, ref1, results;
	      ref1 = this.local.errors;
	      results = [];
	      for (i = 0, len = ref1.length; i < len; i++) {
	        error = ref1[i];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      style: {
	        marginTop: 3,
	        marginBottom: '.5em'
	      }
	    }, !this.proposal.active ? DIV({
	      style: {
	        color: '#777',
	        fontSize: 12
	      }
	    }, translator('engage.no_new_points', 'New points disabled for this proposal')) : BUTTON({
	      className: 'primary_button',
	      'data-action': 'submit-point',
	      onClick: this.savePoint,
	      style: {
	        marginTop: 0,
	        display: 'inline-block',
	        fontSize: PORTRAIT_MOBILE() ? 50 : LANDSCAPE_MOBILE() ? 36 : 24,
	        padding: '4px 25px',
	        float: 'left',
	        backgroundColor: focus_color()
	      }
	    }, translator('engage.done_button', 'Done')), BUTTON({
	      onTouchEnd: this.done,
	      onClick: this.done,
	      style: {
	        display: 'inline-block',
	        color: '#888888',
	        cursor: 'pointer',
	        zIndex: 1,
	        top: mobile ? 0 : 12,
	        fontSize: PORTRAIT_MOBILE() ? 50 : LANDSCAPE_MOBILE() ? 36 : 16,
	        right: mobile ? -10 : 20,
	        position: 'relative',
	        float: mobile ? 'left' : 'right',
	        padding: mobile ? 10 : 0,
	        backgroundColor: 'transparent',
	        border: 'none'
	      }
	    }, translator('engage.cancel_button', 'cancel')), DIV({
	      style: {
	        clear: 'both'
	      }
	    })), this.proposal.active ? DIV({
	      style: {
	        position: 'relative'
	      }
	    }, INPUT({
	      className: 'newpoint-anonymous',
	      type: 'checkbox',
	      id: "sign_name-" + this.props.valence,
	      name: "sign_name-" + this.props.valence,
	      checked: this.local.sign_name,
	      onChange: (function(_this) {
	        return function() {
	          _this.local.sign_name = !_this.local.sign_name;
	          return save(_this.local);
	        };
	      })(this)
	    }), LABEL({
	      htmlFor: "sign_name-" + this.props.valence,
	      title: translator('engage.point_anonymous_toggle_explanation', "This won\'t make your point perfectly anonymous, but will make it considerably harder for others to associate with you. Note that signing your name lends your point more weight with peers.")
	    }, translator('engage.point_anonymous_toggle', 'Sign your name'))) : void 0);
	  },
	  componentWillMount: function() {
	    if (browser.is_mobile) {
	      return this.scrollY = window.scrollY;
	    }
	  },
	  componentDidMount: function() {
	    var $el;
	    if (this.proposal.active) {
	      $el = $(this.getDOMNode());
	      if (!browser.is_mobile) {
	        $el.find('#nutshell').focus();
	      }
	      return $el.find('[data-action="submit-point"]').ensureInView({
	        scroll: false,
	        position: 'bottom'
	      });
	    }
	  },
	  componentWillUnmount: function() {
	    var s;
	    s = fetch('reasons_height_adjustment');
	    s.edit_point_height = 0;
	    return save(s);
	  },
	  drawTips: function() {
	    var guidelines_h, guidelines_w, mobile, plural, singular;
	    mobile = browser.is_mobile;
	    guidelines_w = mobile ? 'auto' : 230;
	    guidelines_h = 238;
	    singular = this.props.valence === 'pros' ? get_point_label('pro', this.proposal) : get_point_label('con', this.proposal);
	    plural = get_point_label(this.props.valence, this.proposal);
	    return DIV({
	      id: 'tips_for_new_point',
	      style: {
	        position: mobile ? 'relative' : 'absolute',
	        left: !mobile ? (this.props.valence === 'pros' ? -guidelines_w - 25 : POINT_WIDTH() + 15) : void 0,
	        width: guidelines_w,
	        color: focus_color(),
	        zIndex: 1,
	        marginBottom: mobile ? 20 : void 0,
	        backgroundColor: mobile ? 'rgba(255,255,255,.85)' : void 0
	      }
	    }, !mobile ? SVG({
	      width: guidelines_w + 28,
	      height: guidelines_h,
	      viewBox: "-4 0 " + (guidelines_w + 20 + 9) + " " + guidelines_h,
	      style: css.crossbrowserify({
	        position: 'absolute',
	        transform: this.props.valence === 'cons' ? 'scaleX(-1)' : void 0,
	        left: this.props.valence === 'cons' ? -20 : void 0
	      })
	    }, DEFS(null, svg.dropShadow({
	      id: "guidelines-shadow",
	      dx: '0',
	      dy: '2',
	      stdDeviation: "3",
	      opacity: .5
	    })), PATH({
	      stroke: focus_color(),
	      strokeWidth: 1,
	      fill: "#FFF",
	      filter: 'url(#guidelines-shadow)',
	      d: "M" + guidelines_w + ",33\nL" + guidelines_w + ",0\nL1,0\nL1," + guidelines_h + " \nL" + guidelines_w + "," + guidelines_h + " \nL" + guidelines_w + ",58\nL" + (guidelines_w + 20) + ",48\nL" + guidelines_w + ",33 \nZ"
	    })) : void 0, DIV({
	      style: {
	        padding: !mobile ? '14px 18px' : void 0,
	        position: 'relative',
	        marginLeft: 5
	      }
	    }, SPAN({
	      style: {
	        fontWeight: 600,
	        fontSize: PORTRAIT_MOBILE() ? 70 : LANDSCAPE_MOBILE() ? 36 : void 0
	      }
	    }, translator({
	      id: 'engage.write_point_header',
	      pro_or_con: capitalize(singular)
	    }, "Write a new {pro_or_con}")), UL({
	      style: {
	        listStylePosition: 'outside',
	        marginLeft: 16,
	        marginTop: 5
	      }
	    }, (function() {
	      var i, len, results, tip, tips;
	      tips = [
	        translator({
	          id: "engage.point_authoring.tip_single",
	          pros_or_cons: capitalize(plural)
	        }, "Make only one point. Add multiple {pros_or_cons} if you have more."), translator("engage.point_authoring.tip_direct", "Be direct. The summary is your main point."), translator("engage.point_authoring.tip_review", "Review your language. Don’t be careless."), translator("engage.point_authoring.tip_attacks", "No personal attacks.")
	      ];
	      results = [];
	      for (i = 0, len = tips.length; i < len; i++) {
	        tip = tips[i];
	        results.push(LI({
	          style: {
	            paddingBottom: 3,
	            fontSize: PORTRAIT_MOBILE() ? 24 : LANDSCAPE_MOBILE() ? 14 : void 0
	          }
	        }, tip));
	      }
	      return results;
	    })())));
	  },
	  done: function() {
	    var your_points;
	    your_points = fetch(this.props.your_points_key);
	    if (this.props.fresh) {
	      your_points.adding_new_point = false;
	    } else {
	      your_points.editing_points = _.without(your_points.editing_points, this.props.key);
	    }
	    return save(your_points);
	  },
	  savePoint: function(ev) {
	    var $form, current_user, hide_name, nutshell, point, text;
	    $form = $(this.getDOMNode());
	    nutshell = $form.find('#nutshell').val();
	    text = $form.find('#text').val();
	    hide_name = !$form.find("#sign_name-" + this.props.valence).is(':checked');
	    if (!this.props.fresh) {
	      point = this.data();
	      point.nutshell = nutshell;
	      point.text = text;
	      point.hide_name = hide_name;
	    } else {
	      current_user = fetch('/current_user').user;
	      point = {
	        key: '/new/point',
	        is_pro: this.props.valence === 'pros',
	        user: current_user,
	        comment_count: 0,
	        includers: [current_user],
	        proposal: this.proposal.key,
	        nutshell: nutshell,
	        text: text,
	        hide_name: hide_name
	      };
	    }
	    point.errors = [];
	    return save(point, (function(_this) {
	      return function() {
	        var ref;
	        if (((ref = point.errors) != null ? ref.length : void 0) === 0) {
	          return _this.done();
	        } else {
	          _this.local.errors = point.errors;
	          return save(_this.local);
	        }
	      };
	    })(this));
	  }
	});


/***/ },
/* 36 */
/***/ function(module, exports) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	window.EditProposal = ReactiveComponent({
	  displayName: 'EditProposal',
	  render: function() {
	    var block_style, cluster, current_user, description_field_style, error, field, field_open, i, idx, input_style, label_style, len, loc, operation_style, permitted, proposal, ref, ref1, subdomain, toggleDescriptionFieldOpen;
	    current_user = fetch('/current_user');
	    proposal = this.data();
	    subdomain = fetch('/subdomain');
	    if (!this.props.fresh && !proposal.id) {
	      return SPAN(null);
	    }
	    permitted = this.props.fresh ? permit('create proposal') : permit('update proposal', proposal);
	    if (permitted < 0) {
	      recourse(permitted, 'create a proposal');
	      return DIV(null);
	    }
	    block_style = {
	      width: CONTENT_WIDTH(),
	      padding: '2px 0px',
	      marginBottom: 12,
	      position: 'relative'
	    };
	    description_field_style = {
	      fontSize: 18,
	      width: CONTENT_WIDTH(),
	      padding: 12,
	      marginBottom: 8,
	      border: '1px solid #ccc'
	    };
	    input_style = _.extend({}, description_field_style, {
	      display: 'block'
	    });
	    label_style = {
	      fontSize: 24,
	      fontWeight: 600,
	      width: 240,
	      display: 'inline-block',
	      color: focus_color(),
	      marginBottom: 3
	    };
	    operation_style = {
	      color: '#aaa',
	      textDecoration: 'underline',
	      fontSize: 14,
	      cursor: 'pointer',
	      display: 'block',
	      backgroundColor: 'transparent',
	      padding: 0,
	      border: 'none'
	    };
	    if (this.props.fresh) {
	      loc = fetch('location');
	      cluster = loc.query_params.category || '';
	    } else {
	      cluster = proposal.cluster;
	    }
	    if (!this.local.description_fields && (this.props.fresh || proposal.slug)) {
	      this.local.description_fields = proposal.description_fields ? $.parseJSON(proposal.description_fields) || [] : [];
	      this.local.open_fields = [];
	      if (this.local.description_fields.length > 0) {
	        if (this.local.description_fields[0].group) {
	          this.local.description_fields = _.flatten(this.local.description_fields.map(function(group) {
	            return group.items;
	          }));
	        }
	        ref = this.local.description_fields;
	        for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	          field = ref[idx];
	          field.id = idx;
	        }
	      }
	      save(this.local);
	    }
	    toggleDescriptionFieldOpen = (function(_this) {
	      return function(field, field_open) {
	        if (field_open) {
	          _this.local.open_fields = _.without(_this.local.open_fields, field.id);
	        } else {
	          _this.local.open_fields.push(field.id);
	        }
	        return save(_this.local);
	      };
	    })(this);
	    return DIV(null, DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        margin: 'auto',
	        padding: '3em 0',
	        position: 'relative'
	      }
	    }, DIV({
	      style: {
	        fontSize: 28,
	        marginBottom: 20
	      }
	    }, H2({
	      style: {
	        fontSize: 30,
	        fontWeight: 700
	      }
	    }, this.props.fresh ? translator('engage.add_new_proposal_button', "Create new proposal") : (capitalize(translator('engage.edit_button', 'edit'))) + " '" + proposal.name + "'")), DIV({
	      style: block_style
	    }, LABEL({
	      htmlFor: 'name',
	      style: label_style
	    }, translator("engage.edit_proposal.summary_label", "Summary") + ':'), INPUT({
	      id: 'name',
	      name: 'name',
	      pattern: '^.{3,}',
	      placeholder: translator('engage.proposal_name_placeholder', 'Clear and concise summary'),
	      required: 'required',
	      defaultValue: this.props.fresh ? null : proposal.name,
	      style: input_style
	    })), DIV({
	      style: block_style
	    }, LABEL({
	      htmlFor: "description-" + proposal.key,
	      style: label_style
	    }, translator("engage.edit_proposal.description_label", "Details") + ':'), WysiwygEditor({
	      key: "description-" + proposal.key,
	      style: _.extend({}, input_style, {
	        minHeight: 20
	      }),
	      html: this.props.fresh ? null : proposal.description
	    }), false ? DIV({
	      style: {
	        marginBottom: 20,
	        marginLeft: 45,
	        display: !current_user.is_admin ? 'none' : void 0
	      }
	    }, (function() {
	      var j, len1, ref1, ref2, results;
	      ref1 = this.local.description_fields;
	      results = [];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        field = ref1[j];
	        field_open = (ref2 = field.id, indexOf.call(this.local.open_fields, ref2) >= 0);
	        results.push(DIV({
	          key: "field-" + field.id,
	          style: _.extend({}, block_style, {
	            width: ''
	          })
	        }, BUTTON({
	          className: "fa fa-" + (field_open ? 'minus' : 'plus') + "-circle",
	          style: {
	            position: 'absolute',
	            left: -20,
	            top: 18,
	            color: '#414141',
	            cursor: 'pointer',
	            padding: 0,
	            border: 'none',
	            backgroundColor: 'transparent'
	          },
	          onClick: (function(_this) {
	            return function(field, field_open) {
	              return function() {
	                return toggleDescriptionFieldOpen(field, field_open);
	              };
	            };
	          })(this)(field, field_open)
	        }), field_open ? [
	          INPUT({
	            style: _.extend({}, description_field_style, {
	              width: description_field_style.width - 45
	            }),
	            type: 'text',
	            id: "field-" + field.id + "-label",
	            name: "field-" + field.id + "-label",
	            pattern: '^.{3,}',
	            placeholder: t('Label'),
	            required: 'required',
	            onChange: (function(_this) {
	              return function(field) {
	                return function(e) {
	                  field.label = e.target.value;
	                  return save(_this.local);
	                };
	              };
	            })(this)(field),
	            value: field.label
	          }), WysiwygEditor({
	            key: "field-" + field.id + "-html-" + (this.props.fresh ? '/new/proposal' : proposal.key),
	            name: "field-" + field.id + "-html",
	            placeholder: t('expandable_body_instr'),
	            style: _.extend({}, description_field_style, {
	              width: description_field_style.width - 45
	            }),
	            html: field.html
	          })
	        ] : DIV({
	          style: {
	            fontSize: 18,
	            fontWeight: 600,
	            cursor: 'pointer',
	            marginTop: 12,
	            marginLeft: 5,
	            width: description_field_style.width - 45
	          },
	          onClick: (function(_this) {
	            return function(field, field_open) {
	              return function() {
	                return toggleDescriptionFieldOpen(field, field_open);
	              };
	            };
	          })(this)(field, field_open)
	        }, field.label), DIV({
	          style: {
	            position: 'absolute',
	            right: 150,
	            top: 12
	          }
	        }, BUTTON({
	          style: operation_style,
	          onClick: (function(_this) {
	            return function(field, field_open) {
	              return function() {
	                return toggleDescriptionFieldOpen(field, field_open);
	              };
	            };
	          })(this)(field, field_open)
	        }, field_open ? t('close') : t('edit')), BUTTON({
	          style: operation_style,
	          onClick: (function(_this) {
	            return function(field) {
	              return function() {
	                _this.local.description_fields = _.filter(_this.local.description_fields, function(fld) {
	                  return fld.id !== field.id;
	                });
	                return save(_this.local);
	              };
	            };
	          })(this)(field)
	        }, t('delete')))));
	      }
	      return results;
	    }).call(this), BUTTON({
	      style: {
	        color: '#aaa',
	        cursor: 'pointer',
	        fontSize: 18,
	        marginLeft: -18,
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onClick: (function(_this) {
	        return function() {
	          var j, len1, new_id, ref1;
	          new_id = 0;
	          ref1 = _this.local.description_fields;
	          for (j = 0, len1 = ref1.length; j < len1; j++) {
	            field = ref1[j];
	            new_id += field.id;
	          }
	          new_id += 1;
	          _this.local.description_fields.push({
	            label: null,
	            html: null,
	            id: new_id
	          });
	          _this.local.open_fields.push(new_id);
	          return save(_this.local);
	        };
	      })(this)
	    }, "+ ", SPAN({
	      style: {
	        textDecoration: 'underline',
	        marginLeft: 7
	      }
	    }, t('add_expandable')))) : void 0), DIV({
	      style: block_style
	    }, LABEL({
	      htmlFor: 'cluster',
	      style: label_style
	    }, translator('category') + ' (' + translator('optional') + '):'), INPUT({
	      id: 'cluster',
	      name: 'cluster',
	      pattern: '^.{3,}',
	      placeholder: translator("engage.proposal_cluster_placeholder", 'The proposal will be shown on the homepage under this category. (Default="Proposals")'),
	      defaultValue: cluster,
	      style: input_style
	    })), DIV({
	      style: _.extend({}, block_style, {
	        display: !current_user.is_admin ? 'none' : void 0
	      })
	    }, LABEL({
	      htmlFor: 'listed_on_homepage',
	      style: label_style
	    }, translator("engage.edit_proposal.show_on_homepage", 'List on homepage?')), INPUT({
	      id: 'listed_on_homepage',
	      name: 'listed_on_homepage',
	      type: 'checkbox',
	      defaultChecked: this.props.fresh ? true : !proposal.hide_on_homepage,
	      style: {
	        fontSize: 24
	      }
	    })), DIV({
	      style: _.extend({}, block_style, {
	        display: !current_user.is_admin ? 'none' : void 0
	      })
	    }, LABEL({
	      htmlFor: 'open_for_discussion',
	      style: label_style
	    }, translator("engage.edit_proposal.open_for_discussion", 'Open for discussion?')), INPUT({
	      id: 'open_for_discussion',
	      name: 'open_for_discussion',
	      type: 'checkbox',
	      defaultChecked: this.props.fresh ? true : proposal.active,
	      style: {
	        fontSize: 24
	      }
	    })), current_user.is_admin ? FORM({
	      id: 'proposal_pic_files',
	      action: '/update_proposal_pic_hack'
	    }, DIV({
	      className: 'input_group',
	      style: block_style
	    }, DIV(null, LABEL({
	      style: label_style,
	      htmlFor: 'pic'
	    }, 'Pic')), INPUT({
	      id: 'pic',
	      type: 'file',
	      name: 'pic',
	      onChange: (function(_this) {
	        return function(ev) {
	          return _this.submit_pic = true;
	        };
	      })(this)
	    })), DIV({
	      className: 'input_group',
	      style: block_style
	    }, DIV(null, LABEL({
	      style: label_style,
	      htmlFor: 'banner'
	    }, 'Banner')), INPUT({
	      id: 'banner',
	      type: 'file',
	      name: 'banner',
	      onChange: (function(_this) {
	        return function(ev) {
	          return _this.submit_pic = true;
	        };
	      })(this)
	    }))) : void 0, DIV({
	      style: {
	        display: !current_user.is_admin ? 'none' : void 0
	      }
	    }, SPAN({
	      style: _.extend({}, label_style, {
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        width: 400,
	        position: 'relative'
	      }),
	      onClick: (function(_this) {
	        return function() {
	          _this.local.edit_roles = !_this.local.edit_roles;
	          return save(_this.local);
	        };
	      })(this)
	    }, I({
	      className: 'fa-child fa',
	      style: {
	        position: 'absolute',
	        left: -25,
	        top: 5
	      }
	    }), translator('engage.edit_proposal.permissions', 'Permissions')), DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        backgroundColor: '#fafafa',
	        padding: '10px 60px',
	        display: this.local.edit_roles ? 'block' : 'none'
	      }
	    }, ProposalRoles({
	      key: this.props.fresh ? this.local.key : proposal.key
	    }))), ((ref1 = this.local.errors) != null ? ref1.length : void 0) > 0 ? DIV({
	      role: 'alert',
	      style: {
	        fontSize: 18,
	        color: 'darkred',
	        backgroundColor: '#ffD8D8',
	        padding: 10,
	        marginTop: 10
	      }
	    }, (function() {
	      var j, len1, ref2, results;
	      ref2 = this.local.errors;
	      results = [];
	      for (j = 0, len1 = ref2.length; j < len1; j++) {
	        error = ref2[j];
	        results.push(DIV(null, I({
	          className: 'fa fa-exclamation-circle',
	          style: {
	            paddingRight: 9
	          }
	        }), SPAN(null, error)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV(null, BUTTON({
	      className: 'button primary_button',
	      style: {
	        width: 400,
	        marginTop: 35,
	        backgroundColor: focus_color()
	      },
	      onClick: this.saveProposal
	    }, this.props.fresh ? translator('Publish') : translator('Update')), BUTTON({
	      style: {
	        marginTop: 10,
	        padding: 25,
	        marginLeft: 10,
	        fontSize: 22,
	        border: 'none',
	        backgroundColor: 'transparent'
	      },
	      onClick: (function(_this) {
	        return function() {
	          if (_this.props.fresh) {
	            return loadPage("/");
	          } else {
	            return loadPage("/" + proposal.slug);
	          }
	        };
	      })(this)
	    }, translator('engage.cancel_button', 'cancel'))), this.local.file_errors ? DIV({
	      style: {
	        color: 'red'
	      }
	    }, 'Error uploading files!') : void 0));
	  },
	  saveProposal: function() {
	    var $el, active, after_save, cluster, description, edited_html, field, hide_on_homepage, i, len, name, proposal, ref;
	    $el = $(this.getDOMNode());
	    name = $el.find('#name').val();
	    description = fetch("description-" + (this.data().key)).html;
	    cluster = $el.find('#cluster').val();
	    if (cluster === "") {
	      cluster = null;
	    }
	    active = $el.find('#open_for_discussion:checked').length > 0;
	    hide_on_homepage = $el.find('#listed_on_homepage:checked').length === 0;
	    if (this.props.fresh) {
	      proposal = {
	        key: '/new/proposal',
	        name: name,
	        description: description,
	        cluster: cluster,
	        active: active,
	        hide_on_homepage: hide_on_homepage
	      };
	    } else {
	      proposal = this.data();
	      _.extend(proposal, {
	        cluster: cluster,
	        name: name,
	        description: description,
	        active: active,
	        hide_on_homepage: hide_on_homepage
	      });
	    }
	    if (this.local.roles) {
	      proposal.roles = this.local.roles;
	      proposal.invitations = this.local.invitations;
	    }
	    if (this.local.description_fields) {
	      ref = this.local.description_fields;
	      for (i = 0, len = ref.length; i < len; i++) {
	        field = ref[i];
	        edited_html = fetch("field-" + field.id + "-html-" + proposal.key);
	        if (edited_html.html) {
	          field.html = edited_html.html;
	        }
	      }
	      proposal.description_fields = JSON.stringify(this.local.description_fields);
	    }
	    proposal.errors = [];
	    this.local.errors = [];
	    save(this.local);
	    after_save = (function(_this) {
	      return function() {
	        var ref1;
	        if (((ref1 = proposal.errors) != null ? ref1.length : void 0) === 0) {
	          window.scrollTo(0, 0);
	          return loadPage("/" + proposal.slug);
	        } else {
	          _this.local.errors = proposal.errors;
	          return save(_this.local);
	        }
	      };
	    })(this);
	    return save(proposal, (function(_this) {
	      return function() {
	        var current_user;
	        if (_this.submit_pic) {
	          current_user = fetch('/current_user');
	          return $('#proposal_pic_files').ajaxSubmit({
	            type: 'PUT',
	            data: {
	              authenticity_token: current_user.csrf,
	              id: proposal.id
	            },
	            success: after_save,
	            error: function() {
	              _this.local.file_errors = true;
	              return save(_this.local);
	            }
	          });
	        } else {
	          return after_save();
	        }
	      };
	    })(this));
	  }
	});


/***/ },
/* 37 */
/***/ function(module, exports) {

	$.fn.ensureInView = function(options) {
	  var $el, bottom_inside, distance_to_travel, doc_bottom, doc_height, doc_top, el_bottom, el_height, el_top, in_viewport, is_onscreen, target, top_inside;
	  if (options == null) {
	    options = {};
	  }
	  _.defaults(options, {
	    fill_threshold: .5,
	    offset_buffer: 50,
	    scroll: true,
	    position: 'top',
	    speed: null,
	    callback: function() {}
	  });
	  $el = $(this);
	  el_height = $el.height();
	  el_top = $el.offset().top;
	  el_bottom = el_top + el_height;
	  doc_height = $(window).height();
	  doc_top = $(window).scrollTop();
	  doc_bottom = doc_top + doc_height;
	  is_onscreen = el_top > doc_top && el_bottom < doc_bottom;
	  bottom_inside = el_bottom < doc_bottom && (el_bottom - doc_top) > options.fill_threshold * el_height;
	  top_inside = el_top > doc_top && (doc_bottom - el_top) > options.fill_threshold * el_height;
	  in_viewport = is_onscreen || top_inside || bottom_inside;
	  if (!in_viewport) {
	    switch (options.position) {
	      case 'top':
	        target = el_top - options.offset_buffer;
	        break;
	      case 'bottom':
	        target = el_bottom - doc_height + options.offset_buffer;
	        break;
	      default:
	        throw 'bad position for ensureInView';
	    }
	    if (options.scroll) {
	      distance_to_travel = options.speed || Math.abs(doc_top - target);
	      return $("html, body").animate({
	        scrollTop: $el.offset().top - options.offset_buffer
	      }, {
	        duration: Math.min(distance_to_travel, 1500),
	        complete: options.callback
	      }, 'ease-in');
	    } else {
	      $(document).scrollTop(target);
	      return options.callback();
	    }
	  } else {
	    return options.callback();
	  }
	};
	
	$.fn.moveToTop = function(options) {
	  var $el, distance_to_travel, doc_top, el_bottom, el_top, target;
	  if (options == null) {
	    options = {};
	  }
	  _.defaults(options, {
	    offset_buffer: 50,
	    scroll: false
	  });
	  $el = $(this);
	  el_top = $el.offset().top;
	  el_bottom = target = el_top - options.offset_buffer;
	  doc_top = $(document).scrollTop();
	  if (options.scroll) {
	    distance_to_travel = Math.abs(doc_top - target);
	    return $('body').animate({
	      scrollTop: target
	    }, distance_to_travel);
	  } else {
	    return $(document).scrollTop(target);
	  }
	};


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1);
	
	window.GodMode = ReactiveComponent({
	  displayName: 'GodMode',
	  render: function() {
	    var godmode, user, users;
	    godmode = fetch('godmode');
	    if (!godmode.enabled) {
	      return SPAN(null);
	    }
	    users = fetch('/users');
	    if (this.local.switch_user == null) {
	      this.local.switch_user = true;
	      save(this.local);
	    }
	    return DIV({
	      style: {
	        position: 'absolute',
	        zIndex: 9999,
	        left: 0,
	        top: 0,
	        width: '100%',
	        backgroundColor: 'black',
	        color: 'white',
	        padding: 10
	      },
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.switch_user = false;
	          return save(_this.local);
	        };
	      })(this)
	    }, SPAN({
	      style: {
	        fontWeight: 300,
	        color: 'cyan',
	        display: 'inline-block',
	        fontSize: 28,
	        marginRight: 20
	      }
	    }, 'GODMODE'), A({
	      style: {
	        fontWeight: 'bold'
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.switch_user = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, 'Switch user'), this.local.switch_user ? UL({
	      style: {
	        width: '100%'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = users.users;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        user = ref[i];
	        results.push(LI({
	          style: {
	            backgroundColor: 'black',
	            listStyle: 'none',
	            display: 'inline-block',
	            margin: 10,
	            cursor: 'pointer'
	          },
	          onClick: (function(_this) {
	            return function(user) {
	              return function() {
	                var current_user;
	                current_user = fetch('/current_user');
	                current_user.trying_to = 'switch_users';
	                current_user.switch_to = user;
	                save(current_user, function() {
	                  return location.reload();
	                });
	                _this.local.switch_user = false;
	                save(_this.local);
	                godmode.enabled = false;
	                return save(godmode);
	              };
	            };
	          })(this)(user)
	        }, Avatar({
	          key: user,
	          user: user,
	          hide_tooltip: true,
	          style: {
	            width: 50,
	            height: 50
	          }
	        }), SPAN({
	          style: {
	            paddingTop: 12,
	            paddingLeft: 5,
	            display: 'inline-block'
	          }
	        }, fetch(user).name)));
	      }
	      return results;
	    }).call(this)) : void 0);
	  },
	  componentDidMount: function() {
	    return document.addEventListener("keyup", function(e) {
	      var godmode, key;
	      key = (e && e.keyCode) || e.keyCode;
	      if (key === 85 && e.ctrlKey) {
	        godmode = fetch('godmode');
	        godmode.enabled = !godmode.enabled;
	        return save(godmode);
	      }
	    });
	  }
	});


/***/ },
/* 39 */
/***/ function(module, exports) {

	var GoogleDocEmbed, LegalDoc, privacy_policy, terms_of_service;
	
	GoogleDocEmbed = ReactiveComponent({
	  displayName: 'GoogleDocEmbed',
	  render: function() {
	    return DIV({
	      style: {
	        width: '80%',
	        margin: 'auto',
	        maxWidth: 800
	      }
	    }, IFRAME({
	      ref: 'iframe',
	      width: '100%',
	      height: window.innerHeight,
	      src: this.props.link
	    }));
	  }
	});
	
	LegalDoc = function(html) {
	  return DIV({
	    style: {
	      width: '80%',
	      margin: '40px auto',
	      maxWidth: 1000,
	      padding: '25px 60px',
	      backgroundColor: 'white',
	      boxShadow: '0 1px 2px rgba(0,0,0,.2)'
	    }
	  }, STYLE({
	    dangerouslySetInnerHTML: {
	      __html: ".legaldoc .title {font-size: 36px; font-weight: bold; margin-bottom: 10px; margin-top: 20px}\n.legaldoc h1 {font-size: 28px; font-weight: 600; margin-bottom: 10px; margin-top: 20px}\n.legaldoc h2 {font-size: 20px; font-weight: 500; margin-bottom: 10px; margin-top: 20px}\n.legaldoc ul {list-style-position: outside; padding-left: 40px;}\n.legaldoc p {padding-top: 5px; padding-bottom: 5px;}\n.legaldoc a {text-decoration: underline; color:" + logo_red + ";}"
	    }
	  }), DIV({
	    className: 'legaldoc',
	    dangerouslySetInnerHTML: {
	      __html: html.replace(/hello@consider.it/g, '<a href="mailto:hello@consider.it">hello@consider.it</a>')
	    }
	  }));
	};
	
	window.PrivacyPolicy = function() {
	  return LegalDoc(privacy_policy);
	};
	
	window.TermsOfService = function() {
	  return LegalDoc(terms_of_service);
	};
	
	privacy_policy = '<p class="c0 title" id="h.46ek5o6s6nll"><span>Consider.it Privacy Policy </span></p><p class="c1"><span>Updated: 12/9/2019</span></p><p class="c1 c3"><span></span></p><p class="c1 c3"><span></span></p><p class="c1"><span>Hi Friends,</span></p><p class="c1"><span>We want you (the end user) to understand how and why Consider.it, Invisible College LLC (&ldquo;Consider.it,&rdquo; &ldquo;we&rdquo; or &ldquo;us&rdquo;) collects, uses and shares information about you when you access and use Consider.it&rsquo;s site and services (collectively, the &ldquo;Services&rdquo;) or when you otherwise interact with us. </span></p><h1 class="c0" id="h.htirnipe6py7"><span>Information we collect about you</span></h1><p class="c1"><span>We collect information you provide directly to us when you use our Services. Depending on which Service you use, we may collect different information about you. This includes: </span></p><h2 class="c0" id="h.wdoprsyqfsnu"><span>Content you share</span></h2><p class="c1"><span>Consider.it allows users to post content, including proposals, points, comments, photos, links and other materials. Anything that a user posts or otherwise makes available on our Services is referred to as &ldquo;Content.&rdquo; We collect the Content you post to the Services, such as opinions you give, the proposals, points and comments you write, both in public and in private Consider.it Forums.</span></p><h2 class="c0" id="h.zg7yli1ymy2p"><span>Information regarding your account</span></h2><p class="c1"><span>We collect the information you provide when you use our Services. This includes information used to create your account (e.g., a username, </span><span>password</span><span>, email address and avatar).</span></p><h2 class="c0" id="h.peooesnmsifi"><span>Other Information</span></h2><p class="c1"><span>You may choose to provide other information or certain Consider.it Forums might require you to provide other information to join. For example, a Forum about housing affordability may ask questions about your housing type and whether you own or rent it. </span></p><h2 class="c0" id="h.5d0vpdd0m38"><span>Information we collect automatically</span></h2><p class="c1"><span>When you access or use our Services, we may also automatically collect information about you. This includes Log and Usage Data such as your IP address, user-agent string, browser type, operating system, referral URLs, device information, pages listed, links clicked, user interactions (opinions, proposals, comments and points created), the requested URL, and hardware settings. </span></p><h2 class="c1 c4" id="h.dy0wqhng99wx"><span>Children Under the Age of 13</span></h2><p class="c1"><span>Our Services are not intended for children under 13 years of age. No one under age 13 may provide any information to or on the Services. We do not knowingly collect personal information from children under 13. If you are under 13, do not use or provide any information on these Services or on or through any of its features/register on the Services, make any purchases through the Services, use any of the interactive or public comment features of the Services or provide any information about yourself to us, including your name, address, telephone number, email address, or any screen name or user name you may use.</span></p><p class="c1 c3"><span></span></p><p class="c1"><span>If we learn we have collected or received personal information from a child under 13 without verification of parental consent, we will delete that information. If you believe we might have any information from or about a child under 13, please contact us at hello@consider.it.</span></p><p class="c1 c3"><span></span></p><h1 class="c0" id="h.m7sqfsgs9n6w"><span>How we use information about you</span></h1><p class="c1"><span>By way of example, and not as a limitation, w</span><span>e use information about you to</span><span>:</span></p><ul class="c8 lst-kix_c2vn886nr1ma-0 start"><li class="c2 c1"><span>Provide, maintain, and improve the Services;</span></li><li class="c2 c1"><span>Help protect the safety of Consider.it and our users, which includes blocking suspected spammers, addressing abuse, and enforcing the <a class="c5" href="/terms_of_service">Terms of Service</a></li><li class="c2 c1"><span>Send you technical notices, updates, security alerts, and other support and administrative messages;</span></li><li class="c2 c1"><span>Provide customer service;</span></li><li class="c2 c1"><span>Communicate with you about product and service news and information we think be of interest to you;</span></li><li class="c2 c1"><span>Monitor and analyze trends, usage, and activities in connection with our Services; and</span></li><li class="c2 c1"><span>Promote our Services using Content that you share in public forums</span></li></ul><h1 class="c0" id="h.w4d372dnyqwt"><span>How we share information</span></h1><p class="c1"><span>When you use the Services, certain information may be shared with other users and the public. For example, when you submit a proposal, point, opinion, comment or other Content to the Services, visitors to and users of our Services will be able to see your Content, the username associated with your Content, and sometimes the date and time you originally submitted the Content. Although some parts of the Services may be private, they may become public (e.g., at the moderator&rsquo;s option in the case of private communities) and you should take that into consideration before posting Content to the Services.</span></p><h2 class="c0" id="h.d32epkgxe9cs"><span>Forum Information</span></h2><p class="c1"><span>In private Forums, proposals, points, comments, usernames and other Content are only viewable by members of the respective private Forum. In order to enter a Forum, a member must log in with his or her proper credentials. </span></p><p class="c1 c3"><span></span></p><p class="c1"><span>In public Forums, proposals, points, comments, usernames, and other Content are viewable by the public at large. </span><span>Consider.it may use publicly viewable information and Content to promote the Services in any and all media, including, without limitation, social media</span><span>.</span></p><p class="c1 c3"><span></span></p><h2 class="c0" id="h.1dm6kvt1bc2e"><span>Sponsors; Governmental Entities</span></h2><ul class="c8 lst-kix_7h72mbu6em9h-0 start"><li class="c2 c1"><span>General. We will provide certain Personal Information to certain Sponsors of a Forum. These sponsors will be chartered organizations that (1) have clearly communicated that the forum is run by that organization and (2) have signed a contract with us. Specifically, we will provide Sponsor with reports containing (a) Content created in the Forum, linked to the account information of the user who created it and (b) Account information about users of the forum including but not limited to demographic data and personal contact information; and (c) other related data.</span></li><li class="c2 c1"><span>Public Records. If the Sponsor is a government entity or other public body, then representatives of that government entity or public body will communicate via the Services. Consequently, any communication via the Services (whether by a government representative, your, or the general public) may be considered a &ldquo;public record&rdquo; in the jurisdiction of the Sponsor, and, as such, may be subject to monitoring and retention by the Sponsor, and disclosure to third parties.</span></li><li class="c2 c1"><span>Other/Legal. There are other instances in which Consider.it may divulge your Personal Information, such as when required by law, regulation, or litigation.</span></li></ul><p class="c1 c3"><span></span></p><p class="c1"><span>We will not share, sell, or give away any of our users&rsquo; personal information to third parties, unless one of the following circumstances applies:</span></p><p class="c1 c3"><span></span></p><ul class="c8 lst-kix_fx6f8rldc2zc-0 start"><li class="c2 c1"><span>We may share information (and will attempt to provide you with prior notice, to the extent legally permissible) in response to a request for information if we believe disclosure is in accordance with, or required by, any applicable law, regulation, legal process or governmental request;</span></li><li class="c2 c1"><span>We may share information in response to an emergency if we believe it&#39;s necessary to prevent imminent and serious bodily harm to a person;</span></li><li class="c2 c1"><span>We may share information with vendors, consultants, and other service providers who need access to such information to carry out work for us;</span></li><li class="c2 c1"><span>We may share information with your consent or at your direction;</span></li><li class="c1 c2"><span>We may share aggregated or de-identified information, which cannot reasonably be used to identify you</span><span>;</span></li><li class="c2 c1"><span>We may share information with Sponsors of a Forum as described elsewhere in this document</span></li></ul><p class="c1 c3"><span></span></p><h2 class="c0" id="h.3xtgda5h3qbo"><span>Security</span></h2><p class="c1"><span>We take reasonable measures to help protect information about you from loss, theft, misuse and unauthorized access, disclosure, alteration, and destruction. For example, we do not directly store your password on our server; instead we store a salted password that is then encrypted using a cryptographic hash function.</span></p><h2 class="c1 c4" id="h.szjbarfnyus8"><span>California Rights</span></h2><p class="c1"><span>California Civil Code Section &sect; 1798.83 permits users of our site that are California residents to request certain information regarding our disclosure of personal information to third parties for their direct marketing purposes. To make such a request, please send an email to hello@consider.it.</span></p><h1 class="c0" id="h.6ccag1e9eq8m"><span>Accessing and Correcting Your Information</span></h1><p class="c1"><span>You can review and change your personal information by logging into Services and visiting your account profile page.</span></p><p class="c1 c3"><span></span></p><p class="c1"><span>You may also send us an email at hello@consider.it to request access to, or correct any personal information that you have provided to us. Sometimes we cannot delete your personal information except by also deleting your user account. We may not accommodate a request to change information if we believe the change would violate any law or legal requirement or cause the information to be incorrect.</span></p><p class="c1 c3"><span></span></p><p class="c1"><span>If you delete your Content from the Services, copies of your Content may remain viewable in cached and archived pages, or might have been copied or stored by other users of the Service. Proper access and use of information provided on the Services, including Content, is governed by our <a class="c5" href="/terms_of_service">Terms of Service</a>.</p><h1 class="c0" id="h.h1c028lcgxnq"><span>Changes</span></h1><p class="c1"><span>We may change this Privacy Policy from time to time. If we do, we will let you know by revising the </span><span>date at the top of the policy</span><span>. We encourage you to review the Privacy Policy whenever you access or use our Services or otherwise interact with us to stay informed about our information practices and the ways you can help protect your privacy. If you continue to use our Services after Privacy Policy changes go into effect, you consent to the revised policy.</span></p><h1 class="c0" id="h.y4nstxs9j4rd"><span>Contact Us</span></h1><p class="c1"><span>If you have any questions about this Privacy Policy, please email hello@consider.it. </span></p>';
	
	terms_of_service = '<p class="c1 c3 title" id="h.593bs2mn3ara"><span>Consider.it Terms of Service</span></p><p class="c1"><span>Updated: 10/23/2016</span></p><p class="c0"><span></span></p><p class="c0"><span></span></p><p class="c1"><span>Hi Friends,</span></p><p class="c0"><span></span></p><p class="c1"><span>This agreement is a legal contract between you (the user of the Service) and us (Consider.it). You acknowledge that you have read, understood, and agree to be bound by the terms of this agreement. If you do not agree to this agreement, you should not use Consider.it. Please also take a look at Consider.it&rsquo;s <a class="c5" href="/privacy_policy">Privacy Policy</a>; it explains how we collect and use your information.</span></p><p class="c0"><span></span></p><p class="c1"><span>Consider.it and Invisible College, LLC (&ldquo;Consider.it&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) has established the Consider.it website located at https://consider.it (the &ldquo;Site&rdquo;) to enable you to provide input, feedback and suggestions on the topics described on pages of the Site and contribute to the conversation with other users of the Site, as applicable. Please read these Terms of Use (the &ldquo;Terms&rdquo;) carefully because they govern your use of the Site and our services accessible via our Site. To make these Terms easier to read, the Site and our services are collectively called the &ldquo;Services.&rdquo;</span></p><h2 class="c1 c3" id="h.3de3zzlneeje"><span>Acceptance of Terms</span></h2><p class="c1"><span>By using our Services in any way, including registering on the Site, contributing your input, feedback or suggestions, or merely browsing the Site, you agree to be and are bound by these Terms. If you do not agree to all of the Terms, do not access or use our Services.</span></p><h2 class="c1 c3" id="h.yt4of1k1ez0i"><span>Who can use Consider.it? </span></h2><p class="c1"><span>You may use our Services only if you can form a binding contract with Consider.it, and only in compliance with these Terms and all applicable laws. Any use or access by anyone under the age of 13 is prohibited. If you open an account on behalf of a company, organizations, or other entity, then (a) &ldquo;you&rdquo; includes you and that entity, and (b) you represent and warrant that you are authorized to grant all permissions and licenses provided in these Terms and bind the entity to these Terms, and that you agree to these Terms on the entity&rsquo;s behalf.</span></p><h2 class="c1 c3" id="h.p9lbo1actl5o"><span>User content in Consider.it</span></h2><p class="c1"><span>Consider.it allows users to post content, including proposals, points, comments, photos, links and other materials. Anything that a user posts or otherwise makes available on our Services is referred to as &ldquo;Content.&rdquo;</span></p><p class="c0"><span></span></p><p class="c1"><span>Consider.it does not guarantee the accuracy, integrity or quality of any Content posted or submitted to the Site. You understand that by using the Site you may be exposed to Content that is offensive, indecent or objectionable.</span></p><p class="c0"><span></span></p><p class="c1"><span>The Services may provide, or third parties may provide, links to other websites or resources. Because Consider.it has no control over such sites and resources, you acknowledge and agree that Consider.it is not responsible for the availability of such external sites or resources, and does not endorse and is not responsible or liable for any content, advertising, products or other materials on or available from such sites or resources. You further acknowledge and agree that Consider.it shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such site or resource. </span></p><h2 class="c1 c3" id="h.p5gmj19t7a2i"><span>Your content in Consider.it&rsquo;s services</span></h2><p class="c1"><span>Consider.it allows you to post content, including proposals, points, comments, photos, links, user profile information and other materials (the &ldquo;Content&rdquo;).</span></p><p class="c0"><span></span></p><p class="c1"><span>You own all of the Content you post on Consider.it and retain all rights therein. When you use our Services, you give Consider.it and those who we work with a perpetual, worldwide, non-exclusive, royalty-free license to use, host, store, reproduce, modify, create derivative works (such as those resulting from translations, adaptations or other changes we make so that your Content works better with our Services), communicate, publish, publicly perform, publicly display and distribute such Content, including all versions of that Content. This license continues even if you stop using our Services.</span></p><p class="c0"><span></span></p><p class="c1"><span>When you post or otherwise submit Content to the Site, you acknowledge and agree that you, and not Consider.it, are entirely responsible for all such Content. You agree to defend, indemnify and hold harmless Consider.it, its affiliates, licensors and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors and assigns from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses or fees (including reasonable attorneys&#39; fees) arising out of or relating to your violation of these Terms of Use or your use of the Site, including, but not limited to, your Content, any use of the Site&rsquo;s content, services and products other than as expressly authorized in these Terms of Use or your use of any information obtained from the Site.</span></p><h2 class="c1 c3" id="h.1mt0zz1mupsr"><span>User conduct </span></h2><p class="c1"><span>As a condition of use, you promise not to use the Services for any purpose that is unlawful or prohibited by these Terms, or any other purpose not reasonably intended by Consider.it. Such Content may be subject to removal by Consider.it. By way of example, and not as a limitation, you agree not to use the Services:</span></p><ul class="c2 lst-kix_ezu80jfv7war-0 start"><li class="c4 c1"><span>To abuse, harass, threaten, impersonate or intimidate any person;</span></li><li class="c1 c4"><span>To post or transmit, or cause to be posted or transmitted, any Content or communications that are libelous, defamatory, abusive, or that infringes any copyright or other right of any person;</span></li><li class="c4 c1"><span>For any purpose that is not permitted under the laws of the jurisdiction where you use the Services;</span></li><li class="c4 c1"><span>To post or transmit, or cause to be posted or transmitted, any communication designed or intended to obtain password, account, or private information from any other Consider.it user;</span></li><li class="c4 c1"><span>To advertise to or solicit, any user to buy or sell any third party products or services, or to use any information obtained from the Services in order to contact, advertise to, solicit, or sell to any user without their prior explicit consent;</span></li><li class="c4 c1"><span>To create multiple accounts for the purpose of manipulating the feedback in Consider.it; or</span></li><li class="c4 c1"><span>To post copyrighted communications that do not belong to you.</span></li></ul><p class="c1"><span>&nbsp;</span></p><p class="c1"><span>Certain Consider.it sites have a moderation interface and the administrators of those conversations can choose to hide or remove user Content that do not meet the standards of their forum.</span></p><p class="c0"><span></span></p><p class="c1"><span>To report suspected abuse of the Site or a breach of the Terms please send written notice to Consider.it at email: hello@consider.it. For conversations without moderation, you are responsible for your interactions with other users of the Site. Consider.it reserves the right, but has no obligation, to monitor disputes between you and other users. </span></p><h2 class="c1 c3" id="h.63u6qavynfo6"><span>Termination</span></h2><p class="c1"><span>Consider.it may terminate or suspend any and all Services and/or your Consider.it account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination of your account, your right to use the Services will immediately cease. If you wish to terminate your Consider.it account, you may simply discontinue using the Services or request your account to be deleted. All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</span></p><p class="c0"><span></span></p><p class="c1"><span>It is your responsibility to remove all Content from your account prior to termination.</span></p><h2 class="c1 c3" id="h.7i6iujwwmfc2"><span>Copyright Infringement</span></h2><p class="c1"><span>If you believe that any content or user contributions violate your copyright, please email us at hello@consider.it for instructions on sending us a notice of copyright infringement. It is the policy of the Consider.it to terminate the user accounts of repeat infringers. </span></p><h2 class="c1 c3" id="h.h6i9zzhvw1i"><span>Reliance on Information Posted</span></h2><p class="c1"><span>The information presented on or through the Services is made available solely for general information purposes. We do not warrant the accuracy, completeness or usefulness of this information. Any reliance you place on such information is strictly at your own risk. We disclaim all liability and responsibility arising from any reliance placed on such materials by you or any other visitor to Consider.it, or by anyone who may be informed of any of its contents.</span></p><p class="c0"><span></span></p><p class="c1"><span>The Services may include content provided by third parties, including materials provided by other users, bloggers and third-party licensors, syndicators, aggregators and/or reporting services. All statements and/or opinions expressed in these materials, and all articles and responses to questions and other content, other than the content provided by Consider.it, are solely the opinions and the responsibility of the person or entity providing those materials. These materials do not necessarily reflect the opinion of Consider.it. We are not responsible, or liable to you or any third party, for the content or accuracy of any materials provided by any third parties.</span></p><h2 class="c1 c3" id="h.p52q8qmtj4rg"><span>Deleting Account</span></h2><p class="c1"><span>Users may delete their account by emailing a request for deletion to hello@consider.it. Because you may have created points that other users have included in their personal lists or commented on or you may have created proposals that other users have given their opinion on, any Content that may be lawfully retained and displayed will continue to be visible through the Services and retained by us. The account associated with these points and proposals will have the name, email address and demographic information removed, leaving an anonymous profile. </span></p><h2 class="c1 c3" id="h.rjqgabgm7kmm"><span>Use of site by Governmental Entities</span></h2><p class="c1"><span>Consider.it intends to comply with all local, state and federal laws related to the required disclosure of any information provided via the Services. Under some instances the entity sponsoring specific Content or a project (&ldquo;Sponsor&rdquo;) through our Services will be a governmental entity. In such instances, the governmental Sponsor may or may not use the information that you provide to the Services for the purposes associated with the Services. It should be noted that such information may or may not be considered public information or public records under applicable state and federal laws. To the extent that anything you contribute to the Services, including your personal information, is considered a public record or as otherwise belonging to a governmental entity and, therefore, subject to certain local, state or federal disclosure laws, such applicable laws will govern the use and required disclosure of such information. </span></p><h2 class="c1 c3" id="h.civhky9d7umo"><span>Data Requests</span></h2><p class="c1"><span>Users and group coordinators may request data related to their personal account and group(s) respectively. The data provided shall be related to the Consider.it plan chosen. Consider.it will take reasonable efforts to provide this data. Consider.it has the right to refuse repetitive or technically difficult requests. For information about how we collect and share user information, please refer to Consider.it&rsquo;s</span><span> <a class="c5" href="/privacy_policy">privacy policy</a></span><span>.</span></p><h2 class="c1 c3" id="h.emnayct82llp"><span>Limitation of Liability</span></h2><p class="c1"><span>In no event shall Consider.it, its affiliates or their respective officers, directors, members, managers, partners, employees, or agents (or the Sponsor) be liable to you or any third party for any special, punitive, incidental, indirect or consequential damages or losses of any kind, or any damages or losses whatsoever, including those resulting from loss of use, data or profits, whether or not foreseeable or if Consider.it (or the Sponsor) has been advised of the possibility of such damages or losses, and on any theory of liability, including breach of contract or warranty, negligence or other tortious action, or any other claim arising out of or in connection with: (i) the access or use or of or the inability to access or use the services; (ii) the statements or actions of any third party on or via the services; (iii) any dealings with vendors or other third parties; (iv) any unauthorized access to or alteration of your transmissions, submitted content or other data; (v) any information that is sent or received or not sent or received; (vi) any failure to store or loss of data, files, materials or other content; (vii) any services available that are delayed or interrupted; (viii) any web site referenced or linked to from this services; or ix) your access to or use of or inability to access or use any linked site. Some jurisdictions prohibit the exclusion or limitation of liability for consequential or incidental damages. Accordingly, the limitations and exclusions set forth above may not apply to you.</span></p><p class="c0"><span></span></p><p class="c1"><span>You understand that we cannot and do not guarantee or warrant that files available for downloading from the internet or the Site will be free of viruses or other destructive code. You are responsible for implementing sufficient procedures and checkpoints to satisfy your particular requirements for anti-virus protection and accuracy of data input and output, and for maintaining a means external to our site for any reconstruction of any lost data. WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES OR OTHER TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER EQUIPMENT, COMPUTER PROGRAMS, DATA OR OTHER PROPRIETARY MATERIAL DUE TO YOUR USE OF THE SITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE OR TO YOUR DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR ON ANY WEBSITE LINKED TO IT.</span></p><p class="c0"><span></span></p><p class="c1"><span>YOUR USE OF THE SITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE IS AT YOUR OWN RISK. THE SITE, ITS CONTENT AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE PROVIDED ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. NEITHER CONSIDER.IT NOR ANY PERSON ASSOCIATED WITH CONSIDER.IT MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS, SECURITY, RELIABILITY, QUALITY, ACCURACY OR AVAILABILITY OF THE SITE. WITHOUT LIMITING THE FOREGOING, NEITHER CONSIDER.IT NOR ANYONE ASSOCIATED WITH CONSIDER.IT REPRESENTS OR WARRANTS THAT THE SITE, ITS CONTENT OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE OR SERVICES WILL BE ACCURATE, RELIABLE, ERROR-FREE OR UNINTERRUPTED, THAT DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS OR THAT THE SITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE SITE WILL OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.</span></p><p class="c0"><span></span></p><p class="c1"><span>CONSIDER.IT HEREBY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY OR OTHERWISE, INCLUDING BUT NOT LIMITED TO ANY WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR PARTICULAR PURPOSE.</span></p><p class="c0"><span></span></p><p class="c1"><span>THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.</span></p><h2 class="c1 c3" id="h.vxk2pa6dld7y"><span>Change to Terms or Services</span></h2><p class="c1"><span>Consider.it may change the Terms and other guidelines and rules posted on the Site from time to time at its sole discretion. If we do so, we&rsquo;ll let you know either by posting the modified Terms on the Site or through other communications. Your continued access or use for the Services constitutes your acceptance of the changes. Your access to and use of the Site will be subject to the most current version of the Terms posted on the Site at the time of such use. Please regularly check the </span><span><a class="c5" href="terms_of_service">Terms of Service link</a></span><span> to view the then-current terms. If you don&rsquo;t agree to be bound by the modified Terms, then you may no longer use the Services. If you breach any of the Terms, your authorization to access or use our Services automatically terminates. Because our Services are evolving over time we may change or discontinue all or any part of the Services, at any time and without notice, at our sole discretion.</span></p><h2 class="c1 c3" id="h.ypa68ydlyz73"><span>Contact Information</span></h2><p class="c1"><span>If you have any questions about these Terms or the Services, please contact us at hello@consider.it</span><span>.</span></p><p class="c0"><span></span></p>';


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(15);
	
	document.addEventListener("keypress", function(e) {
	  var filter, key;
	  key = (e && e.keyCode) || e.keyCode;
	  if (key === 23) {
	    filter = fetch('homepage_filter');
	    filter.watched = !filter.watched;
	    return save(filter);
	  }
	});
	
	window.Notifications = ReactiveComponent({
	  displayName: 'Notifications',
	  render: function() {
	    var current_user, data, loc, prefs, ref, settings, subdomain;
	    data = this.data();
	    settings = {};
	    current_user = fetch('/current_user');
	    subdomain = fetch('/subdomain');
	    prefs = current_user.subscriptions;
	    loc = fetch('location');
	    if ((ref = loc.query_params) != null ? ref.unsubscribe : void 0) {
	      if (current_user.subscriptions['send_emails']) {
	        current_user.subscriptions['send_emails'] = null;
	        save(current_user);
	        this.local.unsubscribed = true;
	        save(this.local);
	      }
	      delete loc.query_params.unsubscribe;
	      save(loc);
	    }
	    return DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: '0px auto'
	      }
	    }, this.local.unsubscribed && !current_user.subscriptions['send_emails'] ? DIV({
	      style: {
	        border: "1px solid " + logo_red,
	        color: logo_red,
	        padding: '4px 8px'
	      }
	    }, TRANSLATE({
	      id: "email_notifications.unsubscribed_ack",
	      subdomain_name: subdomain.name
	    }, "You are unsubscribed from summary emails from {subdomain_name}.consider.it")) : void 0, DIV({
	      style: {
	        fontSize: 24,
	        marginBottom: 10,
	        position: 'relative'
	      }
	    }, H1({
	      style: {
	        fontSize: 28,
	        padding: '20px 0',
	        fontWeight: 400
	      }
	    }, TRANSLATE("email_notifications.heading", 'Email notification settings')), INPUT({
	      type: 'checkbox',
	      defaultChecked: !!prefs['send_emails'],
	      id: 'enable_email',
	      name: 'enable_email',
	      style: {
	        verticalAlign: 'top',
	        display: 'inline-block',
	        marginTop: 12,
	        fontSize: 24,
	        position: 'absolute',
	        left: -40
	      },
	      onChange: (function(_this) {
	        return function(e) {
	          if (prefs['send_emails']) {
	            current_user.subscriptions['send_emails'] = null;
	          } else {
	            current_user.subscriptions['send_emails'] = settings['default_subscription'];
	          }
	          save(current_user);
	          return e.stopPropagation();
	        };
	      })(this)
	    }), DIV({
	      style: {
	        display: 'inline-block'
	      }
	    }, LABEL({
	      htmlFor: 'enable_email'
	    }, SPAN({
	      style: {
	        color: focus_color(),
	        fontWeight: 600
	      }
	    }, TRANSLATE("email_notifications.send_digests", 'Send me email summaries of activity')), DIV({
	      style: {
	        fontSize: 14,
	        color: '#888'
	      }
	    }, TRANSLATE({
	      id: "email_notifications.digests_purpose",
	      project_name: subdomain.app_title || subdomain.name
	    }, "The emails summarize relevant new activity for you regarding {project_name}"))))), prefs['send_emails'] ? [this.drawEmailSettings(), this.drawWatched()] : void 0);
	  },
	  drawEmailSettings: function() {
	    var config, current_user, event, settings, u;
	    current_user = fetch('/current_user');
	    settings = current_user.subscriptions;
	    return DIV({
	      style: {
	        padding: '10px 10px 10px 30px'
	      }
	    }, LABEL({
	      htmlFor: 'send_digests_at_most',
	      style: {
	        marginRight: 10,
	        display: 'inline-block'
	      }
	    }, TRANSLATE("email_notifications.digest_timing", "Send email summaries at most")), SELECT({
	      id: 'send_digests_at_most',
	      style: {
	        width: 120,
	        fontSize: 18
	      },
	      value: settings['send_emails'],
	      onChange: (function(_this) {
	        return function(e) {
	          current_user.subscriptions['send_emails'] = e.target.value;
	          return save(current_user);
	        };
	      })(this)
	    }, (function() {
	      var i, len, ref, results;
	      ref = ['hour', 'day', 'week', 'month'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        u = ref[i];
	        results.push(OPTION({
	          value: "1_" + u
	        }, u === 'day' ? translator("email_notifications.frequency.daily", 'daily') : translator("email_notifications.frequency." + u + "ly", u + "ly")));
	      }
	      return results;
	    })()), DIV({
	      style: {
	        marginTop: 15
	      }
	    }, DIV({
	      style: {
	        marginBottom: 10
	      }
	    }, TRANSLATE('email_notifications.notable_events', "Emails are only sent if a notable event occurred. Which events are notable to you?")), UL({
	      style: {
	        listStyle: 'none'
	      }
	    }, (function() {
	      var i, len, ref, results;
	      ref = _.keys(settings).sort();
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        event = ref[i];
	        config = settings[event];
	        if (!config.ui_label) {
	          continue;
	        }
	        results.push(LI({
	          style: {
	            display: 'block',
	            padding: '5px 0'
	          }
	        }, SPAN({
	          style: {
	            display: 'inline-block',
	            verticalAlign: 'top',
	            position: 'relative'
	          }
	        }, INPUT({
	          id: event + "_input",
	          name: event + "_input",
	          type: 'checkbox',
	          checked: config.email_trigger ? true : void 0,
	          style: {
	            fontSize: 24,
	            position: 'absolute',
	            left: -30,
	            top: 2
	          },
	          onChange: (function(_this) {
	            return function(config) {
	              return function() {
	                config.email_trigger = !config.email_trigger;
	                return save(current_user);
	              };
	            };
	          })(this)(config)
	        })), LABEL({
	          htmlFor: event + "_input",
	          style: {
	            display: 'inline-block',
	            verticalAlign: 'top'
	          }
	        }, TRANSLATE("email_notifications.event." + event, config.ui_label))));
	      }
	      return results;
	    }).call(this))));
	  },
	  drawWatched: function() {
	    var current_user, k, ref, unsubscribed, v;
	    current_user = fetch('/current_user');
	    unsubscribed = {};
	    ref = current_user.subscriptions;
	    for (k in ref) {
	      v = ref[k];
	      if (v === 'watched' && k.match(/\/proposal\//)) {
	        unsubscribed[k] = v;
	      }
	    }
	    if (_.keys(unsubscribed).length > 0) {
	      return DIV({
	        style: {
	          padding: '20px 0'
	        }
	      }, H2({
	        style: {
	          fontSize: 24,
	          position: 'relative',
	          paddingBottom: 10,
	          fontWeight: 400
	        }
	      }, TRANSLATE("email_notifications.watched_proposals", 'The proposals you are watching for new activity')), DIV({
	        style: {
	          width: 550,
	          display: 'inline-block'
	        }
	      }, UL({
	        style: {
	          position: 'relative',
	          paddingLeft: 30
	        }
	      }, (function() {
	        var results;
	        results = [];
	        for (k in unsubscribed) {
	          v = unsubscribed[k];
	          results.push((function(_this) {
	            return function(k) {
	              var obj;
	              obj = fetch(k);
	              return LI({
	                style: {
	                  listStyle: 'none',
	                  padding: '5px 0',
	                  position: 'relative'
	                }
	              }, WatchStar({
	                proposal: obj,
	                watch_color: "#777",
	                label: function(watching) {
	                  return translator("email_notifications.unfollow_proposal", "Unfollow this proposal");
	                },
	                style: {
	                  position: 'absolute',
	                  left: -35,
	                  top: 3
	                }
	              }), A({
	                href: "/" + obj.slug,
	                style: {
	                  textDecoration: 'underline'
	                }
	              }, obj.name));
	            };
	          })(this)(k));
	        }
	        return results;
	      }).call(this))));
	    }
	  }
	});


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(9);
	
	__webpack_require__(1);
	
	__webpack_require__(2);
	
	window.OpinionSlider = ReactiveComponent({
	  displayName: 'OpinionSlider',
	  render: function() {
	    var hist, hist_selection, slider, slider_style, your_opinion;
	    this.proposal || (this.proposal = fetch(this.props.proposal));
	    slider = fetch(this.props.key);
	    your_opinion = fetch(this.props.your_opinion);
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    hist_selection = hist.selected_opinions || hist.selected_opinion;
	    if (slider.value !== your_opinion.stance && !slider.has_moved) {
	      slider.value = your_opinion.stance;
	      if (your_opinion.stance) {
	        slider.has_moved = true;
	      }
	      save(slider);
	    }
	    slider_style = {
	      position: 'relative',
	      left: -(this.props.width - PROPOSAL_HISTO_WIDTH()) / 2,
	      width: this.props.width,
	      height: SLIDER_HANDLE_SIZE()
	    };
	    if (this.props.backgrounded) {
	      css.grayscale(slider_style);
	    }
	    return DIV({
	      className: 'opinion_slider',
	      style: slider_style
	    }, (this.props.focused || TWO_COL()) && this.props.permitted && !hist_selection ? this.drawFeedback() : void 0, Slider({
	      key: this.props.key,
	      width: this.props.width,
	      handle_height: SLIDER_HANDLE_SIZE(),
	      base_height: 6,
	      base_color: 'transparent',
	      base_endpoint: slider.docked ? 'square' : 'sharp',
	      regions: customization('slider_regions', this.proposal),
	      polarized: true,
	      draw_helpers: this.props.focused && !slider.has_moved,
	      handle: this.props.backgrounded ? slider_handle.flat : customization('slider_handle', this.proposal),
	      handle_props: {
	        color: this.props.backgrounded ? '#ccc' : focus_color(),
	        detail: this.props.focused
	      },
	      handle_style: {
	        transition: "transform " + TRANSITION_SPEED + "ms",
	        transform: "scale(" + (!this.props.focused || slider.docked ? 1 : 2.5) + ")",
	        visibility: hist_selection || !this.props.permitted ? 'hidden' : void 0
	      },
	      onMouseUpCallback: this.handleMouseUp,
	      respond_to_click: false,
	      label: translator({
	        id: "sliders.instructions-with-proposal",
	        negative_pole: this.props.pole_labels[0],
	        positive_pole: this.props.pole_labels[1],
	        proposal_name: this.proposal.name
	      }, "Express your opinion on a slider from {negative_pole} to {positive_pole} about {proposal_name}"),
	      readable_text: (function(_this) {
	        return function(value) {
	          if (value > .03) {
	            return ((value * 100).toFixed(0)) + "% " + _this.props.pole_labels[1];
	          } else if (value < -.03) {
	            return (-1 * (value * 100).toFixed(0)) + "% " + _this.props.pole_labels[0];
	          } else {
	            return translator("sliders.feedback-short.neutral", "Neutral");
	          }
	        };
	      })(this)
	    }), this.saveYourOpinionNotice());
	  },
	  saveYourOpinionNotice: function() {
	    var current_user, notice, s, slider, style, your_opinion;
	    your_opinion = fetch(this.props.your_opinion);
	    slider = fetch(this.props.key);
	    current_user = fetch('/current_user');
	    if ((!TWO_COL() && customization('discussion_enabled', this.proposal)) || (your_opinion.published || (!slider.has_moved && your_opinion.point_inclusions.length === 0)) || slider.is_moving) {
	      return SPAN(null);
	    }
	    style = {
	      padding: 10,
	      color: 'white',
	      textAlign: 'center',
	      fontSize: 16,
	      margin: '10px 0',
	      position: 'relative',
	      fontWeight: 700,
	      textDecoration: 'underline',
	      cursor: 'pointer',
	      color: focus_color()
	    };
	    notice = current_user.logged_in ? translator("engage.save_opinion_button", "Save your opinion") : translator("engage.login_to_save_opinion", 'Log in to save your opinion');
	    s = sizeWhenRendered(notice, style);
	    return DIV({
	      style: {
	        width: this.props.width,
	        margin: 'auto',
	        position: 'relative'
	      }
	    }, A({
	      style: _.extend(style, {
	        left: (slider.value + 1) / 2 * this.props.width - s.width / 2 - 10
	      }),
	      onClick: (function(_this) {
	        return function() {
	          return saveOpinion(_this.proposal);
	        };
	      })(this)
	    }, notice));
	  },
	  drawFeedback: function() {
	    var default_feedback, feedback_left, feedback_style, feedback_width, func, labels, slider, slider_feedback;
	    slider = fetch(this.props.key);
	    default_feedback = function(value, proposal) {
	      if (Math.abs(value) < 0.02) {
	        return translator("sliders.feedback.neutral", "You are neutral");
	      } else {
	        return (Math.round(value * 100)) + "%";
	      }
	    };
	    labels = customization('slider_pole_labels', this.proposal);
	    slider_feedback = !slider.has_moved ? TRANSLATE("sliders.slide_prompt", 'Slide Your Overall Opinion') : (func = labels.slider_feedback || default_feedback) ? func(slider.value, this.proposal) : TWO_COL() ? TRANSLATE("sliders.slide_feedback_short", "Your opinion") : '';
	    if (slider_feedback === '') {
	      return SPAN(null);
	    }
	    feedback_style = {
	      pointerEvents: 'none',
	      fontSize: TWO_COL() ? 22 : 30,
	      fontWeight: !TWO_COL() ? 700 : void 0,
	      color: this.props.backgrounded ? '#eee' : focus_color(),
	      textAlign: 'center'
	    };
	    feedback_left = this.props.width * (slider.value + 1) / 2;
	    feedback_width = widthWhenRendered(slider_feedback, feedback_style) + 10;
	    if (slider.docked) {
	      if (slider.value > 0) {
	        feedback_left = Math.min(this.props.width - feedback_width / 2, feedback_left);
	      } else {
	        feedback_left = Math.max(feedback_width / 2, feedback_left);
	      }
	    }
	    _.extend(feedback_style, {
	      position: 'absolute',
	      top: slider.docked ? -57 : !TWO_COL() ? -80 : 37,
	      left: feedback_left,
	      marginLeft: -feedback_width / 2,
	      width: feedback_width
	    });
	    return DIV({
	      'aria-hidden': true,
	      style: feedback_style
	    }, slider_feedback);
	  },
	  handleMouseUp: function(e) {
	    var mode, new_page, slider, transition, your_opinion;
	    slider = fetch(this.props.key);
	    your_opinion = fetch(this.props.your_opinion);
	    mode = get_proposal_mode();
	    e.stopPropagation();
	    transition = !TWO_COL() && (slider.value === your_opinion.stance || mode === 'results') && customization('discussion_enabled', this.proposal);
	    if (transition) {
	      new_page = mode === 'results' ? 'crafting' : 'results';
	      updateProposalMode(new_page, 'click_slider');
	    }
	    if (your_opinion.stance !== slider.value) {
	      your_opinion.stance = slider.value;
	      if (!transition && fetch('/current_user').logged_in) {
	        your_opinion.published = true;
	      }
	      save(your_opinion);
	      return window.writeToLog({
	        what: 'move slider',
	        details: {
	          stance: slider.value
	        }
	      });
	    }
	  }
	});


/***/ },
/* 42 */
/***/ function(module, exports) {

	window.Point = ReactiveComponent({
	  displayName: 'Point',
	  render: function() {
	    var append, can_opine, current_user, draw_all_includers, expand_to_see_details, includePoint, included, includers_style, ioffset, is_selected, left_or_right, mouth_style, point, point_content_style, point_style, renderIncluders, right, side, sty, your_opinion;
	    point = this.data();
	    is_selected = get_selected_point() === this.props.key;
	    current_user = fetch('/current_user');
	    renderIncluders = (function(_this) {
	      return function(draw_all_includers) {
	        var curr_column, i, includer, includers, left_right, s, side_offset, style, top_offset;
	        if (_this.data().includers) {
	          if (draw_all_includers) {
	            includers = _this.buildIncluders();
	          } else {
	            includers = [point.user];
	          }
	          s = {
	            rows: 8,
	            dx: 2,
	            dy: 5,
	            col_gap: 8
	          };
	          if (includers.length === 0) {
	            includers = [point.user];
	          }
	          i = includers.length;
	          return DIV(null, (function() {
	            var j, len, results;
	            results = [];
	            for (j = 0, len = includers.length; j < len; j++) {
	              includer = includers[j];
	              i -= 1;
	              curr_column = Math.floor(i / s.rows);
	              side_offset = curr_column * s.col_gap + i * s.dx;
	              top_offset = (i % s.rows) * s.dy;
	              left_right = this.data().is_pro ? 'left' : 'right';
	              style = {
	                top: top_offset,
	                position: 'absolute'
	              };
	              style[left_right] = side_offset;
	              results.push(Avatar({
	                key: includer,
	                className: "point_includer_avatar",
	                style: style,
	                anonymous: point.user === includer && point.hide_name
	              }));
	            }
	            return results;
	          }).call(_this));
	        }
	      };
	    })(this);
	    point_content_style = {
	      width: POINT_WIDTH(),
	      borderWidth: 3,
	      borderStyle: 'solid',
	      borderColor: 'transparent',
	      top: -3,
	      position: 'relative',
	      zIndex: 1,
	      outline: 'none'
	    };
	    if (is_selected) {
	      _.extend(point_content_style, {
	        borderColor: focus_color(),
	        backgroundColor: 'white'
	      });
	    } else if (this.local.has_focus) {
	      _.extend(point_content_style, {
	        borderColor: '#999',
	        backgroundColor: 'white'
	      });
	    }
	    if (this.props.rendered_as === 'decision_board_point') {
	      _.extend(point_content_style, {
	        padding: 8,
	        borderRadius: 8,
	        top: point_content_style.top - 8,
	        left: -11
	      });
	    } else if (this.props.rendered_as === 'community_point') {
	      _.extend(point_content_style, {
	        padding: 8,
	        borderRadius: TWO_COL() ? "16px 16px 0 0" : 16,
	        top: point_content_style.top - 8
	      });
	    }
	    expand_to_see_details = !!point.text;
	    point_style = {
	      position: 'relative',
	      listStyle: 'none outside none'
	    };
	    if (this.props.rendered_as === 'decision_board_point') {
	      _.extend(point_style, {
	        marginLeft: 9,
	        padding: '0 18px 0 18px'
	      });
	    } else if (this.props.rendered_as === 'community_point') {
	      point_style.marginBottom = '0.5em';
	    }
	    includers_style = {
	      position: 'absolute',
	      height: 25,
	      width: 25,
	      top: 0
	    };
	    left_or_right = this.data().is_pro && this.props.rendered_as !== 'decision_board_point' ? 'right' : 'left';
	    ioffset = -50;
	    includers_style[left_or_right] = ioffset;
	    draw_all_includers = this.props.rendered_as === 'community_point' || TWO_COL();
	    if (expand_to_see_details && !is_selected) {
	      append = SPAN({
	        key: 1,
	        style: {
	          fontSize: 10,
	          color: '#888'
	        }
	      }, " (" + (translator({
	        id: "engage.read_more"
	      }, "read more")) + ")");
	    } else {
	      append = null;
	    }
	    return LI({
	      key: "point-" + point.id,
	      'data-id': this.props.key,
	      className: "point " + this.props.rendered_as + " " + (point.is_pro ? 'pro' : 'con'),
	      onClick: this.selectPoint,
	      onTouchEnd: this.selectPoint,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if ((is_selected && e.which === 27) || e.which === 13 || e.which === 32) {
	            _this.selectPoint(e);
	            return e.preventDefault();
	          }
	        };
	      })(this),
	      style: point_style
	    }, this.props.rendered_as === 'decision_board_point' ? DIV({
	      style: {
	        position: 'absolute',
	        left: 0,
	        top: 0
	      }
	    }, this.data().is_pro ? '•' : '•') : void 0, DIV({
	      className: 'point_content',
	      style: point_content_style,
	      tabIndex: 0,
	      onBlur: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, this.props.rendered_as !== 'decision_board_point' ? (side = point.is_pro ? 'right' : 'left', mouth_style = {
	      top: 8,
	      position: 'absolute'
	    }, mouth_style[side] = -POINT_MOUTH_WIDTH + (is_selected || this.local.has_focus ? 3 : 1), !point.is_pro ? mouth_style['transform'] = 'rotate(270deg) scaleX(-1)' : mouth_style['transform'] = 'rotate(90deg)', DIV({
	      'role': 'presentation',
	      key: 'community_point_mouth',
	      style: css.crossbrowserify(mouth_style)
	    }, Bubblemouth({
	      apex_xfrac: 0,
	      width: POINT_MOUTH_WIDTH,
	      height: POINT_MOUTH_WIDTH,
	      fill: considerit_gray,
	      stroke: is_selected ? focus_color() : this.local.has_focus ? '#888' : 'transparent',
	      stroke_width: is_selected || this.local.has_focus ? 20 : 0,
	      box_shadow: {
	        dx: 3,
	        dy: 0,
	        stdDeviation: 2,
	        opacity: .5
	      }
	    }))) : void 0, DIV({
	      style: {
	        wordWrap: 'break-word',
	        fontSize: POINT_FONT_SIZE()
	      }
	    }, DIV({
	      className: 'point_nutshell'
	    }, splitParagraphs(point.nutshell, append)), DIV({
	      id: "point-aria-interaction-" + point.id,
	      className: 'hidden'
	    }, translator({
	      id: "engage.point_explanation",
	      author: point.hide_name ? 'Anonymous' : fetch(point.user).name,
	      num_inclusions: this.data().includers.length,
	      comment_count: point.comment_count
	    }, "By {author}. \n{ num_inclusions, plural, =0 {} one {Important to one person.} other {Important to # people.} } \n{comment_count, plural, =0 {} one {Has received one comment.} other {Has received # comments.} }\nPress ENTER or SPACE for details or discussion.")), DIV({
	      'aria-hidden': true,
	      className: "point_details" + (is_selected ? '' : '_tease'),
	      style: {
	        wordWrap: 'break-word',
	        marginTop: '0.5em',
	        fontSize: POINT_FONT_SIZE(),
	        fontWeight: browser.high_density_display && !browser.is_mobile ? 300 : 400
	      }
	    }, DIV({
	      style: {
	        fontSize: 12
	      }
	    }, prettyDate(point.created_at), ', ', SPAN({
	      key: 2,
	      style: {
	        whiteSpace: 'nowrap'
	      }
	    }, A({
	      className: 'select_point'
	    }, translator({
	      id: 'engage.link_to_comments',
	      comment_count: point.comment_count
	    }, "{comment_count, plural, one {# comment} other {# comments}}")))))), current_user.user === point.user ? DIV(null, permit('update point', point) > 0 && (this.props.rendered_as === 'decision_board_point' || TWO_COL()) ? BUTTON({
	      style: {
	        fontSize: browser.is_mobile ? 24 : 14,
	        color: focus_color(),
	        padding: '3px 12px 3px 0',
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onClick: ((function(_this) {
	        return function(e) {
	          var points;
	          e.stopPropagation();
	          points = fetch(_this.props.your_points_key);
	          points.editing_points.push(_this.props.key);
	          return save(points);
	        };
	      })(this))
	    }, translator('engage.edit_button', 'edit')) : void 0, permit('delete point', point) > 0 && (this.props.rendered_as === 'decision_board_point' || TWO_COL()) ? BUTTON({
	      'data-action': 'delete-point',
	      style: {
	        fontSize: browser.is_mobile ? 24 : 14,
	        color: focus_color(),
	        padding: '3px 8px',
	        backgroundColor: 'transparent',
	        border: 'none'
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          e.stopPropagation();
	          if (confirm('Delete this point forever?')) {
	            return destroy(_this.props.key);
	          }
	        };
	      })(this)
	    }, translator('engage.delete_button', 'delete')) : void 0) : void 0), this.props.rendered_as !== 'decision_board_point' ? DIV({
	      'aria-hidden': true,
	      className: 'includers',
	      onMouseEnter: this.highlightIncluders,
	      onMouseLeave: this.unHighlightIncluders,
	      style: includers_style
	    }, renderIncluders(draw_all_includers)) : void 0, TWO_COL() || (!TWO_COL() && this.props.enable_dragging) ? (your_opinion = fetch(this.proposal.your_opinion), (your_opinion != null ? your_opinion.published : void 0) ? can_opine = permit('update opinion', this.proposal, your_opinion) : can_opine = permit('publish opinion', this.proposal), included = this.included(), includePoint = (function(_this) {
	      return function(e) {
	        e.stopPropagation();
	        e.preventDefault();
	        if (!(e.type !== 'click' || (!browser.is_android_browser && e.type === 'click'))) {
	          return;
	        }
	        if (included) {
	          return _this.remove();
	        } else {
	          return _this.include();
	        }
	      };
	    })(this), !TWO_COL() && this.props.enable_dragging ? (right = (included && point.is_pro) || (!included && !point.is_pro), right ? sty = {
	      right: !this.local.focused_include ? 20 : included ? -20 : -40
	    } : sty = {
	      left: !this.local.focused_include ? 20 : included ? -20 : -40
	    }, BUTTON({
	      'aria-label': included ? translator('engage.uninclude_explanation', 'Mark this point as unimportant and move to next point') : translator('engage.include_explanation', 'Mark this point as important and move to next point'),
	      style: _.extend(sty, {
	        position: 'absolute',
	        top: 20,
	        opacity: !this.local.focused_include ? 0 : void 0,
	        padding: 0,
	        backgroundColor: 'transparent',
	        border: 'none',
	        display: get_selected_point() ? 'none' : void 0
	      }),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.focused_include = true;
	          return save(_this.local);
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          _this.local.focused_include = false;
	          return save(_this.local);
	        };
	      })(this),
	      onTouchEnd: includePoint,
	      onClick: includePoint,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          var next, valence;
	          if (e.which === 13 || e.which === 32) {
	            next = $(e.target).closest('.point').next().find('.point_content');
	            includePoint(e);
	            valence = _this.data().is_pro ? 'pros' : 'cons';
	            next.focus();
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, I({
	      style: {
	        fontSize: included ? 25 : 40,
	        color: focus_color()
	      },
	      className: "fa fa-long-arrow-" + (!right ? 'left' : 'right')
	    }))) : BUTTON({
	      style: {
	        border: "1px solid " + (included || this.local.hover_important ? focus_color() : '#414141'),
	        borderTopColor: included ? focus_color() : 'transparent',
	        color: included ? 'white' : this.local.hover_important ? focus_color() : "#414141",
	        position: 'relative',
	        top: -13,
	        padding: '8px 5px',
	        textAlign: 'center',
	        borderRadius: '0 0 16px 16px',
	        cursor: 'pointer',
	        backgroundColor: included ? focus_color() : 'white',
	        fontSize: 18,
	        zIndex: 0,
	        display: can_opine < 0 ? 'none' : void 0,
	        width: '100%'
	      },
	      onMouseEnter: (function(_this) {
	        return function() {
	          _this.local.hover_important = true;
	          return save(_this.local);
	        };
	      })(this),
	      onMouseLeave: (function(_this) {
	        return function() {
	          _this.local.hover_important = false;
	          return save(_this.local);
	        };
	      })(this),
	      onTouchEnd: includePoint,
	      onClick: includePoint,
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            includePoint(e);
	            return e.preventDefault();
	          }
	        };
	      })(this)
	    }, I({
	      className: 'fa fa-thumbs-o-up',
	      style: {
	        display: 'inline-block',
	        marginRight: 10
	      }
	    }), translator("engage.include_button", "Important point") + ("" + (included ? '' : '?')))) : void 0, is_selected ? Discussion({
	      key: "/comments/" + point.id,
	      point: point.key,
	      rendered_as: this.props.rendered_as
	    }) : void 0);
	  },
	  componentDidMount: function() {
	    this.setDraggability();
	    return this.ensureDiscussionIsInViewPort();
	  },
	  componentDidUpdate: function() {
	    this.setDraggability();
	    return this.ensureDiscussionIsInViewPort();
	  },
	  ensureDiscussionIsInViewPort: function() {
	    var i, is_selected;
	    is_selected = get_selected_point() === this.props.key;
	    if (this.local.is_selected !== is_selected) {
	      if (is_selected) {
	        if (browser.is_mobile) {
	          $(this.getDOMNode()).moveToTop({
	            scroll: false
	          });
	        } else {
	          $(this.getDOMNode()).ensureInView({
	            scroll: false
	          });
	        }
	        i = setInterval(function() {
	          if ($('#open_point').length > 0) {
	            $('#open_point').focus();
	            return clearInterval(i);
	          }
	        }, 10);
	      }
	      this.local.is_selected = is_selected;
	      return save(this.local);
	    }
	  },
	  setDraggability: function() {
	    var $point_content, revert;
	    $point_content = $(this.getDOMNode()).find('.point_content');
	    revert = this.props.rendered_as === 'community_point' ? 'invalid' : (function(_this) {
	      return function(valid) {
	        if (!valid) {
	          _this.remove();
	        }
	        return valid;
	      };
	    })(this);
	    if ($point_content.hasClass("ui-draggable")) {
	      return $point_content.draggable(this.props.enable_dragging ? 'enable' : 'disable');
	    } else {
	      return $point_content.draggable({
	        revert: revert,
	        disabled: !this.props.enable_dragging
	      });
	    }
	  },
	  included: function() {
	    var your_opinion;
	    your_opinion = fetch(this.proposal.your_opinion);
	    return your_opinion.point_inclusions.indexOf(this.props.key) > -1;
	  },
	  remove: function() {
	    var $point_content, pnt, validate_first, your_opinion;
	    pnt = fetch(this.props.key);
	    validate_first = pnt.user === fetch('/current_user').user && pnt.includers.length < 2;
	    if (!validate_first || confirm('Are you sure you want to remove your point? It will be gone forever.')) {
	      your_opinion = fetch(this.proposal.your_opinion);
	      your_opinion.point_inclusions = _.without(your_opinion.point_inclusions, this.props.key);
	      save(your_opinion);
	      return window.writeToLog({
	        what: 'removed point',
	        details: {
	          point: this.props.key
	        }
	      });
	    } else {
	      $point_content = $(this.getDOMNode()).find('.point_content');
	      $point_content.css('left', '-11px');
	      return $point_content.css('top', '-11px');
	    }
	  },
	  include: function() {
	    var your_opinion;
	    your_opinion = fetch(this.proposal.your_opinion);
	    your_opinion.point_inclusions.push(this.data().key);
	    save(your_opinion);
	    return window.writeToLog({
	      what: 'included point',
	      details: {
	        point: this.data().key
	      }
	    });
	  },
	  selectPoint: function(e) {
	    var loc, what;
	    e.stopPropagation();
	    if (!((browser.is_mobile && e.type !== 'click') || (!browser.is_mobile && e.type === 'click') || e.type === 'keydown')) {
	      return;
	    }
	    loc = fetch('location');
	    if (get_selected_point() === this.props.key) {
	      delete loc.query_params.selected;
	      what = 'deselected a point';
	      document.activeElement.blur();
	    } else {
	      what = 'selected a point';
	      loc.query_params.selected = this.props.key;
	    }
	    save(loc);
	    return window.writeToLog({
	      what: what,
	      details: {
	        point: this.props.key
	      }
	    });
	  },
	  highlightIncluders: function() {
	    var hist, includers, point;
	    point = this.data();
	    includers = point.includers;
	    if (point.hide_name) {
	      includers = _.without(includers, point.user);
	    }
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    if (hist.highlighted_users !== includers) {
	      hist.highlighted_users = includers;
	      return save(hist);
	    }
	  },
	  unHighlightIncluders: function() {
	    var hist;
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    hist.highlighted_users = null;
	    return save(hist);
	  },
	  buildIncluders: function() {
	    var filter_out, hist, i, includers, o, point, selected_opinions, selected_users;
	    filter_out = fetch('filtered');
	    point = this.data();
	    includers = point.includers;
	    hist = fetch(namespaced_key('histogram', this.proposal));
	    selected_opinions = hist.selected_opinion ? [hist.selected_opinion] : hist.selected_opinions;
	    if ((selected_opinions != null ? selected_opinions.length : void 0) > 0) {
	      selected_users = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = selected_opinions.length; j < len; j++) {
	          o = selected_opinions[j];
	          results.push(fetch(o).user);
	        }
	        return results;
	      })();
	      includers = _.intersection(includers, selected_users);
	    }
	    if (filter_out.users) {
	      includers = (function() {
	        var j, len, results;
	        results = [];
	        for (j = 0, len = includers.length; j < len; j++) {
	          i = includers[j];
	          if (!filter_out.users[i]) {
	            results.push(i);
	          }
	        }
	        return results;
	      })();
	    }
	    if (true) {
	      includers = _.without(includers, point.user);
	      includers.push(point.user);
	    }
	    return _.uniq(includers);
	  }
	});
	
	styles += "\n/* war! disabled jquery UI draggable class defined with !important */\n.point_content.ui-draggable-disabled {\n  cursor: pointer !important; }\n\n" + (css.grab_cursor('.point_content.ui-draggable')) + "\n\n.community_point .point_content {\n  border-radius: 16px;\n  padding: 0.5em 9px;\n  background-color: " + considerit_gray + ";\n  box-shadow: #b5b5b5 0 1px 1px 0px;\n  min-height: 34px; }\n\n.point_nutshell a { text-decoration: underline; }\n.point_details_tease a, .point_details a {\n  text-decoration: underline;\n  word-break: break-all; }\n.point_details a.select_point{text-decoration: none;}\n\n.point_details {\n  display: block; }\n\n.point_details_tease {\n  cursor: pointer; }\n  .point_details_tease a.select_point {\n    text-decoration: none; }\n    .point_details_tease a.select_point:hover {\n      text-decoration: underline; }\n\n.point_details p {\n  margin-bottom: 1em; }\n\n.point_details p:last-child {\n  margin-bottom: 0; }\n\n.point_includer_avatar {\n  width: 22px;\n  height: 22px; }\n\n.community_point.con .point_includer_avatar {\n  box-shadow: -1px 2px 0 0 #eeeeee; }\n\n.community_point.pro .point_includer_avatar {\n  box-shadow: 1px 2px 0 0 #eeeeee; }\n\n.decision_board_point.pro .point_includer_avatar {\n  left: -10px; }\n";
	
	window.Comment = ReactiveComponent({
	  displayName: 'Comment',
	  render: function() {
	    var comment, comment_action_style, current_user;
	    comment = this.data();
	    current_user = fetch('/current_user');
	    if (comment.editing) {
	      return EditComment({
	        fresh: false,
	        point: comment.point,
	        key: comment.key
	      });
	    } else {
	      return DIV({
	        className: 'comment_entry'
	      }, DIV({
	        className: 'comment_entry_name'
	      }, fetch(comment.user).name + ':'), Avatar({
	        key: comment.user,
	        hide_tooltip: true,
	        style: {
	          position: 'absolute',
	          width: 50,
	          height: 50
	        }
	      }), DIV({
	        className: 'comment_entry_body'
	      }, splitParagraphs(comment.body)), current_user.user === comment.user ? permit('update comment', comment) > 0 ? (comment_action_style = {
	        color: '#444',
	        textDecoration: 'underline',
	        cursor: 'pointer',
	        padding: '0 10px 0 0',
	        backgroundColor: 'transparent',
	        border: 'none'
	      }, DIV({
	        style: {
	          marginLeft: 60
	        }
	      }, BUTTON({
	        'data-action': 'delete-comment',
	        style: comment_action_style,
	        onClick: (function(_this) {
	          return function(key) {
	            return function(e) {
	              e.stopPropagation();
	              if (confirm('Delete this comment forever?')) {
	                return destroy(key);
	              }
	            };
	          };
	        })(this)(comment.key)
	      }, translator('engage.delete_button', 'delete')), BUTTON({
	        style: comment_action_style,
	        onClick: (function(_this) {
	          return function(key) {
	            return function(e) {
	              e.stopPropagation();
	              comment.editing = true;
	              return save(comment);
	            };
	          };
	        })(this)(comment.key)
	      }, translator('engage.edit_button', 'edit')))) : void 0 : void 0);
	    }
	  }
	});
	
	styles += ".comment_entry {\n  margin-bottom: 25px;\n  min-height: 60px;\n  position: relative; }\n\n.comment_entry_name {\n  font-weight: 600;\n  color: #666666; }\n\n.comment_entry_body {\n  margin-left: 60px;\n  word-wrap: break-word;\n  position: relative; }\n  .comment_entry_body a {\n    text-decoration: underline; }\n  .comment_entry_body strong {\n    font-weight: 600; }\n  .comment_entry_body p {\n    margin-bottom: 1em; }";
	
	window.Discussion = ReactiveComponent({
	  displayName: 'Discussion',
	  render: function() {
	    var HEADING, close_point, comment, comments, discussion_style, in_wings, is_pro, mouth_style, point, point_included, proposal, ref, side, trans_func, your_opinion;
	    point = fetch(this.props.point);
	    proposal = fetch(point.proposal);
	    is_pro = point.is_pro;
	    your_opinion = fetch(proposal.your_opinion);
	    point_included = _.contains(your_opinion.point_inclusions, point.key);
	    in_wings = get_proposal_mode() === 'crafting' && !point_included;
	    comments = this.discussion.comments;
	    comments.sort(function(a, b) {
	      return a.created_at > b.created_at;
	    });
	    discussion_style = {
	      width: DECISION_BOARD_WIDTH(),
	      border: "3px solid " + (focus_color()),
	      position: 'absolute',
	      zIndex: 100,
	      padding: '20px 40px',
	      borderRadius: 16,
	      backgroundColor: 'white',
	      outline: 'none',
	      boxShadow: this.local.has_focus ? "0 0 7px " + (focus_color()) : void 0
	    };
	    side = is_pro ? 'right' : 'left';
	    if (in_wings) {
	      discussion_style[side] = POINT_WIDTH() + 13;
	      discussion_style['top'] = 20;
	    } else {
	      discussion_style[side] = is_pro ? -23 : -30;
	      discussion_style['marginTop'] = 18;
	    }
	    mouth_style = {
	      position: 'absolute'
	    };
	    if (in_wings) {
	      mouth_style[side] = -29;
	      trans_func = 'rotate(270deg)';
	      if (is_pro) {
	        trans_func += ' scaleY(-1)';
	      }
	      _.extend(mouth_style, {
	        transform: trans_func,
	        top: 19
	      });
	    } else {
	      _.extend(mouth_style, {
	        left: is_pro ? 335 : 100,
	        top: -28,
	        transform: !is_pro ? 'scaleX(-1)' : void 0
	      });
	    }
	    close_point = function(e) {
	      var loc;
	      loc = fetch('location');
	      delete loc.query_params.selected;
	      save(loc);
	      e.preventDefault();
	      return e.stopPropagation();
	    };
	    HEADING = this.props.rendered_as !== 'decision_board_point' ? H4 : H5;
	    return SECTION({
	      id: 'open_point',
	      style: discussion_style,
	      tabIndex: 0,
	      onClick: function(e) {
	        return e.stopPropagation();
	      },
	      onTouchEnd: function(e) {
	        return e.stopPropagation();
	      },
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 27) {
	            return close_point(e);
	          }
	        };
	      })(this),
	      onBlur: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = false;
	          return save(_this.local);
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.has_focus = true;
	          return save(_this.local);
	        };
	      })(this)
	    }, DIV({
	      style: css.crossbrowserify(mouth_style)
	    }, Bubblemouth({
	      apex_xfrac: 1.1,
	      width: 36,
	      height: 28,
	      fill: 'white',
	      stroke: focus_color(),
	      stroke_width: 11
	    })), BUTTON({
	      'aria-label': 'close point',
	      onClick: close_point,
	      onKeyDown: function(e) {
	        if (e.which === 13 || e.which === 32) {
	          return close_point(e);
	        }
	      },
	      style: {
	        position: 'absolute',
	        right: 8,
	        top: 8,
	        fontSize: 24,
	        color: '#aaa',
	        backgroundColor: 'transparent',
	        border: 'none'
	      }
	    }, 'x'), ((ref = point.text) != null ? ref.length : void 0) > 0 ? SECTION({
	      style: {
	        marginBottom: 24,
	        marginTop: 10
	      }
	    }, HEADING({
	      style: {
	        textAlign: 'left',
	        fontSize: 24,
	        color: focus_color(),
	        fontWeight: 600,
	        marginBottom: 10
	      }
	    }, translator('engage.author_explanation', 'Author’s Explanation')), DIV({
	      className: 'point_details'
	    }, splitParagraphs(point.text))) : void 0, SECTION(null, HEADING({
	      style: {
	        textAlign: 'left',
	        fontSize: 24,
	        color: focus_color(),
	        marginBottom: 25,
	        marginTop: 10,
	        fontWeight: 600
	      }
	    }, translator("engage.point_details_heading", 'Discuss this Point')), DIV({
	      className: 'comments'
	    }, (function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = comments.length; j < len; j++) {
	        comment = comments[j];
	        results.push(Comment({
	          key: comment.key
	        }));
	      }
	      return results;
	    })()), EditComment({
	      fresh: true,
	      point: arest.key_id(this.props.key)
	    })));
	  },
	  componentDidUpdate: function() {
	    return this.setHeight();
	  },
	  componentDidMount: function() {
	    return this.setHeight();
	  },
	  setHeight: function() {
	    var dist_from_parent, open_point_height, s;
	    s = fetch('reasons_height_adjustment');
	    dist_from_parent = $(this.getDOMNode()).offset().top - $('.reasons_region').offset().top;
	    open_point_height = $(this.getDOMNode()).height() + dist_from_parent;
	    if (s.open_point_height !== open_point_height) {
	      s.open_point_height = open_point_height;
	      return save(s);
	    }
	  }
	});


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2);
	
	__webpack_require__(1);
	
	window.get_next_proposals = function(args) {
	  var all_proposals, all_proposals_flat, cluster, clusters, hala, i, idx, j, l, len, mod, next_idx, next_proposals, o, p, prev_idx, prev_proposals, proposal, ref, ref1, ref2, ref3, relative_to, subdomain;
	  relative_to = args.relative_to;
	  all_proposals = fetch('/proposals');
	  subdomain = fetch('/subdomain');
	  mod = function(n, m) {
	    return ((n % m) + m) % m;
	  };
	  if (!all_proposals.proposals || all_proposals.proposals.length === 0) {
	    return [[], []];
	  }
	  next_proposals = [];
	  prev_proposals = [];
	  clusters = clustered_proposals_with_tabs();
	  all_proposals_flat = _.flatten((function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = clusters.length; i < len; i++) {
	      cluster = clusters[i];
	      results.push(sorted_proposals(cluster.proposals));
	    }
	    return results;
	  })());
	  if (subdomain.name === 'HALA' && fetch('homepage_tabs').filter === 'Draft zoning changes') {
	    hala = fetch('hala');
	    hala.name || (hala.name = capitalize(relative_to.slug.split('--')[0].replace(/_/g, ' ')));
	    all_proposals_flat = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = all_proposals_flat.length; i < len; i++) {
	        p = all_proposals_flat[i];
	        if (p.name.toLowerCase().indexOf(hala.name.toLowerCase()) > -1) {
	          results.push(p);
	        }
	      }
	      return results;
	    })();
	  } else if ((ref = subdomain.name) === 'cprs-network' || ref === 'engage-cprs') {
	    all_proposals_flat = [];
	  }
	  idx = 0;
	  for (idx = i = 0, len = all_proposals_flat.length; i < len; idx = ++i) {
	    proposal = all_proposals_flat[idx];
	    if (proposal === relative_to) {
	      break;
	    }
	  }
	  next_idx = mod(idx + 1, all_proposals_flat.length);
	  prev_idx = mod(idx - 1, all_proposals_flat.length);
	  for (idx = j = 0, ref1 = (args.count || all_proposals.proposals.length) - 1; 0 <= ref1 ? j <= ref1 : j >= ref1; idx = 0 <= ref1 ? ++j : --j) {
	    if (!all_proposals_flat[next_idx + idx]) {
	      break;
	    }
	    if (all_proposals_flat[next_idx + idx].key === relative_to.key) {
	      continue;
	    }
	    next_proposals.push(all_proposals_flat[next_idx + idx]);
	  }
	  if (!args.count || (next_proposals.length < all_proposals.proposals.length && next_idx > 0)) {
	    for (idx = l = 0, ref2 = (args.count || all_proposals.proposals.length) - 1 - next_proposals.length; 0 <= ref2 ? l <= ref2 : l >= ref2; idx = 0 <= ref2 ? ++l : --l) {
	      if (!all_proposals_flat[idx] || all_proposals_flat[idx].key === relative_to.key) {
	        break;
	      }
	      next_proposals.push(all_proposals_flat[idx]);
	    }
	  }
	  for (idx = o = 0, ref3 = (args.count || all_proposals.proposals.length) - 1; 0 <= ref3 ? o <= ref3 : o >= ref3; idx = 0 <= ref3 ? ++o : --o) {
	    if (prev_idx - idx < 0) {
	      break;
	    }
	    if (!all_proposals_flat[prev_idx - idx] || all_proposals_flat[prev_idx - idx].key === relative_to.key) {
	      continue;
	    }
	    prev_proposals.push(all_proposals_flat[prev_idx - idx]);
	  }
	  return [prev_proposals, next_proposals];
	};
	
	window.NextProposals = ReactiveComponent({
	  displayName: 'NextProposals',
	  render: function() {
	    var cluster, count, dummy, hash, heading_style, i, idx, len, loc, next, proposal, ref, ref1, to_show, to_show_first, to_show_later;
	    ref = get_next_proposals({
	      relative_to: this.props.proposal
	    }), dummy = ref[0], next = ref[1];
	    count = this.props.count || 5;
	    to_show_first = [];
	    to_show_later = [];
	    for (i = 0, len = next.length; i < len; i++) {
	      proposal = next[i];
	      if (!proposal.your_opinion.published) {
	        to_show_first.push(proposal);
	      } else {
	        to_show_later.push(proposal);
	      }
	    }
	    to_show = to_show_first.concat(to_show_later);
	    if (to_show.length < 2 && (((ref1 = arest.cache['/proposals']) != null ? ref1.proposals : void 0) != null)) {
	      return SPAN(null);
	    }
	    heading_style = _.defaults({}, customization('list_label_style'), {
	      fontSize: 36,
	      fontWeight: 700,
	      fontStyle: 'oblique',
	      textAlign: 'center',
	      marginBottom: 18
	    });
	    loc = fetch('location');
	    hash = loc.url.split('/')[1].replace('-', '_');
	    return DIV({
	      style: {}
	    }, H2({
	      style: heading_style
	    }, TRANSLATE({
	      id: "engage.related_proposals"
	    }, 'Explore a related idea')), !to_show || to_show.length === 0 ? LOADING_INDICATOR : UL(null, (function() {
	      var j, len1, results;
	      results = [];
	      for (idx = j = 0, len1 = to_show.length; j < len1; idx = ++j) {
	        proposal = to_show[idx];
	        if (idx > count) {
	          break;
	        }
	        cluster = proposal.cluster || 'Proposals';
	        results.push(CollapsedProposal({
	          key: "collapsed" + (proposal.key || proposal),
	          proposal: proposal,
	          show_category: true,
	          width: this.props.width,
	          hide_scores: true
	        }));
	      }
	      return results;
	    }).call(this)), DIV({
	      style: {
	        textAlign: 'right',
	        fontSize: 22
	      }
	    }, TRANSLATE({
	      id: 'engage.back_to_homepage_option',
	      link: {
	        component: A,
	        args: {
	          href: "/#" + hash,
	          style: {
	            textDecoration: 'underline',
	            fontWeight: 600
	          }
	        }
	      }
	    }, "…or go <link>back to the homepage</link>")));
	  }
	});
	
	window.GroupedProposalNavigation = function(args) {
	  var active_list, active_section, cluster_key, current_section, hash, heading_style, heading_text, is_collapsed, k, list, list_items_title, lists, loc, local, name, proposals, proposals_by_list, sections, th, toggle_list, total_proposals, tw, v;
	  proposals = fetch('/proposals').proposals;
	  heading_style = _.defaults({}, customization('list_label_style'), {
	    fontSize: 36,
	    fontWeight: 700,
	    fontStyle: 'oblique',
	    textAlign: 'center',
	    marginBottom: 18
	  });
	  proposals_by_list = clustered_proposals(true);
	  sections = (function() {
	    var ref, results;
	    ref = customization('homepage_tabs');
	    results = [];
	    for (k in ref) {
	      v = ref[k];
	      results.push([k, v]);
	    }
	    return results;
	  })();
	  if (!sections || sections.length === 0) {
	    sections = [['all', _.keys(proposals_by_list)]];
	  }
	  active_list = args.proposal.cluster || 'Proposals';
	  local = fetch('popnav');
	  if (local.show == null) {
	    local.show = {};
	    local.show[args.proposal.cluster || 'Proposals'] = true;
	  }
	  toggle_list = function(category) {
	    local.show[category] = !local.show[category];
	    return save(local);
	  };
	  loc = fetch('location');
	  hash = loc.url.split('/')[1].replace('-', '_');
	  current_section = null;
	  return DIV({
	    style: {}
	  }, H2({
	    style: heading_style
	  }, TRANSLATE({
	    id: 'engage.navigate_elsewhere.groupednav.header'
	  }, 'Done? Navigate to a different question')), !proposals || proposals.length === 0 ? LOADING_INDICATOR : UL({
	    style: {
	      listStyle: 'none',
	      padding: 0
	    }
	  }, (function() {
	    var i, j, len, len1, ref, results;
	    results = [];
	    for (i = 0, len = sections.length; i < len; i++) {
	      ref = sections[i], name = ref[0], lists = ref[1];
	      active_section = false;
	      lists = clustered_proposals_with_tabs(name);
	      total_proposals = 0;
	      for (j = 0, len1 = lists.length; j < len1; j++) {
	        list = lists[j];
	        if (active_list === list.name) {
	          active_section = true;
	          current_section = name;
	        }
	        total_proposals += (list.proposals || []).length;
	      }
	      if (total_proposals === 0 || name === 'Show all') {
	        continue;
	      }
	      results.push(LI({
	        style: {
	          marginBottom: 24
	        }
	      }, sections.length > 1 ? H3({
	        style: {}
	      }, A({
	        href: "/?tab=" + (encodeURIComponent(name)) + "#active_tab",
	        style: {
	          fontSize: 28,
	          fontWeight: 700,
	          backgroundColor: '#ddd',
	          cursor: 'pointer',
	          color: "#888",
	          fontWeight: 800,
	          display: 'block',
	          marginLeft: -34,
	          padding: '0 34px'
	        }
	      }, name)) : void 0, active_section ? UL({
	        style: {
	          listStyle: 'none',
	          marginTop: 14
	        }
	      }, (function() {
	        var l, len2, results1;
	        results1 = [];
	        for (l = 0, len2 = lists.length; l < len2; l++) {
	          list = lists[l];
	          is_collapsed = !local.show[list.name];
	          tw = is_collapsed ? 15 : 20;
	          th = is_collapsed ? 20 : 15;
	          cluster_key = list.key;
	          list_items_title = customization('list_items_title', cluster_key) || list.name || 'Proposals';
	          heading_text = customization('list_label', cluster_key) || list_items_title;
	          if ((list.proposals || []).length === 0) {
	            continue;
	          }
	          results1.push((function(_this) {
	            return function(list) {
	              var active, cluster, proposal;
	              return LI({
	                style: {}
	              }, lists.length > 1 || sections.length === 1 ? H4({
	                style: {
	                  marginBottom: 12,
	                  cursor: 'pointer',
	                  position: 'relative'
	                },
	                onKeyDown: function(e) {
	                  if (e.which === 13 || e.which === 32) {
	                    toggle_list(list.name);
	                    return e.preventDefault();
	                  }
	                },
	                onClick: function() {
	                  toggle_list(list.name);
	                  return document.activeElement.blur();
	                }
	              }, lists.length > 1 ? SPAN({
	                'aria-hidden': true,
	                style: cssTriangle((is_collapsed ? 'right' : 'bottom'), heading_style.color || 'black', tw, th, {
	                  position: 'absolute',
	                  left: -tw - 20,
	                  top: is_collapsed ? 10 : 13,
	                  width: tw,
	                  height: th,
	                  outline: 'none'
	                })
	              }) : void 0, SPAN({
	                style: {
	                  fontSize: 24
	                }
	              }, heading_text)) : void 0, local.show[list.name] ? UL({
	                style: {
	                  marginLeft: 0
	                }
	              }, (function() {
	                var len3, o, ref1, results2;
	                ref1 = list.proposals;
	                results2 = [];
	                for (o = 0, len3 = ref1.length; o < len3; o++) {
	                  proposal = ref1[o];
	                  cluster = proposal.cluster || 'Proposals';
	                  active = proposal.slug === args.proposal.slug;
	                  results2.push([
	                    active ? DIV({
	                      style: {
	                        width: args.width,
	                        position: 'relative'
	                      }
	                    }, DIV({
	                      style: {
	                        position: 'absolute',
	                        left: -150,
	                        top: 0
	                      },
	                      dangerouslySetInnerHTML: {
	                        __html: (TRANSLATE('engage.navigation_helper_current_location', 'You are here')) + " &rarr;"
	                      }
	                    })) : void 0, CollapsedProposal({
	                      key: "collapsed" + (proposal.key || proposal),
	                      proposal: proposal,
	                      show_category: true,
	                      width: args.width,
	                      hide_scores: true,
	                      hide_icons: true,
	                      hide_metadata: true,
	                      show_category: false,
	                      name_style: {
	                        fontSize: 16
	                      },
	                      wrapper_style: {
	                        backgroundColor: active ? "#eee" : void 0
	                      },
	                      icon: proposal.your_opinion.published ? function() {
	                        return SPAN({
	                          style: {
	                            position: 'relative',
	                            left: -22,
	                            top: 3
	                          },
	                          width: 8,
	                          dangerouslySetInnerHTML: {
	                            __html: '&#x2714;'
	                          }
	                        });
	                      } : function() {
	                        return SPAN(null);
	                      }
	                    })
	                  ]);
	                }
	                return results2;
	              })()) : void 0);
	            };
	          })(this)(list));
	        }
	        return results1;
	      }).call(this)) : void 0));
	    }
	    return results;
	  }).call(this)), DIV({
	    style: {
	      textAlign: 'right',
	      fontSize: 22,
	      marginTop: 40
	    }
	  }, TRANSLATE({
	    id: 'engage.back_to_homepage_option',
	    link: {
	      component: A,
	      args: {
	        href: current_section && current_section !== 'all' ? "/?tab=" + (encodeURIComponent(current_section)) + "#" + hash : "/#" + hash,
	        style: {
	          textDecoration: 'underline',
	          fontWeight: 600
	        }
	      }
	    }
	  }, "…or go <link>back to the homepage</link>")));
	};
	
	window.BackHomeNavigation = function(args) {
	  var hash, heading_style, loc, proposals;
	  proposals = fetch('/proposals').proposals;
	  heading_style = _.defaults({}, customization('list_label_style'), {
	    fontSize: 36,
	    fontWeight: 400,
	    fontStyle: 'oblique',
	    textAlign: 'center',
	    marginBottom: 18
	  });
	  loc = fetch('location');
	  hash = loc.url.split('/')[1].replace('-', '_');
	  return DIV({
	    style: {}
	  }, H2({
	    style: heading_style
	  }, 'Done? Go ', A({
	    href: "/#" + hash,
	    style: {
	      textDecoration: 'underline',
	      fontWeight: 700
	    }
	  }, "back to the homepage"), '.'));
	};
	
	window.DefaultProposalNavigation = ReactiveComponent({
	  displayName: 'ProposalNavigation',
	  render: function() {
	    var editor, next_proposal, next_proposals, prev_proposal, prev_proposals, ref, width;
	    ref = get_next_proposals({
	      relative_to: this.proposal,
	      count: 1
	    }), prev_proposals = ref[0], next_proposals = ref[1];
	    next_proposal = next_proposals[0];
	    prev_proposal = prev_proposals[0];
	    return DIV({
	      style: {
	        margin: "30px auto 0 auto",
	        width: HOMEPAGE_WIDTH(),
	        position: 'relative'
	      }
	    }, next_proposal || prev_proposal ? NAV({
	      'aria-label': 'Previous or next proposals',
	      role: 'navigation',
	      style: {
	        position: 'absolute',
	        right: 0
	      }
	    }, next_proposal ? A({
	      'title': 'Previous proposal',
	      style: {
	        display: 'inline-block',
	        float: 'right'
	      },
	      href: proposal_url(next_proposal),
	      'data-no-scroll': true
	    }, (translator("engage.navigation.next_proposal", "next")) + " >") : void 0, prev_proposal ? A({
	      'title': 'Next proposal',
	      style: {
	        display: 'inline-block',
	        float: 'right',
	        marginRight: next_proposal ? 10 : void 0
	      },
	      href: proposal_url(prev_proposal),
	      'data-no-scroll': true
	    }, "< " + (translator("engage.navigation.previous_proposal", "prev"))) : void 0) : void 0, customization('show_proposer_icon', "list/" + this.proposal.cluster) ? (editor = proposal_editor(this.proposal), width = Math.min(GUTTER(), 120), editor ? Avatar({
	      key: editor,
	      user: editor,
	      img_size: 'original',
	      style: {
	        position: 'absolute',
	        width: width,
	        top: 36,
	        maxWidth: width - (width === 120 ? 20 : 10),
	        marginLeft: -width - (width === 120 ? 20 : 10),
	        borderRadius: 0,
	        backgroundColor: 'transparent'
	      }
	    }) : void 0) : void 0, DIV({
	      style: {
	        fontStyle: 'italic',
	        visibility: !this.proposal.cluster ? 'hidden' : void 0
	      }
	    }, permit('update proposal', this.proposal) > 0 ? INPUT({
	      ref: 'cluster',
	      name: 'cluster',
	      pattern: '^.{3,}',
	      defaultValue: this.proposal.cluster,
	      'aria-label': 'Update the proposal category',
	      style: {
	        border: 'none',
	        fontStyle: 'italic',
	        fontSize: 16
	      },
	      onBlur: (function(_this) {
	        return function() {
	          _this.proposal.cluster = _this.refs.cluster.getDOMNode().value;
	          return save(_this.proposal);
	        };
	      })(this)
	    }) : this.proposal.cluster || '-'));
	  },
	  componentDidUpdate: function() {
	    return this.typeset();
	  },
	  componentDidMount: function() {
	    return this.typeset();
	  },
	  typeset: function() {
	    var subdomain;
	    subdomain = fetch('/subdomain');
	    if (subdomain.name === 'RANDOM2015' && $('#proposal_name').find('.MathJax').length === 0) {
	      return MathJax.Hub.Queue(["Typeset", MathJax.Hub, "proposal_name"]);
	    }
	  }
	});


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	var AddRolesAndInvite, ProposalRoles, SpecifyRoles, SubdomainRoles, UserWithRole, UsersWithRole, proposal_roles;
	
	__webpack_require__(2);
	
	__webpack_require__(22);
	
	__webpack_require__(1);
	
	proposal_roles = function() {
	  var all, con_label, pro_label;
	  pro_label = get_point_label('pro');
	  con_label = get_point_label('con');
	  all = [
	    {
	      name: 'editor',
	      label: 'Editors',
	      description: 'Can modify the description of the proposal, as well as ' + 'write, comment, and opine.',
	      wildcard: {
	        label: 'Any registered user can edit',
	        "default": false
	      }
	    }, {
	      hide: true,
	      name: 'writer',
	      label: 'Writers',
	      description: ("Can write " + pro_label + " and " + con_label + " points that are ") + "shared with others. Any writer can comment and opine.",
	      wildcard: {
	        label: 'Any registered user who can observe can write',
	        "default": true
	      }
	    }, {
	      hide: true,
	      name: 'commenter',
	      label: 'Commenters',
	      description: "Can comment on " + pro_label + " and " + con_label + " points.",
	      wildcard: {
	        label: 'Any registered user who can observe can comment',
	        "default": true
	      }
	    }, {
	      hide: true,
	      name: 'opiner',
	      label: 'Opiners',
	      description: 'Can drag the slider and build a list of other people\'s Pros/Cons, but can\'t write new Pros, Cons or Comments.',
	      wildcard: {
	        label: 'Any registered user who can observe can opine',
	        "default": true
	      }
	    }, {
	      hide: true,
	      name: 'observer',
	      label: 'Observers',
	      description: 'Can access this proposal. But that\'s it.',
	      wildcard: {
	        label: "Public. Anyone can view",
	        "default": true
	      }
	    }
	  ];
	  all = _.compact(all);
	  return all;
	};
	
	ProposalRoles = ReactiveComponent({
	  displayName: 'ProposalRoles',
	  render: function() {
	    var current_user, proposal, subdomain;
	    subdomain = fetch('/subdomain');
	    current_user = fetch('/current_user');
	    proposal = fetch(this.props.key);
	    if (!proposal.roles) {
	      InitializeProposalRoles(proposal);
	    }
	    return SpecifyRoles(proposal, proposal_roles());
	  }
	});
	
	window.InitializeProposalRoles = function(proposal) {
	  var current_user, i, len, ref, role, subdomain;
	  current_user = fetch('/current_user');
	  subdomain = fetch('/subdomain');
	  proposal.roles = {};
	  ref = proposal_roles();
	  for (i = 0, len = ref.length; i < len; i++) {
	    role = ref[i];
	    proposal.roles[role.name] = [];
	    if (role.wildcard && role.wildcard["default"]) {
	      if (role.name === 'observer') {
	        proposal.roles[role.name] = subdomain.roles['visitor'].slice();
	      } else {
	        proposal.roles[role.name].push('*');
	      }
	    }
	  }
	  return proposal.roles['editor'].push("/user/" + current_user.id);
	};
	
	SubdomainRoles = ReactiveComponent({
	  displayName: 'SubdomainRoles',
	  render: function() {
	    var roles, subdomain;
	    subdomain = fetch('/subdomain');
	    roles = [
	      {
	        name: 'admin',
	        label: 'Administrators',
	        description: 'Can configure everything related to this forum.'
	      }, {
	        hide: true,
	        name: 'moderator',
	        label: 'Moderators',
	        description: 'Can moderate user content. Will receive emails for content needing moderation.'
	      }, {
	        hide: false,
	        name: 'proposer',
	        label: 'Proposers',
	        description: 'Can add new proposals.',
	        wildcard: {
	          label: 'Any registered user can post new proposals',
	          "default": true
	        }
	      }, {
	        name: 'visitor',
	        label: 'People who can access forum',
	        description: 'If set to private forum, invite specific people to join below.',
	        wildcard: {
	          label: 'Public forum. Anyone with a link can see all proposals.',
	          "default": true
	        }
	      }
	    ];
	    roles = _.compact(roles);
	    return DIV(null, DashHeader({
	      name: 'User Roles'
	    }), DIV({
	      style: {
	        width: HOMEPAGE_WIDTH(),
	        margin: 'auto'
	      }
	    }, SpecifyRoles(subdomain, roles)));
	  }
	});
	
	SpecifyRoles = function(target, roles) {
	  var role;
	  return DIV(null, (function() {
	    var i, len, results;
	    results = [];
	    for (i = 0, len = roles.length; i < len; i++) {
	      role = roles[i];
	      if (!role.hide) {
	        results.push(DIV({
	          key: role.name,
	          style: {
	            marginTop: 24
	          }
	        }, H2({
	          style: {
	            fontSize: 18,
	            position: 'relative'
	          }
	        }, I({
	          className: "fa " + role.icon,
	          style: {
	            position: 'absolute',
	            top: 2,
	            left: -35,
	            fontSize: 24
	          }
	        }), role.label), SPAN({
	          style: {
	            fontSize: 14
	          }
	        }, role.description), UsersWithRole({
	          key: role.name,
	          target: target,
	          role: role
	        })));
	      }
	    }
	    return results;
	  })(), DIV({
	    style: {
	      marginLeft: -35,
	      marginTop: 12
	    }
	  }, AddRolesAndInvite({
	    key: 'roles_and_invite',
	    roles: roles,
	    target: target
	  })));
	};
	
	AddRolesAndInvite = ReactiveComponent({
	  displayName: 'Invite',
	  render: function() {
	    var available_users, idx, other_roles, processNewFolks, role, target, user, user_key, users;
	    target = fetch(this.props.target);
	    users = fetch('/users');
	    console.log({
	      roles: this.props.roles
	    });
	    if (!this.local.role) {
	      this.local.added = [];
	      this.local.role = this.props.roles[0];
	      save(this.local);
	    }
	    processNewFolks = (function(_this) {
	      return function() {
	        var $filter, candidate_email, candidates, i, len;
	        $filter = $(_this.getDOMNode()).find('#filter');
	        candidates = $filter.val();
	        $filter.val('');
	        if (candidates) {
	          candidates = candidates.split(',');
	          for (i = 0, len = candidates.length; i < len; i++) {
	            candidate_email = candidates[i];
	            candidate_email = candidate_email.trim();
	            if (candidate_email.indexOf(' ') < 0 && candidate_email.indexOf('@') > 0 && candidate_email.indexOf('.') > 0) {
	              _this.local.added.push(candidate_email);
	            }
	          }
	          return save(_this.local);
	        }
	      };
	    })(this);
	    other_roles = this.props.roles;
	    return DIV({
	      style: {
	        position: 'relative',
	        backgroundColor: '#f2f2f2',
	        padding: '18px 24px'
	      }
	    }, SELECT({
	      id: 'select_role',
	      type: 'text',
	      name: 'select_role',
	      defaultValue: 0,
	      onChange: (function(_this) {
	        return function(event) {
	          var role;
	          role = other_roles[event.target.value];
	          _this.local.role = role;
	          return save(_this.local);
	        };
	      })(this),
	      style: {
	        fontSize: 18,
	        marginBottom: 18,
	        display: 'inline-block'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = other_roles.length; i < len; idx = ++i) {
	        role = other_roles[idx];
	        if (!role.hide) {
	          results.push((function(_this) {
	            return function(role, idx) {
	              return OPTION({
	                value: idx
	              }, "Add " + role.label);
	            };
	          })(this)(role, idx));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    }).call(this)), this.local.added.length > 0 ? DIV(null, (function() {
	      var i, len, ref, results;
	      ref = this.local.added;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        user_key = ref[idx];
	        results.push(UserWithRole(user_key, (function(_this) {
	          return function(user_key) {
	            _this.local.added = _.without(_this.local.added, user_key);
	            return save(_this.local);
	          };
	        })(this)));
	      }
	      return results;
	    }).call(this)) : void 0, DIV({
	      ref: 'autocomplete',
	      onKeyDown: (function(_this) {
	        return function(e) {
	          if (e.which === 27 && _this.local.selecting) {
	            _this.local.selecting = false;
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, INPUT({
	      id: 'filter',
	      type: 'text',
	      style: {
	        fontSize: 18,
	        width: 350,
	        padding: '3px 6px'
	      },
	      autoComplete: 'off',
	      placeholder: "Name or email...",
	      onChange: (function(_this) {
	        return function() {
	          _this.local.filtered = $(_this.getDOMNode()).find('#filter').val();
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 13) {
	            e.preventDefault();
	            return processNewFolks();
	          }
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.selecting = true;
	          save(_this.local);
	          e.stopPropagation();
	          $(document).on('click.roles', function(e) {
	            if (e.target.id !== 'filter') {
	              processNewFolks();
	              _this.local.selecting = false;
	              _this.local.filtered = null;
	              save(_this.local);
	              return $(document).off('click.roles');
	            }
	          });
	          return false;
	        };
	      })(this)
	    }), this.local.selecting ? (available_users = _.filter(users.users, (function(_this) {
	      return function(u) {
	        return target.roles[_this.local.role.name].indexOf(u.key) < 0 && _this.local.added.indexOf(u.key) < 0 && (!_this.local.filtered || (u.name + " <" + u.email + ">").indexOf(_this.local.filtered) > -1);
	      };
	    })(this)), available_users.length > 0 ? UL({
	      style: {
	        width: 500,
	        position: 'absolute',
	        zIndex: 99,
	        listStyle: 'none',
	        backgroundColor: '#fff',
	        border: '1px solid #eee'
	      }
	    }, (function() {
	      var i, len, results;
	      results = [];
	      for (idx = i = 0, len = available_users.length; i < len; idx = ++i) {
	        user = available_users[idx];
	        results.push(LI({
	          className: 'invite_menu_item',
	          style: {
	            padding: '2px 12px',
	            fontSize: 18,
	            cursor: 'pointer',
	            borderBottom: '1px solid #fafafa'
	          },
	          key: idx,
	          onClick: (function(_this) {
	            return function(user) {
	              return function(e) {
	                _this.local.added.push(user.key);
	                save(_this.local);
	                return e.stopPropagation();
	              };
	            };
	          })(this)(user),
	          onTouchEnd: (function(_this) {
	            return function(user) {
	              return function(e) {
	                _this.local.added.push(user.key);
	                save(_this.local);
	                return e.stopPropagation();
	              };
	            };
	          })(this)(user),
	          onKeyDown: (function(_this) {
	            return function(user) {
	              return function(e) {
	                if (e.which === 13) {
	                  _this.local.added.push(user.key);
	                  save(_this.local);
	                  e.stopPropagation();
	                  return e.preventDefault();
	                }
	              };
	            };
	          })(this)(user)
	        }, user.name + " <" + user.email + ">"));
	      }
	      return results;
	    }).call(this)) : void 0) : void 0), DIV({
	      style: {
	        marginTop: 20
	      }
	    }, INPUT({
	      type: 'checkbox',
	      id: 'send_email_invite',
	      name: 'send_email_invite',
	      onClick: (function(_this) {
	        return function() {
	          _this.local.send_email_invite = !_this.local.send_email_invite;
	          return save(_this.local);
	        };
	      })(this)
	    }), LABEL({
	      htmlFor: 'send_email_invite'
	    }, 'Send email invitation'), this.local.send_email_invite ? DIV({
	      style: {
	        marginLeft: 20,
	        marginTop: 10
	      }
	    }, AutoGrowTextArea({
	      id: 'custom_email_message',
	      name: 'custom_email_message',
	      placeholder: '(optional) custom message',
	      style: {
	        width: '90%',
	        fontSize: 18,
	        padding: '8px 14px'
	      }
	    })) : void 0), BUTTON({
	      style: {
	        backgroundColor: focus_color(),
	        color: 'white',
	        padding: '8px 14px',
	        fontSize: 16,
	        display: 'inline-block',
	        cursor: 'pointer',
	        borderRadius: 8,
	        marginTop: 12,
	        border: 'none'
	      },
	      onClick: (function(_this) {
	        return function(e) {
	          var invitation;
	          if (_this.local.added.length > 0) {
	            target.roles[_this.local.role.name] = target.roles[_this.local.role.name].concat(_this.local.added);
	            if (_this.local.send_email_invite) {
	              if (!target.invitations) {
	                target.invitations = [];
	              }
	              invitation = {
	                role: _this.local.role.name,
	                keys_or_emails: _this.local.added
	              };
	              invitation.message = $('#custom_email_message').val();
	              target.invitations.push(invitation);
	            }
	            _this.local.added = [];
	            save(target);
	            return save(_this.local);
	          }
	        };
	      })(this)
	    }, 'Done. Add these roles.'));
	  }
	});
	
	UsersWithRole = ReactiveComponent({
	  displayName: 'UsersWithRole',
	  render: function() {
	    var role, target, user_key;
	    target = fetch(this.props.target);
	    role = this.props.role;
	    return DIV({
	      style: {
	        marginLeft: -4
	      }
	    }, role.wildcard ? DIV(null, INPUT({
	      id: "wildcard-" + role.name,
	      name: "wildcard-" + role.name,
	      type: 'checkbox',
	      defaultChecked: target.roles[role.name].indexOf('*') > -1,
	      onChange: function() {
	        if ($("#wildcard-" + role.name).is(':checked')) {
	          target.roles[role.name].push('*');
	        } else {
	          target.roles[role.name] = _.without(target.roles[role.name], '*');
	        }
	        return save(target);
	      }
	    }), LABEL({
	      htmlFor: "wildcard-" + role.name
	    }, role.wildcard.label)) : !target.roles[role.name] || target.roles[role.name].length === 0 ? DIV({
	      style: {
	        fontStyle: 'italic',
	        margin: 4
	      }
	    }, 'None') : void 0, (function() {
	      var i, len, ref, results;
	      if (target.roles[role.name]) {
	        ref = target.roles[role.name];
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          user_key = ref[i];
	          if (user_key !== '*') {
	            results.push(UserWithRole(user_key, (function(_this) {
	              return function(user_key) {
	                var invite, j, len1, ref1;
	                target.roles[role.name] = _.without(target.roles[role.name], user_key);
	                if (target.invitations) {
	                  ref1 = target.invitations;
	                  for (j = 0, len1 = ref1.length; j < len1; j++) {
	                    invite = ref1[j];
	                    if (invite.role === role.name) {
	                      invite.keys_or_emails = _.without(invite.keys_or_emails, user_key);
	                    }
	                  }
	                }
	                return save(target);
	              };
	            })(this)));
	          } else {
	            results.push(void 0);
	          }
	        }
	        return results;
	      }
	    }).call(this));
	  }
	});
	
	UserWithRole = function(user_key, on_remove_from_role) {
	  var user;
	  return SPAN({
	    key: user_key,
	    style: {
	      display: 'inline-block',
	      padding: '6px 12px',
	      fontSize: 13,
	      backgroundColor: '#ddd',
	      color: 'black',
	      borderRadius: 8,
	      margin: 4
	    }
	  }, SPAN(null, user_key && user_key[0] === '/' ? (user = fetch(user_key), SPAN(null, user.avatar_file_name ? Avatar({
	    key: user_key,
	    hide_tooltip: true,
	    style: {
	      width: 20,
	      height: 20,
	      marginRight: 5
	    }
	  }) : void 0, user.name ? user.name : user.email)) : user_key), BUTTON({
	    'aria-label': "Remove " + ((user != null ? user.name : void 0) || user_key) + " from role",
	    style: {
	      cursor: 'pointer',
	      marginLeft: 8,
	      border: 'none',
	      'backgroundColor': 'transparent'
	    },
	    onClick: function() {
	      if (on_remove_from_role) {
	        return on_remove_from_role(user_key);
	      }
	    }
	  }, 'x'));
	};
	
	window.SubdomainRoles = SubdomainRoles;
	
	window.ProposalRoles = ProposalRoles;


/***/ },
/* 45 */
/***/ function(module, exports) {

	var el, rainbows, recent_keys, reset_selection;
	
	for (el in React.DOM) {
	  this[el.toUpperCase()] = React.DOM[el];
	}
	
	window.parse_key = function(key) {
	  var has_match, is_new, m, name, number, owner, regexp, server_owned, tmp1, tmp2, word;
	  word = "([^/]+)";
	  regexp = new RegExp("(/)?(new/)?" + word + "(/" + word + ")?(/)?");
	  m = key.match(regexp);
	  if (!m) {
	    return null;
	  }
	  has_match = m[0], server_owned = m[1], is_new = m[2], name = m[3], tmp1 = m[4], number = m[5], tmp2 = m[6];
	  owner = server_owned ? 'server' : 'client';
	  return has_match && {
	    owner: owner,
	    'new': is_new,
	    name: name,
	    number: number
	  };
	};
	
	window.StateDash = ReactiveComponent({
	  displayName: 'State Dash',
	  render: function() {
	    var best_guess, cache, cluster_rows, clusters, dash, field, fieldset, first_key, key, name, owner, prefix, ref, ref1, row, search_results, selected_keys, tree, url_tree;
	    dash = this.fetch('state_dash');
	    if (((ref = dash.filter) != null ? ref.match(/idkfa/) : void 0) || ((ref1 = dash.filter) != null ? ref1.match(/idmap/) : void 0)) {
	      dash.on = false;
	      dash.filter = '';
	      save(dash);
	    }
	    if (!dash.on) {
	      return DIV(null, '');
	    }
	    url_tree = function(cache) {
	      var add_key, key, tree;
	      tree = {
	        server: {},
	        client: {}
	      };
	      add_key = function(key) {
	        var base, name1, p;
	        p = parse_key(key);
	        if (!p) {
	          console.log('The state dash can\'t deal with key', key);
	          return null;
	        }
	        (base = tree[p.owner])[name1 = p.name] || (base[name1] = []);
	        return tree[p.owner][p.name][p.number || null] = cache[key];
	      };
	      for (key in cache) {
	        add_key(key);
	      }
	      return tree;
	    };
	    search_results = this.search_results();
	    cache = search_results.matches;
	    tree = url_tree(cache);
	    first_key = function(cache) {
	      var key, reject_name, reject_numb;
	      for (key in cache) {
	        reject_name = dash.selected.name && parse_key(key).name !== dash.selected.name;
	        reject_numb = dash.selected.number && parse_key(key).number !== dash.selected.number;
	        if (!reject_name && !reject_numb) {
	          return key;
	        }
	      }
	      return null;
	    };
	    best_guess = first_key(search_results.key_matches) || first_key(search_results.data_matches);
	    cluster_rows = function(keys) {
	      var clusters, fields, i, key, len;
	      clusters = {};
	      for (i = 0, len = keys.length; i < len; i++) {
	        key = keys[i];
	        fields = JSON.stringify(Object.keys(cache[key]));
	        clusters[fields] = clusters[fields] || [];
	        clusters[fields].push(key);
	      }
	      return clusters;
	    };
	    return DIV({
	      className: 'state_dash',
	      style: this.props.style
	    }, STYLE(null, ".state_dash {\n  position: absolute;\n  margin: 20px;\n  z-index: 10000;\n}\n.state_dash .left, .state_dash .right, .state_dash .top {\n  background-color: #eee;\n  overflow-wrap: break-word;\n  padding: 10px;\n  vertical-align: top;\n}\n.state_dash .left  { min-width:   40px; display: inline-block; }\n.state_dash .right { margin-left: 30px; display: inline-block; }\n.state_dash .top   { max-width:   100%; margin: 20px 0; }\n\n.string { color: green; }\n.number { color: darkorange; }\n.boolean { color: blue; }\n.null { color: magenta; }\n.key { color: red; }\n\n.cell {\n  width: 150px;\n  border: 1px solid grey;\n  padding: 2px;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: clip;\n  margin: 0;\n}"), DIV({
	      className: 'left'
	    }, INPUT({
	      className: 'search',
	      onChange: this.filter_to,
	      onMouseEnter: reset_selection
	    }), (function() {
	      var i, len, ref2, results;
	      ref2 = ['client', 'server'];
	      results = [];
	      for (i = 0, len = ref2.length; i < len; i++) {
	        owner = ref2[i];
	        prefix = (owner === 'server') && '/' || '';
	        results.push(DIV({
	          key: owner
	        }, (function() {
	          var results1;
	          results1 = [];
	          for (name in tree[owner]) {
	            results1.push((function(owner, name) {
	              var f, style;
	              f = function() {
	                dash.selected = {
	                  owner: owner,
	                  name: name,
	                  number: null
	                };
	                return save(dash);
	              };
	              style = (name === dash.selected.name) && {
	                'background-color': '#aaf'
	              } || {};
	              return DIV({
	                onMouseEnter: f,
	                key: name,
	                style: style
	              }, prefix + name);
	            })(owner, name));
	          }
	          return results1;
	        })()));
	      }
	      return results;
	    })()), DIV({
	      className: 'right'
	    }, (function() {
	      var results;
	      if (dash.selected.name) {
	        selected_keys = (function() {
	          var results;
	          results = [];
	          for (key in cache) {
	            if (parse_key(key).name === dash.selected.name) {
	              results.push(key);
	            }
	          }
	          return results;
	        })();
	        clusters = cluster_rows(selected_keys);
	        results = [];
	        for (fieldset in clusters) {
	          results.push(DIV(null, (function() {
	            var i, len, ref2, results1;
	            ref2 = JSON.parse(fieldset);
	            results1 = [];
	            for (i = 0, len = ref2.length; i < len; i++) {
	              field = ref2[i];
	              results1.push(DIV({
	                key: field,
	                style: {
	                  fontWeight: 'bold',
	                  borderColor: '#eee'
	                },
	                className: 'cell'
	              }, field));
	            }
	            return results1;
	          })(), (function() {
	            var i, len, ref2, results1;
	            ref2 = clusters[fieldset];
	            results1 = [];
	            for (i = 0, len = ref2.length; i < len; i++) {
	              key = ref2[i];
	              row = cache[key];
	              results1.push(DIV({
	                key: key
	              }, (function() {
	                var results2;
	                results2 = [];
	                for (field in row) {
	                  results2.push(DIV({
	                    className: 'cell',
	                    key: field,
	                    onClick: (function(_this) {
	                      return function(key, field) {
	                        return function(evt) {
	                          _this.local.editing = {
	                            key_: key,
	                            field: field
	                          };
	                          save(_this.local);
	                          return setTimeout(function() {
	                            return _this.refs.dash_input.getDOMNode().focus();
	                          });
	                        };
	                      };
	                    })(this)(key, field)
	                  }, (this.local.editing && this.local.editing.key_ === key && this.local.editing.field === field) ? SPAN(null, TEXTAREA({
	                    key: field,
	                    type: 'text',
	                    ref: 'dash_input',
	                    defaultValue: JSON.stringify(row[field]),
	                    onChange: (function(_this) {
	                      return function(event) {
	                        var e, val;
	                        try {
	                          val = JSON.parse(_this.refs.dash_input.getDOMNode().value);
	                          cache[_this.local.editing.key_][_this.local.editing.field] = val;
	                          save(cache[_this.local.editing.key_]);
	                          event.stopPropagation();
	                          delete _this.local.editing.error;
	                          return save(_this.local);
	                        } catch (error) {
	                          e = error;
	                          _this.local.editing.error = true;
	                          return save(_this.local);
	                        }
	                      };
	                    })(this),
	                    onBlur: (function(_this) {
	                      return function(event) {
	                        delete _this.local.editing;
	                        return save(_this.local);
	                      };
	                    })(this),
	                    style: {
	                      position: 'absolute',
	                      backgroundColor: this.local.editing.error ? '#faa' : void 0
	                    }
	                  })) : void 0, JSON.stringify(row[field])));
	                }
	                return results2;
	              }).call(this)));
	            }
	            return results1;
	          }).call(this)));
	        }
	        return results;
	      }
	    }).call(this)));
	  },
	  search_results: function() {
	    var dash, data_matches, key, key_matches, matches;
	    dash = fetch('state_dash');
	    matches = {};
	    key_matches = {};
	    data_matches = {};
	    if (dash.filter) {
	      for (key in arest.cache) {
	        if (key.match(dash.filter)) {
	          matches[key] = arest.cache[key];
	          key_matches[key] = arest.cache[key];
	        }
	        if (JSON.stringify(arest.cache[key]).match(dash.filter)) {
	          matches[key] = arest.cache[key];
	          data_matches[key] = arest.cache[key];
	        }
	      }
	    } else {
	      matches = key_matches = data_matches = arest.cache;
	    }
	    return {
	      matches: matches,
	      key_matches: key_matches,
	      data_matches: data_matches
	    };
	  },
	  filter_to: function(e) {
	    var dash;
	    dash = this.data('state_dash');
	    dash.filter = e.target.value;
	    if (dash.filter.length === 0) {
	      dash.filter = null;
	    }
	    save(dash);
	    return true;
	  }
	});
	
	reset_selection = function() {
	  var dash;
	  dash = fetch('state_dash');
	  dash.selected = {
	    owner: null,
	    name: null,
	    number: null
	  };
	  return save(dash);
	};
	
	rainbows = function(json) {
	  json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	  return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function(match) {
	    var cls;
	    cls = 'number';
	    if (/^"/.test(match)) {
	      if (/:$/.test(match)) {
	        cls = 'key';
	      } else {
	        cls = 'string';
	      }
	    } else if (/true|false/.test(match)) {
	      cls = 'boolean';
	    } else if (/null/.test(match)) {
	      cls = 'null';
	    }
	    return "<span class=\"" + cls + "\">" + match + "</span>";
	  });
	};
	
	fetch('state_dash', {
	  on: false,
	  selected: {
	    owner: null,
	    name: null,
	    number: null
	  },
	  filter: null
	});
	
	recent_keys = [0, 0, 0, 0, 0];
	
	document.addEventListener("keypress", function(e) {
	  var dash, key;
	  key = (e && e.keyCode) || e.keyCode;
	  recent_keys.push(key);
	  recent_keys = recent_keys.slice(1);
	  if (key === 4 || ("" + recent_keys) === ("" + [105, 100, 109, 97, 112]) || ("" + recent_keys) === ("" + [105, 100, 107, 102, 97])) {
	    dash = fetch('state_dash');
	    if (dash.on) {
	      dash.on = false;
	    } else {
	      dash.on = true;
	    }
	    save(dash);
	    return setTimeout(function() {
	      return $('.state_dash input').focus();
	    });
	  }
	});


/***/ },
/* 46 */
/***/ function(module, exports) {

	window.BUBBLE_WRAP = ReactiveComponent({
	  displayName: 'BUBBLE_WRAP',
	  render: function() {
	    var ioffset, left_or_right, mouth_style, mouth_w, pic_style, w;
	    left_or_right = 'right';
	    ioffset = -10;
	    w = this.props.width || POINT_WIDTH();
	    mouth_w = (this.props.mouth_style || {}).width || POINT_MOUTH_WIDTH;
	    mouth_style = _.defaults(this.props.mouth_style || {}, {
	      top: 8,
	      position: 'absolute',
	      left: -mouth_w + 1,
	      transform: 'rotate(270deg) scaleX(-1)'
	    });
	    pic_style = _.defaults({}, this.props.avatar_style || {}, {
	      position: 'absolute',
	      top: 0,
	      width: 50,
	      height: 50,
	      left: -64,
	      boxShadow: '-1px 2px 0 0 #eeeeee;'
	    });
	    return DIV({
	      style: {
	        position: 'relative',
	        listStyle: 'none outside none',
	        marginBottom: '0.5em'
	      }
	    }, this.props.user ? Avatar({
	      key: this.props.user,
	      style: pic_style,
	      hide_tooltip: false,
	      anonymous: this.props.anon
	    }) : this.props.pic ? IMG({
	      style: pic_style,
	      src: this.props.pic
	    }) : void 0, DIV({
	      style: _.defaults({}, this.props.bubble_style || {}, {
	        width: w,
	        borderWidth: 3,
	        borderStyle: 'solid',
	        borderColor: 'transparent',
	        position: 'relative',
	        zIndex: 1,
	        outline: 'none',
	        padding: 8,
	        borderRadius: 16,
	        backgroundColor: considerit_gray,
	        boxShadow: '#b5b5b5 0 1px 1px 0px'
	      })
	    }, DIV({
	      style: css.crossbrowserify(mouth_style)
	    }, Bubblemouth({
	      apex_xfrac: 0,
	      width: mouth_w,
	      height: mouth_w,
	      fill: considerit_gray,
	      stroke: 'none',
	      box_shadow: _.defaults({}, this.props.mouth_shadow || {}, {
	        dx: 3,
	        dy: 0,
	        stdDeviation: 2,
	        opacity: .5
	      })
	    })), this.props.children || STATEMENT(this.props)));
	  }
	});
	
	window.STATEMENT = ReactiveComponent({
	  displayName: 'Statement',
	  render: function() {
	    var body, title;
	    title = this.props.title;
	    body = this.props.body;
	    return DIV({
	      style: {
	        wordWrap: 'break-word'
	      }
	    }, DIV({
	      style: _.defaults({}, this.props.title_style || {}, {
	        fontSize: POINT_FONT_SIZE()
	      }),
	      className: 'statement'
	    }, title), body ? DIV({
	      className: "statement",
	      style: _.defaults({}, this.props.body_style || {}, {
	        wordWrap: 'break-word',
	        marginTop: '0.5em',
	        fontSize: POINT_FONT_SIZE(),
	        fontWeight: 300
	      }),
	      dangerouslySetInnerHTML: {
	        __html: body
	      }
	    }) : void 0);
	  }
	});
	
	styles += "\n.statement a {\n  text-decoration: underline;\n  // word-break: break-all; \n}\n\n.statement p {\n  margin-bottom: 12px; }";


/***/ },
/* 47 */
/***/ function(module, exports) {

	var UserTags;
	
	UserTags = ReactiveComponent({
	  displayName: 'UserTags',
	  render: function() {
	    var all_tags, available_users, change_current_user, current_user, idx, j, k, len, ref, ref1, ref2, subdomain, tag, tag_group, tag_users, tags, user, users, v, val;
	    subdomain = fetch('/subdomain');
	    users = fetch('/users');
	    current_user = this.local.current_user ? fetch(this.local.current_user) : void 0;
	    change_current_user = (function(_this) {
	      return function(new_user) {
	        var k, v;
	        _this.local.new_tags = {};
	        _this.local.current_user = new_user;
	        current_user = _this.local.current_user ? fetch(_this.local.current_user) : void 0;
	        if (current_user) {
	          for (k in all_tags) {
	            v = all_tags[k];
	            if (k !== 'no tags') {
	              if (current_user.tags[k] == null) {
	                _this.local.new_tags[k] = "";
	              }
	            }
	          }
	        }
	        return save(_this.local);
	      };
	    })(this);
	    all_tags = {};
	    ref = users.users;
	    for (j = 0, len = ref.length; j < len; j++) {
	      user = ref[j];
	      if ((user.tags != null) && Object.keys(user.tags).length > 0) {
	        ref1 = user.tags;
	        for (tag in ref1) {
	          val = ref1[tag];
	          console.log(user.tags);
	          all_tags[tag] || (all_tags[tag] = {
	            yes: [],
	            no: []
	          });
	          if (val && ((typeof val !== 'string' && !(val instanceof String)) || ((ref2 = val.toLowerCase()) !== "no" && ref2 !== 'false'))) {
	            all_tags[tag].yes.push(user);
	          } else {
	            all_tags[tag].no.push(user);
	          }
	        }
	        if (Object.keys(user.tags).length === 1 && Object.keys(user.tags)[0] === 'considerit_terms.editable') {
	          all_tags['no tags'] || (all_tags['no tags'] = {
	            yes: [],
	            no: []
	          });
	          all_tags['no tags'].yes.push(user);
	        }
	      } else {
	        all_tags['no tags'] || (all_tags['no tags'] = {
	          yes: [],
	          no: []
	        });
	        all_tags['no tags'].yes.push(user);
	      }
	    }
	    if (all_tags['considerit_terms.editable']) {
	      delete all_tags['considerit_terms.editable'];
	    }
	    return DIV({
	      style: {
	        width: CONTENT_WIDTH(),
	        margin: 'auto',
	        paddingTop: 50
	      }
	    }, DIV({
	      style: {
	        marginBottom: 12
	      }
	    }, H1({
	      style: {
	        fontSize: 28
	      }
	    }, "User tags")), DIV(null, INPUT({
	      id: 'filter',
	      type: 'text',
	      style: {
	        fontSize: 18,
	        width: 350,
	        padding: '3px 6px'
	      },
	      autoComplete: 'off',
	      'aria-label': "Name or email...",
	      placeholder: "Name or email...",
	      value: current_user ? current_user.name : void 0,
	      onChange: (function(_this) {
	        return function() {
	          var ref3;
	          _this.local.filtered = (ref3 = $(_this.getDOMNode()).find('#filter').val()) != null ? ref3.toLowerCase() : void 0;
	          change_current_user(null);
	          return save(_this.local);
	        };
	      })(this),
	      onKeyPress: (function(_this) {
	        return function(e) {
	          if (e.which === 13 || e.which === 32) {
	            e.preventDefault();
	            change_current_user(_this.local.hovered_user);
	            return save(_this.local);
	          }
	        };
	      })(this),
	      onFocus: (function(_this) {
	        return function(e) {
	          _this.local.selecting = true;
	          save(_this.local);
	          e.stopPropagation();
	          $(document).on('click.tags', function(e) {
	            if (e.target.id !== 'filter') {
	              _this.local.selecting = false;
	              save(_this.local);
	              return $(document).off('click.tags');
	            }
	          });
	          return false;
	        };
	      })(this)
	    })), this.local.selecting ? (available_users = _.filter(users.users, (function(_this) {
	      return function(u) {
	        return u.key !== _this.local.current_user && (!_this.local.filtered || (u.name + " <" + u.email + ">").toLowerCase().indexOf(_this.local.filtered) > -1);
	      };
	    })(this)), available_users.length > 0 ? UL({
	      style: {
	        width: 500,
	        position: 'absolute',
	        zIndex: 99,
	        listStyle: 'none',
	        backgroundColor: '#fff',
	        border: '1px solid #eee'
	      }
	    }, (function() {
	      var l, len1, results;
	      results = [];
	      for (idx = l = 0, len1 = available_users.length; l < len1; idx = ++l) {
	        user = available_users[idx];
	        results.push((function(_this) {
	          return function(user) {
	            return LI({
	              className: 'invite_menu_item',
	              style: {
	                padding: '2px 12px',
	                fontSize: 18,
	                cursor: 'pointer',
	                borderBottom: '1px solid #fafafa'
	              },
	              key: idx,
	              onMouseEnter: function(e) {
	                _this.local.hovered_user = user.key;
	                return save(_this.local);
	              },
	              onMouseLeave: function(e) {
	                _this.local.hovered_user = null;
	                return save(_this.local);
	              },
	              onClick: function(e) {
	                change_current_user(_this.local.hovered_user);
	                return e.stopPropagation();
	              }
	            }, user.name + " <" + user.email + ">");
	          };
	        })(this)(user));
	      }
	      return results;
	    }).call(this)) : void 0) : void 0, current_user ? DIV({
	      style: {
	        marginTop: 20
	      }
	    }, (function() {
	      var l, len1, ref3, results;
	      ref3 = [current_user.tags, this.local.new_tags];
	      results = [];
	      for (l = 0, len1 = ref3.length; l < len1; l++) {
	        tags = ref3[l];
	        results.push((function() {
	          var results1;
	          results1 = [];
	          for (k in tags) {
	            v = tags[k];
	            results1.push((function(_this) {
	              return function(k, v, tags) {
	                var editing;
	                editing = _this.local.editing === k;
	                return DIV({
	                  key: k + "-" + v,
	                  style: {},
	                  onFocus: function(e) {
	                    _this.local.editing = k;
	                    return save(_this.local);
	                  },
	                  onBlur: function(e) {
	                    _this.local.editing = null;
	                    return save(_this.local);
	                  }
	                }, INPUT({
	                  ref: k,
	                  style: {
	                    fontWeight: 600,
	                    padding: '5px 10px',
	                    marginRight: 18,
	                    display: 'inline-block',
	                    border: "1px solid " + (editing ? '#bbb' : 'transparent'),
	                    fontSize: 18,
	                    width: 400
	                  },
	                  defaultValue: k
	                }), INPUT({
	                  ref: k + "-val",
	                  style: {
	                    padding: '5px 10px',
	                    display: 'inline-block',
	                    border: "1px solid " + (editing ? '#bbb' : 'transparent'),
	                    fontSize: 18,
	                    width: 400
	                  },
	                  defaultValue: v
	                }));
	              };
	            })(this)(k, v, tags));
	          }
	          return results1;
	        }).call(this));
	      }
	      return results;
	    }).call(this), DIV({
	      style: {
	        marginTop: 12
	      }
	    }, INPUT({
	      type: 'submit',
	      style: {
	        padding: '5px 10px',
	        fontSize: 18
	      },
	      value: 'new tag',
	      onClick: (function(_this) {
	        return function() {
	          var i;
	          i = 0;
	          while (_this.local.new_tags["tag-" + i]) {
	            i++;
	          }
	          _this.local.new_tags["tag-" + i] = "";
	          return save(_this.local);
	        };
	      })(this)
	    })), DIV({
	      style: {
	        marginTop: 12
	      }
	    }, INPUT({
	      type: 'submit',
	      style: {
	        backgroundColor: focus_color(),
	        border: 'none',
	        color: 'white',
	        padding: '5px 10px',
	        borderRadius: 8,
	        fontSize: 18
	      },
	      onClick: (function(_this) {
	        return function() {
	          var l, len1, new_k, new_v, ref3, update;
	          update = {};
	          ref3 = [current_user.tags, _this.local.new_tags];
	          for (l = 0, len1 = ref3.length; l < len1; l++) {
	            tags = ref3[l];
	            for (k in tags) {
	              v = tags[k];
	              new_k = _this.refs[k].getDOMNode().value;
	              new_v = _this.refs[k + "-val"].getDOMNode().value;
	              if ((new_k != null ? new_k.length : void 0) > 0 && (new_v != null ? new_v.length : void 0) > 0) {
	                update[new_k] = new_v;
	              }
	            }
	          }
	          current_user.tags = update;
	          save(current_user);
	          _this.local.new_tags = {};
	          return save(_this.local);
	        };
	      })(this),
	      value: 'Update'
	    }))) : void 0, DIV({
	      style: {
	        marginTop: 12
	      }
	    }, (function() {
	      var results;
	      results = [];
	      for (tag_group in all_tags) {
	        tag_users = all_tags[tag_group];
	        results.push(DIV({
	          style: {
	            width: 300,
	            display: 'inline-block',
	            verticalAlign: 'top',
	            padding: 10,
	            backgroundColor: '#eaeaea',
	            borderRadius: 16,
	            marginRight: 10,
	            marginBottom: 10
	          }
	        }, DIV({
	          style: {
	            fontWeight: 600,
	            marginBottom: 4,
	            color: "#666"
	          }
	        }, tag_group), UL({
	          style: {
	            listStyle: 'none',
	            display: 'inline',
	            fontSize: 0,
	            lineHeight: 0
	          }
	        }, (function() {
	          var l, len1, ref3, results1;
	          ref3 = tag_users.yes;
	          results1 = [];
	          for (l = 0, len1 = ref3.length; l < len1; l++) {
	            user = ref3[l];
	            results1.push((function(_this) {
	              return function(user) {
	                return Avatar({
	                  key: user.key,
	                  style: {
	                    width: 40,
	                    height: 40,
	                    cursor: 'pointer'
	                  },
	                  onClick: function() {
	                    return change_current_user(user.key);
	                  }
	                });
	              };
	            })(this)(user));
	          }
	          return results1;
	        }).call(this), (function() {
	          var l, len1, ref3, results1;
	          ref3 = tag_users.no;
	          results1 = [];
	          for (l = 0, len1 = ref3.length; l < len1; l++) {
	            user = ref3[l];
	            results1.push((function(_this) {
	              return function(user) {
	                return Avatar({
	                  key: user.key,
	                  style: {
	                    width: 40,
	                    height: 40,
	                    cursor: 'pointer',
	                    opacity: .2
	                  },
	                  onClick: function() {
	                    return change_current_user(user.key);
	                  }
	                });
	              };
	            })(this)(user));
	          }
	          return results1;
	        }).call(this))));
	      }
	      return results;
	    }).call(this)));
	  }
	});
	
	window.UserTags = UserTags;


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** franklin.1b66f6b289701c91e7e7.js
 **/